//import '../css/tailwind.css';
import * as Sentry from '@sentry/browser'
import { Html5QrcodeScanner } from 'html5-qrcode'
import IMask from 'imask'
import QRCode from 'qrcode'

import { avaliacao } from './components/Avaliacao'
import { gif, showMessage, showMessageBox, toast } from './components/message'
import { search } from './components/Search'
import { savesInteraction } from './components/UserCounter'
import { estabelecimento } from './Estabelecimento/estabelecimento'
import { buscaPedidoSenha } from './Modules/modoSenha'
import templateConfirmarPedido from './pages/ConfirmarPedido/ConfirmarPedido.hbs'
import {
  calculaCupom,
  cupomDesconto,
  validaDescontoFidelidade,
} from './pages/Cupons/Cupons'
import {
  buscaBairrosMogoSmart,
  buscaCoordenadasCliente,
  buscaEndereco,
  buscaRaioEndereco,
  buscaValorTaxaEntregaPorRaio,
  cadastrarNovoEndereco,
  enderecos,
  solicitaEndereco,
  editarEndereco,
} from './pages/Enderecos/Enderecos'
import { MeusDados } from './pages/MeusDados/MeusDados'
import { initializeFirebase } from './pages/Notifications/firebase'
import { configuraProgramaFidelidade } from './pages/ProgramaDeFidelidade/ProgramaDeFidelidade'
import { Sobre } from './pages/Sobre'
import {
  agrupaItensPedido,
  exibeAdicionaisSabores,
  formataValoresPedido,
  getCodTicks,
  rastreioPedido,
  separaItensPedido,
} from './Pedido/pedido'
import { templates } from './templates/templates'
import { alteraDadosUsuario, solicitaDadosUsuario, usuario } from './usuario'
import {
  bagButtonShow,
  buscaDadosBuscaBalcao,
  buttonLoader,
  convertBRDateToAmerican,
  createElement,
  createMessageBox,
  criaInstanciaGeocoder,
  decimalStringToNumber,
  detectCard,
  elementHeigth,
  format,
  formatAddress,
  formatDecimal,
  formatMoney,
  getScroll,
  getUrlAction,
  inputIsValid,
  loginMessage,
  newPage,
  prevent,
  random,
  ripple,
  sentryError,
  solicitaInformacoesUsuario,
  storage,
  TestaCPF,
  track,
} from './utils'
import { formasPagamento } from './Estabelecimento/components/pagamento'
import { validaAgendamento } from './Pedido/agendamento'
import { validaAberturaEstabelecimento } from './Estabelecimento/components/StatusAbertura'
import { telaCadastroFidelidade } from './components/fidelidade/fidelidade'

window.select = (seletor, wrapper) =>
  (wrapper || document).querySelector(seletor)
window.selectAll = (seletor, wrapper, asArray) =>
  asArray
    ? Array.from((wrapper || document).querySelectorAll(seletor))
    : (wrapper || document).querySelectorAll(seletor)
window.estabelecimentoCarregado = false

export const store = {
  produtos: [],
  agrupamentos: [],
}

let storAdicionaisPedido = []
const storeInfoEstab = {}
let storProduto = {
  Adicionais: [],
  Sabores: [],
}
let loadingAddresses = true
let adicionaisPizza
let totalComAdicionais = 0
let dadosCartao

export var storeOrder = {
  Itens: [],
  Sabores: [],
  PontosUtilizados: 0,
}

window.trackAwait = []

try {
  if (!isDebug) {
    Sentry.init({
      dsn: 'https://6f3ff0f13eef4e73b3e83286abeb095d@o1204392.ingest.sentry.io/6331104',

      // Alternatively, use `process.env.npm_package_version` for a dynamic release version
      // // if your build tool supports it.
      // release: "my-project-name@2.3.12",
      integrations: [
        Sentry.browserTracingIntegration(),
        // Sentry.replayIntegration(),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,

      // // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      // replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })
  }
} catch { }

// Verifica a url atual, conferiendo se não tem um parâmetro que redireciona para algo específico
verificaURL()
String.prototype.capitalizeFirstLetter = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

if (!estabelecimento.qrCode.ativo) {
  document.addEventListener('DOMContentLoaded', function () {
    track('usuario', usuario)
    axios
      .get(getUrlAction('Account', 'isLogado'))
      .then(function ({ data }) {
        usuario.logado = data === true
        initialize()

        if (usuario.logado) {
          track('usuario', usuario)
          conectarSocketOlivo()
          buscaBairrosMogoSmart()
          buscaDadosBuscaBalcao()

          track('usuario-after-initialize', usuario)

          // Se estiver logado busca os dados do programa de fidelidade.
          $.ajax({
            type: 'GET',
            url: getUrlAction('Cadastros', 'GetDadosProgramaFidelidade', {
              params: {
                urlEmpresa: estabelecimento.urlEmpresa,
              }
            }),
            data: { idCliente: usuario.id },
            success: function (response, status, xhr) {
              estabelecimento.programaFidelidade = JSON.parse(response)

              if (estabelecimento.programaFidelidade) {
                estabelecimento.programaFidelidade.cliente = {
                  pontos:
                    estabelecimento.programaFidelidade.pontosAtuaisFideliza,
                  pontosUtilizados:
                    estabelecimento.programaFidelidade.pontosUtilizadosFideliza,
                }
              }

              mensagemBeneficioDisponiveis()
            },
            error: () => {
              gif.end()
            },
          })
        }
      })
      .catch(function (err) {
        console.log(err)
      })

    // Event Listeners click.
    const menuBackground = select('.menu-background')
    menuBackground &&
      menuBackground.addEventListener('click', () => {
        select('.menu').classList.remove('menu-show')
        select('html').style.overflow = ''
      })

    const menuAddress = select('#meus-enderecos')
    menuAddress &&
      menuAddress.addEventListener('click', () => {
        enderecos()
      })
  })
} else {
  initialize()
}

function getEnderecos(callback) {
  if (usuario.logado) {
    axios
      .get(getUrlAction('Cadastros', 'GetLocaisEntrega'))
      .then((response) => {
        callback(response.data)
      })
      .catch((e) => {
        sentryError.exception(e)
      })
      .finally(() => {
        gif.end()
      })
  }
}

function showPedido(animation) {
  const botaoVerPedido = select('#btn-pedido')
  const buttonPedido = select('#btn-pedido #bag-text')

  const isLoading = buttonPedido.getAttribute('loading')

  if (isLoading && isLoading == 'true' && loadingAddresses) {
    if (!loadingAddresses) {
      buttonPedido.removeAttribute('loading')
      buttonPedido.innerHTML = 'Revisar pedido'
    } else {
      return
    }
  } else {
    buttonPedido.innerHTML = 'Revisar pedido'
  }

  const loader = buttonLoader(buttonPedido)
  loader.start()
  // Se a página de confirmar estiver aberta, fecha ela'
  const paginaPedido = select('#pedido')
  if (paginaPedido) {
    paginaPedido.remove()
  }

  if (
    !estabelecimento.qrCode.ativo &&
    !estabelecimento.entrega.SomenteEntregaBalcao &&
    usuario.logado &&
    loadingAddresses &&
    typeof google === 'undefined'
  ) {
    return
  }

  // Calcula a taxa de entrega
  calculaTaxaEntrega().then((configuracoesEntrega) => {
    criaPaginaSalvarPedido(configuracoesEntrega.taxaEntrega)
    buttonPedido.removeAttribute('loading')
    loader.stop()
    buttonPedido.innerHTML = 'Revisar pedido'
  })

  function criaPaginaSalvarPedido(taxaEntrega) {
    const pagePedido = select('#pedido')
    const subTotal = format.money(storeOrder.valorTotal + taxaEntrega)
    if (!pagePedido) {
      let textoBotao = 'Continuar'
      if (estabelecimento.qrCode.ativo) {
        textoBotao = 'Enviar pedido'
      }

      newPage({
        id: 'pedido',
        appbarTitle: 'Pedido',
        classList:
          ' page-bag animate__animated ' + (animation || 'animate__slideInUp'),
        close: () => {
          const page = select('#pedido')

          page.classList.add('animate__slideOutDown')
          setTimeout((e) => {
            page.remove()
          }, 500)
        },
        body: `
                            <div class="pedido-container">
                                <div class="title">
                                    Itens adicionados
                                </div>
                                <div class="itens u-p-8-0">
                                    ${itensTemplate()}
                                </div>
                                <div class="sub-total">
                                    <div ${usuario.logado ? '' : 'style=display:none'}>
                                        <span>entrega</span>
                                        <span id="taxa-entrega">${format.money(taxaEntrega)}</span>
                                    </div> 
                                    <div>
                                        <span>subtotal</span><span id="sub-total">${subTotal}</span></span>
                                    </div>
                                </div>
                                <div class="change-button local-entrega" ${usuario.logado &&
            !estabelecimento.entrega
              .somenteEntregaBalcao &&
            !estabelecimento.desabilitarEntregaBalcao
            ? ''
            : 'style=display:none'
          }>
                                    <input id="inp-entregar" type="radio" name="entrega" value="1" ${(storeOrder.CodObsEntrega &&
            !estabelecimento.entrega
              .somenteEntregaBalcao) ||
            estabelecimento.desabilitarEntregaBalcao
            ? ''
            : 'checked'
          }>
                                    <label class="btn" for="inp-entregar">Para entregar</label>
                                    <input id="inp-buscar" type="radio" name="entrega" value="2" ${storeOrder.CodObsEntrega ||
            estabelecimento.entrega
              .somenteEntregaBalcao
            ? 'checked'
            : ''
          }>
                                    <label class="btn" for="inp-buscar">Buscar no local</label>
                                </div>
                                <div class="wrapper-message"></div>
                                <div class="total">
                                    <span>Total do pedido</span>
                                    <span id="total-pedido">${subTotal}</span>
                                </div>
                                <button id="confirmarPedido" class="btn btn-primary">${textoBotao}</button>
                            </div>`,

        callback: () => {
          $('.container-edicao__edit').on('click', (event) => {
            buscaAdicionais(
              $(event.target).attr('data-id-produto'),
              null,
              $(event.target).attr('data-codticks'),
              true,
              $(event.target).attr('data-pizza'),
              undefined,
              $(event.target).attr('data-agrupamento') == "true",
            )
          })

          $('.container-edicao__trash').on('click', (event) => {
            removerProdutoStor(
              $(event.target).attr('data-id-produto'),
              $(event.target).attr('data-codticks'),
              $(event.target).attr('data-agrupamento') == "true",
            )
          })

          const inputEntregar = select('#inp-entregar')
          const inputRetirar = select('#inp-buscar')
          inputEntregar &&
            inputEntregar.addEventListener('change', verificaEntrega)
          inputRetirar &&
            inputRetirar.addEventListener('change', verificaEntrega)

          function verificaEntrega(event) {
            const input = event.currentTarget
            const taxaEl = select('#taxa-entrega')
            const subEl = select('#sub-total')
            const totalElement = select('#total-pedido')

            const wrapper = select('.wrapper-message')
            wrapper.innerHTML = ''

            if (input.value == 1) {
              storeOrder.CodObsEntrega = undefined

              calculaTaxaEntrega().then((configuracoesEntrega) => {
                const total = format.money(
                  storeOrder.valorTotal + configuracoesEntrega.taxaEntrega,
                )
                totalElement.textContent = total
                subEl.textContent = total
                taxaEl.textContent = format.money(
                  configuracoesEntrega.taxaEntrega,
                )
              })
            } else if (input.value == 2) {
              const total = format.money(storeOrder.valorTotal)
              storeOrder.TaxaEntrega = 0
              storeOrder.CodObsEntrega = estabelecimento.codigoBuscaBalcao
              totalElement.textContent = total
              subEl.textContent = total
              taxaEl.textContent = format.money(0)
              exibeMensagemRetirada()
            }
          }
        },
      })

      const itensPedido = selectAll('#pedido .itens > .item')
      itensPedido.forEach((itemPedido) => {
        itemPedido.addEventListener('click', () => {
          itemPedido.classList.toggle('editar-pedido')
        })
      })

      const buttom = select('#confirmarPedido')
      if (buttom) {
        ripple(buttom)
        buttom.addEventListener('click', () => {
          const produtoForaDeHorario = []
          storeOrder.Itens.forEach((item) => {
            const [produto] = store.produtos.filter(
              (produto) => produto.IdProd == item.idProduto,
            )

            if (produto && produto.Intervalo) {
              const isAgrupamento =
                typeof produto.SubAgrupamentoDelivery !== 'undefined' &&
                produto.SubAgrupamentoDelivery != null
              const disponivel = verificaDisponibilidade(produto, isAgrupamento)
              if (!disponivel) {
                produtoForaDeHorario.push(item.Produto_Produto)
                storeOrder.Itens = storeOrder.Itens.filter(
                  (item) => item.IdProd != produto.IdProd,
                )
                toast(
                  `O produto ${produto.Produto_Produto || produto.NomeDelivery} está fora do horário de disponibilidade`,
                )
              }
            }

            // Se o produto não foi encontrado significa que ele foi removido do cardápio por estar fora do horário
            if (produto == null) {
              produtoForaDeHorario.push(item.Produto_Produto)
              storeOrder.Itens = storeOrder.Itens.filter(
                (it) => it.idProduto != item.idProduto,
              )
            }
          })

          if (produtoForaDeHorario.length > 0) {
            const paginaPedido = select('#pedido')
            paginaPedido && paginaPedido.remove()

            const btnPedido = select('#btn-pedido')
            btnPedido && btnPedido.remove()

            if (storeOrder.Itens.length > 0) {
              showButtonOrder(true)
              storage.set(`pedido-mobile-${estabelecimento.urlEmpresa}`, {
                ...storeOrder,
                cartao: null,
              })
            } else {
              storage.remove(`pedido-mobile-${estabelecimento.urlEmpresa}`)
            }

            let texto = ''
            if (produtoForaDeHorario.length == 1) {
              texto =
                'O produto abaixo está fora do horário de disponibilidade e foi removido do seu pedido: <br>'
              texto += produtoForaDeHorario[0]
            } else {
              texto =
                'Os produtos abaixo estão fora do horário de disponibilidade e foram removidos do seu pedido: <br>'
              texto += produtoForaDeHorario.join(', ')
              texto += '.'
            }
            showMessageBox({
              icon: 'warning',
              message: texto,
              classList: 'no-icon-background small',
              default: true,
            })

            return
          }

          storeOrder.TaxaEntrega = 0
          storeOrder.descontoFidelidade = 0
          storeOrder.ReaisDesconto = 0
          storeOrder.ValorDesconto = 0
          storeOrder.PercentualDesconto = 0

          let valido = true

          // Só entra aqui se o estabecimento não usar QR Code
          if (!estabelecimento.qrCode.ativo) {
            // Se o valor do total é menor que o valor mínimo do pedido ou é etrega balcão aí não é verificado o valor mínimo
            const contemItemFidelidade = storeOrder.Itens.find(
              (it) => it.IsItemFidelidade,
            )

            // Pedido delivery
            let atingiuValorMinimo =
              storeOrder.valorTotal >= estabelecimento.valorMinimoPedido
            let naoAtigiuVlrMinBalcao = false

            // Pedido balcão
            if (
              storeOrder.CodObsEntrega &&
              estabelecimento.valorMinimoPedidoBalcao != null &&
              estabelecimento.valorMinimoPedidoBalcao > 0
            ) {
              atingiuValorMinimo =
                storeOrder.valorTotal >= estabelecimento.valorMinimoPedidoBalcao
              naoAtigiuVlrMinBalcao = !atingiuValorMinimo
            }

            // Se tem item fidelidade, não valida pedido mínimo
            if (contemItemFidelidade) {
              atingiuValorMinimo = true
            }

            /* 

             Se o pedido atingiu o valor mínimo, ou
             se o estabelecimento tem pedido mínimo por bairro, se sim verifica 
             o pedido mínimo somente após logar e criar um endereço

            */
            if (atingiuValorMinimo || (estabelecimento.entrega.TemPedidoMinimoPorBairro && !storeOrder.CodObsEntrega)) {
              if (
                storeOrder.valorTotal <= 0 ||
                storeOrder.valorTotal == '0,00' ||
                !storeOrder.valorTotal
              ) {
                valido = false

                showMessageBox({
                  id: 'message-box-pedido-minimo',
                  icon: 'warning',
                  message: `O valor do pedido deve ser maior que R$0,00`,
                  classList: 'no-icon-background small',
                  default: true,
                })

                return
              }

              if (usuario.logado) {
                // Se é somente entrega balcão
                if (estabelecimento.entrega.somenteEntregaBalcao) {
                  storeOrder.CodObsEntrega = estabelecimento.codigoBuscaBalcao
                  callback()
                }

                // Se não é entrega balcão
                else if (!storeOrder.CodObsEntrega) {


                  const botaoConfirmarItens = select('#confirmarPedido')
                  let loader
                  if (botaoConfirmarItens) {
                    loader = buttonLoader(botaoConfirmarItens)
                  }

                  loader && loader.start()

                  calculaTaxaEntrega().then((configuracoesEntrega) => {
                    loader && loader.stop()

                    const endereco =
                      usuario.enderecoSelecionado ||
                      usuario.enderecoPrincipal ||
                      usuario.enderecos[0]

                    if (!configuracoesEntrega.podeEntregar) {
                      valido = false
                      callback(false)
                    } else if (!configuracoesEntrega.enderecoCadastrado) {
                      valido = false
                      callback()
                    } else if (endereco && !endereco.Bairro) {
                      valido = false
                      toast('Seu endereço atual não possui um bairro selecionado, por favor, selecione um bairro válido.')
                      editarEndereco(endereco.Id)
                    } else {

                      if (estabelecimento.entrega.TemPedidoMinimoPorBairro && endereco.Bairro.PedidoMinimo && storeOrder.valorTotal < endereco.Bairro.PedidoMinimo.parseNumber()) {
                        valido = false
                        showMessageBox({
                          id: 'message-box-pedido-minimo',
                          icon: 'warning',
                          message: `O valor mínimo para entrega no bairro ${endereco.Bairro.Descricao} é de R$${endereco.Bairro.PedidoMinimo}`,
                          classList: 'no-icon-background small',
                          default: true,
                        })
                        return
                      } else {
                        storeOrder.TaxaEntrega = configuracoesEntrega.taxaEntrega
                        valido = true
                      }

                      callback()
                    }
                  })
                } else {
                  valido = true
                  callback()
                }
              } else {
                valido = false
                callback()
              }
            } else {
              valido = false

              showMessageBox({
                id: 'message-box-pedido-minimo',
                icon: 'warning',
                message: `Pedido mínimo: ${format.money(
                  naoAtigiuVlrMinBalcao
                    ? estabelecimento.valorMinimoPedidoBalcao
                    : estabelecimento.valorMinimoPedido,
                )}`,
                classList: 'no-icon-background small',
                default: true,
              })

              return
            }
          } else {
            if (estabelecimento.comanda.ativo) {
              verificaStatusComanda()
                .then((data) => {
                  if (estabelecimento.comanda.QRCodeComandaModoSeguranca) {
                    if (data.liberada) {
                      callback()
                    } else {
                      solicitaLiberacaoComanda()
                    }
                  } else {
                    callback()
                  }
                })
                .catch((error) => {
                  if (error) {
                    toast(
                      'Esta comanda não está disponível para pedidos, utilize outra comanda ou solicite a abertura de uma nova comanda.',
                    )
                  }
                })
            } else {
              callback()
            }
          }

          function callback(entrega) {
            if (valido) {
              if (estabelecimento.qrCode.ativo) {
                if (estabelecimento.qrCode.modoTablet || estabelecimento.qrCode.obrigarLeituraDaComanda) {
                  leituraQrCode().then((comanda) => {
                    estabelecimento.comanda.numero = comanda
                    salvarPedido()
                  })
                } else {
                  salvarPedido()
                }
              } else {
                const orderPage = select('#pedido')
                orderPage.classList.remove('animate__slideInUp')
                orderPage.classList.add('animate__slideOutLeft')
                confirmarPedido()
              }
            } else {
              if (usuario.logado) {
                solicitaEndereco(entrega)
              } else {
                if (estabelecimento.programaFidelidade && estabelecimento.programaFidelidade.Ativo) {
                  localStorage.removeItem('sem-interesse-fideliza')
                  telaCadastroFidelidade()
                } else {
                  loginMessage(confirmarPedido)
                }
              }
            }
          }

          // Salva a interação para a análise de conversão
          savesInteraction(4)
        })
      }

      const buttomPedido = select('#btn-pedido')
      if (buttomPedido) {
        buttomPedido.classList.remove('visible')
      }
    }
  }
}

function exibeMensagemRetirada() {
  const wrapper = select('.wrapper-message')
  wrapper.innerHTML = ''

  if (
    estabelecimento.entrega.tempoRetirada > 0 ||
    (estabelecimento.tempoEntrega &&
      estabelecimento.tempoEntrega[0] &&
      estabelecimento.tempoEntrega[1])
  ) {
    let tempo = ''

    if (estabelecimento.entrega.tempoRetirada > 0) {
      tempo = estabelecimento.entrega.tempoRetirada + ' minutos'
    } else {
      if (
        estabelecimento.tempoEntrega &&
        estabelecimento.tempoEntrega[0] &&
        estabelecimento.tempoEntrega[1]
      ) {
        tempo =
          estabelecimento.tempoEntrega[0] +
          ' - ' +
          estabelecimento.tempoEntrega[1] +
          ' minutos'
      } else if (estabelecimento.tempoEntrega[0]) {
        tempo = estabelecimento.tempoEntrega[0] + ' minutos'
      }
    }

    if (tempo) {
      wrapper.innerHTML = `
            <div class="alert">
                <div class="flex">
                    <div class="alert-icon">
                        <i class="far fa-clock"></i>
                    </div>
                    <div class="alert-content">Você pode retirar seu pedido em ${tempo}</div>
                </div>
            </div>`
    }
  }
}


function filterOptions(grupoDeOpcoes) {
  const produtoAdicionais = {
    radio: [],
    outros: [],
  }

  grupoDeOpcoes = grupoDeOpcoes.filter((grupo) => grupo != null && grupo != '',).sort((a, b) => a.Ordem - b.Ordem)

  // //remove os iguais (com o mesmo id)
  // grupoDeOpcoes = grupoDeOpcoes.filter((item, index) => {
  //   const GrupoOpcoes = item.GrupoOpcoes
  //   const id = GrupoOpcoes.Id
  //   return grupoDeOpcoes.findIndex((item) => {
  //     const GrupoOpcoes = item.GrupoOpcoes
  //     const id2 = GrupoOpcoes.Id
  //     return id == id2
  //   }) == index
  // })

  grupoDeOpcoes.forEach((item, index) => {
    const GrupoOpcoes = item.GrupoOpcoes
    const grupo = {
      id: GrupoOpcoes.Id,
      descricao: GrupoOpcoes.Descricao,
      min: GrupoOpcoes.QuantMinima,
      max: GrupoOpcoes.QuantMaxima,
      itens: GrupoOpcoes.OpcoesGrupo
        ? GrupoOpcoes.OpcoesGrupo.filter((opcao) => opcao.Adicional.Ativo)
        : [],
      ordem: index.toString(),
      ConsiderarAdicionalComValorMaior: GrupoOpcoes.ConsiderarAdicionalComValorMaior,
    }

    if (item.idProduto) {
      grupo.idProduto = item.idProduto
    }

    if (grupo.min == 1 && grupo.max == 1) {
      produtoAdicionais.radio.push(grupo)
    } else {
      produtoAdicionais.outros.push(grupo)
    }
  })

  return produtoAdicionais
}

export function showButtonOrder(open = false) {
  let quantityOfProducts = 0
  let total = 0

  storeOrder.Itens.forEach((item) => {
    quantityOfProducts += item.Quantidade
    total += item.ValorTotal
  })

  const elButton = select('#btn-pedido')
  if (!elButton) {
    const buttom = /* html */ `
            <button id="btn-pedido" class="btn btn-bottom" >
            <div class="bag">
                <img src="${location.origin}/images/mobile/bag.svg" />
                <span id="bag-quantity">${quantityOfProducts}</span>
            </div>
            <span id="bag-text">Revisar pedido</span>
            <span id="bag-total">${format.money(total)}</span></span >
        </button > `

    select('#aux-container').innerHTML = buttom

    const botaoPedido = select('#btn-pedido')
    botaoPedido &&
      botaoPedido.addEventListener('click', () => {
        showPedido()
      })

    bagButtonShow()

    // Para abrir a tela de Pedido após efetuar login
    if (usuario.logado && open) {
      botaoPedido.click()
    }
  } else {
    select('#bag-quantity').textContent = quantityOfProducts
    select('#bag-total').textContent = format.money(total)
    bagButtonShow()
  }
}
function initialize() {
  verificaUsoCookies()

  const isQRCode = typeof configuracoesCardapio === 'object'

  if (isQRCode) {
    estabelecimento.qrCode.ativo = true
  } else {
    conectarSocketOlivo()
  }
  buscaProdutos()
  buscaSugestoesProdutos()

  buscaDadosUsuario()
  // Busca a ulr da capa do estabelecimento

  buscaCapa()

  if (usuario.logado) {
    if (estabelecimentoCarregado) {
      carregaEnderecos()
    } else {
      window.awaitCarregaEnderecos = carregaEnderecos
    }
  }

  /** *Listeners***/

  // Listener para as animações do scroll
  select('.container.body-content').addEventListener('scroll', scrollAnimation)

  // Quando a tela é redimensionada atualiza o tamanho das páginas para preencher todo o viewport
  $(window).resize(function () {
    selectAll('.u-viewport').forEach((item) => {
      item.style.height = window.innerHeight + 'px'
    })
  })

  // Busca todos os botões ripple e adiciona o listener para animação
  selectAll('.btn-ripple').forEach((element) => ripple(element))

  // Listener de busca
  $('#search-area img').on('click', () => {
    select('#nav-bar').classList.add('search')
  })

  $('#search-area #cancel').on('click', () => {
    const categorias = selectAll('.categoria')
    categorias.forEach((categoria) => {
      categoria
        .querySelectorAll('.produto')
        .forEach((produto) => (produto.style.display = ''))
      categoria.style.display = ''
    })

    select('#search-product').value = ''
    select('#nav-bar').classList.remove('search')

    const notfoundMessage = document.querySelector('#not-found')
    notfoundMessage && notfoundMessage.remove()

    const fixedHeader = select('#fixed-header')
    fixedHeader.classList.remove('modo-pesquisa')
    window.scroll({
      top: 1,
      behavior: 'smooth',
    })
  })

  const botaoPedidos = select('#pedidos')
  if (botaoPedidos) {
    botaoPedidos.addEventListener('click', (event) => {
      if (usuario.logado || estabelecimento.qrCode.ativo) {
        track('Abrir pedidos', { estabelecimento })
        paginaPedidos()
      } else {
        loginMessage(paginaPedidos)
      }
    })
  }

  const menuAvaliacao = select('#menu-avaliacao')
  if (usuario.logado) {
    menuAvaliacao &&
      menuAvaliacao.addEventListener('click', () => {
        avaliacao()
      })
  } else {
    menuAvaliacao.remove()
  }
}

export function buscaProdutos() {
  const cUrl = getUrlAction('Home', 'GetProductsByEstab')
  $.ajax({
    url: cUrl,
    type: 'GET',
    dataType: 'json',
    async: true,
    data: {
      isQrCode: estabelecimento.qrCode.ativo || document.body.classList.contains('cardapio-visualizacao'),
      urlEmpresa: estabelecimento.urlEmpresa,
    },
    success: function (response) {
      // let allProducts = []
      // if (response && response.length > 0) {
      //     response.forEach((categoria) => {
      //         categoria.LsProd.forEach((produto) => {
      //             allProducts.push(produto)
      //         })
      //     })
      // }

      // if (allProducts.length > 0) {
      //     storeProdutos = allProducts
      // }

      response = response.sort((a, b) => {
        return a.Ordem - b.Ordem
      })

      const categoriaDestaque = criaProdutosEmDestaque(response)
      if (categoriaDestaque) {
        response.unshift(categoriaDestaque)
      }

      criaTemplateCardapio(response)
      savesInteraction(1)
    },
    error: function (response) {
      //
    },
  })

  axios
    .get(getUrlAction('Home', 'GetGetDadosApoioItemPedido'), {
      params: {
        qrCode: estabelecimento.qrCode.ativo,
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then(function ({ data }) {
      if (data.dados) {
        if (typeof data.dados === 'string') {
          storeDadosItemPedido = JSON.parse(data.dados)
        } else {
          storeDadosItemPedido = data.dados
        }
        showAwaitPizza()

        const elementosPizza = selectAll('[ispizza="1"]')
        elementosPizza.forEach((elemento) => {
          const idProduto = elemento.getAttribute('idprod')
          const produto = store.produtos.find(
            (item) => item.IdProd == idProduto,
          )
          if (
            produto.PrecoDelivery == '0,00' ||
            !produto.PrecoDelivery ||
            produto.PrecoDelivery == 0
          ) {
            atualizaPrecoPizza(idProduto)
          }
        })
      }
    })
    .catch(function (error) {
      console.error(error)
    })
}

export function buscaSugestoesProdutos() {
  axios
    .get(getUrlAction('Home', 'GetSugestoesProdutos'), {
      params: {
        qrCode: estabelecimento.qrCode.ativo,
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then(function ({ data }) {
      estabelecimento.sugestoesProdutos = data
    })
    .catch(function (error) {
      console.error(error)
    })
}
export function carregaEnderecos(callback) {
  setTimeout(function () {
    const cUrl = getUrlAction('Cadastros', 'GetLocaisEntrega')
    $.ajax({
      type: 'GET',
      url: cUrl,
      success: function (response, status, xhr) {
        loadingAddresses = false

        if (response) {
          try {
            // se a resposta foi uma página html
            if (response.includes('<!DOCTYPE html>')) {
              callback && callback()
              return
            }

            usuario.enderecos = JSON.parse(response)

            const [enderecoPrincipal] = usuario.enderecos.filter(
              (endereco) => endereco.Principal,
            )

            usuario.enderecoPrincipal = enderecoPrincipal

            const endereco =
              usuario.enderecoPrincipal ||
              usuario.enderecoSelecionado ||
              usuario.enderecos[0]

            if (!usuario.enderecoPrincipal) {
              usuario.enderecoPrincipal = endereco
            }

            if ((estabelecimento.tipoEntrega === 'raio' || estabelecimento.tipoEntrega === 'distancia') && endereco) {
              buscaRaioEndereco(endereco, continuaConfig)

              function continuaConfig(raio) {
                if (raio) {
                  endereco.TaxaEntrega = raio.TaxaEntrega
                }
              }
            }
          } catch (e) {
            sentryError.exception(e)
          }

          const btnPedido = select('#btn-pedido')
          const menuVisible = select('.menu-show')
          if (btnPedido && !menuVisible) {
            btnPedido.click()
          }
        }
        callback && callback()
      },
      error: function (error) {
        loadingAddresses = false
        console.log(error)
        const btnPedido = select('#btn-pedido')
        if (btnPedido) {
          select('#bag-text').innerHTML = 'Ver pedido'
        }
      },
    })
  }, 100)
}

let lastScrollPositon = 0
let lastCat
function scrollAnimation(e) {
  const fixedHeader = select('#fixed-header')
  const capa = select('#cardapio .capa img')
  const logo = select('#cardapio .logo-container img')
  const logoContainer = select('#cardapio .logo-container')
  const abertura = select('#hr-abertura')
  const scroll = e.target.scrollTop
  const barraNavegacaoCardapio = select('.nav-cardapio')
  const barraNavegacao = select('#nav-bar')
  const header = select('#fixed-header header')
  // Limite para fixar o cardápio
  const breakPoint =
    elementHeigth(fixedHeader) -
    elementHeigth(barraNavegacao) -
    elementHeigth(barraNavegacaoCardapio)

  if (scroll < breakPoint) {
    logo.style.top = ''
    fixedHeader.style.top = scroll * -1 + 'px'

    if (capa) {
      if (scroll < 150) {
        capa.style.height = 200 - scroll + 'px'
      } else {
        capa.style.height = '5rem'
      }
    }

    scroll < 60 &&
      abertura &&
      (abertura.style.opacity = 1 - (scroll * 1.66) / 100)

    if (scroll > 100 && scroll < 180 && header) {
      header.style.opacity = (100 - (scroll - 100) * 1.1) / 100
    } else if (scroll < 100) {
      header.style.opacity = 1
    }
  } else {
    fixedHeader.style.top = '-' + breakPoint + 'px'
    abertura != null && (abertura.style.opacity = 0)
    capa != null && (capa.style.height = '5rem')
    header != null && (header.style.opacity = 0)
  }

  const categorias = selectAll('#cardapio .categoria')
  const diference = select('.content').offsetHeight - getScroll()[1]
  if (
    scroll + diference == select('.content').offsetHeight &&
    scroll > diference
  ) {
    selectAll(`.nav-cardapio .categoria-item`).forEach((cat, index) => {
      if (index + 1 === categorias.length) {
        cat.classList.add('selected')
      } else {
        cat.classList.remove('selected')
      }
    })
  }

  categorias.forEach((categoria, index, arr) => {
    if (categoria.offsetTop < scroll - 180) {
      if (index + 1 != categoria.length) {
        if (categorias[index + 1]) {
          if (scroll - 180 < categorias[index + 1].offsetTop) {
            const idCategoria = categoria.getAttribute('data-aba')

            const categoriaSelecionada = select(
              '.nav-cardapio .categoria-item.selected',
            )
            categoriaSelecionada &&
              categoriaSelecionada.classList.remove('selected')

            const categoriaSelecionar = select(
              `.nav-cardapio .categoria-item[data-aba="${idCategoria}"]`,
            )
            categoriaSelecionar && categoriaSelecionar.classList.add('selected')
          }
        }
      }
    }

    if (index + 1 === arr.length) {
      if (scroll > categoria.offsetTop) {
        const idCategoria = categoria.getAttribute('data-aba')
        select('.nav-cardapio .categoria-item.selected').classList.remove(
          'selected',
        )
        select(
          `.nav-cardapio .categoria-item[data-aba="${idCategoria}"]`,
        ).classList.add('selected')
      }
    }
  })
  let currentCat = select('.selected')
  currentCat && (currentCat = currentCat.getAttribute('data-aba'))

  if (currentCat && lastCat != currentCat) {
    lastCat = currentCat
    const navCardapio = document.querySelector('.nav-cardapio')
    const selectedCat = navCardapio.querySelector('.selected')
    const selectedCatRightPosition =
      selectedCat.offsetLeft + selectedCat.offsetWidth

    if (
      selectedCatRightPosition > navCardapio.offsetWidth &&
      lastScrollPositon < scroll
    ) {
      const scrollPositon = selectedCatRightPosition - navCardapio.offsetWidth
      navCardapio.scrollTo({
        left: scrollPositon,
        behavior: 'smooth',
      })
    } else if (lastScrollPositon > scroll) {
      const scrollPositon = selectedCatRightPosition - navCardapio.offsetWidth
      navCardapio.scrollTo({
        left: scrollPositon,
        behavior: 'smooth',
      })
    }
  }

  lastScrollPositon = scroll
}

function criaProdutosEmDestaque(response) {
  const categoria = {
    Categoria: estabelecimento.tituloDestaques,
    LsProd: [],
    LsSubAgrupamento: [],
    Ordem: 0,
    Destaque: true,
  }

  let encontrou = false
  response.forEach((categoriaDeProdutos) => {
    if (categoriaDeProdutos.LsProd) {
      categoriaDeProdutos.LsProd.forEach((produto) => {
        if (produto.Destaque) {
          categoria.LsProd.push(produto)
          encontrou = true
        }
      })
    }
  })

  return encontrou ? categoria : null
}

let awaitPizza
function criaTemplateCardapio(categorias) {
  const cardapio = select('#cardapio')
  const wrapperCategorias = select('.nav-cardapio', cardapio)
  const wrapperAbas = select('.cardapio-container .content', cardapio)
  wrapperAbas.style.display = 'none'

  if (wrapperCategorias) {
    wrapperCategorias.innerHTML = ''
  }

  categorias.forEach((categoria, index) => {
    if (categoria.LsSubAgrupamento != null) {
      categoria.LsSubAgrupamento.sort(
        (a, b) =>
          a.subAgrupamentoDelivery.Ordem - b.subAgrupamentoDelivery.Ordem,
      )
      // Faz o mapeamento do id do intervalo de disponibilidade para facilitar a validação do horário
      const subAgrupamentos = categoria.LsSubAgrupamento.map(
        (subAgrupamento) => {
          if (subAgrupamento.subAgrupamentoDelivery.IntervaloDisponibilidade) {
            subAgrupamento.subAgrupamentoDelivery.Intervalo =
              subAgrupamento.subAgrupamentoDelivery.IntervaloDisponibilidade.Id
          }

          store.produtos.push(...subAgrupamento.infoProd)
          return subAgrupamento
        },
      )

      store.agrupamentos.push(...subAgrupamentos)
    }

    // Adiciona ao store
    store.produtos.push(...categoria.LsProd)

    // Define o id da categoria como o índicie do array
    categoria.id = index

    if (categoria.Destaque && !categoria.Categoria) {
      categoria.Categoria = estabelecimento.tituloDestaques || 'Destaques'
    }

    let elementoCategoria
    try {
      // Cria o elemento da categoria
      elementoCategoria = createElement(
        'div',
        { class: 'categoria-item', 'data-aba': categoria.id },
        `<span>${categoria.Categoria.toLowerCase()}</span>`,
      )
    } catch (e) {
      Sentry.captureException(e)
    }

    // Se é o primeiro item do array, define como a categoria selecionada
    if (index == 0) {
      elementoCategoria.classList.add('selected')
    }

    // Faz o append da categoria no wrapper de categorias
    wrapperCategorias.appendChild(elementoCategoria)

    categoria.LsProd.forEach((produto) => {
      if (produto.Intervalo && estabelecimento?.intervaloProdutos?.intervalosPromocao) {
        // Verifico se o intervalo está dentro de intervalosPromocao para eu alterar o preço do produto
        const intervalo =
          estabelecimento.intervaloProdutos.intervalosPromocao.find(
            (intervalo) => intervalo == produto.Intervalo,
          )
        const achouIntervalo =
          estabelecimento.intervaloProdutos.intervalos.includes(
            estabelecimento.intervaloProdutos.intervalosPromocao.find(
              (intervalo) => intervalo == produto.Intervalo,
            ),
          )
        if (intervalo && achouIntervalo) {
          produto.PrecoAntigo = produto.PrecoDelivery
          produto.PrecoDelivery = produto.PrecoPromocional
        } else {
          produto.PrecoPromocional = '0,00'
        }
      } else {
        produto.PrecoAntigo = produto.PrecoDelivery
      }
    })

    const categorriaIsPizza =
      categoria.Categoria.toLocaleLowerCase() === 'pizzas'
        ? 1
        : 0 || categoria.IsPizza
    // Cria a aba passad
    const aba = createAba(
      {
        id: index,
        titulo: categoria.Categoria,
        itens: categoria.LsProd,
        itensAgrupados: categoria.LsSubAgrupamento,
        ordem: categoria.Ordem,
        destaque: categoria.Destaque,
      },
      categorriaIsPizza,
    )

    wrapperAbas.appendChild(aba)

    elementoCategoria.addEventListener('click', () => {
      const navWidth = wrapperCategorias.getBoundingClientRect().width
      const targetClientRect = elementoCategoria.getBoundingClientRect()
      const positonAndWidth = targetClientRect.left + targetClientRect.width

      if (positonAndWidth > navWidth) {
        wrapperCategorias.scrollTo({
          left: targetClientRect.x - 15,
          behavior: 'smooth',
        })
      }

      select('.container.body-content').scrollTo({
        top: aba.offsetTop + 190,
        behavior: 'smooth',
      })
    })
  })

  // console.log(store.produtos)

  store.produtos.forEach((produto) => {
    if (produto.Intervalo) {
      // Verifico se o intervalo está dentro de intervalosPromocao para eu alterar o preço do produto
      const intervalo =
        estabelecimento.intervaloProdutos.intervalosPromocao.find(
          (intervalo) => intervalo.Id == produto.Intervalo,
        )
      const achouIntervalo =
        estabelecimento.intervaloProdutos.intervalos.includes(
          estabelecimento.intervaloProdutos.intervalosPromocao.find(
            (intervalo) => intervalo == produto.Intervalo,
          ),
        )
      if (intervalo && achouIntervalo) {
        produto.PrecoAntigo = produto.PrecoDelivery
        produto.PrecoDelivery = produto.PrecoPromocional
      } else {
        produto.PrecoPromocional = '0,00'
      }
    }
  })

  try {
    getIntervaloDisponibilidade(() => {
      store.produtos.forEach((produto) => {
        verificaDisponibilidade(produto)
      })
      if (store.agrupamentos) {
        store.agrupamentos.forEach((agrupamento) => {
          verificaDisponibilidade(agrupamento.subAgrupamentoDelivery, true)
        })
      }

      wrapperAbas.style.display = 'flex'

      const wrapperCategorias = selectAll(
        '.cardapio-container .categoria',
        '',
        true,
      )
      wrapperCategorias.forEach((wrapperCategoria) => {
        const itens = selectAll('.produtos .produto', wrapperCategoria, true)
        if (itens.every((item) => item.classList.contains('indisponivel'))) {
          wrapperAbas.appendChild(wrapperCategoria)

          const aba = select(
            `.categoria-item[data-aba="${wrapperCategoria.getAttribute('data-aba')}"]`,
          )
          aba.style.order = '9999'
          aba.classList.add('aba-indisponivel')
          if (aba.classList.contains('selected')) {
            aba.classList.remove('selected')
            select('.categoria-item:not(.aba-indisponivel)').classList.add(
              'selected',
            )
          }
        }
      })
    })
  } catch {
    wrapperAbas.style.display = 'flex'
  }

  // Define um tamanho mínimo para o último elemento da lista
  if (wrapperAbas && wrapperAbas.lastElementChild) {
    wrapperAbas.lastElementChild.style.minHeight =
      elementHeigth(select('#fixed-header')) + 'px'
  }

  const produtos = selectAll('[idProd]')
  produtos.forEach((element) => {
    element.addEventListener('click', (event) => {
      const elementoProduto = event.currentTarget

      if (elementoProduto.classList.contains('produto-em-falta')) {
        return
      }

      if (estabelecimento.intervaloProdutos.ativo) {
        const idProduto = elementoProduto.getAttribute('idProd')
        getIntervaloDisponibilidade(() => {
          store.produtos.forEach((produto) => {
            verificaDisponibilidade(produto)
          })

          const [produto] = store.produtos.filter(
            (produto) => produto.IdProd == idProduto,
          )

          const exibirForaDeHorario = elementoProduto.getAttribute(
            'exibir-fora-horario',
          )
          if (produto && produto.Intervalo) {
            const disponivel = verificaDisponibilidade(produto)
            if (disponivel) {
              callbackProduto(false)
            } else if (exibirForaDeHorario) {
              callbackProduto(true)
            } else {
              toast('O produto está fora do horário de disponibilidade')
            }
          } else {
            callbackProduto(false)
          }
        })
      } else {
        callbackProduto()
      }

      function callbackProduto(foraDeHorario) {
        if (
          estabelecimento.qrCode.ativo ||
          estabelecimento.cardapio.visualizacao
        ) {
          if (
            estabelecimento.qrCodeAberto ||
            estabelecimento.cardapio.visualizacao
          ) {
            let isPizza = Number($(elementoProduto).attr('isPizza'))

            if (!isPizza && storeDadosItemPedido) {
              storeDadosItemPedido.saboresProd.forEach((sabor) => {
                if (sabor.CodProduto == $(elementoProduto).attr('idProd')) {
                  isPizza = true
                }
              })
            }

            elementoProduto.innerHTML += `
                            <div class="progress">
                                <div class="indeterminate"></div>
                            </div>`

            if (
              isPizza &&
              (!storeDadosItemPedido || !storeGruposPizzas || !storeItensPizza)
            ) {
              awaitPizza = {
                idProduto: $(elementoProduto).attr('idProd'),
                element: elementoProduto,
              }
            } else {
              buscaAdicionais(
                $(elementoProduto).attr('idProd'),
                elementoProduto,
                undefined,
                undefined,
                isPizza,
                foraDeHorario,
              )
            }
          } else {
            showMessageBox({
              icon: 'warning',
              message: 'O estabelecimento está fechado no momento.',
              classList: 'no-icon-background small',
              default: true,
            })
          }
        } else {
          // if (estabelecimento.aberto) {
          let isPizza = Number($(elementoProduto).attr('isPizza'))

          if (!isPizza && storeDadosItemPedido) {
            storeDadosItemPedido.saboresProd.forEach((sabor) => {
              if (sabor.CodProduto == $(elementoProduto).attr('idProd')) {
                isPizza = true
              }
            })
          }

          elementoProduto.innerHTML += `
                        <div class="progress">
                            <div class="indeterminate"></div>
                        </div>`

          if (
            isPizza &&
            (!storeDadosItemPedido || !storeGruposPizzas || !storeItensPizza)
          ) {
            awaitPizza = {
              idProduto: $(elementoProduto).attr('idProd'),
              element: elementoProduto,
            }
          } else {
            buscaAdicionais(
              $(elementoProduto).attr('idProd'),
              elementoProduto,
              undefined,
              undefined,
              isPizza,
              foraDeHorario,
            )
          }
          // } else {
          //   showMessageBox({
          //     icon: 'warning',
          //     message: 'O estabelecimento está fechado no momento.',
          //     classList: 'no-icon-background small',
          //     default: true,
          //   })
          // }
        }

        savesInteraction(2)
      }
    })
  })

  const produtosAgrupados = selectAll('[agrupamento]')
  produtosAgrupados.forEach((element) => {
    element.addEventListener('click', () => {
      if (
        !estabelecimento.aberto &&
        estabelecimento.qrCode.ativo &&
        !estabelecimento.qrCodeAberto
      ) {
        toast('O estabelecimento está fechado no momento.')
        return
      }

      const idAgrupamento = element.getAttribute('agrupamento')
      const agrupamento = store.agrupamentos.find(
        (agrupamento) => agrupamento.subAgrupamentoDelivery.Id == idAgrupamento,
      )

      let subAgrupamentoDelivery
      if (!agrupamento) {
        toast('O produto está fora do horário de disponibilidade')
        return
      } else {
        subAgrupamentoDelivery = agrupamento.subAgrupamentoDelivery
        if (!subAgrupamentoDelivery) {
          toast('O produto está fora do horário de disponibilidade')
          return
        }
      }
      getIntervaloDisponibilidade(() => {
        if (
          !subAgrupamentoDelivery.Intervalo ||
          verificaDisponibilidade(subAgrupamentoDelivery, true)
        ) {
          if (!subAgrupamentoDelivery.mapeado) {
            subAgrupamentoDelivery.mapeado = true
            const grupoDeOpcoesProdutos = []
            agrupamento.infoProd.forEach((produto) => {
              if (produto.GrupoOpcoesProdutoEstab) {
                produto.GrupoOpcoesProdutoEstab.forEach((grupo) => {
                  grupo.idProduto = produto.IdProd
                })
                grupoDeOpcoesProdutos.push(...produto.GrupoOpcoesProdutoEstab)
              }
            })

            subAgrupamentoDelivery.GrupoOpcoesSubAgrupamentoEstab.push(
              ...grupoDeOpcoesProdutos,
            )
          }

          const grupoOpcoes = (
            subAgrupamentoDelivery.GrupoOpcoesSubAgrupamentoEstab || []
          ).filter((item) => {
            if (estabelecimento.qrCode.ativo && item.GrupoOpcoes.ExibirQrCode) {
              return true
            } else {
              return item.GrupoOpcoes.ExibirDelivery
            }
          })

          templateAdicionais({
            GrupoOpcoesProdutoEstab: grupoOpcoes,
            DescricaoDelivery: subAgrupamentoDelivery.InfoSubAd,
            PathImagemS3: subAgrupamentoDelivery.PathImagemS3,
            NomeDelivery: subAgrupamentoDelivery.Descricao,
            agrupamento: true,
            produtos: agrupamento.infoProd,
            pergunta: subAgrupamentoDelivery.Pergunta,
            obrigarEscolhaTodosItens: subAgrupamentoDelivery.ObrigarEscolhaTodosItens,
          })
        } else {
          toast('O produto está fora do horário de disponibilidade')
        }
      })
    })
  })

  const telaAguardandoProduto = select('#aguardando-produto')
  try {
    if (telaAguardandoProduto) {
      const idProduto = telaAguardandoProduto.getAttribute('produto')
      const elementoProduto = select(`[idProd="${idProduto}"]`)
      if (elementoProduto) {
        elementoProduto.click()
      } else {
        telaAguardandoProduto.remove()
      }
    }
  } catch (e) {
    if (telaAguardandoProduto) {
      telaAguardandoProduto.remove()
    }

    Sentry.captureException(e)
  }
}

function createAba(aba, pizza) {
  // Cria o elemento que vai conter os produtos
  const elementoAba = createElement(
    'div',
    {
      class: 'categoria' + (aba.destaque ? ' wrapper-destaques' : ''),
      'data-aba': aba.id,
    },
    `<div class="${aba.destaque ? 'destaques' : 'title'}">${aba.titulo}</div>`,
  )

  const wrapperProdutos = createElement('div', { class: 'produtos' })
  elementoAba.appendChild(wrapperProdutos)

  // se está na metade da lista
  const elementoADS = createElement('div', { class: 'listSpace' })
  wrapperProdutos.appendChild(elementoADS)

  aba.itens.forEach((produto, index) => {
    let img = ''
    // Se tem imagem no produto
    if (produto.PathImagemS3) {
      img = `<div class="produto-img"><img src="${produto.PathImagemS3}" alt="produto"></div>`
    }

    const elementoProduto = createElement(
      'div',
      { class: 'produto', idProd: produto.IdProd, isPizza: pizza },
      `
            <div class="produto-info flex flex-column">
                <div class="produto-info-nome">${produto.NomeDelivery ? produto.NomeDelivery : ''}</div>
                ${aba.destaque ? '' : `<div class="produto-info-ingredientes">${produto.DescricaoDelivery ? produto.DescricaoDelivery : ''}</div>`}
                ${produto.Intervalo &&
        decimalStringToNumber(produto.PrecoPromocional) > 0
        ? `
                    <div class="produto-info-preco-promocional" style="display: flex; gap: 6px;">
                        <span class="produto-info-preco-antigo"style="font-size: 1.2rem; font-weight: 500; color: red; text-decoration: line-through;">${format.money(decimalStringToNumber(produto.PrecoAntigo))}</span>
                        <span class="produto-info-preco-novo" style="font-size: 1.2rem; font-weight: 500; color: #0e8226;">${format.money(decimalStringToNumber(produto.PrecoPromocional))}</span>
                    </div>
                `
        : `<div class="produto-info-preco">${decimalStringToNumber(produto.PrecoDelivery) > 0 ? format.money(decimalStringToNumber(produto.PrecoDelivery)) : ''}</div>`
      }
            </div>
            ${img}
        `,
    )

    if (
      estabelecimento.validaEstoque &&
      produto.ControlaEstoque &&
      produto.SaldoEstoque < 1
    ) {
      elementoProduto.classList.add('produto-em-falta')

      elementoProduto.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        toast('Produto indisponível no momento')
      })
    }

    wrapperProdutos.appendChild(elementoProduto)
  })

  if (aba.itensAgrupados) {
    aba.itensAgrupados.forEach((item) => {
      const agrupamento = item.subAgrupamentoDelivery
      let img = ''
      // Se tem imagem no produto
      if (agrupamento.PathImagemS3) {
        img = `<div class="produto-img"><img src="${agrupamento.PathImagemS3}" alt="produto"></div>`
      }

      let preco
      if (item.infoProd && item.infoProd.length > 0) {
        item.infoProd.forEach((produto) => {
          const precoProduto = decimalStringToNumber(produto.PrecoDelivery)
          if (!preco) {
            preco = precoProduto
          } else {
            if (agrupamento.ObrigarEscolhaTodosItens) {
              preco += precoProduto
            } else {
              if (precoProduto < preco) {
                preco = precoProduto
              }
            }

          }
        })
      } else {
        preco = 0
      }

      preco = format.money(preco)

      const elementoProduto = createElement(
        'div',
        { class: 'produto', agrupamento: agrupamento.Id },
        `
                <div class="produto-info flex flex-column">
                    <div class="produto-info-nome">${agrupamento.Descricao || ''}</div>
                    <div class="produto-info-ingredientes">${agrupamento.InfoSubAd}</div>
                    <div class="produto-info-preco">${agrupamento.ObrigarEscolhaTodosItens ? "" : "A partir de "}${preco}</div>
                </div>
                ${img}
            `,
      )

      wrapperProdutos.appendChild(elementoProduto)
    })
  }

  return elementoAba
}

// Se tem codTicks é para edição
function buscaAdicionais(
  idProduto,
  elemento,
  codTicks,
  edited,
  pizza,
  foraDeHorario,
  produtoAgrupamento
) {
  if (
    estabelecimento.aberto ||
    !estabelecimento.aberto ||
    estabelecimento.qrCode.ativo ||
    estabelecimento.qrCode.apenasVisualizacao
  ) {

    storAdicionaisPedido = []

    let produto

    if (produtoAgrupamento) {
      const produto = storeOrder.Itens.find((item) => item.SubAgrupamentoDelivery && item.SubAgrupamentoDelivery.Id == idProduto)
      if (produto && produto.SubAgrupamentoDelivery) {
        const agrupamento = produto.SubAgrupamentoDelivery
        const produtos = storeOrder.Itens.filter((item) => item.SubAgrupamentoDelivery && item.SubAgrupamentoDelivery.Id == idProduto && (!codTicks || item.CodTicksGrupo == codTicks))
        agrupamento.produtos = produtos

        templateAdicionais(
          {
            GrupoOpcoesProdutoEstab: agrupamento.GrupoOpcoesSubAgrupamentoEstab,
            DescricaoDelivery: agrupamento.InfoSubAd,
            PathImagemS3: agrupamento.PathImagemS3,
            NomeDelivery: agrupamento.Descricao,
            agrupamento: true,
            produtos: agrupamento.produtos,
            pergunta: agrupamento.Pergunta,
            obrigarEscolhaTodosItens: agrupamento.ObrigarEscolhaTodosItens,
          },

          undefined,

          agrupamento.produtos[0].CodTicks,
        )

        return
      }
    } else {
      produto = storeOrder.Itens.find((item) => item.idProduto == idProduto)

    }

    if (!produto) {
      produto = store.produtos.find((item) => item.IdProd == idProduto)
    }

    let grupoPizza = buscaGrupoPizza(produto)

    if (!personalizaPizzaFideliza && produto && produto.IsItemFidelidade) {
      personalizaPizzaFideliza = true
    }

    if (produto && produto.isAgrupamento) {
      const agrupamento = store.agrupamentos.find((item) =>
        item.infoProd.find((prod) => prod.IdProd == idProduto),
      )
      if (agrupamento) {
        templateAdicionais(
          {
            GrupoOpcoesProdutoEstab:
              agrupamento.subAgrupamentoDelivery.GrupoOpcoesSubAgrupamentoEstab,
            DescricaoDelivery: agrupamento.subAgrupamentoDelivery.InfoSubAd,
            PathImagemS3: agrupamento.subAgrupamentoDelivery.PathImagemS3,
            NomeDelivery: agrupamento.subAgrupamentoDelivery.Descricao,
            agrupamento: true,
            produtos: agrupamento.infoProd,
            pergunta: agrupamento.subAgrupamentoDelivery.Pergunta,
            obrigarEscolhaTodosItens: agrupamento.subAgrupamentoDelivery.ObrigarEscolhaTodosItens,
          },

          undefined,

          produto.CodTicks,
        )
      } else {
        toast('Ocorreu um erro ao tentar editar o produto')
        Sentry.captureException(new Error('Não foi encontrado o agrupamento'))
      }
    } else {
      if (usuario.logado) {
        var cUrl = getUrlAction('Cadastros', 'BuscaOpcoes')
        setTimeout(function () {
          $.ajax({
            url: cUrl,
            type: 'GET',
            dataType: 'json',
            async: true,
            data: {
              idProdEst: idProduto,
              qrCode: estabelecimento.qrCode.ativo,
              urlEmpresa: estabelecimento.urlEmpresa,
            },
            success: function (response) {
              templateAdicionais(
                response,
                elemento && elemento.offsetTop,
                codTicks,
                edited,
                grupoPizza,
                foraDeHorario,
              )

              setTimeout(() => {
                select('#cancel').click()
              }, 1000)
            },
            error: function (response) { },
          })
        }, 100)
      } else {
        var cUrl = getUrlAction('Cadastros', 'BuscaOpcoesEstab')
        setTimeout(function () {
          $.ajax({
            url: cUrl,
            dataType: 'json',
            data: {
              urlEmpresa: estabelecimento.urlEmpresa,
              idProdEst: idProduto,
              qrCode: estabelecimento.qrCode.ativo,
            },
            success: function (response) {
              if (elemento) {
                const progress = elemento.querySelector('.progress')
                if (progress) {
                  progress.remove()
                }
              }

              templateAdicionais(
                response,
                elemento && elemento.offsetTop,
                codTicks,
                edited,
                grupoPizza,
                foraDeHorario,
              )
            },
            error: function (response) { },
          })
        }, 100)
      }
    }
  } else {
    showMessageBox({
      icon: 'warning',
      message: 'O estabelecimento está fechado no momento.',
      classList: 'no-icon-background small',
      default: true,
    })
  }
}

// scrollTop => Posição do elemento alvo, para quando a tela ser fechada o cardápio se manter na posição original
function templateAdicionais(
  produtoSelecionado,
  scrollTop,
  codTicks,
  edited,
  grupoPizza,
  foraDeHorario,
) {

  const progress = select('.content .progress')
  progress && progress.remove()

  storProduto = {
    Adicionais: [],
    Sabores: [],
  }

  window.storeAdicionaisAgrupamento = {}
  //Controla o produto em edição no agrupamento obrigatório, representando a posição do produto no array de produtos
  let produtoAgrupamentoAtual = 0
  let quantidadeDeProdutosJaSelecionados = 0
  let produtoAtual = produtoSelecionado
  let storeProdutoAtual = storProduto

  if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
    produtoAtual = produtoSelecionado.produtos[produtoAgrupamentoAtual]
    grupoPizza = buscaGrupoPizza(produtoAtual)
  }

  //Se é obrigatório escolher todos os itens armazena no storProduto.produtosAgrupamento para controlar os produtos selecionados
  if (produtoSelecionado.obrigarEscolhaTodosItens && produtoSelecionado.produtos) {
    storProduto.produtosAgrupamento = [...produtoSelecionado.produtos.map(produto => {

      const adicionaisDoProduto = filterOptions(produto.GrupoOpcoesProdutoEstab)

      const adicionais = (produto.Adicionais || []).map(adicional => {
        const id = adicional.id || adicional.Adicional.Id
        let adc
        for (let key in adicionaisDoProduto) {
          adicionaisDoProduto[key].forEach(gpd => {
            gpd.itens.forEach(ad => {
              if (ad.Adicional.Id == id) {
                adc = ad
              }
            })
          })
        }
        return {
          ...adicional,
          quantidade: adicional.quantidade || adicional.Quantidade,
          id: id,
          preco: adc.Preco
        }
      })
      return {
        ...produto,
        storeAdicionais: adicionais,
        Adicionais: adicionais,
        Sabores: produto.Sabores || [],
        Quantidade: produto.Quantidade || 1,
      }
    })]
    storAdicionaisPedido = [...(storProduto.produtosAgrupamento[produtoAgrupamentoAtual].Adicionais) || []]

    storeProdutoAtual = storProduto.produtosAgrupamento[produtoAgrupamentoAtual]
  }

  let produtoASerEditado
  if (codTicks && !produtoSelecionado.obrigarEscolhaTodosItens) {
    produtoASerEditado = storeOrder.Itens.find((item) => Number(item.CodTicks) === Number(codTicks))
    produtoASerEditado = JSON.parse(JSON.stringify(produtoASerEditado))
  }

  if (produtoASerEditado) {
    storProduto = { ...produtoASerEditado }
    storeProdutoAtual = storProduto
  }

  // itensObrigatorios são os grupos de opções
  let itensObrigatorios = []

  let descricaoProduto = ''
  let ingredientes = ''


  const adicionaisDoProduto = filterOptions(produtoAtual.GrupoOpcoesProdutoEstab)
  const HTMLAdicionais = criaTemplatesAdicionais(adicionaisDoProduto, storeProdutoAtual.CodTicksGrupo ? storeProdutoAtual : produtoASerEditado)
  let HTMLAgrupamento = criaHTMLAgrupamento(produtoSelecionado)

  if (grupoPizza) {
    descricaoProduto = grupoPizza.pizza.DescricaoDelivery ?? ''
  } else if (
    produtoSelecionado.DescricaoDelivery &&
    produtoSelecionado.DescricaoDelivery.includes('|')
  ) {
    descricaoProduto = produtoSelecionado.DescricaoDelivery.split('|')
      .filter((item) => item !== '')
      .map((item) => `<div class='descricao-list'>${item}</div>`)
      .join('')
  } else {
    descricaoProduto = produtoSelecionado.DescricaoDelivery ?? ''
  }

  if (produtoSelecionado.Ingredientes) {
    ingredientes = `
        <div class="span-container">
            <span>O que vem nele?</span>
        </div>
        <div class="span-container"> 
            <span>${produtoSelecionado.Ingredientes.split('|').join(', ')}</span>
        </div>`
  }

  let saboresPizzaHTML = criaHTMLPizza(grupoPizza, storeProdutoAtual.CodTicks ? storeProdutoAtual : storProduto)

  const { PathImagemS3, NomeDelivery, Id } =
    grupoPizza && grupoPizza.pizza ? grupoPizza.pizza : produtoSelecionado

  const imageLink = PathImagemS3
  const descricaoItem = NomeDelivery
  let idProduto = Id

  const templateImagem = imageLink
    ? `
    <a href="${imageLink}" data-fancybox="images" data-caption="${descricaoItem}">
        <img src="${imageLink}" />
    </a>`
    : ` <div class="sem-imagem" title="Nenhuma imagem disponível"></div>`



  // Se o botão de valor total está visível, oculta.
  const btn_pedido = select('#btn-pedido')
  btn_pedido && btn_pedido.classList.remove('visible')

  // Se existe outra tela no documento remove.
  selectAll('.dialog_adicionais').forEach((dialog) => dialog.remove())

  // Criar o elemento pai que será adicionao ao body
  const containerHTML = document.createElement('div')
  containerHTML.innerHTML += criaTemplatePaginaProduto({
    id: produtoSelecionado.produtos ? 'agrupamento' : idProduto,
    capa: templateImagem,
    idProduto,
    descricaoItem,
    pizza: grupoPizza ? grupoPizza.pizza : null,
    ingredientes,
    descricao: descricaoProduto,
    sabores: saboresPizzaHTML,

    //Template de adicionais
    HTMLAdicionais: HTMLAdicionais,

    foraDeHorario,
    produtoASerEditado,
    preco: grupoPizza
      ? grupoPizza.pizza.PrecoDelivery
      : produtoASerEditado
        ? produtoASerEditado.ValorTotal
        : produtoSelecionado.PrecoDelivery,
    HTMLAgrupamento,
  })


  containerHTML.classList = 'dialog_adicionais u-viewport'
  if (foraDeHorario) {
    containerHTML.classList.add('produto-indisponivel-wrapper')
  }

  // Adiciona o elemento ao documento
  document.body.appendChild(containerHTML)



  if (HTMLAgrupamento) {
    const container = select('#adicional-container', containerHTML)

    container.parentElement.style.display = 'block'

    if (produtoSelecionado.obrigarEscolhaTodosItens) {

      if (produtoSelecionado.produtos.length > 1) {
        criaEventosStepsAgrupamento()

        const buttonWrapper = createElement(
          'div',
          { id: 'btn-proximo-passo', class: 'flex fixed-bottom-button' },
          `<button id="proximo-passo" class="btn btn-primary" style="position: relative;">Próximo passo</button>`,
        )

        const button = buttonWrapper.firstElementChild
        button.addEventListener('click', () => {

          //Se não foi selecionado todos os itens vai para o próximo produto
          if (produtoAgrupamentoAtual < produtoSelecionado.produtos.length - 1) {
            if (produtoAtual.IsPizza) {
              const quantidadeSabores = storeProdutoAtual.Sabores.length
              if (quantidadeSabores < 1) {
                toast('Selecione ao menos um sabor')
                return
              }
            }

            const status = verificaAdicionaisObrigatorios(itensObrigatorios, storAdicionaisPedido)
            if (!status) {
              return
            }
            //Grava os adicionais do produto atual
            storProduto.produtosAgrupamento[produtoAgrupamentoAtual].Adicionais = [...storAdicionaisPedido.map((item) => { return { ...item, Adicionais: item.adicional } })]

            produtoAgrupamentoAtual++

            //Se o produto atual já foi selecionado, carrega os adicionais do produto
            storAdicionaisPedido = [...(storProduto.produtosAgrupamento[produtoAgrupamentoAtual].Adicionais) || []]

            if (produtoAgrupamentoAtual > quantidadeDeProdutosJaSelecionados) {
              quantidadeDeProdutosJaSelecionados++
            }

            produtoAtual = produtoSelecionado.produtos[produtoAgrupamentoAtual]

            storeProdutoAtual = storProduto.produtosAgrupamento[produtoAgrupamentoAtual]
            atualizaPassoAtualAgrupamento()

            const quantidade = select('#qtd-produto').valueAsNumber
            if (produtoAgrupamentoAtual == produtoSelecionado.produtos.length - 1) {
              calculaValorTotalAgrupamentos(false, storeProdutoAtual, quantidade)

              button.parentElement.style.display = 'none'
            } else {
              button.parentElement.style.display = ''
              button.textContent = 'Próximo passo'
            }

          }

        })

        container.parentElement.appendChild(buttonWrapper)
      }

    }
    else {
      const adicionais = select('.adicionais-itens', containerHTML)
      if (adicionais && adicionais.childElementCount > 0) {

        container.parentElement.classList.add('adicionais-ocultos')

        const buttonWrapper = createElement(
          'div',
          { id: 'btn-proximo-passo', class: 'flex fixed-bottom-button' },
          `
              <button id="proximo-passo" class="btn btn-primary" style="position: relative;">Próximo passo</button>`,
        )

        const button = buttonWrapper.firstElementChild
        button.addEventListener('click', () => {
          const adicionaisElementos = selectAll(
            '.adicionais-itens .grupo-adicionais',
            containerHTML,
            true,
          )
          const idProduto = select(
            'input[name="produto-agrupamento"]:checked',
            containerHTML,
          ).dataset.idProduto
          if (idProduto) {
            const possuiGrupoEspecifico = adicionaisElementos.some(
              (grupo) => grupo.dataset.idProduto == idProduto,
            )
            adicionaisElementos.forEach((grupo) => {
              const idProdutoAdicional = grupo.dataset.idProduto

              if (possuiGrupoEspecifico && idProdutoAdicional) {
                grupo.style.display =
                  idProdutoAdicional == idProduto ? 'block' : 'none'
              } else if (!idProdutoAdicional && !possuiGrupoEspecifico) {
                grupo.style.display = ''
              } else {
                grupo.style.display = 'none'
              }
            })
          } else {
            adicionaisElementos.forEach((grupo) => {
              if (grupo.dataset.idProduto) {
                grupo.style.display = 'none'
              }
            })
          }
          container.parentElement.classList.remove('adicionais-ocultos')
          buttonWrapper.style.display = 'none'
          adicionais.scrollIntoView({ behavior: 'smooth' })

          const button = select('#btn-adicionar-produto')
          button && button.setAttribute('disabled', 'true')
          setTimeout(() => {
            button.removeAttribute('disabled')
          }, 1000)
        })

        container.parentElement.appendChild(buttonWrapper)
      }
    }
  }


  // Cria os eventos adicionais (adição e remoção de itens, etc)
  criaEventosAdicionais(adicionaisDoProduto)

  try {
    const telaAguardandoProduto = select('#aguardando-produto')
    if (telaAguardandoProduto) {
      telaAguardandoProduto.remove()
    }
  } catch (e) {
    Sentry.captureException(e)
  }

  containerHTML.addEventListener('click', (e) => {
    // se o tamanho da janela forma menor que 460px
    if (window.innerWidth < 460) {
      return
    }

    const pagina = select('.pagina', containerHTML)
    if (pagina) {
      if (e.target != pagina && !pagina.contains(e.target)) {
        containerHTML.remove()
      }
    }
  })

  try {
    // se é ios
    if (!window.navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      console.log('não é ios')
      $('[data-fancybox="images"]').fancybox({
        buttons: ['zoom', 'fullScreen', 'close'],
        thumbs: {
          autoStart: true,
        },
      })
    }
  } catch {
    sentryError.exception('Erro ao inicializar fancybox')
  }

  // Cria a função que será usada como callback do evento 'click'
  function toggleGrupo(elemento, height) {
    const itens = elemento.querySelector('.itens')
    const header = elemento.querySelector('header')

    return (event) => {
      if (elemento.classList.contains('show')) {
        elemento.classList.remove('show')
        itens.style.maxHeight = 0 + 'px'
      } else {
        elemento.classList.add('show')
        itens.style.maxHeight = height + 1000 + 'px'
      }
    }
  }


  // Botão de voltar
  select('.dialog_adicionais .nav-bar').addEventListener('click', function () {
    removeCardapio(scrollTop)
  })

  // Faz a rotina para totalizar o produto, passando como parâmetro 1, que é a quantidade inicial.
  if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
    calculaValorTotalAgrupamentos(false, storeProdutoAtual, storeProdutoAtual.Quantidade)
    select('#qtd-produto').value = storeProdutoAtual.Quantidade
  } else {
    if (grupoPizza) {
      totalizaPizza(grupoPizza, produtoASerEditado ? produtoASerEditado.Quantidade : '1')
    } else {
      totalProduto(produtoASerEditado ? produtoASerEditado.Quantidade : 1)
    }
  }

  // Botão de adicionar
  $('#adicionar-produto').on('click', () => {
    // Pega a quantidade e converte para número
    const quantidade = select('#qtd-produto')
    let quantidadeValor = Number(quantidade.value)

    const produto = store.produtos.find((prod) => prod.IdProd == idProduto)
    if (
      estabelecimento.validaEstoque &&
      produto &&
      produto.ControlaEstoque &&
      produto.SaldoEstoque < quantidadeValor + 1
    ) {
      toast(
        'Desculpe, mas não temos estoque suficiente para atender a quantidade desejada.',
      )
      return
    }
    // Adiciona e atualiza o span que exibe a quantidade
    quantidadeValor += 1
    quantidade.value = quantidadeValor

    if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
      calculaValorTotalAgrupamentos(true, storeProdutoAtual, quantidadeValor)
    } else {
      if (grupoPizza) {
        totalizaPizza(grupoPizza, quantidadeValor)
      } else {
        totalProduto(quantidadeValor)
      }
    }
  })

  // Botão de remover
  $('#remover-produto').on('click', () => {
    // Pega a quantidade e converte para número
    const quantidade = select('#qtd-produto')
    let quantidadeValor = Number(quantidade.value)

    // Remove e atualiza o span que exibe a quantidade
    quantidadeValor = quantidadeValor > 1 ? quantidadeValor - 1 : 1
    quantidade.value = quantidadeValor

    if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
      calculaValorTotalAgrupamentos(false, '', quantidadeValor)
    } else {
      if (grupoPizza) {
        totalizaPizza(grupoPizza, quantidadeValor)
      } else {
        totalProduto(quantidadeValor)
      }
    }
  })

  const buttonAddPedido = select('#add-pedido')
  // Adiciona o efeito ripple ao botão
  ripple(buttonAddPedido)

  if (estabelecimento.pixelFacebook) {
    // Nessa altura o item está sendo visualizado
    if (typeof fbq !== 'undefined') {
      try {
        fbq('track', 'CustomizeProduct')
      } catch (e) {
        Sentry.captureException(e)
      }
    } else {
      Sentry.captureException(
        `O estabelecimento ${estabelecimento.urlEmpresa} usa facebook pixel, mas o facebook SDK não foi carregado.`,
      )
    }
  }

  // Adiciona o item ao pedido;
  buttonAddPedido.addEventListener('click', () => {
    if (estabelecimento.comanda.ativo && estabelecimento.qrCode.ativo) {
      verificaStatusComanda()
        .then((data) => {
          if (estabelecimento.comanda.hash) {
            if (data.liberada) {
              adiciona()
            } else {
              solicitaLiberacaoComanda()
            }
          } else {
            adiciona()
          }
        })
        .catch((error) => {
          toast(
            'Esta comanda não está disponível para pedidos, utilize outra comanda ou solicite a abertura de uma nova comanda.',
          )
        })

      return
    } else {
      adiciona()
    }

    function adiciona() {

      if (estabelecimento.aberto || estabelecimento.qrCode.ativo) {
        if ((grupoPizza && storProduto.Sabores && storProduto.Sabores.length > 0) || !grupoPizza || produtoSelecionado.obrigarEscolhaTodosItens) {
          if (produtoSelecionado.obrigarEscolhaTodosItens && storProduto.produtosAgrupamento) {

            const statusAdicionais = verificaAdicionaisObrigatorios(itensObrigatorios, storAdicionaisPedido)

            if (!statusAdicionais) {
              return
            }
            //Adiciona os adicionais do store no ultimo produto do agrupamento, já que a função para a próxima etapa só é chamada quando um produto anterior ao último é selecionado
            storProduto.produtosAgrupamento[storProduto.produtosAgrupamento.length - 1].Adicionais = [...storAdicionaisPedido.map((item) => { return { ...item, Adicionais: item.adicional } })]

            storAdicionaisPedido = []

            if (storProduto.produtosAgrupamento[0].CodTicksGrupo) {
              const ticks = storProduto.produtosAgrupamento[0].CodTicksGrupo
              storeOrder.Itens = storeOrder.Itens.filter(item => { return item.CodTicksGrupo !== ticks })
            }

            storProduto.produtosAgrupamento[0].CodTicksGrupo = (new Date().getTime())
            const quantidadeProduto = select('#qtd-produto').valueAsNumber

            const lastProduct = storProduto.produtosAgrupamento[storProduto.produtosAgrupamento.length - 1]
            if (lastProduct.IsPizza && lastProduct.Sabores.length == 0) {
              toast('Selecione pelo menos um sabor para a pizza')
              return
            }

            storProduto.produtosAgrupamento.forEach(produto => {
              produto.Quantidade = quantidadeProduto
              produto.CodTicksGrupo = storProduto.produtosAgrupamento[0].CodTicksGrupo
              calculaValorTotalAgrupamentos(false, produto, produto.Quantidade)
              produtoASerEditado = undefined
              adicionaProduto({ ...produto })
            })
          } else {
            adicionaProduto(storProduto)
          }

          function adicionaProduto(storProduto) {

            if (storProduto.IsPizza && storProduto.Sabores.length == 0) {
              toast('Selecione um sabor para a pizza')
              return
            }

            let pedidoCompleto = true
            let grupoTarget

            const pagina = document.querySelector('.dialog_adicionais .pagina')

            const obs = select('#pedido-obs') && select('#pedido-obs').value

            // Busca o produto

            let produto
            if (produtoSelecionado.agrupamento) {
              if (produtoSelecionado.obrigarEscolhaTodosItens) {
                produto = storProduto
              } else {
                produto = getProdutoAgrupamento()
                idProduto = produto.IdProd
              }

            } else {
              let idProduto = pagina.getAttribute('id-produto')
              produto = store.produtos.find((prod) => prod.IdProd == idProduto)
            }

            const btn = select('#qtd-produto')
            let quantidadeDoProduto = 1
            if (btn) {
              quantidadeDoProduto = btn.valueAsNumber
            }

            if (quantidadeDoProduto >= produto.QuantidadeMinima) {

              if (produtoSelecionado.obrigarEscolhaTodosItens) {
                storAdicionaisPedido = [...storProduto.Adicionais]
              }

              if (!produtoSelecionado.obrigarEscolhaTodosItens) {
                const statusAdicionais = verificaAdicionaisObrigatorios(itensObrigatorios, storAdicionaisPedido)
                if (!statusAdicionais) {
                  return
                }

              }

              if (pedidoCompleto) {
                // Se o produto é para edição
                produtoASerEditado && (storProduto = produtoASerEditado)

                storProduto.Adicionais = []
                storAdicionaisPedido.forEach((obj, index) => {
                  storProduto.Adicionais.push({
                    Adicional: obj?.adicional?.Adicional || obj.adicional || obj.Adicional,
                    Quantidade: obj.quantidade,
                    ValorUnitario: obj.preco,
                    ValorTotal: obj.quantidade * obj.preco,
                    idGrupo: obj.idGrupo,
                    nomeGrupo: obj.nomeGrupo,
                  })
                })

                const valorComAdicionais = totalComAdicionais
                let valorTotal = quantidadeDoProduto * valorComAdicionais

                if (produtoSelecionado.obrigarEscolhaTodosItens) {
                  valorTotal = produto.ValorComAdicionais
                }

                if (storProduto.Sabores) {
                  storProduto.Sabores.forEach((sabor) => {
                    if (sabor.Adicionais) {
                      sabor.Adicionais.forEach((adicional) => {
                        valorTotal += calculaValorAdicionalSabor(sabor, adicional, '', quantidadeDoProduto)
                      })
                    }
                  })
                }

                if (produtoASerEditado) {
                  const [prod] = storeOrder.Itens.filter(
                    (item) => item.CodTicks === storProduto.CodTicks,
                  )
                  prod && (storeOrder.valorTotal -= storeOrder.valorTotal)
                  prod &&
                    storeOrder.Itens.splice(storeOrder.Itens.indexOf(prod), 1)
                }

                storProduto.idProduto = produto.IdProd
                storProduto.isAgrupamento = produto.isAgrupamento
                storProduto.Produto_Produto = produto.NomeDelivery
                storProduto.CodProduto = produto.IdProd
                storProduto.Quantidade = quantidadeDoProduto
                storProduto.PrecoDelivery = produto.PrecoDelivery
                storProduto.IsItemFidelidade = false
                storProduto.CodTicksGrupo = produto.CodTicksGrupo

                if (!grupoPizza) {
                } else {
                  storProduto.isPizza = true
                }

                if (
                  !storProduto.isPizza ||
                  (storProduto.isPizza && produto.PrecoDelivery != '0,00')
                ) {
                  storProduto.ValorUnitario = decimalStringToNumber(
                    produto.PrecoDelivery,
                  )
                }

                if (!produtoSelecionado.obrigarEscolhaTodosItens) {
                  storProduto.ValorComAdicionais = valorComAdicionais * quantidadeDoProduto
                }

                storProduto.ValorTotal = valorTotal
                storProduto.ValorAPagar = valorTotal
                storProduto.QuantidadeAPagar = quantidadeDoProduto
                storProduto.Observacao = obs

                if (!produtoASerEditado) {
                  if (storProduto.CodTicks) {
                    storeOrder.Itens = storeOrder.Itens.filter(item => {
                      return item.CodTicks !== storProduto.CodTicks
                    })
                  }
                  else {
                    storProduto.CodTicks = (new Date().getTime() * 10000 + 621355968000000000).toString()
                  }
                }


              } else {
                const target = select(`[container-grupo="${grupoTarget}"]`)
                select('.dialog_adicionais').scrollTo({
                  top: target.offsetTop - select('.nav-bar').offsetHeight - 50, // (-50 => para o foco ficar um pouco acima do grupo)
                  behavior: 'smooth',
                })
                const titulo = target.querySelector('.titulo')
                if (titulo) {
                  const nomeGrupo = titulo.textContent
                  if (nomeGrupo) {
                    toast(nomeGrupo + ' Obrigatório')
                    target.scrollIntoView({ behavior: 'smooth' })
                  } else {
                    toast('Obrigatório')
                  }
                } else {
                  toast('Obrigatório')
                }

                return
              }

              // Oculta a página dos produtos adicionados, caso seja edição.
              const bagPage = select('.page-bag')
              if (bagPage) {
                const arrow = bagPage.querySelector('.app-bar img')
                $(arrow).click()
              }

              // Caso seja uma pizza e personalizaPizzaFideliza for true, significa que é um resgate de pizza pela tela de benefícios do fideliza
              if (storProduto.isPizza && personalizaPizzaFideliza) {
                storProduto.Quantidade = 1
                storProduto.QuantidadeAPagar = 1
                storProduto.ValorAPagar = 0
                storProduto.ValorComAdicionais = 0
                storProduto.ValorTotal = 0
                storProduto.ValorUnitario = 0
                storProduto.ValorUnitarioPizza = 0
                storProduto.IsItemFidelidade = true
              }

              storeOrder.Itens.push({ ...storProduto })

              if (estabelecimento.pixelFacebook) {
                // Adicionou um item no carrinho
                if (typeof fbq !== 'undefined' && fbq) {
                  fbq('track', 'AddToCart')
                } else {
                  Sentry.captureException(
                    `O estabelecimento ${estabelecimento.urlEmpresa} usa facebook pixel, mas o facebook SDK não foi carregado.`,
                  )
                }
              }

              storeOrder.Itens.sort(
                (itemA, itemB) => itemA.CodTicks - itemB.CodTicks,
              )

              storAdicionaisPedido = []

              storProduto = {
                Adicionais: [],
                Sabores: [],
              }

              if (produto.SugestoesProdutosId) {
                const sugestoes = estabelecimento.sugestoesProdutos.find(sugestao => sugestao.Id == produto.SugestoesProdutosId)
                if (sugestoes) {
                  const incluso = storeOrder.Itens.find(itemStore => {
                    if (sugestoes.SugestoesProdutosEstab && sugestoes.SugestoesProdutosEstab.length > 0) {
                      sugestoes.SugestoesProdutosEstab.find(sugestaoEstab => {
                        return sugestaoEstab.Produto.Id == itemStore.idProduto
                      })
                    }
                  })

                  if (!incluso) {
                    exibeSugestoes(sugestoes)
                    return
                  } else {
                    finalizaAdicaoProduto()
                  }
                } else {
                  finalizaAdicaoProduto()
                }
              } else {
                finalizaAdicaoProduto()
              }

              function finalizaAdicaoProduto() {

                storeOrder.valorTotal = 0
                storeOrder.Itens.forEach((item) => {
                  storeOrder.valorTotal += item.ValorTotal

                  if (item.SubAgrupamentoDelivery) {
                    item.SubAgrupamentoDelivery.produtos = []
                  }

                })

                // Se é edição exibe novamente a página dos itens
                produtoASerEditado && showPedido()

                // Fecha a página do item
                $('.dialog_adicionais .nav-bar img').click()

                // Exibe o botão para ver o pedido
                showButtonOrder()

                storage.set(`pedido-mobile-${estabelecimento.urlEmpresa}`, {
                  ...storeOrder,
                  cartao: null,
                })

                personalizaPizzaFideliza = false
              }

              function exibeSugestoes(sugestoes) {
                const quantidades = {};

                // Criar content usando createElement
                const content = createElement('div', {
                  class: 'flex flex-column gap-12 overflow-auto no-select w-100',
                  style: 'max-height: calc(100vh - 312px);'
                });

                const createQuantityControl = (produtoId) => {
                  const wrapper = createElement('div', {
                    class: 'flex flex-between flex-align-center'
                  });

                  const quantityWrapper = createElement('div', {
                    class: 'border border-1 border-rounded flex flex-align-center gap-8 w-100'
                  });


                  // Botão -
                  const btnMenos = createElement('div', {
                    class: 'flex-1 flex flex-center u-p-8'
                  }, `
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H18.75C19.1642 12 19.5 12.3358 19.5 12.75C19.5 13.1642 19.1642 13.5 18.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z" fill="#353535"></path>
                      </svg> 
                 
                    `);



                  // Display de quantidade
                  const quantityDisplay = createElement('span', {
                    class: 'flex-1 flex flex-center u-p-8'
                  }, '0');

                  // Botão +
                  const btnMais = createElement('div', {
                    class: 'flex-1 flex flex-center u-p-8'
                  }, `
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7499 4.5C12.1641 4.5 12.4999 4.83579 12.4999 5.25V11H18.25C18.6642 11 19 11.3358 19 11.75C19 12.1642 18.6642 12.5 18.25 12.5H12.4999V18.25C12.4999 18.6642 12.1641 19 11.7499 19C11.3357 19 10.9999 18.6642 10.9999 18.25V12.5H5.25C4.83579 12.5 4.5 12.1642 4.5 11.75C4.5 11.3358 4.83579 11 5.25 11H10.9999V5.25C10.9999 4.83579 11.3357 4.5 11.7499 4.5Z" fill="#353535"></path>
                    </svg>   
                    `);

                  btnMais.addEventListener('click', () => {
                    alteraQuantidade((quantidades[produtoId] || 0) + 1)
                  });

                  btnMenos.addEventListener('click', () => {
                    alteraQuantidade((quantidades[produtoId] || 0) - 1)
                  });

                  function alteraQuantidade(quantidade) {
                    quantidades[produtoId] = Math.max(0, quantidade);
                    quantityDisplay.textContent = quantidades[produtoId];

                    const btnContinuar = select('.btn-continuar');
                    if (btnContinuar) {
                      if (quantidades[produtoId] == 0) {
                        btnContinuar.textContent = "Continuar"
                      } else {
                        const valorTotal = Object.keys(quantidades).reduce((acc, id) => {
                          const produto = sugestoes.SugestoesProdutosEstab.find(s => s.Produto.Id == id).Produto;
                          return acc + (produto.PrecoDelivery * quantidades[id]);
                        }, 0);

                        btnContinuar.textContent = `Continuar (R$ ${valorTotal.toFixed(2)})`

                      }
                    }
                  }

                  // Montar estrutura
                  quantityWrapper.appendChild(btnMenos);
                  quantityWrapper.appendChild(quantityDisplay);
                  quantityWrapper.appendChild(btnMais);
                  wrapper.appendChild(quantityWrapper);

                  return wrapper;
                };

                sugestoes.SugestoesProdutosEstab.forEach(sugestao => {
                  const produto = sugestao.Produto;
                  const produtoDiv = createElement('div', {
                    class: 'produto-sugestao flex flex-column gap-8'
                  });

                  // Container principal
                  const flexContainer = createElement('div', {
                    class: 'flex flex-align-start gap-12 flex-between'
                  });

                  // Imagem ou placeholder
                  if (produto.PathImagemS3) {
                    const img = createElement('img', {
                      class: 'imagem-produto',
                      src: produto.PathImagemS3,
                      alt: produto.NomeDelivery
                    });
                    flexContainer.appendChild(img);
                  } else {
                    const placeholder = createElement('div', {
                      class: 'imagem-produto placeholder'
                    });
                    flexContainer.appendChild(placeholder);
                  }

                  // Text container
                  const textContainer = createElement('div', {
                    class: 'flex flex-column flex-1'
                  });

                  // Nome do produto
                  const nome = createElement('div', {
                    class: 'font-14 font-500'
                  }, produto.NomeDelivery);

                  // Preço
                  const preco = createElement('span', {
                    class: 'font-14 color-preco'
                  }, `R$ ${produto.PrecoDelivery.toFixed(2)}`);

                  // Montar elementos
                  textContainer.appendChild(nome);
                  textContainer.appendChild(preco);
                  flexContainer.appendChild(textContainer);
                  produtoDiv.appendChild(flexContainer);
                  produtoDiv.appendChild(createQuantityControl(produto.Id));
                  content.appendChild(produtoDiv);
                });

                createMessageBox({
                  title: sugestoes.Pergunta,
                  widthMessageCard: '90%',
                  closeButton: true,
                  closeOnClickOutside: true,
                  class: 'sugestoes-modal z-index-max',
                  content: content,
                  buttons: [
                    {
                      content: 'Continuar',
                      class: 'btn-azul btn-continuar',
                      callback: (wrapper) => {
                        Object.entries(quantidades).forEach(([id, qtd]) => {
                          if (qtd > 0) {
                            const produto = sugestoes.SugestoesProdutosEstab
                              .find(s => s.Produto.Id == id).Produto;

                            const produtoParaAdicionar = {
                              ...produto,
                              Quantidade: qtd,
                              Adicionais: [],
                              ValorUnitario: produto.PrecoDelivery,
                              ValorTotal: produto.PrecoDelivery * qtd,
                              Observacao: '',
                              CodTicks: (new Date().getTime() + produto.Id * 10000 + 621355968000000000).toString(),
                              CodProduto: produto.Id,
                              idProduto: produto.Id,
                              Produto_Produto: produto.NomeDelivery,
                              PrecoDelivery: produto.PrecoDelivery.toFixed(2),
                              IsItemFidelidade: false,
                              ValorComAdicionais: produto.PrecoDelivery * qtd,
                              ValorAPagar: produto.PrecoDelivery * qtd,
                              QuantidadeAPagar: qtd,

                            };

                            storeOrder.Itens.push({ ...produtoParaAdicionar });
                          }
                        });
                        wrapper.remove();
                        finalizaAdicaoProduto();
                      }
                    }
                  ],
                });
              }

            } else {
              toast(
                'A quantidade mínima para este produto é de ' +
                produto.QuantidadeMinima +
                ' itens',
              )
            }


          }


        } else {
          toast('Selecione pelo menos um sabor')
          select('.adicional-img-container').scrollIntoView({
            top: 0,
            behavior: 'smooth',
          })
        }
      } else {
        showMessageBox({
          icon: 'warning',
          message: 'O estabelecimento está fora do horário de atendimento',
          classList: 'no-icon-background small',
          default: true,
        })
      }
    }

    savesInteraction(3)
  })

  // Seleciona todos os itens
  if (grupoPizza) {
    criaEventosSaboresPizza(grupoPizza)
  }

  function criaEventosAdicionais(produtoAdicionais) {
    const adicionaisNode = selectAll('.dialog_adicionais .item-adicional')
    if (adicionaisNode) {
      adicionaisNode.forEach((adc) => {
        // Se utiliza quantidade
        const utilizaQuantidade = adc.getAttribute('qtd')
        if (utilizaQuantidade) {
          const botaoAdicao = adc.querySelector('.btn-adicao')
          const botaoSubtracao = adc.querySelector('.btn-subtracao')

          $(botaoAdicao).on('click', () => {
            let adicionado = false
            // Id do grupo do adicional
            const idGrupo = Number(adc.getAttribute('id-grupo'))
            const idAdicional = adc.getAttribute('id-adicional')

            for (const property in produtoAdicionais) {
              produtoAdicionais[property].forEach((grupoAdicionais) => {
                if (grupoAdicionais.id == idGrupo && !adicionado) {
                  let count = 0
                  storAdicionaisPedido.forEach((storeAdicional) => {
                    if (storeAdicional.idGrupo == idGrupo) {
                      count += storeAdicional.quantidade

                    }
                  })

                  if (count < grupoAdicionais.max || grupoAdicionais.max == 0) {
                    const adicionaItem = () => {
                      grupoAdicionais.itens.forEach((itemAdc) => {
                        if (!adicionado && itemAdc.Adicional.Id == idAdicional) {

                          if (grupoAdicionais.ConsiderarAdicionalComValorMaior) {

                            const adicionalComValorMaior = storAdicionaisPedido.find(item => item.idGrupo == idGrupo && item.preco > itemAdc.Preco)
                            if (adicionalComValorMaior) {
                              storAdicionaisPedido.push({
                                id: idAdicional,
                                idGrupo,
                                adicional: itemAdc,
                                preco: 0,
                                quantidade: 1,
                                nomeGrupo: grupoAdicionais.descricao,
                              })
                            } else {
                              //zera o valor de todos os adicionais do grupo
                              storAdicionaisPedido.forEach(item => {
                                if (item.idGrupo == idGrupo) {
                                  item.preco = 0
                                }
                              })

                              storAdicionaisPedido.push({
                                id: idAdicional,
                                idGrupo,
                                adicional: itemAdc,
                                preco: itemAdc.Preco,
                                quantidade: 1,
                                nomeGrupo: grupoAdicionais.descricao,
                              })
                            }


                          } else {
                            storAdicionaisPedido.push({
                              id: idAdicional,
                              idGrupo,
                              adicional: itemAdc,
                              preco: itemAdc.Preco,
                              quantidade: 1,
                              nomeGrupo: grupoAdicionais.descricao,
                            })
                          }


                          adicionado = true

                          const qtd = select('#qtd-produto')
                          const qtdValue = Number(qtd.value)
                          if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
                            calculaValorTotalAgrupamentos(true, '', qtdValue)
                          } else {
                            if (grupoPizza) {
                              totalizaPizza(grupoPizza, qtdValue)
                            } else {
                              totalProduto(qtdValue)
                            }
                          }

                          const quantidadeItens = adc.querySelector('.qtd-value')
                          const quantidade = Number(quantidadeItens.textContent)
                          quantidadeItens.textContent = quantidade + 1
                        }
                      })
                    }

                    let found = false
                    if (storAdicionaisPedido.length > 0) {
                      // storAdicionaisPedido.find(item => {
                      //    item.id === idAdicional && item.idGrupo === idGrupo;
                      // });
                      storAdicionaisPedido.forEach((item, index) => {
                        if (item.id == idAdicional && item.idGrupo == idGrupo && !found) {
                          found = true
                          item.quantidade++
                          item.Quantidade = item.quantidade

                          const qtd = select('#qtd-produto')
                          const qtdValue = Number(qtd.value)

                          if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {

                          } else {
                            if (grupoPizza) {
                              totalizaPizza(grupoPizza, qtdValue)
                            } else {
                              totalProduto(qtdValue)
                            }
                          }

                          const quantidadeItens = adc.querySelector('.qtd-value')
                          const quantidade = Number(quantidadeItens.textContent)
                          quantidadeItens.textContent = quantidade + 1
                        } else if (
                          index + 1 == storAdicionaisPedido.length &&
                          !found
                        ) {
                          adicionaItem()
                        }
                      })
                    } else {
                      adicionaItem()
                    }
                  } else {
                    toast('Quantidade máxima atingida')
                  }
                }
              })
            }

            if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
              const quantidadeItens = adc.querySelector('.qtd-value')
              const quantidade = Number(quantidadeItens.textContent)
              calculaValorTotalAgrupamentos(true, '', quantidade)
            }
          })

          $(botaoSubtracao).on('click', () => {
            // Id do grupo do adicional
            const idGrupo = Number(adc.getAttribute('id-grupo'))
            const idAdicional = adc.getAttribute('id-adicional')
            const quantidadeItens = adc.querySelector('.qtd-value')
            const quantidade = Number(quantidadeItens.textContent)

            if (quantidade > 0) {
              storAdicionaisPedido.forEach((item, index) => {
                const idItem = item.id ? item.id : item.Adicional.Id
                if (idItem == idAdicional && item.idGrupo == idGrupo) {
                  item.quantidade -= 1
                  item.Quantidade = item.quantidade
                  quantidadeItens.textContent = item.quantidade

                  if (item.quantidade == 0) {
                    storAdicionaisPedido.splice(index, 1)
                  }

                  const qtd = select('#qtd-produto')
                  const qtdValue = Number(qtd.value)

                  //verifica se considera o adicional com valor maior 
                  let grupoAdicionais
                  for (const property in produtoAdicionais) {
                    produtoAdicionais[property].forEach((grupo) => {
                      if (grupo.id == idGrupo) {
                        grupoAdicionais = grupo
                      }
                    })
                  }

                  if (grupoAdicionais && grupoAdicionais.ConsiderarAdicionalComValorMaior) {
                    let adicionalDeMaiorValor
                    grupoAdicionais.itens.forEach(itemAdc => {
                      const adicionalIncluso = storAdicionaisPedido.find(item => item.id == itemAdc.Adicional.Id)
                      if (adicionalIncluso) {
                        if (!adicionalDeMaiorValor) {
                          adicionalDeMaiorValor = adicionalIncluso
                          adicionalDeMaiorValor.preco = itemAdc.Preco
                        } else {
                          if (itemAdc.Preco > adicionalDeMaiorValor.preco) {
                            adicionalDeMaiorValor = adicionalIncluso
                            adicionalDeMaiorValor.preco = itemAdc.Preco
                          }
                        }
                      }
                    })

                    if (adicionalDeMaiorValor) {
                      storAdicionaisPedido.forEach(item => {
                        //Se não for o adicional de maior valor, zera o valor
                        if (item.id != adicionalDeMaiorValor.id) {
                          item.preco = 0
                        }
                      })
                    }
                  }


                  if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {

                  } else {
                    if (grupoPizza) {
                      if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
                        calculaValorTotalAgrupamentos(false, storeProdutoAtual, qtdValue)
                      } else {
                        totalizaPizza(grupoPizza, qtdValue)
                      }

                    } else {
                      totalProduto(qtdValue)
                    }
                  }
                }
              })
            }

            if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {

              calculaValorTotalAgrupamentos(false, storeProdutoAtual, quantidade)
            }
          })
        } else {
          adc.addEventListener('click', (e) => {
            prevent(e)
            let adicionais = { ...produtoAdicionais }
            if (e.currentTarget.classList.contains('item-agrupamento')) {


              const selecionado = select('[name="produto-agrupamento"]:checked')
              const idProduto = selecionado.dataset.idProduto

              const idAtual = e.currentTarget.getAttribute('for')
              const inputAtual = select('#' + idAtual)
              const idProdutoAtual = inputAtual.dataset.idProduto


              if (!window.storeAdicionaisAgrupamento[idProduto]) {
                window.storeAdicionaisAgrupamento[idProduto] = [...storAdicionaisPedido]
                storAdicionaisPedido = window.storeAdicionaisAgrupamento[idProdutoAtual] || []
              }

              const input = select('#' + e.currentTarget.getAttribute('for'))
              input.checked = true
              totalProduto(select('#qtd-produto').value)

              const button = select('#btn-proximo-passo')
              if (button) {
                button.style.display = ''
              }
              const container = select('#adicional-container', containerHTML)
              if (container && button) {
                container.parentElement.classList.add('adicionais-ocultos')
              }
              return
            }

            let produtoAgrupamentoSelecionado = select('[name="produto-agrupamento"]:checked')
            if (produtoAgrupamentoSelecionado) {
              const idProduto = produtoAgrupamentoSelecionado.dataset.idProduto
              function removerDuplicadosPriorizandoIdProduto(array) {
                return Object.values(array.reduce((acc, item) => {
                  if (!acc[item.id] || (item.idProduto && !acc[item.id].idProduto)) {
                    acc[item.id] = item;
                  }
                  return acc;
                }, {}));
              }

              let outros = removerDuplicadosPriorizandoIdProduto(
                adicionais.outros.filter(item => item.idProduto == idProduto || item.idProduto == undefined)
              );

              let radio = removerDuplicadosPriorizandoIdProduto(
                adicionais.radio.filter(item => item.idProduto == idProduto || item.idProduto == undefined)
              );
              adicionais = { outros, radio }
            }

            adcState(adc, grupoPizza, adicionais, produtoSelecionado, getCurrentStore())
            e.preventDefault()
          })
        }
      })
    }

  }

  function getCurrentStore() {
    if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
      return storeProdutoAtual
    } else {
      return storProduto
    }
  }
  function criaEventosSaboresPizza(grupoPizza) {


    // Verifica se tem pizza para adicionar os eventos de exibir e ocultar os sabores

    // Cria o evendo que detecta o scroll da página para fixar o título do grupo pizza no topo da tela
    const container = select('#adicional-container', containerHTML)
    criaScrollPizza(container)

    const gruposPizza = selectAll(
      '.dialog_adicionais .grupo-sabor, [adicional-pizza]',
    )

    gruposPizza.forEach((grupo) => {
      const height = elementHeigth(grupo.querySelector('.itens')) + 10
      const header = grupo.querySelector('header')
      header.addEventListener('click', toggleGrupo(grupo, height))
    })


    const grupoSabor = selectAll('.dialog_adicionais .grupo-sabor')
    const limiteSabores = grupoPizza.pizza.LimiteSabores

    grupoSabor.forEach((item) => {
      item.querySelectorAll('.item-adicional').forEach((sabor) => {
        const btnRemover = sabor.querySelector('.btn-subtracao')
        const btnAdicionar = sabor.querySelector('.btn-adicao')
        const quantidadeElemento = sabor.querySelector('.qtd-value')
        const CodSabor = sabor.getAttribute('cod-sabor')
        const codGrupoSabor = sabor.getAttribute('cod-grupo-sabor')

        btnRemover.addEventListener('click', () => {
          removeSabor(getCurrentStore())
        })

        btnAdicionar.addEventListener('click', () => {
          adicionaSabor(getCurrentStore())
        })

        function adicionaSabor(storProduto) {
          const quantidade = Number(quantidadeElemento.textContent)

          if (!storProduto.Sabores) {
            storProduto.Sabores = []
          }
          let quantidadeSabores = 0
          storProduto.Sabores.forEach((itemSabor) => {
            quantidadeSabores += itemSabor.Quantidade
          })

          if (quantidadeSabores < limiteSabores) {
            const itemSabor = storProduto.Sabores.find(
              (item) =>
                item.CodSabor == CodSabor &&
                item.CodGrupoSabor == codGrupoSabor,
            )

            const grupoSabor = grupoPizza.sabores.find(
              (sabor) => sabor.Id == codGrupoSabor,
            )
            const objetoSabor = grupoSabor.itens.find(
              (sabor) => sabor.Sabor_Id == CodSabor,
            )

            const idPizza = grupoPizza.idProduto

            if (!itemSabor && grupoPizza.pizza.UtilizaAdicionalSabor) {
              sabor.appendChild(loaderSabor())
              exibeAdicionaisSabores(objetoSabor, idPizza, adicionaSabor)
            } else {
              adicionaSabor()
            }

            function adicionaSabor(adicionaisSabor = []) {
              if (itemSabor) {
                itemSabor.Quantidade += 1
                quantidadeElemento.textContent = quantidade + 1
              } else {
                storProduto.Sabores.push({
                  CodSabor,
                  CodGrupoSabor: objetoSabor.CodGrupoSabor,
                  Quantidade: 1,
                  Valor: objetoSabor.Preco,
                  Descricao: objetoSabor.Sabor_Descricao,
                  IdSlave: objetoSabor.IdSlave,
                  Adicionais: adicionaisSabor,
                  idPizza,
                })

                quantidadeElemento.textContent = quantidade + 1
                !sabor.classList.contains('item-adicionado') &&
                  sabor.classList.add('item-adicionado')
              }

              const btn = select('#qtd-produto')
              let quantidadeValor = 1
              if (btn) {
                quantidadeValor = btn.valueAsNumber
              }

              if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
                const quantidade = select('#qtd-produto').valueAsNumber
                calculaValorTotalAgrupamentos(false, storeProdutoAtual, quantidade)
              } else {
                const valor = totalizaPizza(grupoPizza, quantidadeValor, getCurrentStore())
                select('#total-button').textContent = format.money(valor.toFixed(2)).replace('.', ',')
              }
            }
          } else {
            toast('Limite de sabores atingido')
          }
        }

        function removeSabor(storProduto) {
          let quantidade = Number(quantidadeElemento.textContent)
          if (quantidade > 0) {
            if (storProduto.Sabores) {
              storProduto.Sabores.forEach((itemSabor, index) => {
                if (
                  itemSabor.CodSabor == CodSabor &&
                  itemSabor.CodGrupoSabor == codGrupoSabor
                ) {
                  if (itemSabor.Quantidade == 1) {
                    storProduto.Sabores.splice(index, 1)
                  } else {
                    itemSabor.Quantidade -= 1
                  }
                  quantidade -= 1
                  quantidadeElemento.textContent = quantidade
                  quantidade == 0 && sabor.classList.remove('item-adicionado')
                }
              })
            }
          }

          const btn = select('#qtd-produto')
          let quantidadeValor = 1
          if (btn) {
            quantidadeValor = btn.valueAsNumber
          }

          if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
            calculaValorTotalAgrupamentos(false, storeProdutoAtual, quantidadeValor)
          } else {
            totalizaPizza(grupoPizza, quantidadeValor, getCurrentStore())
          }
        }
      })
    })
  }

  if (produtoSelecionado.produtos) {
    const produtosAgrupadosNODES = selectAll('[name="produto-agrupamento"]')
    if (produtosAgrupadosNODES) {
      produtosAgrupadosNODES.forEach((item) => {
        item.addEventListener('change', () => {
          if (item.checked) {
            const quantidade = select('#qtd-produto')
            totalProduto(quantidade.value)
          }
        })
      })
    }

    if (produtoASerEditado) {
      const inputProduto = select(
        `.dialog_adicionais [data-id-produto="${produtoASerEditado.idProduto}"]`,
      )
      if (inputProduto) {
        inputProduto.checked = true
        inputProduto.dispatchEvent(new Event('change'))
      }
    }
  }

  function criaScrollPizza(container) {
    container.addEventListener('scroll', (e) => {


      const headers = selectAll('.grupo-adicionais header', container)

      headers.forEach((header) => {
        if (header.parentElement.getBoundingClientRect().top < 0) {
          header.classList.add('fixed-title')
        } else {
          header.classList.remove('fixed-title')
        }
      })
    })
  }

  function verificaAdicionaisObrigatorios(itensObrigatorios, storAdicionaisPedido) {

    let pedidoCompleto = true
    const gruposVisiveis = selectAll('.dialog_adicionais .grupo-adicionais', '', true)
      .filter((grupo) => {
        return grupo.style.display != 'none'
      })
      .map((grupo) => {
        const grupoItem = grupo.getAttribute('container-grupo')
        if (grupoItem) {
          return Number(grupoItem)
        }
      })


    let adcFoco = undefined

    itensObrigatorios.forEach((item) => {
      if (pedidoCompleto && !edited) {
        let quantidade = 0
        storAdicionaisPedido.forEach((adicional) => {
          if (adicional.idGrupo == item.idGrupo) {
            quantidade += adicional.quantidade
          }
        })

        if (quantidade < item.min) {
          if (
            gruposVisiveis.length > 0 &&
            gruposVisiveis.includes(item.idGrupo)
          ) {
            pedidoCompleto = false
            adcFoco = item
          }
        }
      }
    })

    for (const adc of itensObrigatorios) {
      if (pedidoCompleto && !edited && adc.QtdMinima > 0) {
        const adicionalEncontrado = storAdicionaisPedido.find(
          (adicional) =>
            adicional.idGrupo === adc.idGrupo &&
            adicional.adicional.Adicional.Id === adc.Adicional.Id &&
            adicional.quantidade >= adc.QtdMinima,
        )

        if (!adicionalEncontrado) {
          adcFoco = adc
          pedidoCompleto = false
        }

      }
    }

    if (!pedidoCompleto && adcFoco) {
      const target = select(`[container-grupo="${adcFoco.idGrupo}"]`)
      target.scrollIntoView({ behavior: 'smooth' })
      const titulo = target.querySelector('.titulo')

      toast('Você precisa pelo menos ' + adcFoco.min + ' ' + titulo.textContent)
    }

    return pedidoCompleto
  }
  function criaHTMLPizza(grupoPizza, produtoASerEditado) {
    let saboresPizzaHTML = ''
    if (grupoPizza) {
      grupoPizza.sabores.forEach((grupoSabor) => {
        let saboresHTML = ''
        grupoSabor.itens.forEach((sabor) => {
          const saborEdicao =
            produtoASerEditado && (getCurrentStore()).Sabores.length > 0
              ? (getCurrentStore()).Sabores.find(
                (itemSabor) =>
                  sabor.CodGrupoSabor == itemSabor.CodGrupoSabor &&
                  sabor.Sabor_Id == itemSabor.CodSabor,
              )
              : undefined

          const itensComposicao = storeDadosItemPedido.saboresComp.filter(
            (item) => item.CodSabor === sabor.Sabor_Id,
          )

          const composicao = itensComposicao
            ? itensComposicao
              .map(
                (item, index) =>
                  item.Descricao +
                  (index + 1 === itensComposicao.length ? '.' : ', '),
              )
              .join('')
            : ''

          const imagemSabor = sabor.PathImagemS3 ? `<img 
            
            style="min-width: 52px;
    min-height: 52px;
    width: 52px;
    height: 52px;
    border-radius: 4px;
    object-fit: cover;
    margin-right: 12px;"
            src="${sabor.PathImagemS3}" alt="${sabor.Sabor_Descricao}" class="imagem-sabor">` : ''

          saboresHTML += `    
                         <div class="item-adicional" cod-grupo-sabor="${sabor.CodGrupoSabor}" cod-sabor="${sabor.Sabor_Id}" sabor-pizza>
                          ${imagemSabor}   
                         <div class="flex-between w-100">
                                <div class="flex-column">
                                    <div class="font-14 font-weight-500 font-dark">${sabor.Sabor_Descricao.toLowerCase().trim().capitalizeFirstLetter()}</div>
                                    <div class="preco">${grupoPizza.pizza.PrecoDelivery > 0 ? '' : sabor.Preco > 0 ? format.money(sabor.Preco) : ''}</div>
                                    ${sabor.DescricaoDoSabor ? `  <div class="font-12 font-gray">${sabor.DescricaoDoSabor}</div>` : ''}
                                    <div class="font-12 font-gray">${composicao}</div>
                                </div>
                                <div class="u-flex-center border-1 border-rounded">
                                    <div class="btn-subtracao btn-ripple u-p-8">
                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.25 5.75H0.75C0.335786 5.75 0 6.08579 0 6.5C0 6.91421 0.335786 7.25 0.75 7.25H11.25C11.6642 7.25 12 6.91421 12 6.5C12 6.08579 11.6642 5.75 11.25 5.75Z" fill="#282828"/>
                                        </svg>
                                    </div>
                                    <span class="qtd-value">${saborEdicao ? saborEdicao.Quantidade : 0}</span>
                                    <div class="btn-adicao btn-ripple u-p-8">
                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 5.75H11.25C11.6642 5.75 12 6.08579 12 6.5C12 6.91422 11.6642 7.25 11.25 7.25H6.75V11.75C6.75 12.1642 6.41422 12.5 6 12.5C5.58579 12.5 5.25 12.1642 5.25 11.75V7.25H0.75C0.335786 7.25 0 6.91422 0 6.5C0 6.08579 0.335786 5.75 0.75 5.75H5.25V1.25C5.25 0.835786 5.58579 0.5 6 0.5C6.41422 0.5 6.75 0.835786 6.75 1.25V5.75Z" fill="#282828"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>                    
                        </div>`
        })

        saboresPizzaHTML += `
                <div class="grupo-adicionais grupo-sabor show">
                    <header>
                        <div class="font-title-dark">${grupoSabor.descricao}</div>
                        <div class="flex">
                            <div class="maximo"></div>
                            <div class="flex-center font-12 font-gray gap-4"> 
                                <div>sabores</div>
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 6.2916L6.79565 3.99593C6.9911 3.80048 7.308 3.80048 7.5034 3.99593C7.69885 4.19137 7.69885 4.50825 7.5034 4.70369L4.35356 7.85355C4.15829 8.0488 3.84171 8.0488 3.64645 7.85355L0.496588 4.70369C0.301145 4.50825 0.301145 4.19137 0.496588 3.99593C0.69203 3.80048 1.0089 3.80048 1.20435 3.99593L3.5 6.2916V0.5C3.5 0.223857 3.72386 0 4 0C4.27615 0 4.5 0.223857 4.5 0.5V6.2916Z" fill="currentColor"/>
                                </svg>
                            </div>
                        </div>
                    </header>
                    <div class="itens">
                        ${saboresHTML}
                    </div>
                </div>
                <div class="divider"></div>
                `
      })
    }

    return saboresPizzaHTML
  }

  function criaHTMLAgrupamento() {
    let HTMLAgrupamento = ''

    if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {

      let HTMLSteps = ''
      produtoSelecionado.produtos.forEach((item, index) => {

        const currentStep = index === produtoAgrupamentoAtual ? 'current-step' : ''
        const stepClass = (index <= quantidadeDeProdutosJaSelecionados) ? currentStep : 'opacity-03'

        HTMLSteps += `
        <div class="step relative flex-1" data-step="${index}">
            <div class="flex-center label-button nowrap ${stepClass}">
                <div class="step-title text-elipsis">${item.NomeDelivery}</div>
            </div>
        </div>`

      })

      const item = produtoSelecionado.produtos[produtoAgrupamentoAtual]
      let img = ''
      // Se tem imagem no produto
      if (item.PathImagemS3) {
        img = `<img class="img-product border-rounded" src="${item.PathImagemS3}" alt="produto">`
      }

      let HTMLPreco = ""
      const precoDecimal = decimalStringToNumber(item.PrecoDelivery)
      if (item.Intervalo && decimalStringToNumber(item.PrecoPromocional) > 0) {
        HTMLPreco = `
        <div class="produto-info-preco-promocional" style="display: flex; gap: 6px;">
           <span class="produto-info-preco-antigo"style="font-size: 1.2rem; font-weight: 500; color: red; text-decoration: line-through;">${format.money(precoDecimal)}</span>
           <span class="produto-info-preco-novo" style="font-size: 1.2rem; font-weight: 500; color: #0e8226;">${format.money(decimalStringToNumber(item.PrecoPromocional))}</span>
        </div>
        `
      } else {
        HTMLPreco = `<div class="font-green font-weight-500">${precoDecimal > 0 ? format.money(precoDecimal) : ''}</div>`
      }


      const HTMLProdutoAtual = `
          <div class="u-flex gap-16">
          ${img}
          <div class="produto-info u-flex flex-column">
            <div class="font-16 font-weight-500">${item.NomeDelivery}</div>
            <div class="produto-info-ingredientes text-gray-500">${item.DescricaoDelivery}</div>
            ${HTMLPreco}         
           </div>
          </div>
          `



      HTMLAgrupamento = `
          <div>
            <div class="u-flex m-12-0 overflow-auto flex-start gap-8 hidden-scroll">
              ${HTMLSteps}
            </div>
            ${HTMLProdutoAtual}
          </div>
          `

    } else {
      HTMLAgrupamento = produtoSelecionado.produtos
        ? produtoSelecionado.produtos
          .map((item, index) => {
            const preco = item.PrecoDelivery
              ? `<div class="preco font-500 font-13 font-green">R$ ${item.PrecoDelivery}</div>`
              : ''
            const imagem = item.PathImagemS3
              ? `<img src="${item.PathImagemS3}" alt="${item.NomeDelivery}"/>`
              : ''
            return `
        <input id="pd-a-${item.IdProd}" class="oculto" type="radio" name="produto-agrupamento" data-id-produto="${item.IdProd}" ${index === 0 ? 'checked' : ''}>         
        <label for="pd-a-${item.IdProd}" class="item-adicional item-agrupamento flex">
            <div class="flex-between w-100"> 
                <div class="flex-column">
                    <div class="descricao">${item.NomeDelivery}</div> 
                    <div class="ingredientes">${item.DescricaoDelivery || ''}</div>
                    ${preco}
                </div>
                ${imagem}   
            </div>
        </label>`
          })
          .join('')
        : ''
    }

    return HTMLAgrupamento
  }

  function criaEventosStepsAgrupamento() {
    const steps = selectAll('.step', containerHTML)
    steps.forEach((step, index) => {
      step.addEventListener('click', (event) => {

        prevent(event)

        if (index <= quantidadeDeProdutosJaSelecionados) {

          if (produtoAtual.IsPizza && storeProdutoAtual.Sabores.length == 0) {
            toast('Selecione pelo menos um sabor')
            return
          }

          const button = select('#btn-proximo-passo')
          if (index == quantidadeDeProdutosJaSelecionados) {
            button.style.display = 'none'
          } else {
            button.style.display = ''
            button.firstElementChild.textContent = 'Próximo passo'
          }


          //Grava os adicionais do produto atual
          storProduto.produtosAgrupamento[produtoAgrupamentoAtual].Adicionais = [...storAdicionaisPedido.map((item) => { return { ...item, Adicionais: item.adicional } })]


          produtoAgrupamentoAtual = index

          //Se o produto atual já foi selecionado, carrega os adicionais do produto
          storAdicionaisPedido = [...(storProduto.produtosAgrupamento[produtoAgrupamentoAtual].Adicionais) || []]

          produtoAtual = produtoSelecionado.produtos[produtoAgrupamentoAtual]

          storeProdutoAtual = storProduto.produtosAgrupamento[produtoAgrupamentoAtual]

          atualizaPassoAtualAgrupamento()
        }
      })
    })

    //Foca no passo atual
    const currentStep = select('.current-step', containerHTML)
    if (currentStep) {
      const containerRect = containerHTML.getBoundingClientRect()
      const stepRect = currentStep.getBoundingClientRect()
      const containerCenter = containerRect.left + containerRect.width / 2
      const stepCenter = stepRect.left + stepRect.width / 2

      let scrollBehavior = { behavior: 'smooth', block: 'center' }

      if (stepCenter < containerCenter) {
        // Step is left of center, scroll to show more right-side items
        scrollBehavior.block = 'start'
      } else {
        // Step is right of center, scroll to show more left-side items
        scrollBehavior.block = 'end'
      }

      currentStep.scrollIntoView(scrollBehavior)
    }
  }

  //Usado para criar os itens adicionais
  //produtoAdicionais --> produtoAdicionais

  //Se o produto é edição
  //produtoASerEditado

  //Armazena em cache os itens adicionais do produto
  //storProduto
  //storAdicionaisPedido
  function criaTemplatesAdicionais(produtoAdicionais, produtoASerEditado) {

    // if(!produtoASerEditado && produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens){
    //   produtoASerEditado = {...storeProdutoAtual}
    // }

    let HTMLAdicionais = ''

    itensObrigatorios = []
    produtoAdicionais.radio.forEach((grupo) => {
      itensObrigatorios.push({
        idGrupo: grupo.id,
        min: grupo.min,
        max: grupo.max,
        itens: grupo.itens,
      })

      grupo.itens.forEach((it) => {
        it.idGrupo = grupo.id
      })

      let radioitensHTML = ''
      grupo.itens.forEach((item, index) => {
        let adcToEdit
        if (produtoASerEditado) {
          adcToEdit = produtoASerEditado.Adicionais.filter((itemToEdit) => {

            if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
              return (
                itemToEdit.idGrupo == grupo.id &&
                (itemToEdit.id || itemToEdit.Adicional.Id) == item.Adicional.Id
              )
            } else {
              return (
                itemToEdit.idGrupo === grupo.id &&
                itemToEdit.Adicional.Id === item.Adicional.Id
              )
            }

          })[0]
        }

        if (adcToEdit && !(produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens)) {
          const has = getCurrentStore().Adicionais.find((item) => {
            return item.Adicional.Id === adcToEdit.Adicional.Id
          })
          if (!has) {
            getCurrentStore().Adicionais.push({
              Adicional: adcToEdit.Adicional,
              Quantidade: adcToEdit.Quantidade,
              ValorUnitario: adcToEdit.ValorUnitario,
              ValorTotal: adcToEdit.ValorTotal,
              idGrupo: adcToEdit.idGrupo,
              nomeGrupo: adcToEdit.nomeGrupo,
            })
          }

          const has2 = storAdicionaisPedido.find((item) => {
            return item.id === adcToEdit.Adicional.Id
          })

          if (!has2) {
            storAdicionaisPedido.push({
              id: adcToEdit.Adicional.Id,
              idGrupo: adcToEdit.idGrupo,
              adicional: adcToEdit.Adicional,
              preco: adcToEdit.ValorUnitario,
              quantidade: adcToEdit.Quantidade,
              nomeGrupo: adcToEdit.nomeGrupo,
            })
          }
        }

        const forId = 'rd-' + random()
        radioitensHTML += `
                  <label class="item-adicional" id-adicional="${item.Adicional.Id}" id-grupo="${grupo.id}" for="${forId}" >
                      <div class="flex-between w-100"> 
                          <div class="flex-column">
                              <div class="descricao">${item.Adicional.Descricao.trim().toLowerCase().capitalizeFirstLetter()}</div> 
                              <div class="preco" ${item.Preco == 0 ? "style='display: none'" : ''}>${format.money(item.Preco)}</div>
                          </div>    
                          <input type="radio"  name="group-${grupo.id}" id="${forId}" ${adcToEdit ? 'checked' : ''}>
                          <label  for="${forId}"></label>
                          </div>
                  </label>`
      })

      HTMLAdicionais += /* html */ `
               <div 
               class="grupo-adicionais show"
               ${grupoPizza ? 'adicional-pizza' : ''} 
               container-grupo="${grupo.id}" 
               style="order: ${grupo.ordem}" 
               ${grupo.idProduto ? `data-id-produto="${grupo.idProduto}"` : ''}
               >
                  <header>
                      <div class="titulo">${grupo.descricao}</div>
                      <div>
                          <div class="maximo flex-center font-12 font-gray gap-4">${grupo.max > 0 ? 'Selecione até ' + grupo.max : ''}   
                          <svg ${!grupoPizza ? 'style="display:none"' : ''} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 6.2916L6.79565 3.99593C6.9911 3.80048 7.308 3.80048 7.5034 3.99593C7.69885 4.19137 7.69885 4.50825 7.5034 4.70369L4.35356 7.85355C4.15829 8.0488 3.84171 8.0488 3.64645 7.85355L0.496588 4.70369C0.301145 4.50825 0.301145 4.19137 0.496588 3.99593C0.69203 3.80048 1.0089 3.80048 1.20435 3.99593L3.5 6.2916V0.5C3.5 0.223857 3.72386 0 4 0C4.27615 0 4.5 0.223857 4.5 0.5V6.2916Z" fill="currentColor"></path>
                          </svg>                   
                          </div>
                      </div>
                  </header>
                  ${grupo.ConsiderarAdicionalComValorMaior ? `<div class="alert font-12">No total, apenas o adicional de maior valor será calculado.</div>` : ''}
                  <div class="itens">
                      ${radioitensHTML}
                  </div>
               </div>`
    })

    produtoAdicionais.outros.forEach((grupo) => {
      let adicionaisHTML = ''

      grupo.itens.forEach((it) => {
        it.idGrupo = grupo.id
      })

      if (grupo.min > 0) {
        itensObrigatorios.push({
          idGrupo: grupo.id,
          min: grupo.min,
        })
      }

      grupo.itens.forEach((item) => {
        let adcToEdit
        if (produtoASerEditado) {
          adcToEdit = produtoASerEditado.Adicionais.filter((itemToEdit) => {
            if (produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
              return (
                itemToEdit.idGrupo == grupo.id &&
                (itemToEdit.id || itemToEdit.Adicional.Id) == item.Adicional.Id
              )
            } else {
              return (
                itemToEdit.idGrupo === grupo.id &&
                itemToEdit.Adicional.Id === item.Adicional.Id
              )
            }
          })[0]
        }

        if (adcToEdit && !(produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens)) {
          const has = getCurrentStore().Adicionais.find((item) => {
            return item.Adicional.Id === adcToEdit.Adicional.Id
          })
          if (!has) {
            getCurrentStore().Adicionais.push({
              Adicional: adcToEdit.Adicional,
              Quantidade: adcToEdit.Quantidade,
              ValorUnitario: adcToEdit.ValorUnitario,
              ValorTotal: adcToEdit.ValorTotal,
              idGrupo: adcToEdit.idGrupo,
              nomeGrupo: adcToEdit.nomeGrupo,
            })
          }

          const has2 = storAdicionaisPedido.find((item) => {
            return item.id === adcToEdit.Adicional.Id
          })

          if (!has2) {
            storAdicionaisPedido.push({
              id: adcToEdit.Adicional.Id,
              idGrupo: adcToEdit.idGrupo,
              adicional: adcToEdit.Adicional,
              preco: adcToEdit.ValorUnitario,
              quantidade: adcToEdit.Quantidade,
              nomeGrupo: adcToEdit.nomeGrupo,
            })
          }
        }
        if (item.Adicional.UtilizaQuantidade) {
          adicionaisHTML += /* html */ `
                  <div class="item-adicional u-flex-center" id-adicional="${item.Adicional.Id
            }" id-grupo="${grupo.id}" qtd="true">
                      <div class="flex-column">
                          <div class="font-13 font-weight-500 font-color-primary">${item.Adicional.Descricao.trim()
              .toLowerCase()
              .capitalizeFirstLetter()}</div>
                          <div class="preco">${item.Preco > 0 ? format.money(item.Preco) : ''
            }</div>
                      </div>
                      <div class="u-flex-center">
                          <div class="btn-subtracao">
                              <img src="${location.origin}/images/global/button-subtracao.svg">
                          </div>
                          <span class="qtd-value">${adcToEdit ? (adcToEdit.Quantidade || adcToEdit.quantidade) : 0
            }</span>
                          <div class="btn-adicao">
                          <img src="${location.origin}/images/global/button-adicao.svg">
                          </div>
                      </div>
                  </div>
                  `
        } else {
          const id_cb = random()
          adicionaisHTML += `
                  <div class="item-adicional flex-between w-100" id-adicional="${item.Adicional.Id
            }" id-grupo="${grupo.id}">    
                          <div class="flex-column">
                              <div class="descricao">${item.Adicional.Descricao.trim()
              .toLowerCase()
              .capitalizeFirstLetter()}</div>
                              <div class="preco">${item.Preco > 0 ? format.money(item.Preco) : ''
            }</div>
                          </div>
                          <span class="svg-checkbox" >
                              <input type="checkbox" name="cb" id="cb${id_cb}" ${adcToEdit ? 'checked' : ''
            } prevent="${!!grupoPizza}">
                              <label for="cb${id_cb}"> 
                                 <svg viewBox="0 0 100 100"> 
                                    <path class="box" d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z" />
                                    <polyline class="check" points="25.5,53.5 39.5,67.5 72.5,34.5 " />
                                 </svg>
                              </label>
                      </span>
                  </div>`
        }
      })

      HTMLAdicionais += `
              <div class="grupo-adicionais" ${grupoPizza ? 'adicional-pizza' : ''} container-grupo="${grupo.id}" style="order: ${grupo.ordem}" ${grupo.idProduto ? `data-id-produto="${grupo.idProduto}"` : ''}>
                  <header>
                      <div class="titulo">${grupo.descricao}</div>
                      <div class="maximo flex-center font-12 font-gray gap-4">${grupo.max > 0 ? 'Selecione até ' + grupo.max : ''}  
                          <svg ${!grupoPizza ? 'style="display:none"' : ''} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 6.2916L6.79565 3.99593C6.9911 3.80048 7.308 3.80048 7.5034 3.99593C7.69885 4.19137 7.69885 4.50825 7.5034 4.70369L4.35356 7.85355C4.15829 8.0488 3.84171 8.0488 3.64645 7.85355L0.496588 4.70369C0.301145 4.50825 0.301145 4.19137 0.496588 3.99593C0.69203 3.80048 1.0089 3.80048 1.20435 3.99593L3.5 6.2916V0.5C3.5 0.223857 3.72386 0 4 0C4.27615 0 4.5 0.223857 4.5 0.5V6.2916Z" fill="currentColor"></path>
                          </svg>                  
                      </div>
                  </header>
                  ${grupo.ConsiderarAdicionalComValorMaior ? `<div class="alert font-12">No total, apenas o adicional de maior valor será calculado.</div>` : ''}
                  <div class="itens">
                      ${adicionaisHTML}
                  </div>
              </div>`
    })

    return HTMLAdicionais
  }

  function atualizaPassoAtualAgrupamento() {


    const adicionaisDoProduto = filterOptions(produtoAtual.GrupoOpcoesProdutoEstab)
    const HTMLAgrupamento = criaHTMLAgrupamento()
    const HTMLAdicionais = criaTemplatesAdicionais(adicionaisDoProduto, getCurrentStore().CodTicks ? getCurrentStore() : '')
    let HTMLSabores = ""
    let grupoPizza
    if (produtoAtual.IsPizza) {

      grupoPizza = buscaGrupoPizza(produtoAtual)
      HTMLSabores = criaHTMLPizza(grupoPizza, getCurrentStore())

    }
    //Este elemento é o container do conteúdo do produto, como adicionais, sabores, agrupamentos, etc
    const conteudoProduto = select('#conteudo-produto', containerHTML)
    const novoConteudo = createElement('div', { id: 'conteudo-produto' })

    novoConteudo.innerHTML = `
         ${HTMLAgrupamento}
        ${HTMLSabores}
            <div class="adicionais-itens">
                ${HTMLAdicionais}
          </div>
      `

    conteudoProduto.replaceWith(novoConteudo)

    criaEventosAdicionais(adicionaisDoProduto)

    if (grupoPizza) {
      criaEventosSaboresPizza(grupoPizza)
    }
    criaEventosStepsAgrupamento()

  }


}

function buscaGrupoPizza(produto) {

  let grupoPizza

  if (!storeItensPizza) {
    return null
  }
  // Busca os sabores pelo Id do produto
  let sabores = []
  if (storeDadosItemPedido.saboresProd) {
    sabores = storeDadosItemPedido.saboresProd.filter(
      (item) => item.CodProduto == (produto.IdProd || produto.CodProduto),
    )
  }

  grupoPizza = {
    sabores: [],
    idProduto: (produto.IdProd || produto.CodProduto),
    pizza: storeItensPizza.find((itemPizza) => itemPizza.Id == (produto.IdProd || produto.CodProduto)),
  }


  if (!grupoPizza.pizza) {
    return null
  }

  // Filtra todos os sabores, adicionando ao seu grupo
  sabores.forEach((sabor) => {
    // Busca o grupo do sabor
    const grupo = storeGruposPizzas.find(
      (grupo) => grupo.Id === sabor.CodGrupoSabor,
    )

    // Verifica se o objeto de grupos contem o grupo
    const sabores = grupoPizza.sabores.find((item) => item.Id === grupo.Id)
    if (sabores) {
      sabores.itens.push(sabor)
    } else {
      grupoPizza.sabores.push({
        itens: [sabor],
        ordem: grupo.OrdemExibicao,
        Id: grupo.Id,
        descricao: grupo.Descricao,
      })
    }
  })

  grupoPizza.sabores.sort((a, b) => a.ordem - b.ordem)

  return JSON.parse(JSON.stringify(grupoPizza))
}

function totalizaPizza(grupoPizza, quantidadeValor, storProdutoAtual, storAdicionais) {

  if (!storAdicionais) {
    storAdicionais = storAdicionaisPedido
  }
  const store = storProdutoAtual || storProduto
  const pizza = grupoPizza.pizza
  let ValorTotal = 0
  let valorTotalMediaDeSabores = 0
  let itemMaiorValor = 0

  store.Sabores.forEach((item) => {
    valorTotalMediaDeSabores += item.Valor * item.Quantidade

    if (item.Valor > itemMaiorValor) {
      itemMaiorValor = item.Valor
    }
  })

  const quantidadeDeSaboresAdicionados = store.Sabores.reduce(
    (totalSabores, saborAtual) => {
      return totalSabores + saborAtual.Quantidade
    },
    0,
  )
  valorTotalMediaDeSabores =
    (valorTotalMediaDeSabores /= quantidadeDeSaboresAdicionados) || 0

  if (
    pizza.PrecoDelivery > 0 &&
    !estabelecimento.pizza.considerarSaborComValorMaior
  ) {
    ValorTotal += pizza.PrecoDelivery
    store.ValorUnitarioPizza = ValorTotal
  } else {
    if (store.Sabores.length > 0) {
      if (estabelecimento.pizza.considerarSaborComValorMaior) {
        ValorTotal =
          itemMaiorValor > 0 && itemMaiorValor > pizza.PrecoDelivery
            ? itemMaiorValor
            : pizza.PrecoDelivery
        store.ValorUnitarioPizza =
          itemMaiorValor > 0 && itemMaiorValor > pizza.PrecoDelivery
            ? itemMaiorValor
            : pizza.PrecoDelivery
      } else {
        ValorTotal =
          valorTotalMediaDeSabores > 0 &&
            valorTotalMediaDeSabores > pizza.PrecoDelivery
            ? valorTotalMediaDeSabores
            : pizza.PrecoDelivery
        store.ValorUnitarioPizza = valorTotalMediaDeSabores
      }
    }
  }

  // Variável global
  totalComAdicionais = 0

  storAdicionais &&
    storAdicionais.length > 0 &&
    storAdicionais.forEach((item) => {
      totalComAdicionais += item.preco * item.quantidade
    })

  totalComAdicionais += ValorTotal
  ValorTotal = totalComAdicionais

  store.ValorUnitario = totalComAdicionais
  ValorTotal *= quantidadeValor

  store.Sabores.forEach((sabor) => {
    let precoAdicionais = 0
    sabor.Adicionais.forEach((adicional) => {
      precoAdicionais += calculaValorAdicionalSabor(sabor, adicional, '', quantidadeValor)
    })

    ValorTotal += precoAdicionais
  })

  store.ValorTotal = ValorTotal

  exibeSaboresAdicionados(grupoPizza, storProdutoAtual)

  if (storProdutoAtual) {
    storProdutoAtual.ValorTotal = ValorTotal
  }

  const totalButton = select('#total-button')

  if (totalButton) {
    totalButton.textContent = format.money(ValorTotal.toFixed(2)).replace('.', ',')
  }

  return ValorTotal
}

function calculaValorTotalAgrupamentos(updateStore, storProdutoAtual, quantidade = 1) {
  let total = storProduto.produtosAgrupamento.reduce((acc1, produto) => {

    produto.Quantidade = quantidade

    let valor = 0
    if (updateStore && storProdutoAtual.IdProd == produto.IdProd) {
      produto.Adicionais = [...storAdicionaisPedido.map((item) => { return { ...item, Adicionais: item.adicional } })]
    }

    if (produto.IsPizza) {
      const grupoPizza = buscaGrupoPizza(produto)

      const totalPizza = totalizaPizza(grupoPizza, quantidade, produto, produto.Adicionais)
      valor += totalPizza
      produto.ValorComAdicionais = totalPizza
    } else {
      const totalAdicionais = produto.Adicionais.reduce((acc2, adicional) => {
        return acc2 + (adicional.preco || adicional.ValorUnitario || 0) * (adicional.quantidade || adicional.Quantidade || 0)
      }, 0)

      produto.ValorComAdicionais = produto.PrecoDelivery.parseNumber() + totalAdicionais
      valor += produto.ValorComAdicionais * quantidade
    }

    return acc1 + valor
  }, 0)


  const btnAdicionarPedidoTextValue = select('#btn-adicionar-produto #total-button')
  if (btnAdicionarPedidoTextValue) {
    btnAdicionarPedidoTextValue.textContent = format.money(total)
  }
}

export function exibeSaboresAdicionados(grupoPizza, produtoAgrupamento, storeProdutoAtual) {
  const wrapperExist = select('#sabores-adicionados')
  wrapperExist && wrapperExist.remove()

  if (storProduto.Sabores.length > 0) {
    const wrapper = createElement('div', { id: 'sabores-adicionados' })
    const title = createElement(
      'div',
      { class: 'label-orange' },
      'Sabores adicionados',
    )
    const sabores = createElement('div', {
      class: 'flex font-500 gap-12 list-sabores',
    })

    storProduto.Sabores.forEach((itemSabor) => {
      const sabor = createElement('div', {
        class: 'flex font-12 font-dark sabor-adicionado',
      })

      let adicionaisSabor = ''
      const quantidadePizzas = select('#qtd-produto').valueAsNumber
      if (itemSabor.Adicionais.length > 0) {
        itemSabor.Adicionais.forEach((item) => {
          const valorAdicional = calculaValorAdicionalSabor(itemSabor, item, '', quantidadePizzas)

          adicionaisSabor += `
                    <div class="flex-between gap-4">
                        <span class="descricao-adicional-sabor text-elipsis">${item.descricao}</span>
                        <span>${format.money(valorAdicional)}</span>
                    </div>
                    `
        })

        adicionaisSabor = `
                <div class="flex flex-column font-10 font-gray">
                ${adicionaisSabor}
                </div>
                `
      }

      sabor.innerHTML = `
            <div class="flex flex-column">
                ${itemSabor.Quantidade + 'x ' + itemSabor.Descricao.toLowerCase().trim().capitalizeFirstLetter()}
                ${adicionaisSabor}
            </div>
            `

      sabores.appendChild(sabor)

      if (itemSabor.Adicionais.length > 0) {
        sabor.addEventListener('click', () => {
          const idPizza = Number(itemSabor.idPizza)

          const callback = (adicionaisSabor) => {
            itemSabor.Adicionais = adicionaisSabor

            if (produtoAgrupamento) {
              const quantidade = select('#qtd-produto').valueAsNumber
              calculaValorTotalAgrupamentos(false, storeProdutoAtual, quantidade)
            } else {
              totalizaPizza(grupoPizza, 1)
            }
          }

          const grupoSabor = grupoPizza.sabores.find(
            (sabor) => sabor.Id == itemSabor.CodGrupoSabor,
          )
          const objetoSabor = grupoSabor.itens.find(
            (sabor) => sabor.Sabor_Id == itemSabor.CodSabor,
          )

          exibeAdicionaisSabores(
            objetoSabor,
            idPizza,
            callback,
            itemSabor,
            storProduto,
          )
        })
      }
    })

    wrapper.appendChild(title)
    wrapper.appendChild(sabores)

    const wrapperButtonFixed = select(
      '#btn-adicionar-produto .wrapper-btn-fixed',
    )
    wrapperButtonFixed.insertBefore(wrapper, wrapperButtonFixed.firstChild)
  }
}

function adcState(adc, grupoPizza, adicionaisDoProduto, produtoSelecionado, storeProdutoAtual) {
  const input = adc.querySelector('input')

  if (input) {
    // Id do grupo do adicional
    const idGrupo = Number(adc.getAttribute('id-grupo'))
    const idAdicional = adc.getAttribute('id-adicional')

    function remove(itemId) {
      storAdicionaisPedido.forEach((item, index) => {
        if (item.id == itemId && item.idGrupo == idGrupo) {
          storAdicionaisPedido.splice(index, 1)

          const qtd = select('#qtd-produto')
          const qtdValue = Number(qtd.value)

          if (produtoSelecionado && produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
            calculaValorTotalAgrupamentos(true, storeProdutoAtual, qtdValue)
          } else if (grupoPizza) {
            totalizaPizza(grupoPizza, qtdValue)
          } else {
            totalProduto(qtdValue)
          }

        }
      })
    }

    if (input.checked && input.type != 'radio') {
      remove(idAdicional)
      input.checked = !input.checked
    } else {
      if (input.type == 'radio') {
        if (!input.checked) {
          selectAll(`.item-adicional[id-grupo='${idGrupo}']`).forEach(
            (item) => {
              const inputRadio = item.querySelector('input')
              if (inputRadio.checked) {
                const idAdicional = item.getAttribute('id-adicional')
                remove(idAdicional)
              }
            },
          )
        }
      }

      for (const property in adicionaisDoProduto) {
        adicionaisDoProduto[property].forEach((grupoAdicionais) => {
          if (grupoAdicionais.id == idGrupo) {
            let count = 0
            storAdicionaisPedido.forEach((storeAdicional) => {
              if (storeAdicional.idGrupo == idGrupo) {
                count += storeAdicional.quantidade
              }
            })

            if (count < grupoAdicionais.max || grupoAdicionais.max == 0) {
              grupoAdicionais.itens.forEach((item) => {
                if (item.Adicional.Id == idAdicional) {
                  storAdicionaisPedido.push({
                    id: idAdicional,
                    idGrupo,
                    adicional: item,
                    preco: item.Preco,
                    quantidade: 1,
                    nomeGrupo: grupoAdicionais.descricao,
                  })

                  const qtd = select('#qtd-produto')
                  const qtdValue = Number(qtd.value)

                  if (produtoSelecionado && produtoSelecionado.agrupamento && produtoSelecionado.obrigarEscolhaTodosItens) {
                    calculaValorTotalAgrupamentos(true, storeProdutoAtual, qtdValue)
                  } else {
                    if (grupoPizza) {
                      totalizaPizza(grupoPizza, qtdValue)
                    } else {
                      totalProduto(qtdValue)
                    }
                  }

                  // Modifica o estado do input
                  input.checked = !input.checked
                }
              })
            }
          }
        })
      }
    }
  }
}

function totalProduto(qtdValue, isPizza) {
  let idProduto = select('.pagina').getAttribute('id-produto')

  let produto
  if (idProduto == 'agrupamento') {
    const elemento = select('[name="produto-agrupamento"]:checked')
    if (elemento) {
      idProduto = elemento.getAttribute('data-id-produto')
    }

    store.agrupamentos.forEach((agrupamento) => {
      agrupamento.infoProd.forEach((produtoArr) => {
        if (produtoArr.IdProd == idProduto) {
          produto = produtoArr
        }
      })
    })
  } else {
    produto = store.produtos.find((produto) => produto.IdProd == idProduto)
  }



  const precoProduto = decimalStringToNumber(produto.PrecoDelivery)

  if (precoProduto || precoProduto === 0) {
    // Variável global
    totalComAdicionais = 0

    storAdicionaisPedido.forEach((item) => {
      totalComAdicionais += item.preco * item.quantidade
    }) /// Terminar

    totalComAdicionais += precoProduto
    if (isPizza) {
      storProduto.Sabores.forEach((sabor) => {
        totalComAdicionais += sabor.Valor
      })
    }
    const total = qtdValue * totalComAdicionais

    select('#total-button').textContent = format
      .money(total.toFixed(2))
      .replace('.', ',')
  } else {
    console.error('Produto não encontrado')
  }
}

function removeCardapio(scrollTop) {
  const container = select('#adicional-container')
  if (container) {
    const cardapio = container.parentElement
    cardapio && cardapio.remove()
    const dlgAdicionais = select('.dialog_adicionais')
    dlgAdicionais && dlgAdicionais.remove()
    return
    cardapio.classList.add('animate__slideOutRight')

    const nav = select('.dialog_adicionais .nav-bar')
    if (nav) {
      nav.classList.add('animate__slideOutRight', 'oculta-nav')
    }

    const app = select('#app')
    if (app) {
      app.classList.remove('dark-background', 'animate___toLeft')
      app.style.display = ''
    }

    window.scrollTo({
      top: scrollTop,
    })

    setTimeout(() => {
      cardapio && cardapio.remove()
      const logoContainer = select('.logo-container')
      if (logoContainer) {
        logoContainer.style.left = ''
      }
      const dlgAdicionais = select('.dialog_adicionais')
      dlgAdicionais && dlgAdicionais.remove()
      bagButtonShow()
    }, 500)
  }
}

function dialog(object) {
  const dialogEl = document.createElement('div')
  dialogEl.classList = 'dialog'
  if (object.pedeMesa) {
    dialogEl.classList = 'dialog pede-mesa'
  }
  dialogEl.innerHTML = `
         <div class="dialog-background" ></div>
         <div class="dialog-container ${object.classList ? object.classList : ''
    }">
             <header>
                <span>${object.title}</span>
                ${object.close
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      : ''
    }
            </header>
            <div>${object.body}</div>
        </div>`

  // Ao pedido o número da mesa, o dlg tava abrindo atrás, então mudei a div que ele vai renderizar --Alexandre 14/04/2023
  if (object.pedeMesa) {
    const pageBody = select('.page-body')
    if (pageBody) {
      pageBody.appendChild(dialogEl)
    }
  } else {
    const dialogContainer = select('#dialog')
    dialogContainer.appendChild(dialogEl)
  }

  $('#dialog header svg').on('click', () => {
    dialogContainer.innerHTML = ''
  })

  if (object.function) {
    object.function()
  }
}

function paginaPedidos() {
  // Cria a página
  newPage({
    id: 'list-pedidos',
    appbarTitle: 'Pedidos',
    classList: 'page-list-pedidos',
  })

  if (!estabelecimento.qrCode.ativo) {
    exibePedidosDelivery()
  } else if (estabelecimento.qrCode.modoSenha) {
    exibePedidosSenha()
  } else if (estabelecimento.comanda.ativo) {
    exibePedidosComanda()
  } else {
    exibePedidosMesa()
  }
}

function exibePedidosDelivery() {
  if (estabelecimento.offline) {
    buscaPedidosLog()
  } else {
    axios
      .get(getUrlAction('Pedido', 'GetPedidos'), {
        params: {
          index: 0,
        },
      })
      .then(({ data }) => {
        const pedidos = []

        if (data.pedidosD.length > 0) {
          data.pedidosD.forEach((pedido) => {
            pedido.status = {
              enviado: true,
              lido: true,
              cancelado: pedido.StatusPedido == 2,
              saiuParaEntrega: pedido.HoraEntrega,
              pago: pedido.StatusPedido == 1,
            }

            pedidos.push(pedido)
          })
        }

        showPedidos(pedidos)
      })
      .catch((error) => {
        console.error(error)
        Sentry.captureException(error)
      })
  }
}

let storePedidosMesa

function showPedidos(listPedidos, senha, saldoFidelidade) {
  converteValoresPedidoParaDecimal(listPedidos)

  const pedidosPage = select('#list-pedidos .page-body')

  if (!listPedidos) {
    pedidosPage.innerHTML = templates.paginaVazia
    return
  } else {
    pedidosPage.innerHTML = ''
  }

  !senha && agrupaItensPedido(listPedidos)

  let vlrTotalPedidos = 0
  const pedidos = []

  if (listPedidos) {
    if (!senha) {
      listPedidos.forEach((pedido) => {
        removeProdutoTaxaEntrega(pedido)

        const timeElapsed = Date.now()
        const today = new Date(timeElapsed)

        const dataPedido =
          (pedido.DataPedido && pedido.DataPedido.substring(0, 10)) ||
          today.toLocaleDateString()

        if (pedidos.length > 0) {
          const [item] = pedidos.filter((grupo) => grupo.data == dataPedido)
          if (item) {
            item.pedidosNodes.push(templatePedido(pedido))
          } else {
            pedidos.push({
              data: dataPedido,
              pedidosNodes: [templatePedido(pedido)],
            })
          }
        } else {
          pedidos.push({
            data: dataPedido,
            pedidosNodes: [templatePedido(pedido)],
          })
        }
      })

      if (pedidos.length > 0) {
        const pagPedidos = select('.pedidos-container')
        if (pagPedidos) {
          pagPedidos.remove()
        }

        if (estabelecimento.qrCode.ativo) {
          var page = createElement(
            'div',
            { class: 'pedidos-container' },
            `
                    <div class="mensagem-estab-taxaentrega">
                        <div class="mensagem-estab-taxaentrega--content">Detalhes do pedido não caracteriza como comprovante de lançamento.</div>
                    </div>
                    <div class="cards"></div>
                    `,
          )
        } else {
          var page = createElement(
            'div',
            { class: 'pedidos-container' },
            `<div class="cards"></div>`,
          )
        }
        const cards = page.querySelector('.cards')

        pedidos.forEach((diaPedidos) => {
          const [dia, mes, ano] = diaPedidos.data.split('/')
          let formatedDate = ''

          try {
            formatedDate = format.date(new Date(ano, mes - 1, dia))
          } catch (erro) {
            formatedDate = '--/--/----'
            Sentry.captureException(erro)
          }

          const wrapper = document.createElement('div')

          if (dia && mes) {
            wrapper.innerHTML = `<div class="pedido-date">${dia}/${mes}</div>`
          }

          let timer = 0
          diaPedidos.pedidosNodes.forEach((node) => {
            node.addEventListener('click', () => {
              const id = node.getAttribute('id-card')

              const objPedido = listPedidos.find((pedido) => pedido.Id == id)
              if (objPedido) {
                // Comentado pois agora a data já tá vindo certo dentro de objPedido.DataPedido --Alexandre 02/06/2023
                // try {
                //     if (objPedido.Itens && objPedido.Itens.length > 0) {
                //         const data = new Date(((objPedido.Itens[0].CodTicks || objPedido.IdPedRemoteDevice) - 621355968000000000) / 10000)
                //         objPedido.DataPedido = formataData({ data }).dataString
                //     }
                // } catch (error) {
                //     console.log(error)
                //     Sentry.captureException(error)
                // }

                // Só para tirar os '00:00:00' do final da data
                try {
                  if (
                    objPedido.DataPedido &&
                    objPedido.DataPedido?.length > 0
                  ) {
                    objPedido.DataPedido = objPedido.DataPedido.slice(0, 10)
                  }
                } catch {
                  //
                }

                newPage({
                  id: 'detalhes-pedido',
                  appbarTitle: 'Detalhes do pedido',
                  classList: '',
                })

                showOrderDetails(objPedido)
              } else {
                showDetails(id, false)
              }
            })
            setTimeout(() => {
              wrapper.appendChild(node)
            }, timer)
            timer += 50
          })
          cards.appendChild(wrapper)
        })

        /* Rodapé */
        // Crio o rodapé com totais apenas quando for QR Code (Mesa/Comanda)
        const rodape = document.createElement('footer')
        if (!isNaN(vlrTotalPedidos)) {
          rodape.classList = 'rodape-pedidos'
          rodape.innerHTML = `<span>Total: ${format.money(vlrTotalPedidos)}</span>${estabelecimento.taxaDeServico ? `<span style=" font-size: 1rem;">Sujeito à taxas de serviço</span>` : ``}`
        }

        if (saldoFidelidade) {
          page.innerHTML += `<div class="saldo-fidelidade">Saldo Cartão Fidelidade <span class="${saldoFidelidade > 0 ? 'font-green' : 'font-red'}">${format.money(saldoFidelidade)}</span></div>`
        }

        if (pedidosPage) {
          pedidosPage.appendChild(page)
          if (estabelecimento.qrCode.ativo) {
            pedidosPage.appendChild(rodape)
          }
          gif.end(pedidosPage)
        }

        selectAll('#card-body-button').forEach((itemPedido) => {
          const status = itemPedido.getAttribute('data-status')
          if (status != 2) {
            itemPedido.addEventListener('click', () => {
              const id = itemPedido.getAttribute('data-item-pedido-id')
              const pedidoTemporario = itemPedido.getAttribute('temporario')
              if (pedidoTemporario && pedidoTemporario == 'true') {
                showDetails(id, '', pedidoTemporario)
              } else {
                showDetails(id, '')
              }
            })
            $(itemPedido).on('click', (e) => { })
          }
        })
      } else {
        pedidosPage.innerHTML = templates.paginaVazia
      }
    } else {
      let contentHTML = ''
      listPedidos.forEach((pedido) => {
        contentHTML += `
                <div class="card card-pedido">
                    <header>
                        <span>Pedido ${pedido.numeroPedido}</span>
                        <span>${pedido.hora}</span>
                    </header>   
                    <div class="body pedido-senha">
                        <span class="senha-title">SENHA</span>
                        <span>${pedido.senha}</span>
                    </div>         
                    <div class="footer" id-pedido="${pedido.id}" senha="${pedido.senha}">
                        <span>Ver detalhes</span>
                    </div>     
                </div>
                `
      })

      const page = document.createElement('div')
      page.classList = 'pedidos-container'
      page.innerHTML = `<div class="cards">${contentHTML}</div>`
      if (pedidosPage) {
        pedidosPage.appendChild(page)

        const botaoDetalhes = selectAll('.card-pedido .footer')
        botaoDetalhes.forEach((botao) => {
          botao.addEventListener('click', () => {
            const idPedido = botao.getAttribute('id-pedido')
            const senha = botao.getAttribute('senha')

            showDetails(idPedido, senha)
          })
        })

        gif.end(pedidosPage)
      }
    }
  } else {
    pedidosPage.innerHTML = templates.paginaVazia
  }

  function templatePedido(itemPedido) {
    if (itemPedido) {
      let itensHTML = ''
      if (estabelecimento.qrCode.ativo) {
        const total = itemPedido.Itens.reduce((acc, item) => {
          return acc + item.ValorTotal
        }, 0)
        vlrTotalPedidos += total
      } else {
        vlrTotalPedidos += itemPedido.SubTotal + itemPedido.TaxaEntrega
      }

      for (let i = 0; i < 3; i++) {
        const produto = itemPedido.Itens[i]
        if (produto) {
          itensHTML += `
                    <div class="item">
                        <div class="qtd">${produto.Quantidade}</div>
                        <div class="prod">${produto.Descricao || produto.Produto_Produto}</div>
                    </div>`
        }
      }

      let itensQueNaoAparecem = ''
      if (itemPedido.Itens.length > 3) {
        itensQueNaoAparecem += `
                <div class="maisItens">
                    <div class="quantidade">mais ${itemPedido.Itens.length - 3} itens</div>
                </div>`
      }

      let adiantamentosHTML = ''
      if (itemPedido.Adiantamentos) {
        itemPedido.Adiantamentos.forEach((ad) => {
          if (ad.Itens) {
            ad.Itens.forEach((it) => {
              adiantamentosHTML += `<div class="item">${it.Quantidade}x ${it.Descricao} - ${format.money(it.ValorUnitario)}</div>`
            })
          }
        })
      }

      const verificaStatusPedido = (icon) => {
        if (!itemPedido.status) {
          return ''
        }

        if (itemPedido.status.cancelado) {
          if (icon) {
            return `<svg width="17" height="17" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.38354 3.80497C4.22378 3.64521 3.96476 3.64521 3.805 3.80497C3.64524 3.96473 3.64524 4.22375 3.805 4.38351L5.42141 5.99992L3.805 7.61633C3.64524 7.77609 3.64524 8.03511 3.805 8.19487C3.96476 8.35463 4.22378 8.35463 4.38354 8.19487L5.99995 6.57846L7.61636 8.19487C7.77612 8.35463 8.03515 8.35463 8.19491 8.19487C8.35467 8.03511 8.35467 7.77609 8.19491 7.61633L6.5785 5.99992L8.19491 4.38351C8.35467 4.22375 8.35467 3.96473 8.19491 3.80497C8.03515 3.64521 7.77612 3.64521 7.61636 3.80497L5.99995 5.42138L4.38354 3.80497Z" fill="#FF304F"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM0.818182 6C0.818182 3.13816 3.13816 0.818182 6 0.818182C8.86184 0.818182 11.1818 3.13816 11.1818 6C11.1818 8.86184 8.86184 11.1818 6 11.1818C3.13816 11.1818 0.818182 8.86184 0.818182 6Z" fill="#FF304F"></path></svg>`
          }
          return 'Cancelado'
        } else if (itemPedido.status.pago) {
          if (icon) {
            return `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.0002 2.52092C15.6825 2.52092 19.4794 6.31684 19.4794 11.0001C19.4794 15.6824 15.6825 19.4793 11.0002 19.4793C6.31693 19.4793 2.52102 15.6824 2.52102 11.0001C2.52102 6.31776 6.31785 2.52092 11.0002 2.52092Z" stroke="#00d26e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.5 10.873L9.874 13.246L14.62 8.5" stroke="#00d26e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`
          }
          return 'Finalizado'
        } else if (itemPedido.status.saiuParaEntrega) {
          if (icon) {
            return `<svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7632 10.3891L9.35938 8.6872V6.71889L12.7632 7.1444V10.3891ZM12.9557 10.4854L12.9556 10.4853L12.9557 10.4854Z" stroke="#4285F4"></path><path d="M7.80391 6.02054C7.57508 5.99894 7.39142 6.16647 7.39142 6.38466V8.03536C7.39142 8.1755 7.46919 8.30128 7.59426 8.36364L8.12538 8.62919V6.06071L7.80391 6.02054Z" fill="#4285F4"></path><path d="M10.2595 2.24075C11.3793 2.99202 12.1839 4.12065 12.5592 5.37153L7.95894 4.79645C7.9586 4.7964 7.95827 4.79636 7.95793 4.79632C7.01431 4.67514 6.15746 5.41284 6.15746 6.38467V8.0356C6.15746 8.64194 6.50007 9.19625 7.04237 9.46742L7.04238 9.46742L11.7696 11.831C11.395 12.6218 10.4811 12.9648 9.68944 12.6367L9.68855 12.6363L1.59372 9.29939C1.3698 9.19443 1.23682 8.97905 1.23682 8.75036V6.99286C1.23682 5.80449 1.69424 4.56836 2.44859 3.5463C3.20353 2.52344 4.22737 1.75306 5.3174 1.45404L5.31756 1.454C7.00903 0.98938 8.82552 1.27885 10.2595 2.24075Z" stroke="#4285F4"></path></svg>`
          }
          return 'Saiu para entrega'
        } else if (itemPedido.status.lido) {
          if (icon) {
            return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7388 6.15362C19.7388 3.40274 17.8581 2.29999 15.1503 2.29999H8.79143C6.16687 2.29999 4.19995 3.32756 4.19995 5.97016V20.694C4.19995 21.4198 4.9809 21.8769 5.61348 21.522L11.9954 17.9421L18.3223 21.516C18.9558 21.8729 19.7388 21.4158 19.7388 20.689V6.15362Z" stroke="#DF7800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.27124 9.02799H15.5895" stroke="#DF7800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`
          }
          return 'Lido'
        } else {
          if (icon) {
            return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7388 6.15362C19.7388 3.40274 17.8581 2.29999 15.1503 2.29999H8.79143C6.16687 2.29999 4.19995 3.32756 4.19995 5.97016V20.694C4.19995 21.4198 4.9809 21.8769 5.61348 21.522L11.9954 17.9421L18.3223 21.516C18.9558 21.8729 19.7388 21.4158 19.7388 20.689V6.15362Z" stroke="#DF7800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.27124 9.02799H15.5895" stroke="#DF7800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`
          }

          return 'Enviado'
        }
      }

      let horario = itemPedido.HoraPedido
      if (!horario) {
        horario = new Date((itemPedido.CodTicks - 621355968000000000) / 10000)
        horario = format.hour(horario)
        itemPedido.HoraPedido = horario
      } else {
        horario = horario.substr(0, 5)
      }

      return criaCardPedido({
        id: itemPedido.Id,
        numeroPedido: itemPedido.NumeroPedido || itemPedido.Id,
        inclusao: horario,
        status: verificaStatusPedido(),
        statusEnum: itemPedido.status,
        icon: verificaStatusPedido(true),
        itensHTML,
        itensQueNaoAparecem,
        adiantamentosHTML,
        dataPedido: itemPedido.DataPedido,
      })
    }
  }
}

function criaCardPedido(pedido) {
  const wrapper = createElement('div', {
    id: 'card-body-button',
    'id-card': pedido.id,
  })
  let entregaHTML = ''
  if (
    pedido.statusEnum &&
    !pedido.statusEnum.pago &&
    estabelecimento.tempoEntrega
  ) {
    entregaHTML = `
        <div class="mensagem-previsao-entrega"> 
            <div class="mensagem-estab-taxaentrega--content">${criaTemplateTempoEntrega(pedido.inclusao)}</div> 
        </div>
        `
  }
  let dataFormatada = ''
  if (pedido.dataPedido && pedido.dataPedido.length > 10) {
    dataFormatada = pedido.dataPedido.substring(0, 10)
  }

  let headerHTML = `
  <header>
  <div>
    #${pedido.numeroPedido.toString().substring(0, 5)}
  </div>
  <div class="font-14">${dataFormatada + ' às ' + pedido.inclusao}</div>
  <div class="flex gap-4">                
    ${pedido.status}
    ${pedido.icon}
  </div>
</header>
  `

  if (estabelecimento.qrCode.ativo) {

    let statusHTML = ''
    if (pedido.statusEnum.lido) {
      statusHTML = `
        <div class="alert-content flex-center flex-column text-center u-p-16">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 2rem;height: 2rem;">
        <circle cx="16" cy="16" r="16" fill="#97FFCD"></circle>
        <path d="M23.5607 12.5607C24.1464 11.9749 24.1464 11.0251 23.5607 10.4393C22.9749 9.85355 22.0251 9.85355 21.4393 10.4393L13.5 18.3787L10.5607 15.4393C9.97487 14.8536 9.02513 14.8536 8.43934 15.4393C7.85355 16.0251 7.85355 16.9749 8.43934 17.5607L12.4393 21.5607C13.0251 22.1464 13.9749 22.1464 14.5607 21.5607L23.5607 12.5607Z" fill="#00D26E"></path>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z" fill="#00D26E"></path>
        </svg>
        <span class="font-green">Seu pedido foi lido e está sendo preparado</span>
     </div>
      `
    }
    else if (!pedido.statusEnum.pago && !pedido.statusEnum.cancelado && !pedido.statusEnum.saiuParaEntrega) {
      statusHTML = `
    <div class="alert-content flex-center flex-column text-center u-p-16">
      <div class="showbox" style="height: 2rem;width: 2rem;">
          <div class="loader" style="width: 2rem;height: 2rem;"> 
              <svg class="circular" viewBox="25 25 50 50">
              <circle stroke="#4f44e0" style="stroke: #4f44e0!important" class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
              </svg>
          </div>
      </div>
     <span>Aguardando confirmação do estabelecimento</span>
     </div>
      `
    }

    if (statusHTML) {
      headerHTML = `
      <header>
        <div class="flex flex-column w-100">
          <div class="flex flex-between gap-4">
            <div>#${pedido.numeroPedido.toString().substring(0, 5)}</div>
            <div class="font-14">${dataFormatada + ' às ' + pedido.inclusao}</div>
          </div>
          ${statusHTML}
        </div>
      </header>
      `
    }

  }
  wrapper.innerHTML = `
        <div class="card card-pedido">
            <div id="status-pedido"></div>
            ${headerHTML}
            ${entregaHTML}
            <div class="body">
                ${pedido.itensHTML}
                ${pedido.itensQueNaoAparecem}
                <div class="icon-seta">
                    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.71967 13.7803C1.01256 14.0732 1.48744 14.0732 1.78033 13.7803L8.03033 7.53033C8.32322 7.23744 8.32322 6.76256 8.03033 6.46967L1.78033 0.21967C1.48744 -0.0732231 1.01256 -0.0732231 0.71967 0.21967C0.426777 0.512563 0.426777 0.987437 0.71967 1.28033L6.43934 7L0.71967 12.7197C0.426777 13.0126 0.426777 13.4874 0.71967 13.7803Z" fill="#8E8E8E"></path>
                    </svg>
                </div>
            </div>
            ${pedido.adiantamentosHTML
      ? `
                <div class="adiantamentos">
                    <div class="title">Adiantamentos</div>
                    ${adiantamentosHTML}
                </div>
                `
      : ``
    }                
</div>
`

  return wrapper
}

function showDetails(idPedido, senha, pedido) {
  newPage({
    id: 'detalhes-pedido',
    appbarTitle: 'Detalhes do pedido',
    classList: '',
  })
  5
  idPedido = Number(idPedido)

  if (!estabelecimento.qrCode.ativo) {
    $.ajax({
      type: 'GET',
      url: getUrlAction('Pedido', 'GetPedidoById'),
      data: {
        idPedido,
      },
      success: function (response) {
        response = JSON.parse(response)
        if (!response.isOffline) {
          const pedido = response.pedidoDel
          showOrderDetails(pedido)
        }
      },
      error: function (response) {
        console.log(JSON.parse(response))
      },
    })
  } else {
    if (senha) {
      buscaPedidoSenha(idPedido, senha, showOrderDetails)
    } else {
      const [pedido] = storePedidosMesa.filter((item) => item.Id == idPedido)
      showOrderDetails(pedido)
    }
  }
}

function showOrderDetails(pedidoData) {
  const formatAddress = [
    pedidoData.Logradouro,
    pedidoData.Numero,
    pedidoData.Complemento,
    pedidoData.Bairro,
    pedidoData.Cidade,
  ]
    .filter((string) => string != '' && string != undefined)
    .join(', ')

  const stringToFloat = (string) => {
    if (typeof string === 'string') {
      return parseFloat(string)
    } else {
      return string
    }
  }

  if (estabelecimento.offline) {
    pedidoData.SubTotal = pedidoData.ValorTotalPedido - pedidoData.TaxaEntrega
  }
  pedidoData.TaxaEntrega = stringToFloat(pedidoData.TaxaEntrega)
  pedidoData.TrocoDelivery = stringToFloat(pedidoData.TrocoDelivery)

  if (!pedidoData.SubTotal) {
    pedidoData.SubTotal = pedidoData.Itens.reduce((acc, item) => { return acc + item.ValorComAdicionais * item.Quantidade }, 0)
  }

  let itensPedidoHTML = ''
  pedidoData.Itens.forEach((itemPedido) => {
    let pedidoAdicionaisHTML = ''
    itemPedido.Adicionais.forEach((itemPedidoAdicional) => {
      if (typeof itemPedidoAdicional.ValorUnitario === 'string') {
        itemPedidoAdicional.ValorUnitario = parseFloat(
          itemPedidoAdicional.ValorUnitario,
        )
      }

      const valorAdicional =
        itemPedidoAdicional.ValorUnitario *
        stringToFloat(itemPedidoAdicional.Quantidade)
      const valorFormatado =
        valorAdicional > 0 ? format.money(valorAdicional) : ''
      pedidoAdicionaisHTML += `
                <div class="detalhes__itens-adicionais">
                    <div class="qtdEprod">
                        <div class="qtd">${itemPedidoAdicional.Quantidade}</div>
                        <div class="prod">${itemPedidoAdicional.Descricao || (itemPedidoAdicional.Adicional ? itemPedidoAdicional.Adicional.Descricao : '')}</div>
                    </div>
                    <div class="vlr">${valorFormatado}</div>
                </div>`
    })

    let sabores_HTML = ''
    if (itemPedido.Sabores && itemPedido.Sabores.length > 0) {
      itemPedido.Sabores.forEach((sabor, index) => {
        if (
          !sabor.Descricao &&
          storeDadosItemPedido &&
          storeDadosItemPedido.saboresProd
        ) {
          const saborReferencia = storeDadosItemPedido.saboresProd.find(
            (item) => {
              return item.Sabor_Id == sabor.CodSabor
            },
          )

          if (saborReferencia) {
            sabor.Descricao = saborReferencia.Sabor_Descricao.trim()
          }
        }

        let adicionaisSabores = ''

        const adicionaisSabor = itemPedido.AdicionaisXSabor || itemPedido.AdicionaisSabor
        if (adicionaisSabor) {

          adicionaisSabor.forEach((adicionalSabor) => {

            if (typeof adicionalSabor.ValorTotal == "string") {
              adicionalSabor.ValorTotal = adicionalSabor.ValorTotal.parseNumber()
            }

            const valorTotal = calculaValorAdicionalSabor(sabor, adicionalSabor, itemPedido.Sabores.reduce((acc, sabor) => { return acc + sabor.Quantidade }, 0))

            if (adicionalSabor.CodSabor == sabor.CodSabor) {
              adicionaisSabores += `<div class="font-12 font-gray">1x ${adicionalSabor.Descricao} (${formatMoney(valorTotal)})</div>`
            }
          })
        }

        sabores_HTML += `
                <div class="detalhes__itens-sabores">
                    <div class="qtdEprod">
                        <div class="qtd">${sabor.Quantidade}</div>
                        <div class="prod">${sabor.Descricao}</div>
                    </div>
                </div>                
                ${adicionaisSabores}
                `
      })
    }

    if (!itemPedido.Descricao) {
      itemPedido.Descricao = itemPedido.Produto_Produto
    }

    if (itemPedido && itemPedido.Descricao.toLowerCase() != 'taxa de entrega') {
      if (typeof itemPedido.ValorUnitario === 'string') {
        itemPedido.ValorUnitario = parseFloat(itemPedido.ValorUnitario)
      }

      itensPedidoHTML += `
            <div class="detalhes__itens-item">
                    <div class="u-flex-between">
                        <div class="detalhes__itens-descricao">
                            <div class="qtd">${itemPedido.Quantidade}</div>
                            <div class="prod">${itemPedido.Descricao}</div>
                        </div>
                        <div class="detahles__itens-preco">
                            ${format.money(itemPedido.ValorUnitario * stringToFloat(itemPedido.Quantidade))}
                        </div>
                    </div>
                    ${pedidoAdicionaisHTML
          ? `
                        <div class="content-adicionais">
                            <div class="titleAdc">Adicionais</div>
                            ${pedidoAdicionaisHTML}
                        </div>`
          : ''
        }

                        ${itemPedido.Observacao
          ? `
                        <div class="content-adicionais">
                            <div class="titleAdc">Observação</div>
                            ${itemPedido.Observacao}
                        </div>`
          : ''
        }

                    ${sabores_HTML
          ? `
                        <div class="content-sabores">
                            <div class="titleSab">Sabores</div>
                                ${sabores_HTML}
                        </div>`
          : ''
        }
            </div>`
    }
  })

  let desconto
  let totalComDesconto
  pedidoData.SubTotal = stringToFloat(pedidoData.SubTotal)
  pedidoData.PercentualDesconto = stringToFloat(pedidoData.PercentualDesconto)
  pedidoData.ReaisDesconto = stringToFloat(
    pedidoData.ReaisDesconto || pedidoData.ValorDesconto,
  )

  if (!pedidoData.FormaPagamento) {
    estabelecimento.pagamento.metodos.forEach((grupo) => {
      if (grupo.Id == pedidoData.CodTipoPagamento) {
        pedidoData.FormaPagamento = grupo.Descricao
      }
    })
  }

  if (pedidoData.PercentualDesconto) {
    const totalDesconto = pedidoData.PercentualDesconto / 100
    desconto = totalDesconto * pedidoData.SubTotal
    totalComDesconto = pedidoData.SubTotal - desconto
  }

  if (pedidoData.ReaisDesconto) {
    if (totalComDesconto) {
      totalComDesconto -= pedidoData.ReaisDesconto
      desconto && (desconto += pedidoData.ReaisDesconto)
      !desconto && (desconto = pedidoData.ReaisDesconto)

      if (totalComDesconto < 0) {
        totalComDesconto = 0
      }
    } else {
      totalComDesconto = pedidoData.SubTotal - pedidoData.ReaisDesconto
      desconto = pedidoData.ReaisDesconto
      if (totalComDesconto < 0) {
        totalComDesconto = 0
      }
    }
  }

  const isPagPIX =
    (pedidoData.FormaPagamento === 'PIX' ||
      pedidoData.FormaPagamento === 'pix') &&
    !estabelecimento.utilizaIntegracaoPagarme
  if (isPagPIX) {
    const totalPedidoPIX =
      pedidoData.SubTotal +
      pedidoData.TaxaEntrega -
      (pedidoData.ReaisDesconto || 0)
    const formaPagPix = estabelecimento.pagamento?.metodos.find(
      (metodo) => metodo.Prefixo === 'PIX',
    )
    let bandeiraPix

    if (formaPagPix && formaPagPix.Bandeiras.length > 0) {
      bandeiraPix = formaPagPix.Bandeiras.find(
        (band) => band.Bandeira?.ChavePIX?.length > 0,
      )
    }

    if (
      (bandeiraPix && typeof bandeiraPix !== 'undefined') ||
      estabelecimento.chavepix
    ) {
      // Função que busca o QRCode/Copia e cola do PIX
      const buscaPixCopiaeCola = (settings) => {
        setTimeout(() => {
          $.ajax({
            type: settings.method,
            url: settings.url,
            success: function (response, status, xhr) {
              if (response && response.status === 'success') {
                continua(response.qrstring || '')
              }
            },
            error: function (xhr, status, error) {
              console.log(error)
            },
          })
        }, 333)
      }

      // Função que continua a montagem da tela, independente de qual chave pix o cliente use
      const continua = (stringPIX) => {
        // Se o desconto existe e o desconto é maior que o valor do pedido.
        desconto &&
          desconto > pedidoData.SubTotal &&
          (desconto = pedidoData.SubTotal)

        const bodyPage = select('#detalhes-pedido .page-body')
        const bodyHTML = document.createElement('div')

        bodyHTML.classList = 'detalhes__container'
        bodyHTML.innerHTML = `
                    <div class="u-height-100">
                    <div class="detalhes__data">Pedido feito às
                        <span class="hora">${(pedidoData.HoraPedido || '').substring(0, 5)}</span>
                        no dia
                        <span class="dia">${pedidoData.DataPedido || ''}</span>            
                    </div>

                    ${estabelecimento.qrCode.ativo
            ? `
                    <div class="mensagem-estab-taxaentrega">
                        <div class="mensagem-estab-taxaentrega--content">Detalhes do pedido não caracteriza como comprovante de lançamento.</div>
                    </div>`
            : ''
          }

                ${estabelecimento.agendamento.ativo &&
            pedidoData.DataEntregaTxt &&
            pedidoData.HoraEntregaTxt
            ? `
                    <div id="aviso-box">
                        <span class="aviso-box-title">Agendado</span>
                        <div class="aviso-box-content">
                            <span class="aviso-box-text">Este pedido foi agendado para dia 
                            ${pedidoData.DataEntregaTxt + ' às ' + (pedidoData.HoraEntregaTxt || '').slice(0, 5)}
                            </span>
                        </div>
                    </div>`
            : ''
          }
        
                ${estabelecimento.qrCode.ativo
            ? ``
            : `<div class="title">Status <div class="divider"></div></div> <div id="status-wrapper"></div>`
          }
        
                <div class="detalhes__pedido" ${estabelecimento.qrCode.ativo ? `style="margin-top: 15px;"` : ``}>Itens <div class="divider"></div></div>
                <div class="detalhes__itens">
                    ${itensPedidoHTML}
                </div>
        
                <div class="divider" style="margin-left: 0; margin-top: 6px;"></div>
        
                <div class="detalhes__total">
                ${!estabelecimento.qrCode.ativo
            ? `
                    <div class="detalhes__total-subtotal">
                        <div class="detalhes__space-between">
                            <div>Subtotal</div>
                            <div>${format.money(pedidoData.SubTotal)}</div>
                        </div>
                    </div>`
            : ''
          }
        
                <div class="detalhes__total-desconto" ${desconto ? "style='color: #ff304f'" : "style='display:none'"}>
        
                    <div class="detalhes__space-between">
                    <div>Desconto</div>
                    <div>- ${format.money(desconto)}</div>
                    </div>
                </div>
        
                <div class="detalhes__total-taxa-entrega">
                    <div class="detalhes__space-between">
                    <div>Taxa de entrega</div>
                    <div>${format.money(pedidoData.TaxaEntrega)}</div>
                    </div>
                </div>
                <div class="detalhes__total-total">
                    <div class="detalhes__space-between">
                    <div>Total</div>
                    <div>${format.money((totalComDesconto || Number(pedidoData.SubTotal)) + Number(pedidoData.TaxaEntrega))}</div>
                    </div>
                </div>
                </div>
                ${estabelecimento.qrCode.ativo &&
            estabelecimento.confirmarPedido
            ? `<div class="detalhes__total">
                        <div class="detalhes__total-total">
                            <div class="detalhes__space-between">
                                ${pedidoData.Vendedor
              ? `<div>Atendente: </div>
                                    <div>${pedidoData.Vendedor}</div>`
              : ``
            }
                            </div>
                        </div> 
                    </div>`
            : ''
          }
                <div class="detalhes__pagamento">
                    <div class="formaPag">
                        <span>Forma de pagamento</span>
                        <span>${pedidoData.FormaPagamento}</span>
                    </div>
                    ${isPagPIX && !estabelecimento.utilizaIntegracaoPagarme
            ? `<div class="pix">
                            <div class="message-chavepix">                                                        
                                <div class="text">PIX Copia e Cola para pagamento:</div>
                                    <div id="chave">
                                        <span id="chavepix">${stringPIX}</span>
                                    <div class="copiar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 24 24" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                                    </div>
                                    <div class="copiado" style="display: none">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                        <div class="txtcopy">Copiado!</div>
                                    </div>
                                </div>
                            </div>
                        </div>`
            : ``
          }
                    ${pedidoData.TrocoDelivery
            ? `<div class="troco">
                        <span>Troco</span>
                        <span>Levar troco para: ${format.money(pedidoData.TrocoDelivery)}</span>
                    </div>`
            : ``
          }
                </div>
        
                ${estabelecimento.qrCode.ativo
            ? ''
            : pedidoData.CodObsEntrega ==
              estabelecimento.codigoBuscaBalcao
              ? `
                        <div class="detalhes_endereco retirada">
                            <div class="title">
                                <span>Endereço para retirada</span>
                                <div class="divider"></div>
                            </div>                
                            <span class="detalhes__endereco-value">${estabelecimento.endereco.toString()}</span>
                        </div>
                        `
              : `
                        <div class="detalhes_endereco">
                            <div class="title">
                                <span>Endereço de entrega</span>
                                <div class="divider"></div>
                            </div>                
                            <div class="enderecoEobs">
                                <span class="detalhes__endereco-value">${formatAddress}</span>
                                ${pedidoData.ObsEntrega
                ? `<span class="detalhes__endereco-value">Observação para entrega: ${pedidoData.ObsEntrega}</span>`
                : ''
              }
                            </div>
                        </div>
                        `
          }
                
                </div>`

        if (bodyPage) {
          bodyPage.appendChild(bodyHTML)

          let status = ''
          if (!estabelecimento.qrCode.ativo) {
            status = progressoPedido(pedidoData)
          }

          const statusWrapper = select('#status-wrapper')
          if (statusWrapper) {
            statusWrapper.appendChild(status)
          }

          const botaoCopiar = select('.copiar')
          botaoCopiar.addEventListener('click', () => {
            const key = select('.message-chavepix #chavepix').textContent.trim()

            navigator.clipboard.writeText(key)

            botaoCopiar.style.display = 'none'

            const copiado = select('.message-chavepix .copiado')
            copiado.style.display = 'flex'

            setTimeout(() => {
              copiado.style.display = 'none'
              botaoCopiar.style.display = 'flex'
            }, 2000)
          })

          gif.end(bodyPage)
        }
      }

      // Caso ele tenha bandeira com pix cadastro no Mogo, então ele utiliza o copia e cola.
      if (typeof bandeiraPix !== 'undefined') {
        const settings = {
          url:
            'https://pix.ae?chave=' +
            bandeiraPix.Bandeira.ChavePIX +
            '&tipo=' +
            bandeiraPix.Bandeira.StrTipoChavePIX +
            '&nome=' +
            bandeiraPix.Bandeira.NomeRecebedor +
            '&info=' +
            estabelecimento.fantasia +
            '&valor=' +
            totalPedidoPIX +
            '&txid=70a8cdcb-59b5-4eac-9ccb',
          method: 'POST',
        }
        buscaPixCopiaeCola(settings)
      } else if (
        typeof bandeiraPix === 'undefined' &&
        estabelecimento.chavepix
      ) {
        // Aqui é só pra seguir conforme era antes
        continua(estabelecimento.chavepix)
      }
    }
  } else {
    // Se o desconto existe e o desconto é maior que o valor do pedido.
    desconto &&
      desconto > pedidoData.SubTotal &&
      (desconto = pedidoData.SubTotal)

    const bodyPage = select('#detalhes-pedido .page-body')
    const bodyHTML = document.createElement('div')

    bodyHTML.classList = 'detalhes__container'
    bodyHTML.innerHTML = ` 
        <div class="u-height-100">
            <div class="detalhes__data">Pedido feito às
                <span class="hora">${(pedidoData.HoraPedido || '').substring(0, 5)}</span>
                no dia
                <span class="dia">${pedidoData.DataPedido || ''}</span>            
            </div>

            ${estabelecimento.qrCode.ativo
        ? `
            <div class="mensagem-estab-taxaentrega">
                <div class="mensagem-estab-taxaentrega--content">Detalhes do pedido não caracteriza como comprovante de lançamento.</div>
            </div>`
        : ''
      }
      
    
    ${estabelecimento.agendamento.ativo &&
        pedidoData.DataEntregaTxt &&
        pedidoData.HoraEntregaTxt
        ? `
        <div id="aviso-box">
            <span class="aviso-box-title">Agendado</span>
            <div class="aviso-box-content">
                <span class="aviso-box-text">Este pedido foi agendado para dia 
                ${pedidoData.DataEntregaTxt + ' às ' + (pedidoData.HoraEntregaTxt || '').slice(0, 5)}
                </span>
            </div>
        </div>`
        : ''
      }

        ${estabelecimento.qrCode.ativo ? '' : `<div class="title">Status <div class="divider"></div></div> <div id="status-wrapper"></div>`}

        <div class="detalhes__pedido" ${estabelecimento.qrCode.ativo ? `style="margin-top: 15px;"` : ``}>Itens <div class="divider"></div></div>
        <div class="detalhes__itens">
            ${itensPedidoHTML}
        </div>

        <div class="divider" style="margin-left: 0; margin-top: 6px;"></div>

        <div class="detalhes__total">
        ${!estabelecimento.qrCode.ativo
        ? `
            <div class="detalhes__total-subtotal">
                <div class="detalhes__space-between">
                    <div>Subtotal</div>
                    <div>${format.money(pedidoData.SubTotal)}</div>
                </div>
            </div>`
        : ''
      }        

          <div class="detalhes__total-desconto" ${desconto ? "style='color: #ff304f'" : "style='display:none'"}>

            <div class="detalhes__space-between">
              <div>Desconto</div>
              <div>- ${format.money(desconto)}</div>
            </div>
          </div>

          <div class="detalhes__total-taxa-entrega">
            <div class="detalhes__space-between">
              <div>Taxa de entrega</div>
              <div>${format.money(pedidoData.TaxaEntrega)}</div>
            </div>
          </div>
          <div class="detalhes__total-total">
            <div class="detalhes__space-between">
              <div>Total</div>
              <div>${format.money(
        (totalComDesconto || Number(pedidoData.SubTotal)) +
        Number(pedidoData.TaxaEntrega),
      )}</div>
            </div>
          </div>
        </div>
        ${estabelecimento.qrCode.ativo && estabelecimento.confirmarPedido
        ? `
            <div class="detalhes__total">
                <div class="detalhes__total-total">
                    <div class="detalhes__space-between">
                        ${pedidoData.Vendedor
          ? `
                        <div>Atendente: </div>
                        <div>${pedidoData.Vendedor}</div>
                        `
          : ''
        }
                    </div>
                </div> 
            </div>
        `
        : ''
      }
        <div class="detalhes__pagamento">
            <div class="formaPag">
                <span>Forma de pagamento</span>
                <span>${pedidoData.FormaPagamento}</span>
            </div>
            ${isPagPIX && !estabelecimento.utilizaIntegracaoPagarme
        ? `
                <div class="pix">
                    <div class="message-chavepix">                                                        
                        <div class="text">PIX Copia e Cola para pagamento:</div>
                            <div id="chave">
                                <span id="chavepix">${stringPIX}</span>
                            <div class="copiar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 24 24" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                            </div>
                            <div class="copiado" style="display: none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                <div class="txtcopy">Copiado!</div>
                            </div>
                        </div>
                    </div>
                </div>
            `
        : ``
      }
            ${pedidoData.TrocoDelivery
        ? `<div class="troco">
                <span>Troco</span>
                <span>Levar troco para: ${format.money(pedidoData.TrocoDelivery)}</span>
            </div>`
        : ``
      }
        </div>

        ${estabelecimento.qrCode.ativo
        ? ''
        : pedidoData.CodObsEntrega == estabelecimento.codigoBuscaBalcao
          ? `
                <div class="detalhes_endereco retirada">
                    <div class="title">
                        <span>Endereço para retirada</span>
                        <div class="divider"></div>
                    </div>                
                    <span class="detalhes__endereco-value">${estabelecimento.endereco.toString()}</span>
                </div>
                `
          : `
                <div class="detalhes_endereco">
                    <div class="title">
                        <span>Endereço de entrega</span>
                        <div class="divider"></div>
                    </div>                
                    <div class="enderecoEobs">
                        <span class="detalhes__endereco-value">${formatAddress}</span>
                        ${pedidoData.ObsEntrega
            ? `
                        <span class="detalhes__endereco-value">Observação para entrega: ${pedidoData.ObsEntrega}</span>
                        `
            : ''
          }
                    </div>
                </div>
                `
      }
        
    </div>`

    if (bodyPage) {
      bodyPage.appendChild(bodyHTML)

      let status = ''
      if (!estabelecimento.qrCode.ativo) {
        status = progressoPedido(pedidoData)
      }

      const statusWrapper = select('#status-wrapper')
      if (statusWrapper) {
        statusWrapper.appendChild(status)
      }
      gif.end(bodyPage)
    }
  }
}

function getInfoEntrega(callback) {
  if (usuario.logado) {
    getEnderecos((response) => {
      if (response.length > 0) {
        // Atribui os endereços ao objeto usuário
        usuario.enderecos = response

        // Busca o endereço principal do usuário
        const [enderecoPrincipal] = response.filter(
          (endereco) => endereco.Principal,
        )
        usuario.enderecoPrincipal = enderecoPrincipal

        // Se não tem um endereço principal define o primeiro.
        !usuario.enderecoPrincipal && (usuario.enderecoPrincipal = response[0])

        gif.end()
        if (typeof callback === 'function') {
          callback()
        }
      } else {
        gif.end()
      }
    })
  } else {
    gif.end()
  }
}

function removerProdutoStor(idProd, codTicks, agrupamento) {
  const callback = () => {
    $('.message-box button:first-of-type').on('click', () => {

      codTicks = Number(codTicks)

      if (agrupamento) {
        storeOrder.Itens = storeOrder.Itens.filter(item => item.CodTicksGrupo != codTicks)
      } else {
        storeOrder.Itens = storeOrder.Itens.filter(item => item.CodTicks != codTicks)
      }

      const item = select('#item-' + codTicks)
      if (item) {
        if (agrupamento) {
          item.parentElement.parentElement.parentElement.remove()
        } else {
          item.parentElement.remove()
        }
      }

      if (storeOrder.Itens.length == 0) {
        storeOrder = {
          Itens: [],
          Sabores: [],
        }

        select('#pedido .app-bar img').click()
        select('#btn-pedido').remove()

        localStorage.removeItem(`pedido-mobile-${estabelecimento.urlEmpresa}`)
      } else {
        storeOrder.valorTotal = 0
        storeOrder.Itens.forEach((item) => {
          storeOrder.valorTotal += item.ValorTotal
        })

        let taxa = 0
        const endereco =
          usuario.enderecoSelecionado ||
          usuario.enderecoPrincipal ||
          usuario.enderecos[0]
        if ((estabelecimento.tipoEntrega == 'raio' || estabelecimento.tipoEntrega == 'distancia') && endereco) {
          taxa = endereco.TaxaEntrega
        } else {
          taxa = storeOrder.TaxaEntrega ? storeOrder.TaxaEntrega : 0
        }

        if (
          estabelecimento.entregaGratis > 0 &&
          storeOrder.valorTotal > estabelecimento.entregaGratis
        ) {
          taxa = 0
        } else {
          if (storeOrder.TaxaAntiga) {
            taxa = storeOrder.TaxaAntiga
          }
        }
        select('#taxa-entrega').textContent = format.money(taxa)
        const total = format.money(storeOrder.valorTotal + taxa)
        select('#sub-total').textContent = total
        select('#total-pedido').textContent = total

        storage.set(`pedido-mobile-${estabelecimento.urlEmpresa}`, {
          ...storeOrder,
          cartao: null,
        })
      }
      const btnEntrega = select('label[for="inp-entregar"]')
      const btnBusca = select('label[for="inp-buscar"]')
      if (btnEntrega && btnBusca) {
        btnBusca.click()
        btnEntrega.click()
      }

      select('.message-box').remove()
    })
    $('.message-box button:last-of-type').on('click', () => {
      select('.message-box').remove()
    })
  }
  showMessage(
    '',
    'Tem certeza que deseja remover?',
    'warning',
    '',
    callback,
    true,
    'small',
    true,
  )
}

function itensTemplate() {
  let itens_HTML = ''

  const itens = []

  //Agrupa os itens que são frutos de um sub agrupamento
  storeOrder.Itens.forEach((item) => {
    if (item.SubAgrupamentoDelivery && item.SubAgrupamentoDelivery.ObrigarEscolhaTodosItens) {

      const index = itens.findIndex((x) => x.agrupamento && item.SubAgrupamentoDelivery && x.agrupamento.Id == item.SubAgrupamentoDelivery.Id && x.CodTicksGrupo == item.CodTicksGrupo)
      //Se o agrupamento já existe, adiciona o item ao array de itens
      if (index > -1) {
        itens[index].itens.push(item)
      } else {
        //Se o agrupamento não existe, cria um novo agrupamento
        itens.push({
          itens: [item],
          agrupamento: item.SubAgrupamentoDelivery,
          CodTicksGrupo: item.CodTicksGrupo,
        })
      }
    } else {
      itens.push(item)
    }
  })

  itens.forEach((item) => {
    if (item.itens) {

      let htmlItensAgrupamento = ""
      item.itens.forEach((itemAgrupamento) => {
        htmlItensAgrupamento += criaHTMLItem(itemAgrupamento)
      })

      itens_HTML += `
      <div class="u-m-16-0 item b border-1-0 px-8" style="border-left: 2px solid #ff5c00;">
        <div class="font-14 font-500 font-laranja u-m-b-8">${item.agrupamento.Descricao}</div>     
        <div class="lista-agrupamento">
          ${htmlItensAgrupamento}
        </div>
        <div class="container-edicao">
              <img class="container-edicao__edit" src="${location.origin}/images/mobile/editar.svg" data-id-produto="${item.agrupamento.Id}" data-codticks="${item.itens[0].CodTicksGrupo}" data-agrupamento="true" >
              <img class="container-edicao__trash" src="${location.origin}/images/mobile/trash.svg" data-id-produto="${item.agrupamento.Id}" data-codticks="${item.itens[0].CodTicksGrupo}" data-agrupamento="true" >
        </div>
      </div>
         
      `
    } else {
      const htmlItem = criaHTMLItem(item)
      itens_HTML += htmlItem
    }
  })

  function criaHTMLItem(item) {
    const grupos = []
    item.Adicionais.forEach((adicional) => {
      if (grupos.length == 0) {
        grupos.push({
          adicionais: [adicional],
          idGrupo: adicional.idGrupo,
        })
      } else {
        let found = false
        grupos.forEach((item, index) => {
          if (adicional.idGrupo == item.idGrupo && !found) {
            item.adicionais.push(adicional)
            found = true
          } else if (!found && index + 1 == grupos.length) {
            grupos.push({
              adicionais: [adicional],
              idGrupo: adicional.idGrupo,
            })
          }
        })
      }
    })

    let adicional_HTML = ''
    grupos.forEach((itemGrupo) => {
      let itensAdicionaisHTML = ''
      itemGrupo.adicionais.forEach((itemAdicional) => {
        itensAdicionaisHTML += `
                     <div class="item-adicionais-itens u-flex-between">
                        <div class="item-adicionais-itens-descricao">
                            <span class="quantidade-box">${itemAdicional.Quantidade * item.Quantidade
          }</span>
                            ${itemAdicional.Adicional.Descricao.camelCase()}
                        </div>
                        <div class="item-adicionais-itens-preco">
                            ${itemAdicional.ValorTotal
            ? itemAdicional.ValorTotal > 0
              ? format.money(
                itemAdicional.ValorTotal *
                item.Quantidade,
              )
              : ''
            : ''
          }
                        </div>
                    </div>`
      })

      adicional_HTML += `
            <div class="item-adicionais">
                <div class="item-adicionais-title">
                ${itemGrupo.adicionais[0].nomeGrupo}
                </div>
                ${itensAdicionaisHTML}
            </div>`
    })

    let sabores_HTML = ''
    if (item.Sabores && item.Sabores.length > 0) {
      sabores_HTML += `
            <div class="sabores-title">Sabores</div>
            <div class="sabores-itens">`

      item.Sabores.forEach((sabor, index) => {
        let adicionaisSabor = ''
        let valorAdicionaisSabor = 0
        if (sabor.Adicionais) {
          sabor.Adicionais.forEach((adicional, index) => {
            const preco = calculaValorAdicionalSabor(
              sabor,
              adicional,
              item.Sabores.reduce((acc, sabor) => { acc += sabor.Quantidade; return acc }, 0),
              item.Quantidade,
            )
            valorAdicionaisSabor += preco
            const virgula = index != sabor.Adicionais.length - 1 ? ', ' : '.  '
            adicionaisSabor += `<span class="font-10 font-gray">${adicional.descricao} (${formatMoney(preco)})${virgula}</span>`
          })
        }

        sabores_HTML += `
                    <div class="sabor-descricao font-12 flex flex-between gap-12">
                        <span>
                            ${sabor.Quantidade +
          'x ' +
          sabor.Descricao +
          (adicionaisSabor
            ? ` (Adicionais: ${adicionaisSabor})`
            : '') +
          (index == item.Sabores.length - 1 ? '. ' : ', ')
          }
                        </span>
                        <span class="item-header-preco">
                            ${valorAdicionaisSabor > 0 ? format.money(valorAdicionaisSabor) : ''}
                        </span>
                    </div>`
      })

      sabores_HTML += '</div>'
    }

    let valorItem = 0

    if (item.isPizza) {
      valorItem = item.ValorUnitarioPizza * item.Quantidade
    } else {
      valorItem = item.ValorUnitario * item.Quantidade
    }

    return `
        <div class="item">
            <div id="item-${item.CodTicksGrupo || item.CodTicks}" class="item-header u-flex-between">
                <div class="flex gap-4">
                    <span class="quantidade-box">${item.Quantidade}</span>
                    <div class="item-header-descricao">
                        ${item.Produto_Produto.camelCase()}
                    </div>
                </div>
                 
                <div class="item-header-preco">${format.money(valorItem)}</div>
            </div>
            ${sabores_HTML}
            ${adicional_HTML}
            <div class="item-observacao">${item.Observacao ? `Observação: <span>${item.Observacao}</span>` : ''}</div>
            ${!item?.SubAgrupamentoDelivery?.ObrigarEscolhaTodosItens ? `
              <div class="container-edicao">
                <img class="container-edicao__edit" src="${location.origin}/images/mobile/editar.svg" data-id-produto="${item.idProduto}" data-codticks="${item.CodTicks}" data-adiantamento="true">
                <img class="container-edicao__trash" src="${location.origin}/images/mobile/trash.svg" data-id-produto="${item.idProduto}" data-codticks="${item.CodTicks}" data-adiantamento="true"">
            </div>
              ` : ""}
        </div>`
  }

  return itens_HTML
}

export function confirmarPedido() {

  let pagamentoOnlineSelecionado = false
  // Cria o html dos itens
  const itens = itensTemplate()

  if (estabelecimento.pixelFacebook) {
    // Aba de revisão de pedido
    if (fbq) {
      fbq('track', 'InitiateCheckout')
    } else {
      Sentry.captureException(
        `O estabelecimento ${estabelecimento.urlEmpresa} usa facebook pixel, mas o facebook SDK não foi carregado.`,
      )
    }
  }

  newPage({
    id: 'confirmar-pedido',
    appbarTitle: 'Confirmar pedido',
    classList: ` animate__animated animate__slideInRight u-500-ms}`,
    callback: () => {

      const bodyPage = select('#confirmar-pedido .page-body')

      const pontos = estabelecimento.programaFidelidade
        ? estabelecimento.programaFidelidade.cliente
          ? estabelecimento.programaFidelidade.cliente.pontos
          : ''
        : ''

      bodyPage.innerHTML = templateConfirmarPedido({
        entrega: !(
          estabelecimento.qrCode.ativo ||
          storeOrder.CodObsEntrega ||
          estabelecimento.entrega.somenteEntregaBalcao
        ),
        enderecoEntrega: formatAddress(
          usuario.enderecoSelecionado
            ? usuario.enderecoSelecionado
            : usuario.enderecoPrincipal,
        ),
        enderecoEstabelecimento: estabelecimento.endereco.toString(),
        itens,
        taxaEntrega: format.money(storeOrder.TaxaEntrega),
        totalPedidoComTaxa: format.money(
          storeOrder.valorTotal + storeOrder.TaxaEntrega,
        ),
        entregaBalcao: storeOrder.CodObsEntrega,
        qrCode: estabelecimento.qrCode.ativo,
        somenteAgendamentos: estabelecimento.agendamento.somenteAgendamentos,
        agendamentos: estabelecimento.agendamento.ativo,
        pontos: pontos || 0,
        fidelidadeAtivo: estabelecimento.programaFidelidade
          ? estabelecimento.programaFidelidade.Ativo
          : false,
      })

      const botaoSalvarPedidoContexto = select('#salva-pedido')
      if (!estabelecimento.qrCode.ativo) {
        botaoSalvarPedidoContexto.setAttribute('disabled', true)
        botaoSalvarPedidoContexto.textContent = 'Selecione uma forma de pagamento'
      }

      const containerPagamento = select('#container-pagamento')
      formasPagamento(containerPagamento, (activeTab) => {
        if (activeTab == 0) {
          pagamentoOnlineSelecionado = true
        } else {
          pagamentoOnlineSelecionado = false
        }
      })

      const diasFechados = estabelecimento.diasDelivery
        .filter((item) => item.Aberto === false)
        .map((item) => item.DiaDaSemana)
      flatpickr('#agendamento-data', {
        locale: 'pt',
        dateFormat: 'd/m/Y',
        minDate: new Date().fp_incr(estabelecimento.agendamento.intervalo),
        disableMobile: true,
        disable: [
          function (date) {
            return diasFechados.includes(date.getDay())
          },
        ],
      })

      // Estab tenha fidelidade e o usuário não seja ativo nele, apresenta uma tela de inscrição.
      if (localStorage.getItem('sem-interesse-fideliza') == null || localStorage.getItem('sem-interesse-fideliza') == undefined) {
        mensagemFidelidade()
      }

      const inputAgendamentoData = select('#agendamento-data')
      if (inputAgendamentoData) {
        inputAgendamentoData.addEventListener('input', () => {
          const inputAgendamentoHora = select('#agendamento-hora')

          let dataReversa = inputAgendamentoData.value.split('/')
          dataReversa = [dataReversa[2], dataReversa[1], dataReversa[0]].join(
            '/',
          )

          const todayIndex = new Date(dataReversa).getDay()
          const [selectedDay] = estabelecimento.diasDelivery.filter(
            (dia) => dia.DiaDaSemana == todayIndex,
          )

          const firstInterval = selectedDay.Intervalos[0]
          const lastInterval =
            selectedDay.Intervalos[selectedDay.Intervalos.length - 1]

          inputAgendamentoHora.removeAttribute('disabled')

          flatpickr('#agendamento-hora', {
            enableTime: true,
            noCalendar: true,
            dateFormat: 'H:i',
            locale: 'pt',
            minTime: firstInterval.StartTime,
            maxTime: lastInterval.EndTime,
            disableMobile: 'true',
            onReady: (_, __, fp) => {
              fp.calendarContainer.classList.add('flatpickr-mobile')
              const inputs = fp.calendarContainer.querySelectorAll('.numInput ')
              inputs.forEach((input) => input.setAttribute('readonly', ''))
            },
          })
        })
      }

      $('#troca-endereco').on('click', (event) => {
        enderecos(event.target)
      })

      if (estabelecimento.agendamento.ativo) {
        $('#agendamento-enable').on('click', (e) => {
          if (e.target.checked) {
            select('#agendamento').classList.add('enabled')
            selectAll('#agendamento [agendamento]').forEach((item) => {
              item.removeAttribute('disabled')
            })
          } else {
            select('#agendamento').classList.remove('enabled')
            selectAll('#agendamento [agendamento]').forEach((item) => {
              item.setAttribute('disabled', '')
            })
          }
        })
      }

      const programaFidelidade = select('#detalhes-programa-fidelidade')
      if (programaFidelidade) {
        programaFidelidade.addEventListener('click', abreProgramaDeFidelidade)
      }

      if (storeOrder.cupom) {
        calculaCupom(storeOrder.cupom, storeOrder)
      } else if (storeOrder.descontoFidelidade) {
        validaDescontoFidelidade(storeOrder)
      }

    },
    close: (close) => {
      select('#confirmar-pedido').classList.add('animate__slideOutRight')
      setTimeout((e) => {
        close()
      }, 500)
    },
    beforeClose: (event) => { },
    afterClose: () => {
      showPedido('animate__slideInLeft')
    },
  })

  setTimeout(function () {
    $('.page-bag').remove()
    bagButtonShow()
  }, 500)

  const buttomPedido = select('#btn-pedido')
  if (buttomPedido) {
    buttomPedido.classList.remove('visible')
  }

  const obsEntrega = select('#obs-entrega')
  if (obsEntrega) {
    obsEntrega.addEventListener('input', ({ target }) => {
      storeOrder.ObservacaoEntrega = target.value
    })
  }

  const cupom = select('#cupom-desconto')
  if (cupom) {
    cupom.addEventListener('click', () => {
      cupomDesconto(storeOrder)
    })
  }

  const botaoSalvarPedido = select('#salva-pedido')
  if (estabelecimento.qrCode.ativo) {
    botaoSalvarPedido.setAttribute('disabled', true)
    botaoSalvarPedido.textContent = 'Selecione uma forma de pagamento'
  }

  botaoSalvarPedido.addEventListener('click', () => {
    salvarPedido()
  })

}

function salvarPedido() {

  let lValid = true

  const metodoPIX = estabelecimento.pagamento.metodos.find(item => item.Prefixo == "PIX");
  const metodoSelecionado = estabelecimento.pagamento.metodos.find(item => item.Id == storeOrder.CodTipoPagamento)
  const pagamentoOnlineSelecionado = metodoSelecionado?.PagamentoOnlineMogoMenu

  // Verifica se o estabelecimento está aberto
  if (!validaAberturaEstabelecimento()) {
    return
  }

  if (storeOrder.CodObsEntrega && estabelecimento.entrega.tempoRetirada) {
    const horaAtual = new Date()
    // adiciona os minutos
    horaAtual.setMinutes(horaAtual.getMinutes() + estabelecimento.TempoRetirada)
    const horaEntrega = horaAtual.getHours() + ':' + horaAtual.getMinutes() + ':' + horaAtual.getSeconds()
    storeOrder.HoraEntregaTxt = horaEntrega
  }

  // Verifica se o agendamento é válido
  if (estabelecimento.agendamento.ativo && !validaAgendamento()) {
    return
  }

  if (lValid) {
    if (!estabelecimento.qrCode.ativo && !usuario.telefone && !storeOrder.CodObsEntrega) {
      const endereco = usuario.enderecoSelecionado || usuario.enderecoPrincipal || usuario.enderecos[0]
      usuario.telefone = endereco.Telefone
    }

    if (!estabelecimento.qrCode.ativo && !usuario.telefone) {
      const callBack = ({ nome, telefone, cpf }) => {

        storeOrder.ClienteCpf = cpf
        storeOrder.NomeEntrega = nome
        storeOrder.CelularCliente = telefone

        const salvaPedidoButton = select('#salva-pedido')
        salvaPedidoButton && salvaPedidoButton.click()

      }

      solicitaInformacoesUsuario(true, callBack)

    } else {

      storeOrder.Id = 0
      storeOrder.CodVendedor = 0
      storeOrder.CodSessaoUsuario = 0
      storeOrder.IdPedRemoteDevice = getCodTicks()
      storeOrder.IdSocket = estabelecimento.idSocket

      if (!estabelecimento.qrCode.ativo) {
        if (!storeOrder.CodObsEntrega) {
          var addressOrder = usuario.enderecoSelecionado || usuario.enderecoPrincipal

          storeOrder.NomeEntrega = addressOrder.Apelido
          storeOrder.logradouro = addressOrder.Rua
          storeOrder.Bairro = addressOrder.StrBairro
          storeOrder.Numero = addressOrder.Numero
          storeOrder.Complemento = addressOrder.Complemento
          storeOrder.CEP = addressOrder.CEP
          storeOrder.Cidade = addressOrder.Cidade.Nome
          storeOrder.Estado = addressOrder.UFCidade.Sigla || addressOrder.UFCidade.Descricao
          storeOrder.TaxaEntrega = estabelecimento.semTaxaEntrega ? 0 : addressOrder.TaxaEntrega ? addressOrder.TaxaEntrega : 0
        } else {
          storeOrder.TaxaEntrega = 0
        }

        usuario.enderecoSelecionado = ''
        storeOrder.TipoPedido = 2

        // Valida se o usuário tem telefone cadastrado
        if (usuario.telefone) {
          storeOrder.CelularCliente = usuario.telefone
        } else {
          if (usuario.enderecoPrincipal && usuario.enderecoPrincipal.Telefone) {
            storeOrder.CelularCliente = usuario.enderecoPrincipal.Telefone
          }
        }

        //Aqui
        if (pagamentoOnlineSelecionado && (dadosCartao || storeOrder.TokenCript)) {
          const [codigoPagamentoOnline] =
            estabelecimento.pagamento.metodos.filter(
              (payments) => payments.Prefixo === 'OLON',
            )

          if (codigoPagamentoOnline) {
            storeOrder.CodTipoPagamento = codigoPagamentoOnline.Id
          }
        } else {
          if (pagamentoOnlineSelecionado && storeOrder.CodTipoPagamento == metodoPIX.Id) {

          } else {
            const selecionado = select('.outra-forma-pag.selecionado')
            if (selecionado) {
              const idPagamento = selecionado.getAttribute('id')
              storeOrder.CodTipoPagamento = idPagamento.parseNumber()
            }
          }
        }

        if (storeOrder.descontoFidelidade) {
          storeOrder.ValorDesconto = storeOrder.descontoFidelidade.desconto
          storeOrder.PontosUtilizados = storeOrder.descontoFidelidade.pontosGastos
        }

        if (estabelecimento.programaFidelidade.ativo && storeOrder.descontoFidelidade
        ) {
          estabelecimento.programaFidelidade.cliente.pontos -= storeOrder.descontoFidelidade.pontosGastos
        }

        storeOrder.Itens = separaItensPedido(storeOrder.Itens)
        storeOrder.TokenFirebase = usuario.tokenFirebase || ''

        if (!storeOrder.CodObsEntrega) {
          if (estabelecimento.tipoEntrega == 'bairro' && addressOrder.Bairro && (!addressOrder.Bairro.ExibirDelivery || !addressOrder.Bairro.Ativo)
          ) {
            storeOrder.Bairro = ''
            showMessage(
              'Erro ao salvar pedido',
              'Este estabelecimento não realiza entregas no bairro selecionado.',
              'warning',
              'Entendi',
              () => {
                const button = select('.message-box button')
                button &&
                  $(button).on('click', function () {
                    select('.message-box').remove()
                  })
              },
            )
            return
          }
        }

        if (storeOrder.ValorDesconto) {
          storeOrder.ReaisDesconto = storeOrder.ValorDesconto
        }

        // Só para garantir que o usuário tenha um telefone válido
        if (storeOrder.CelularCliente.trim().length <= 8) {
          showMessageBox({
            id: 'alert-message',
            icon: 'warning',
            message: 'Verifique o telefone celular para prosseguir.',
            classList: 'no-icon-background small',
            noEffect: true,
            body: `
                            <div class="dlgConfirmaTelefone" style="display: flex; flex-direction: column; gap: 4px;">
                                <span class="text" style="font-weight: 500;">Insira um telefone válido: </span>
                                <div class="divInput" style="display: flex; flex-direction: column; gap: 10px;">
                                    <input type="text" id="telefone-cliente" placeholder="(99) 9 9999-9999" style="font-weight: 500; border: 1px solid #dbdbdb; border-radius: 4px; height: 25px; padding: 5px; color: #3d3d3d;" />
                                <div>
                            </div>
                        `,
            buttons: [
              {
                id: 'confirm-telefone',
                text: 'Salvar',
                classList: 'btn-small-primary btn-green',
                callback: () => {
                  const containerMessage = select('#alert-message')
                  const btnMessage = select('#confirm-telefone')
                  $('#telefone-cliente').mask('(99) 99999-9999')
                  btnMessage.addEventListener('click', () => {
                    const validarTelefone = (telefone) => {
                      const regex = /^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/
                      return regex.test(telefone)
                    }

                    // Valido se o telefone é válido
                    const elementInput = select('#telefone-cliente')
                    if (validarTelefone(elementInput.value)) {
                      storeOrder.CelularCliente = elementInput.value
                      usuario.telefone = elementInput.value
                      containerMessage.remove()
                      window.scrollTo({
                        top: scrollPosition,
                      })
                      toast('Telefone salvo com sucesso!')
                    } else {
                      toast('Telefone inválido.')
                    }
                  })
                },
              },
            ],
          })

          return
        }

        storage.set('pedidoTemp' + estabelecimento.urlEmpresa, { ...storeOrder, cartao: null, })
        const sicredi = metodoPIX?.Bandeiras?.find(item => item.Bandeira?.IntegradorPIX?.Banco == "SICREDI")
        const pagamentoPIXOnline = (estabelecimento.utilizaIntegracaoPagarme || sicredi) && pagamentoOnlineSelecionado && storeOrder.CodTipoPagamento == metodoPIX.Id && !storeOrder.pixNaEntrega

        if (pagamentoPIXOnline && !sicredi) {
          const autorizado = verificaAutorizacaoPix()
          if (!autorizado) {
            return
          }
        }

        let steps
        if (!select('.wrapper-message-pedido-salvo')) {
          steps = mensagemSalvandoPedido(pagamentoPIXOnline)
        }

        let log = ''

        if (usuario.logado) {
          log = JSON.stringify({
            endereco: usuario.enderecoSelecionado || usuario.enderecoPrincipal,
            pedido: storeOrder,
            usuario,
          })
        }

        if(estabelecimento.entrega.percentualTaxaEntrega > 0){
          storeOrder.IsPercentualTaxaEntrega = true
        }
        
        const order = JSON.parse(JSON.stringify(storeOrder))

        /* Formata a tipagem dos valores do pedido, transformando decimais em string
                        é necessário fazer isso pois o backend não aceita valores com decimais */
        formataValoresPedido(order)
        order.Itens.forEach((item) => {
          if (item.Sabores) {
            item.Sabores.forEach((sabor) => {
              sabor.Valor = formatDecimal(sabor.Valor)
              if (sabor.IdSlave) {
                sabor.CodSabor = sabor.IdSlave.toString()
              }

              if (sabor.Adicionais) {
                if (!item.AdicionaisXSabor) {
                  item.AdicionaisXSabor = []
                }
                sabor.Adicionais.forEach((adicional) => {
                  // const valorAdicional = calculaValorAdicionalSabor(sabor, adicional, item.Sabores.length)
                  item.AdicionaisXSabor.push({
                    CodSabor: Number(sabor.CodSabor),
                    CodAdicional: Number(adicional.id),
                    Quantidade: 1,
                    ValorTotal: formatMoney(adicional.preco, true),
                    ValorUnitario: formatMoney(adicional.preco, true),
                    Descricao: adicional.descricao,
                  })
                })
              }
            })
          }

          item.ValorAPagar = formatDecimal(item.ValorAPagar)
          item.ValorComAdicionais = formatDecimal(item.ValorComAdicionais)
          item.ValorTotal = formatDecimal(item.ValorTotal)
          item.ValorUnitario = formatDecimal(item.ValorUnitario)

          if (item.Adicionais && item.Adicionais.length > 0) {
            item.Adicionais.forEach((adicional) => {
              adicional.ValorTotal = formatDecimal(adicional.ValorTotal)
              adicional.ValorUnitario = formatDecimal(adicional.ValorUnitario)
              adicional.IdSlave && (adicional.Id = adicional.IdSlave)

              if (adicional.Adicional) {
                const instancia = adicional.Adicional
                if (instancia.IdSlave) {
                  adicional.Adicional.Id = instancia.IdSlave
                }
              }
            })
          }

          const [produto] = store.produtos.filter(
            (prod) => prod.IdProd == item.idProduto,
          )

          produto && produto.IdSlave && (item.CodProduto = produto.IdSlave)
          produto && produto.IdSlave && (item.idProduto = produto.IdSlave)
        })

        order.Ip = estabelecimento.ip
        order.Platform = window.navigator?.userAgent

        let dadosCartao = ''

        if (
          storeOrder.cartao &&
          pagamentoOnlineSelecionado &&
          !storeOrder.hashCard
        ) {
          dadosCartao = {
            Holder_name: storeOrder.cartao.nome,
            Number: storeOrder.cartao.numero,
            Cvv: storeOrder.cartao.cvv,
            Cpf: storeOrder.cartao.cpf,
            Exp_month: storeOrder.cartao.mes,
            Exp_year: storeOrder.cartao.ano,
          }
        } else {
          storeOrder.cartao = undefined
        }

        if (!pagamentoOnlineSelecionado) {
          storeOrder.hashCard = undefined
        }

        if (pagamentoOnlineSelecionado) {
          if (usuario.enderecos.length == 0 || storeOrder.CEP == '' && !sicredi) {
            select('.wrapper-message-pedido-salvo').remove()

            createMessageBox({
              content: `
              <img style="width: 100%;height: 76px;margin: 8px 0;" src="images/endereco.svg" alt="Mulher ao lado de celular exibindo um mapa">
              <div class="text-center m-12-0">Para pagamentos online, você precisa informar um endereço.</div>
              <div class="flex-column gap-8">
                  <button class="btn-azul">Cadastrar endereço</button>
                  <button class="btn-transparent">Alterar forma de pagamento</button>
              </div>
              `,
              beforeAppend: (wrapper) => {
                const btnCadastrarEndereco = select('.btn-azul', wrapper)
                const btnAlterarFormaPagamento = select(
                  '.btn-transparent',
                  wrapper,
                )

                btnCadastrarEndereco.addEventListener('click', (E) => {
                  prevent(E)
                  select('.message-box').remove()
                  cadastrarNovoEndereco({
                    obrigatorioCPF: true,
                  })
                })

                btnAlterarFormaPagamento.addEventListener('click', (E) => {
                  prevent(E)
                  select('.message-box').remove()
                })
              },
            })

            return
          } else {
            order.CEP = (
              usuario.enderecoSelecionado || usuario.enderecoPrincipal
            ).CEP
            order.Bairro = (
              usuario.enderecoSelecionado || usuario.enderecoPrincipal
            ).StrBairro
            order.Cidade = (
              usuario.enderecoSelecionado || usuario.enderecoPrincipal
            ).CidadeStr || (usuario.enderecoSelecionado || usuario.enderecoPrincipal).Cidade?.Nome
            order.Estado = (usuario.enderecoSelecionado || usuario.enderecoPrincipal)?.UFCidade?.Sigla || (usuario?.enderecoSelecionado || usuario?.enderecoPrincipal)?.UFCidade?.Descricao
            order.Numero = (
              usuario.enderecoSelecionado || usuario.enderecoPrincipal
            ).Numero
            order.logradouro = (
              usuario.enderecoSelecionado || usuario.enderecoPrincipal
            ).Rua
            order.Complemento = (
              usuario.enderecoSelecionado || usuario.enderecoPrincipal
            ).Complemento
          }
        }

        if (usuario && usuario.UtilizaProgramaFidelidade) {
          order.UtilizaProgramaFidelidade = true
          order.Nascimento = usuario.dataNascimento?.includes('-')
            ? usuario.dataNascimento
            : convertBRDateToAmerican(usuario.dataNascimento || '')
          order.Sexo =
            (usuario.sexo == 0 ? 'Masculino' : 'Feminino') || 'Outros'
        }

        if (storeOrder.CodObsEntrega == window.codigoBuscaBalcao) {
          order.VemBuscar = true;
        }

        order.ClienteCpf = usuario.cpf || order.ClienteCpf || ''

        setTimeout(function () {
          if (isDebug) {
            debugger
          }

          steps && steps[0].classList.add('success')
          steps && steps[1].classList.remove('pendente')
          const dadosCartaoSerializado = dadosCartao
            ? JSON.stringify(dadosCartao)
            : ''

          //continuar aqui
          const messageBox = select('.wrapper-message-pedido-salvo')
          if (pagamentoPIXOnline && !storeOrder.pixPago) {
            if (sicredi) {
              axios.get(getUrlAction('pedido', 'CriaCobrancaPIXAsyncX'), {
                params: {
                  idBandeira: metodoPIX.Bandeiras[0].IdBandeira,
                  valor: storeOrder.valorTotal,
                }

              }).then((response) => {
                const { data } = response
                //   {
                //     "lValid": true,
                //     "cErro": "",
                //     "chavePIX": "00020126880014br.gov.bcb.pix2566pix-qrcode-h.sicredi.com.br/qr/v2/d3bf67d5ad614281906727a3c80326765204000053039865802BR5903PIX6006Cidade62070503***6304C5C6",
                //     "ret": "{\"calendario\":{\"criacao\":\"2025-04-29T17:21:41.479Z\",\"expiracao\":300},\"status\":\"ATIVA\",\"txid\":\"337e0b768b30499a97ea144255d9c0b1\",\"revisao\":0,\"location\":\"pix-qrcode-h.sicredi.com.br/qr/v2/d3bf67d5ad614281906727a3c8032676\",\"loc\":{\"id\":322810,\"location\":\"pix-qrcode-h.sicredi.com.br/qr/v2/d3bf67d5ad614281906727a3c8032676\",\"tipoCob\":\"cob\",\"criacao\":\"2025-04-29T17:21:41.477Z\"},\"valor\":{\"original\":\"200.00\",\"modalidadeAlteracao\":0,\"retirada\":null},\"chave\":\"+5546991249393\",\"solicitacaoPagador\":\"Avalie a sua experiência\",\"infoAdicionais\":[{\"nome\":\"Detalhes do Pagamento\",\"valor\":\"Pedido no Mogo Gourmet\"}],\"pixCopiaECola\":\"00020126880014br.gov.bcb.pix2566pix-qrcode-h.sicredi.com.br/qr/v2/d3bf67d5ad614281906727a3c80326765204000053039865802BR5903PIX6006Cidade62070503***6304C5C6\"}"
                // }

                if (!data.lValid) {
                  steps && steps[1].classList.add('pendente')
                  steps && steps[1].classList.add('font-red')
                  const divError = createElement(
                    'div',
                    { class: 'm-t-8 font-500 font-13 font-red' },
                    'Erro ao gerar QRCode',
                  )
                  steps && steps[1].parentElement.appendChild(divError)

                  const buttonAcompanhar = select('.btn-acompanhar', messageBox)
                  buttonAcompanhar && buttonAcompanhar.remove()
                } else {
                  steps && steps[1].classList.add('success')


                  const ret = JSON.parse(data.ret)
                  const txid = ret.txid

                  //gera uma imagem do qrcode com o link do pix                                  

                  exibeQrCodePIX(null, null, null, data.chavePIX, true, txid, metodoPIX.Bandeiras[0].IdBandeira)
                }
              })
            } else {
              axios.post(getUrlAction('pedido', 'GerarQRCode'), {
                pedido: JSON.stringify(order)
              }, {
                headers: {
                  'Content-Type': 'application/json',
                },
              })
                .then((response) => {
                  const { data } = response

                  if (!data.sucesso) {
                    steps && steps[1].classList.add('pendente')
                    steps && steps[1].classList.add('font-red')
                    const divError = createElement(
                      'div',
                      { class: 'm-t-8 font-500 font-13 font-red' },
                      'Erro ao gerar QRCode',
                    )
                    steps && steps[1].parentElement.appendChild(divError)

                    const buttonAcompanhar = select('.btn-acompanhar', messageBox)
                    buttonAcompanhar && buttonAcompanhar.remove()
                  } else {
                    steps && steps[1].classList.add('success')

                    exibeQrCodePIX(
                      data.qrCodeLink,
                      '',
                      data.order_id,
                      data.qrCode,
                    )
                  }
                })
                .catch((error) => {
                  const messageBox = select('.wrapper-message-pedido-salvo')
                  messageBox && messageBox.remove()
                  toast(error.message || 'Erro ao gerar QRCode')
                })
            }

          } else {

            order.DbName = estabelecimento.urlEmpresa || urlEstabelecimento

            $.ajax({
              type: 'POST',
              url: getUrlAction('Pedido', 'SalvaPedido'),
              timeout: 60000,
              data: {
                jsonPedido: JSON.stringify(order),
                dataEntregaTicks: storeOrder.DataEntregaTicks || '',
                log,
                dadosCartao: dadosCartaoSerializado,
                salvarCartao: storeOrder.saveCard,
                hashCartao: storeOrder.hashCard,
              },
              success: function (response) {
                const status = JSON.parse(response)

                const buttons = select('.buttons-message', messageBox)
                buttons.removeAttribute('disabled')

                if (status.lValid) {
                  processaPedidoSalvo(response, metodoSelecionado)

                  if (estabelecimento.pixelFacebook) {
                    // Comprou um item do seu catálogo
                    if (fbq) {
                      fbq('track', 'Purchase', {
                        currency: 'BRL',
                        value: storeOrder.valorTotal,
                      })
                    } else {
                      Sentry.captureException(
                        `O estabelecimento ${estabelecimento.urlEmpresa} usa facebook pixel, mas o facebook SDK não foi carregado.`,
                      )
                    }
                  }

                  // Faz o rastreio para o mixpanel
                  rastreioPedido(order)
                } else {

                  if (status.Action) {
                    // if (status.Action == 'reload') {
                    //   alert("Sua sessão expirou, por favor, faça login novamente.")
                    //   location.reload()
                    // }
                  }

                  erroAoSalvarPedido(status, pagamentoOnlineSelecionado)
                }
              },
              error: function () {
                erroAoSalvarPedido({}, pagamentoOnlineSelecionado)
              },
            })
          }
        }, 100)
      } else {
        storeOrder.TaxaEntrega = undefined
        storeOrder.TipoPedido = estabelecimento.qrCode.modoSenha ? 1 : 0
        storeOrder.NumeroCartao = estabelecimento.comanda.numero
        storeOrder.DescMesa = estabelecimento.mesa
        storeOrder.idCliente = usuario.id

        const salvaPedido = () => {
          if (estabelecimento.qrCode.ativo) {
            storeOrder.IdentificadorQRCode = usuario.identificadorQRCode
          }

          storeOrder.valorTotal = formatDecimal(storeOrder.valorTotal)

          storeOrder.ValorTotalPedido = formatDecimal(storeOrder.valorTotal)

          if (
            estabelecimento.comanda.ativo &&
            estabelecimento.comanda.hashLocal
          ) {
            storeOrder.HashSegurancaComanda = estabelecimento.comanda.hashLocal
          }

          const order = JSON.parse(JSON.stringify(storeOrder))

          order.Itens.forEach((item) => {
            const [produto] = store.produtos.filter(
              (prod) => prod.IdProd == item.idProduto,
            )

            produto && produto.IdSlave && (item.CodProduto = produto.IdSlave)
            produto && produto.IdSlave && (item.idProduto = produto.IdSlave)
          })

          let botaoConfirmarPedido
          if (estabelecimento.qrCode.ativo) {
            botaoConfirmarPedido = select('#pedido')
          } else {
            botaoConfirmarPedido = select('#confirmar-pedido')
          }

          gif.fullScreen(botaoConfirmarPedido, 'Salvando pedido')

          setTimeout(function () {
            $.ajax({
              type: 'POST',
              url: getUrlAction('Pedido', 'SalvaPedidoEstatico'),
              data: {
                jsonPedido: JSON.stringify(order),
                urlEmpresa: estabelecimento.urlEmpresa,
              },
              success: function (response) {
                const valorTotal =
                  typeof order.valorTotal === 'string'
                    ? decimalStringToNumber(order.valorTotal)
                    : order.valorTotal
                track('Pedido', {
                  valorTotal,
                })

                storage.remove(`pedido-mobile-${estabelecimento.urlEmpresa}`)

                let retorno
                try {
                  response = JSON.parse(response)
                  retorno = JSON.parse(response.retorno)

                  if (retorno.ret != '') {
                    const ret = JSON.parse(retorno.ret)
                    retorno = {
                      ...retorno,
                      ...ret,
                    }
                  }
                } catch (e) { }

                if (retorno.lValid) {
                  if (estabelecimento.qrCode.modoTablet) {
                    estabelecimento.comanda.numero = ''
                  }

                  estabelecimento.comanda.hashLocal = response.hashComanda
                  localStorage.setItem(
                    'hashLocal',
                    estabelecimento.comanda.hashLocal,
                  )

                  let configuracoesStorage = localStorage.getItem(
                    'configuracoes-qrcode',
                  )
                  if (configuracoesStorage) {
                    configuracoesStorage = JSON.parse(configuracoesStorage)
                    if (configuracoesStorage.hashComanda)
                      configuracoesStorage.hashComanda.hash =
                        estabelecimento.comanda.hashLocal
                    localStorage.setItem(
                      'configuracoes-qrcode',
                      JSON.stringify(configuracoesStorage),
                    )
                  }

                  gif.end(select('#gif-fullScreen'))

                  const idPedidoTemporario =
                    'pedido-temporario-' +
                    estabelecimento.urlEmpresa +
                    usuario.id
                  // Salva no storage para que o pedido seja exibido na tela de pedidos rapidamente
                  storage.set(idPedidoTemporario, storeOrder)

                  let message = `
                  <div>Seu pedido foi salvo</div>
                  <div>Aguarde a confirmação do estabelecimento na página de pedidos</div>
                  `
                  if (retorno.Senha && estabelecimento.qrCode.modoSenha) {
                    const pedidoSenha = {
                      id: retorno.IdPedido,
                      senha: retorno.Senha,
                      numeroPedido: retorno.NumeroPedido,
                      data: format.date(new Date()),
                      hora: format.hour(new Date()),
                    }

                    let listaPedidos = localStorage.getItem('pedidos-senha')
                    if (listaPedidos) {
                      listaPedidos = JSON.parse(listaPedidos)
                      listaPedidos.push(pedidoSenha)
                    } else {
                      listaPedidos = [pedidoSenha]
                    }

                    storage.set('pedidos-senha', listaPedidos)

                    message = `
                                            <div class="mensagem-senha">
                                                <div class="mensagem-senha__titulo">Seu pedido foi salvo</div>
                                                <div class="m-28-0">
                                                    <div class="mensagem-senha__gray">SENHA</div>
                                                    <div class="mensagem-senha__senha">${retorno.Senha}</div>
                                                </div>
                                                <div class="mensagem-senha__ajuda">Esta é sua senha para retirar o pedido, você pode consultar sempre que precisar atráves do menu do aplicativo.</div>
                                            </div>
                                            `
                  }

                  showMessageBox({
                    id: 'alert-message',
                    icon: 'success',
                    message,
                    classList: 'no-icon-background small',
                    buttons: [
                      {
                        id: 'go-along',
                        text: 'OK',
                        classList: 'btn-small-primary btn-green',
                        callback: () => {
                          const containerMessage = select('#alert-message')
                          containerMessage.addEventListener('click', () => {
                            storeOrder = {
                              Itens: [],
                              Sabores: [],
                            }

                            $('#confirmar-pedido').remove()
                            $('#btn-pedido').remove()
                            $('#pedido').remove()
                            containerMessage.remove()
                          })
                        },
                      },
                    ],
                  })

                  if (estabelecimento.offline) {
                    const storageKey = getKeyOrders()

                    const orderList = storage.get(storageKey)
                    if (orderList) {
                      orderList.push({ ...storeOrder, cartao: null })
                      storage.set(storageKey, orderList)
                    } else {
                      storage.set(storageKey, [{ ...storeOrder, cartao: null }])
                    }
                  }
                } else {
                  gif.end(select('#gif-fullScreen'))
                  showMessage(
                    'Erro',
                    retorno.Erro || 'Erro ao salvar pedido, tente novamente.',
                    'error',
                    'Ok',
                    () => {
                      const button = select('.message-box button')
                      button &&
                        $(button).on('click', function () {
                          select('.message-box').remove()
                        })
                    },
                  )
                }
              },
              error: function (e) {
                gif.end(select('#gif-fullScreen'))
                showMessage(
                  'Erro',
                  'Erro ao salvar pedido, tente novamente.',
                  'error',
                  'Ok',
                  () => {
                    const button = select('.message-box button')
                    button &&
                      $(button).on('click', function () {
                        select('.message-box').remove()
                      })
                  },
                )

                // SaveException(e, 'Salva pedido', JSON.stringify(storeOrder))
              },
            })
          }, 100)
        }
        if (
          estabelecimento.qrCode.ativo &&
          estabelecimento.qrCode.solicitaInformacoesClienteQRCode
        ) {
          solicitaInformacoesUsuario(false, (retorno) => {
            storeOrder.NomeEntrega = retorno.nome
            storeOrder.CelularCliente = retorno.telefone
            storeOrder.ClienteCpf = retorno.cpf
            continuar()
          })
          return
        } else {
          continuar()
        }

        function continuar() {
          if (estabelecimento.qrCode.modoSenha) {
            if (
              !estabelecimento.qrCode.nomeCliente ||
              !estabelecimento.qrCode.celularCliente
            ) {
              estabelecimento.qrCode.nomeCliente =
                localStorage.getItem('nomeQRCode')
              estabelecimento.qrCode.celularCliente =
                localStorage.getItem('celularQRCode')

              if (
                !estabelecimento.qrCode.nomeCliente ||
                !estabelecimento.qrCode.celularCliente
              ) {
                const salvaPedidoButton = select('#salva-pedido')
                const callback = (info) => {
                  estabelecimento.qrCode.nomeCliente = info.nome
                  estabelecimento.qrCode.celularCliente = info.telefone

                  storeOrder.CelularCliente =
                    estabelecimento.qrCode.celularCliente
                  storeOrder.NomeEntrega = estabelecimento.qrCode.nomeCliente
                  salvaPedidoButton.click()
                }

                solicitaInformacoesUsuario(false, callback)
                return
              }
            }
          }

          if (
            estabelecimento.comanda.numero &&
            !estabelecimento.qrCode.modoTablet &&
            !estabelecimento.qrCode.obrigarLeituraDaComanda
          ) {
            // Foi feito apenas para o Regelli que é em anexo ao Regente Hotel
            const ehRegente = estabelecimento.urlEmpresa == 'regente'

            dialog({
              title: `${ehRegente ? 'Quarto/Mesa' : 'Mesa'}`,
              classList: 'dialog-mesa',
              pedeMesa: true,
              body: `
                                <span>${ehRegente ? 'Qual é o número do quarto ou mesa?' : 'Qual é o número da mesa?'}</span>
                                <input id="numero-mesa" type="number" placeholder="${ehRegente ? 'Quarto/Mesa' : 'Mesa'}" class="input" required />
                                <div class="flex">
                                    <button class="btn btn-seccondary small">Voltar</button>
                                    <button class="btn btn-primary small">Confirmar</button>
                                </div>`,
              function: () => {
                const mesaAssociada = localStorage.getItem('mesa-associada')

                if (mesaAssociada) {
                  const inputMesa = select('#numero-mesa')
                  if (inputMesa) {
                    inputMesa.value = mesaAssociada
                  }
                }
                select('.dialog-mesa .btn-seccondary').addEventListener(
                  'click',
                  () => {
                    const dlgMesa = select('.dialog.pede-mesa')
                    if (dlgMesa) {
                      dlgMesa.remove()
                    }
                  },
                )
                select('.dialog-mesa .btn-primary').addEventListener(
                  'click',
                  () => {
                    let strMesa = select('#numero-mesa').value

                    if (!strMesa) {
                      toast('Digite o número da mesa antes de continuar.')
                    } else {
                      const numberMesa = Number(strMesa)
                      if (
                        (estabelecimento.faixamesa &&
                          numberMesa <
                          estabelecimento.faixamesa.NumeroMesaInicial) ||
                        numberMesa > estabelecimento.faixamesa.NumeroMesaFinal
                      ) {
                        toast('Mesa não encontrada.')
                      } else {
                        if (Number(strMesa) < 10 && strMesa.length == 1) {
                          strMesa = '0' + strMesa
                        }

                        storeOrder.DescMesa = strMesa
                        localStorage.setItem('mesa-associada', strMesa)
                        const dlgMesa = select('.dialog.pede-mesa')
                        if (dlgMesa) {
                          dlgMesa.remove()
                        }
                        salvaPedido()
                      }
                    }
                  },
                )
              },
            })
          } else {
            salvaPedido()
          }
        }
      }
    }

    savesInteraction(5)
  }

  function erroAoSalvarPedido(status, pagamentoOnlineSelecionado) {
    let mensagem = 'Erro ao salvar pedido'
    if (!status.PagamentoOnlineConcluido && pagamentoOnlineSelecionado) {
      if (status.MensagemErroPagamentoOnline.includes('code 422')) {
        status.mensagemErroPagamentoOnline =
          'Ocorreu um erro ao efetuar o pagamento, verifique os dados do cartão e tente novamente.'
      }

      mensagem =
        status.MensagemErroPagamentoOnline ||
        'Erro ao efetuar pagamento, tente uma forma de pagamento diferente.'
    }

    const step = select('[step="2"]')
    step.innerHTML = `
            <svg viewBox="0 0 24 24" width="16" height="16" stroke="#C73E1D" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
            <span class="text">${mensagem}</span>
            `
    const buttons = select('.buttons-message')
    buttons.removeAttribute('disabled')
    const tentarNovamente = createElement(
      'button',
      { class: 'btn btn-primary tentar-novamente' },
      'Tentar novamente',
    )
    buttons.appendChild(tentarNovamente)
    buttons.querySelector('#acompanhar').remove()

    if (!status.PagamentoOnlineConcluido && pagamentoOnlineSelecionado) {
      tentarNovamente.classList.add('oculto')
    }

    tentarNovamente.addEventListener('click', () => {
      select('.wrapper-message-pedido-salvo').remove()
      select('#salva-pedido').click()
    })

    const btnFechar = select('#fechar')
    btnFechar.addEventListener('click', (event) => {
      prevent(event)
      select('.wrapper-message-pedido-salvo').remove()
    })
  }
}

function acompanharPedido(idPedido, scrollPosition, el) {
  const pagina = document.createElement('div')
  const height = window.innerHeight + 'px'

  pagina.id = 'pg' + random()
  pagina.classList.add('u-viewport')
  pagina.style.top = scrollPosition + 'px'
  pagina.style.height = height

  document.body.style.height = height
  document.querySelector('#app').style.height = height

  setTimeout(function () {
    const cUrl = getUrlAction('Pedido', 'GetPedidoById')
    $.ajax({
      type: 'GET',
      url: cUrl,
      data: {
        idPedido,
      },
      success: function (response, status, xhr) {
        const statusPedido = JSON.parse(response).pedidoDel

        const bodyEl = select('.acmp-pedido__body')
        gif.end(bodyEl)

        const statusTemplate = document.createElement('div')
        statusTemplate.classList = 'acmp-pedido__body-container'

        const lidoColor = statusPedido.HoraPedido ? '#0EC140' : '#BEBEBE'
        const lidoHTML = `
                        <div class="step">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z" stroke="${lidoColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15 7.5V15L20 17.5" stroke="${lidoColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div>
                                <span>Seu pedido foi lido e está sendo preparado.</span>
                                <span>Hoje às ${statusPedido.HoraPedido.substring(
          0,
          5,
        )}.</span>
                            </div>
                        </div>`

        const engregueColor = statusPedido.HoraEntrega ? '#0EC140' : '#BEBEBE'
        const prontoHTML = `
                        <div class="step">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.25 7.5V27.5L10 22.5L20 27.5L28.75 22.5V2.5L20 7.5L10 2.5L1.25 7.5Z" stroke="${engregueColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10 2.5V22.5" stroke="${engregueColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M20 7.5V27.5" stroke="${engregueColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div>
                                <span>${statusPedido.HoraEntrega
            ? 'Seu pedido saiu para a entrega. '
            : ''
          }</span>
                                <span>${statusPedido.HoraEntrega
            ? 'Hoje às' +
            statusPedido.HoraEntrega.substring(0, 5)
            : ''
          }.</span>
                            </div>
                        </div>
                    `

        const pagoColor =
          statusPedido.HoraAcerto && statusPedido.HoraEntrega
            ? '#0EC140'
            : '#BEBEBE'
        const entregueHTML = `
                        <div class="step">
                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.3334 8.5L12.75 24.0833L5.66669 17" stroke="${pagoColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div ${statusPedido.HoraAcerto &&
            statusPedido.HoraEntrega
            ? ''
            : "style='display: none'"
          }>
                                <span>Pedido entregue!.</span>
                                <span>Hoje às ${statusPedido.HoraAcerto &&
            statusPedido.HoraEntrega
            ? statusPedido.HoraAcerto.substring(0, 5)
            : ''
          }.</span>
                            </div>
                        </div>
                        </div>
                        `

        let timeString = ''
        if (estabelecimento.agendamento.ativo) {
          timeString =
            statusPedido.DataEntregaTxt +
            ' às ' +
            statusPedido.HoraEntregaTxt.slice(0, 5)
        } else {
          timeString =
            addMinutes(new Date(), Number(estabelecimento.tempoEntrega[0])) +
            ' - ' +
            addMinutes(new Date(), Number(estabelecimento.tempoEntrega[1]))
        }
        statusTemplate.innerHTML = `
                    <div class="acmp-pedido__body-previsao" ${timeString ? '' : "style='display=none'"
          }>
                        <div>${estabelecimento.agendamento.ativo &&
            statusPedido.DataEntregaTxt &&
            statusPedido.HoraEntregaTxt
            ? 'Previsão de entrega:'
            : 'Agendado para:'
          }</div>
                        <div id="acmp-pedido-previsao">${timeString}</div>
                    </div>
                    <div class="acmp-pedido__body-status">
                        ${lidoHTML}
                        <div class="acmp-pedido__body-line"></div>
                        ${prontoHTML}
                        <div class="acmp-pedido__body-line"></div>
                        ${entregueHTML}
                    </div>`

        bodyEl.insertAdjacentElement('afterbegin', statusTemplate)

        let size = elementHeigth(
          document.querySelector('.acmp-pedido__body-status'),
          {
            margin: false,
          },
        )
        const sizeStep = elementHeigth(document.querySelector('.step'))
        size -= sizeStep * 3
        size /= 2
        selectAll('.acmp-pedido__body-line').forEach(
          (el) => (el.style.height = size + 'px'),
        )

        const button = bodyEl.querySelector('button')
        $(button).on('click', function () {
          pagina.remove()
        })
      },
      error: function () { },
    })
  }, 100)

  pagina.innerHTML = `
        <div class="acmp-pedido u-page">
            <div class="acmp-pedido__capa">
                <img src="${storeInfoEstab.capa}">
            </div>
            <div class="acmp-pedido__header">
                <div class="acmp-pedido__header-logo">
                    <img src="${estabelecimento.logo}">
                </div>
            </div>
            <div class="acmp-pedido__body">
                    ${gif.start('', 'gif-container')}
                    <div class="acmp-pedido__body-contato"></div>
                    <div class="acmp-pedido__body-buttom"></div>
                    <button class="btn btn-primary">${el ? 'Voltar' : 'Voltar ao cardápio'
    }</button>
            </div>
        </div>`

  const body = document.body
  const appNode = select('#app')

  body.appendChild(pagina)
}

export const conectarSocketOlivo = () => {
  if (usuario.logado) {
    axios
      .get(getUrlAction('home', 'GetSocketInfo'))
      .then(function ({ data }) {
        const [estab, idUsuario] = [data.estabelecimento, data.idUsuario]
        conectarSocket(estab, idUsuario)
      })
      .catch(function (error) {
        console.log(error)
      })
  } else if (estabelecimento.mesa) {
    conectarSocket(estabelecimento.urlEmpresa, null, estabelecimento.mesa)
  } else if (estabelecimento.comanda.numero) {
    conectarSocket(
      estabelecimento.urlEmpresa,
      null,
      estabelecimento.comanda.numero,
    )
  }

  function conectarSocket(estab, idUsuario, mesa) {
    let cUrlSocketOlivo = ''

    let idSocket = ''

    var idTicks = localStorage.getItem('idTicks')
    if (!idTicks) {
      idTicks = new Date().getTime()
      localStorage.setItem('idTicks', idTicks)
    }

    if (idUsuario) {
      usuario.id = idUsuario
      idSocket = `${idUsuario}:${estab}`
    } else if (estabelecimento.mesa) {
      idSocket = `M${estabelecimento.mesa}:${estab}+` + idTicks
    } else if (estabelecimento.comanda.numero) {
      if (
        estabelecimento.comanda.hash &&
        estabelecimento.comanda.hash == estabelecimento.comanda.hashLocal &&
        estabelecimento.comanda.hashLocal !=
        estabelecimento.comanda.hashAutorizado
      ) {
        idSocket =
          `C${estabelecimento.comanda.numero}:${estabelecimento.urlEmpresa}` +
          estabelecimento.comanda.hash
      } else {
        idSocket =
          `C${estabelecimento.comanda.numero}:${estabelecimento.urlEmpresa}` +
          idTicks
      }
    }

    estabelecimento.idSocket = idSocket

    if (isDebug) {
      cUrlSocketOlivo = `ws://localhost:1689/api/SocketOlivo?idSocket=${idSocket}`
    } else {
      cUrlSocketOlivo = `wss://${estabelecimento.urlServer}/api/SocketOlivo?idSocket=${idSocket}`
    }

    try {
      var idTicks = localStorage.getItem('idTicks')
      if (!idTicks) {
        idTicks = new Date().getTime()
        localStorage.setItem('idTicks', idTicks)
      }

      window.ws = new WebSocket(cUrlSocketOlivo)

      window.ws.onmessage = function (event) {
        const retorno = JSON.parse(event.data)

        // Lista os pedidos
        if (retorno.RemoteMethod === 1) {
          /*
                              track('Pedidos exibidos', {
                                  Estabelecimento: estabelecimento.fantasia,
                                  Offline: true
                              })
                          
                              var retMt = JSON.parse(retorno.Data)
                          
                              const pedidos = retMt.pedidosD
                              const idPedidoTemporario = 'pedido-temporario-' + estabelecimento.urlEmpresa + usuario.id
                              const pedidoTemporario = storage.get(idPedidoTemporario)
                          
                              if (pedidoTemporario) {
                          
                                  //Verifica se o pedido temporário existe foi retornado do servidor
                                  const pedidoTemporarioRecebidoDoServidor = pedidos.some(pedido => pedido.IdPedRemoteDevice == pedidoTemporario.IdPedRemoteDevice)
                          
                                  //Se sim, remove de todos os armazenamentos locais
                                  if (pedidoTemporarioRecebidoDoServidor) {
                                      storage.remove(idPedidoTemporario)
                                  } else {
                                      //Caso não, apenas adiciona ao array de pedidos para ser renderizado
                                      pedidos.push(pedidoTemporario)
                                  }
                          
                              }                
                              showPedidos(pedidos) */
        }
        // Lista um pedido individual
        else if (retorno.RemoteMethod === 2) {
          track('Carregou o pedido', {
            Estabelecimento: estabelecimento.fantasia,
            Offline: true,
          })
          var retMt = JSON.parse(retorno.Data)
          showOrderDetails(retMt.pedidoDel)
        }
        // Exibe Mensagens
        else if (retorno.RemoteMethod === 6) {
          const notificationBox = select('.notification-box')
          if (notificationBox) {
            return
          }
          showMessageBox({
            icon: 'warning',
            message: retorno.Data,
            classList: 'no-icon-background small',
            default: true,
          })
        }
        // Lista pedidos mesa
        else if (retorno.RemoteMethod === 9) {
          var retMt = JSON.parse(retorno.Data)
          storePedidosMesa = retMt.pedidosD
          showPedidos(storePedidosMesa)
        }
        // Dados do programa de fidelidade
        else if (retorno.RemoteMethod === 10) {
          estabelecimento.programaFidelidade.cliente = JSON.parse(retorno.Data)
        }
        // GetPedidosByCard
        else if (retorno.RemoteMethod === 11) {
          var retMt = JSON.parse(retorno.Data)
          storePedidosMesa = retMt.pedidosD
          showPedidos(storePedidosMesa, null, retMt.saldoFidelidade)
        }
        // Autoriza o uso de uma comanda
        else if (retorno.RemoteMethod == 12) {
          mensagemLiberarAcessoComanda(retorno)
        } else if (retorno.RemoteMethod === 13) {
          if (retorno.hash) {
            localStorage.setItem('hashLocal-autorizado', retorno.hash)
            estabelecimento.comanda.hashLocal = retorno.hash
          }

          window.socketAwaitingResponse = false
        }
      }

      window.ws.onclose = function () {
        // try to reconnect in 5 seconds
        setTimeout(function () {
          try {
            conectarSocketOlivo()
          } catch (e) {
            //
          }
        }, 5000)
      }

      window.ws.onopen = function () {
        console.warn('socket::connected')

        if (estabelecimento.offline) {
          configuraProgramaFidelidade()
        }
      }

      window.ws.onerror = function (event) {
        window.ws.close()
      }
    } catch (e) {
      //
    }
  }
}



/* PIZZAS */

/* BUSCA AS PIZZAS */

var storeItensPizza = 0
window.storePizzas = []

axios
  .get(getUrlAction('Home', 'GetPizzas'), {
    params: {
      urlEmpresa: estabelecimento.urlEmpresa,
    },
  })
  .then(function ({ data }) {
    if (data.pizzas) {
      storeItensPizza = JSON.parse(data.pizzas)
      storePizzas = storeItensPizza
      showAwaitPizza()
    }
  })
  .catch(function (error) {
    storeItensPizza = ''
    console.error(error)
  })

let storeGruposPizzas

axios
  .get(getUrlAction('Home', 'GetGruposPizzas'), {
    params: {
      urlEmpresa: estabelecimento.urlEmpresa,
    },
  })
  .then(function ({ data }) {
    if (data.gruposPizzas) {
      storeGruposPizzas = JSON.parse(data.gruposPizzas)
      showAwaitPizza()
    }
  })
  .catch(function (error) {
    storeItensPizza = ''
    console.error(error)
  })

let storeDadosItemPedido

function showAwaitPizza() {
  if (
    awaitPizza &&
    storeDadosItemPedido &&
    storeGruposPizzas &&
    storeItensPizza
  ) {
    buscaAdicionais(awaitPizza.idProduto, awaitPizza.element, '', '', 1)
    awaitPizza = undefined
  }
}

String.prototype.parseNumber = function () {
  const s = this
  let result = 0
  try {
    result = Globalize.parseFloat(s)
    if (!result) result = 0
  } catch (e) {
    result = 0
  }

  return result
}

// Página Sobre o estabelecimento
{
  const el = select('#menu-sobre')
  if (el) {
    el.addEventListener('click', () => {
      Sobre()
    })
  }
}

// Página Meus Dados
{
  const el = select('#menu-dados')
  if (el) {
    el.addEventListener('click', () => {
      MeusDados()
    })
  }
}

// Pesquisa
{
  const botaoPesquisa = select('#search-product')
  if (botaoPesquisa) {
    botaoPesquisa.addEventListener('input', ({ target }) => {
      search(target)
    })
  } else {
    console.error('Não foi possível localizar o botão de pesquisa')
  }
}

export const selecionaEndereco = (addressId) => {
  addressId = Number(addressId)

  const [address] = usuario.enderecos.filter((addr) => addr.Id === addressId)

  if (address) {
    const confirmOrder = select('#confirmar-pedido')

    const textoEndereço = confirmOrder.querySelector('.endereco .font-13')
    const taxaEntrega = confirmOrder.querySelector('#taxa-entrega')
    const subTotal = confirmOrder.querySelector('#sub-total')
    const total = confirmOrder.querySelector('#total-pedido')

    if (
      (estabelecimento.tipoEntrega === 'raio' || estabelecimento.tipoEntrega === 'distancia')) {
      if (!address.latitude || !address.longitude) {
        const enderecoFormatado = formatAddress(address)
        buscaCoordenadasCliente(enderecoFormatado)
          .then((response) => {
            address.latitude = response.latitude
            address.longitude = response.longitude

            if (address.Raio) {
              buscaValorTaxaEntregaPorRaio(address).then((response) => {
                continuaConfig(response)
              })
            } else {
              buscaRaioEndereco(address, continuaConfig)
            }
          })
          .catch(() => {
            showMessageBox({
              id: 'message-box-nao-entrega',
              icon: 'warning',
              message: 'Não foi possível encontrar a localização do endereço.',
              classList: 'no-icon-background small',
              default: true,
            })
          })
      } else {
        if (address.Raio) {
          buscaValorTaxaEntregaPorRaio(address).then((response) => {
            continuaConfig(response)
          })
        } else {
          buscaRaioEndereco(address, continuaConfig)
        }
      }

      function continuaConfig(raio) {
        // Ele retorna de dois jeitos como um obj (raio: PodeEntregar e a TaxaEntrega) ou retorna false da função buscaRaioEndereco
        if (!raio || (raio && !raio.PodeEntregar)) {
          showMessageBox({
            id: 'message-box-nao-entrega',
            icon: 'warning',
            message: 'O endereço não está dentro do raio de entrega da loja.',
            classList: 'no-icon-background small',
            default: true,
          })
          return
        }

        if (textoEndereço) {
          textoEndereço.textContent = formatAddress(address)
        }

        if (
          estabelecimento.entregaGratis > 0 &&
          storeOrder.valorTotal > estabelecimento.entregaGratis
        ) {
          address.TaxaEntrega = 0
        } else {
          address.TaxaEntrega = raio.TaxaEntrega
        }

        if (taxaEntrega && !estabelecimento.semTaxaEntrega) {
          taxaEntrega.textContent = format
            .money(address.TaxaEntrega)
            .replace('.', ',')
        }

        if (subTotal) {
          subTotal.textContent = format
            .money(parseFloat(storeOrder.valorTotal) + address.TaxaEntrega)
            .replace('.', ',')
        }

        if (total) {
          let valorTotal =
            parseFloat(storeOrder.valorTotal) + address.TaxaEntrega

          if (storeOrder.ValorDesconto) {
            valorTotal -= parseFloat(storeOrder.ValorDesconto)
          }

          total.textContent = format.money(valorTotal).replace('.', ',')
        }

        storeOrder.TaxaEntrega = address.TaxaEntrega

        const addressesPage = select('#pagina-enderecos')
        if (addressesPage) {
          addressesPage.remove()
        }

        usuario.enderecoSelecionado = address
      }
    } else {
      if (textoEndereço) {
        textoEndereço.textContent = formatAddress(address)
      }

      if (
        estabelecimento.entregaGratis > 0 &&
        storeOrder.valorTotal > estabelecimento.entregaGratis
      ) {
        address.TaxaEntrega = 0
      }

      if (taxaEntrega && !estabelecimento.semTaxaEntrega) {
        taxaEntrega.textContent = format
          .money(address.TaxaEntrega)
          .replace('.', ',')
      }

      if (subTotal) {
        subTotal.textContent = format
          .money(parseFloat(storeOrder.valorTotal) + address.TaxaEntrega)
          .replace('.', ',')
      }

      if (total) {
        let valorTotal = parseFloat(storeOrder.valorTotal) + address.TaxaEntrega

        if (storeOrder.ValorDesconto) {
          valorTotal -= parseFloat(storeOrder.ValorDesconto)
        }

        total.textContent = format.money(valorTotal).replace('.', ',')
      }

      storeOrder.TaxaEntrega = address.TaxaEntrega

      const addressesPage = select('#pagina-enderecos')
      if (addressesPage) {
        addressesPage.remove()
      }

      usuario.enderecoSelecionado = address
    }
  }
}

function horarioAtendimento(intervalo) {
  let startTime, endTime

  if (intervalo.Intervalos.length == 1) {
    startTime = intervalo.Intervalos[0].StartTime
    endTime = intervalo.Intervalos[0].EndTime
  } else if (intervalo.Intervalos.length == 2) {
    startTime =
      intervalo.Intervalos[0].StartTime || intervalo.Intervalos[1].StartTime
    endTime = intervalo.Intervalos[1].EndTime || intervalo.Intervalos[0].EndTime
  } else if (intervalo.Intervalos.length == 3) {
    startTime =
      intervalo.Intervalos[0].StartTime ||
      intervalo.Intervalos[1].StartTime ||
      intervalo.Intervalos[2].StartTime
    endTime =
      intervalo.Intervalos[2].EndTime ||
      intervalo.Intervalos[1].EndTime ||
      intervalo.Intervalos[0].EndTime
  }

  return [startTime, endTime]
}

const menu = select('#menu')

menu &&
  menu.addEventListener('click', () => {
    select('.menu-container').style.height = window.innerHeight + 'px'
    select('.menu').classList.add('menu-show')
    select('html').style.overflow = 'hidden'

    const tempSemLogin = select('.temp-sem-login')

    if (!usuario.logado || estabelecimento.qrCode.ativo) {
      select('.menu-container .profile').style.display = 'none'
      if (!estabelecimento.qrCode.ativo && tempSemLogin) {
        tempSemLogin.style.display = 'flex'
      }
    } else {
      select('.menu-container .profile').style.display = 'flex'
      tempSemLogin && (tempSemLogin.style.display = 'none')
      const name = select('.profile-name')
      if (name) {
        name.textContent = usuario.nome
      }
    }
  })

const menuBackground = select('.menu-background')
menuBackground &&
  menuBackground.addEventListener('click', () => {
    select('.menu').classList.remove('menu-show')
    select('html').style.overflow = ''
  })

window.solicitaPermissaoNotificacao
try {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

  if (!isIOS) {
    window.solicitaPermissaoNotificacao = initializeFirebase()
  }
} catch (error) {
  // sentryError.exception(error)
}

window.exibeMensagemNotificacao = () => {
  const exibida = localStorage.getItem('notificacao-exibida-2')
  if (!exibida) {
    const notificacaoWrapper = createElement('div', {
      class: 'solicita-notificacao',
    })

    notificacaoWrapper.innerHTML += `
        <div class="flex flex-column text-center">
        <svg width="252" height="157" viewBox="0 0 252 157" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M218.986 123.109C218.93 123.037 218.874 122.966 218.819 122.894C218.763 122.822 218.708 122.75 218.654 122.678C218.599 122.606 218.544 122.534 218.49 122.461C218.436 122.388 218.382 122.315 218.328 122.242C218.238 120.138 218.237 118.053 218.324 115.986C218.41 113.934 218.583 111.907 218.843 109.904C219.099 107.916 219.44 105.959 219.863 104.033C220.284 102.121 220.785 100.246 221.366 98.4063C221.433 98.1943 221.5 97.983 221.569 97.7726C221.638 97.5622 221.708 97.3532 221.779 97.1456C221.85 96.9369 221.922 96.7292 221.995 96.5225C222.069 96.3157 222.143 96.1097 222.219 95.9045C222.779 94.3685 223.395 92.8702 224.068 91.4094C224.737 89.9589 225.459 88.5484 226.234 87.1781C227.004 85.8173 227.824 84.4985 228.695 83.2217C229.56 81.9543 230.473 80.7313 231.435 79.5525L231.586 79.3676L231.738 79.1837L231.891 79.0007L232.043 78.8188L232.154 78.6883L232.265 78.5581C232.302 78.5149 232.34 78.4719 232.377 78.429C232.415 78.3862 232.453 78.3438 232.492 78.3018L232.583 78.2516L232.674 78.2018L232.764 78.1521L232.854 78.1025L232.86 78.1007L232.866 78.098L232.871 78.0953L232.877 78.0932L232.913 78.0732L232.949 78.053L232.984 78.0328L233.019 78.0126L233.176 77.9279L233.332 77.8446L233.489 77.7615L233.644 77.6775L233.525 77.6179L233.228 77.4691L233.23 77.4679C233.256 77.4789 233.281 77.4904 233.306 77.5026C233.331 77.5148 233.356 77.5266 233.382 77.5379C233.407 77.5499 233.433 77.5619 233.457 77.5737C233.482 77.5856 233.507 77.5978 233.533 77.6103L233.561 77.6226L233.59 77.6351L233.62 77.6478C233.63 77.6517 233.639 77.6564 233.648 77.6619C233.657 77.6663 233.665 77.67 233.674 77.6728L233.7 77.6838L233.725 77.6948L233.751 77.7058C234.834 78.205 235.92 78.7117 236.993 79.2432C238.065 79.7746 239.12 80.3284 240.148 80.9245C241.172 81.516 242.164 82.1612 243.121 82.8574C244.076 83.5502 244.979 84.3115 245.824 85.1353C246.716 86.0112 247.513 86.9789 248.203 88.0226C248.886 89.048 249.448 90.1499 249.876 91.3061C250.289 92.4066 250.534 93.5632 250.605 94.7371C250.674 95.8662 250.516 96.9976 250.141 98.0642C250.09 98.2032 250.035 98.3404 249.977 98.4756C249.918 98.6108 249.856 98.7439 249.789 98.875C249.723 99.006 249.652 99.1348 249.578 99.2613C249.504 99.3877 249.426 99.5119 249.344 99.6338C249.31 99.6846 249.275 99.735 249.24 99.7848C249.204 99.8347 249.168 99.8841 249.132 99.9331C249.095 99.9821 249.058 100.031 249.021 100.08C248.983 100.128 248.946 100.176 248.907 100.224C248.198 101.121 247.296 101.845 246.269 102.343C245.237 102.838 244.115 103.118 242.972 103.165C241.771 103.215 240.571 103.04 239.433 102.648C238.213 102.229 237.079 101.59 236.088 100.762C235.745 100.477 235.421 100.171 235.116 99.846C234.813 99.5239 234.532 99.1831 234.271 98.8258C234.014 98.4715 233.778 98.1013 233.567 97.7172C233.357 97.336 233.172 96.9415 233.013 96.5363C232.938 97.7952 233.132 99.0556 233.582 100.233C234.058 101.47 234.704 102.634 235.502 103.691C236.344 104.815 237.279 105.867 238.297 106.835C239.321 107.823 240.409 108.748 241.484 109.601C242.558 110.453 243.671 111.325 244.748 112.234C245.824 113.128 246.849 114.083 247.816 115.095C248.755 116.072 249.585 117.149 250.292 118.306C250.987 119.449 251.489 120.699 251.779 122.006C252.089 123.43 252.073 124.906 251.733 126.323C251.568 127.012 251.332 127.682 251.03 128.323C250.726 128.969 250.361 129.585 249.941 130.162L249.902 130.214L249.863 130.267L249.823 130.319L249.782 130.371C248.757 131.718 247.47 132.842 245.999 133.673C245.259 134.091 244.479 134.434 243.671 134.695C242.843 134.963 241.992 135.147 241.128 135.245C239.485 135.398 237.828 135.302 236.213 134.963C234.55 134.612 232.933 134.069 231.395 133.342C229.805 132.594 228.285 131.703 226.853 130.681C225.409 129.654 224.042 128.522 222.763 127.293C222.423 126.967 222.089 126.636 221.762 126.298C221.434 125.96 221.113 125.617 220.798 125.268C220.482 124.919 220.173 124.565 219.872 124.205C219.57 123.845 219.275 123.48 218.986 123.109Z" fill="#F2F2F2"/>
            <path d="M245.404 98.7328C244.388 98.2029 243.412 97.6005 242.482 96.9302C240.625 95.5917 238.965 93.9953 237.553 92.1886C236.853 91.2922 236.219 90.3455 235.656 89.3563C235.186 88.5206 234.769 87.656 234.408 86.7676C234.054 85.9009 233.757 85.0121 233.519 84.1068C233.285 83.2225 233.111 82.3235 232.998 81.4158C232.887 80.5266 232.838 79.6307 232.852 78.7347C232.854 78.6842 232.855 78.634 232.856 78.5842C232.857 78.5343 232.858 78.4841 232.859 78.4336C232.861 78.383 232.863 78.3332 232.865 78.284L232.872 78.135C232.83 78.1688 232.787 78.203 232.745 78.2374L232.618 78.3413L232.491 78.4461L232.365 78.551L232.284 78.6185L232.203 78.6864L232.122 78.7548L232.042 78.8233L232.152 78.6929L232.266 78.5584C232.303 78.5152 232.34 78.4722 232.378 78.4293C232.415 78.3865 232.454 78.3441 232.492 78.3021L232.584 78.2519L232.674 78.2021L232.763 78.1525L232.853 78.103L232.859 78.1011L232.864 78.0984L232.87 78.0957L232.876 78.0936L232.912 78.0736L232.948 78.0535L232.983 78.0333L233.018 78.0131L233.175 77.9284L233.331 77.8451L233.488 77.762L233.644 77.6786L233.522 77.6176L233.224 77.4686L233.226 77.4673C233.252 77.4783 233.277 77.4899 233.302 77.5021C233.327 77.5143 233.353 77.526 233.378 77.5374C233.404 77.5494 233.429 77.5613 233.454 77.5732C233.479 77.585 233.504 77.5972 233.529 77.6098L233.558 77.6221L233.587 77.6346L233.616 77.6472C233.626 77.6511 233.635 77.6558 233.644 77.6612L233.642 77.7087L233.638 77.7532L233.636 77.7974L233.633 77.8423C233.524 79.3515 233.602 80.8686 233.866 82.3584C234.138 83.8919 234.584 85.3889 235.196 86.82C235.828 88.3014 236.618 89.7093 237.552 91.0192C238.518 92.3742 239.624 93.622 240.852 94.7416C242.088 95.853 243.437 96.8312 244.875 97.6604C245.586 98.0697 246.317 98.4409 247.067 98.7723C247.81 99.1004 248.571 99.3876 249.345 99.6328C249.311 99.6837 249.276 99.734 249.241 99.7839C249.205 99.8337 249.169 99.8832 249.133 99.9322C249.096 99.9812 249.059 100.03 249.022 100.079C248.985 100.127 248.947 100.175 248.908 100.223C248.61 100.124 248.313 100.018 248.017 99.9059C247.722 99.7938 247.428 99.6756 247.135 99.5512C246.843 99.4267 246.553 99.2962 246.264 99.1595C245.976 99.0228 245.689 98.8806 245.404 98.7328Z" fill="white"/>
            <path d="M225.302 110.012C224.969 109.513 224.655 109.005 224.36 108.487C224.065 107.97 223.789 107.445 223.533 106.913C223.276 106.381 223.039 105.842 222.822 105.296C222.605 104.751 222.408 104.2 222.231 103.645C222.141 103.351 222.058 103.055 221.982 102.759C221.906 102.462 221.837 102.165 221.775 101.868C221.714 101.57 221.659 101.272 221.611 100.973C221.563 100.675 221.522 100.376 221.49 100.078C221.473 99.9387 221.458 99.7994 221.444 99.6599C221.431 99.5203 221.419 99.3809 221.409 99.2416C221.399 99.1021 221.39 98.9628 221.383 98.8236C221.375 98.6844 221.37 98.5455 221.365 98.4067C221.432 98.1947 221.499 97.9835 221.568 97.7731C221.636 97.5627 221.706 97.3531 221.777 97.1445C221.848 96.9359 221.92 96.7282 221.993 96.5214C222.067 96.3147 222.141 96.1087 222.217 95.9034C222.201 96.0753 222.187 96.2477 222.175 96.4205C222.163 96.5933 222.154 96.7667 222.147 96.9405C222.14 97.1144 222.135 97.2887 222.133 97.4634C222.131 97.6381 222.132 97.8132 222.134 97.9886C222.134 98.0841 222.135 98.1797 222.137 98.2753C222.139 98.3708 222.141 98.4664 222.145 98.562C222.148 98.6576 222.152 98.7531 222.157 98.8488C222.162 98.9444 222.168 99.04 222.174 99.1356C222.247 100.208 222.414 101.272 222.674 102.315C222.937 103.37 223.28 104.404 223.7 105.407C224.128 106.429 224.622 107.422 225.178 108.38C225.744 109.354 226.363 110.297 227.031 111.203C227.751 112.181 228.511 113.134 229.313 114.061C230.115 114.987 230.947 115.889 231.809 116.765C232.673 117.64 233.561 118.488 234.475 119.309C235.389 120.13 236.318 120.923 237.263 121.687C238.23 122.472 239.217 123.227 240.223 123.952C241.23 124.677 242.252 125.37 243.291 126.032C244.33 126.693 245.384 127.322 246.454 127.919C247.524 128.516 248.606 129.079 249.7 129.608C249.751 129.632 249.796 129.666 249.834 129.707C249.872 129.747 249.902 129.794 249.924 129.844C249.945 129.894 249.958 129.947 249.961 130.001C249.965 130.056 249.958 130.111 249.94 130.163C249.935 130.185 249.927 130.207 249.917 130.228C249.907 130.248 249.896 130.267 249.882 130.285C249.869 130.303 249.853 130.319 249.837 130.334C249.82 130.348 249.801 130.361 249.782 130.371C249.762 130.38 249.74 130.387 249.718 130.391C249.695 130.395 249.673 130.396 249.65 130.395C249.627 130.393 249.604 130.389 249.582 130.382C249.56 130.375 249.538 130.366 249.517 130.354C249.382 130.289 249.247 130.223 249.111 130.158C248.976 130.092 248.842 130.026 248.707 129.959C248.572 129.893 248.438 129.826 248.304 129.758C248.17 129.69 248.036 129.621 247.902 129.551C246.786 128.976 245.686 128.365 244.601 127.72C243.515 127.075 242.446 126.397 241.393 125.684C240.341 124.972 239.308 124.228 238.293 123.452C237.279 122.676 236.286 121.87 235.314 121.032C234.376 120.225 233.449 119.391 232.545 118.529C231.64 117.667 230.759 116.777 229.91 115.859C229.061 114.941 228.246 113.995 227.474 113.02C226.702 112.046 225.975 111.043 225.302 110.012Z" fill="white"/>
            <path d="M246.31 29.8973L245.511 30.0016L250.867 9.79232C251.262 8.44287 251.326 7.01749 251.054 5.63768C250.819 4.51026 250.236 3.48607 249.389 2.71044C248.501 1.93492 247.414 1.42749 246.251 1.24669C244.836 1.02633 243.391 1.09137 242.001 1.43801V1.43801L205.601 9.7719C204.33 10.0818 203.114 10.5847 201.995 11.2634C200.777 11.9913 199.644 12.8545 198.618 13.8367C197.563 14.8383 196.616 15.9491 195.792 17.1506C194.987 18.3135 194.332 19.5735 193.84 20.901V20.901L155.754 126.214C155.121 127.946 154.71 129.751 154.53 131.588C154.363 133.218 154.442 134.864 154.763 136.47C155.032 137.866 155.592 139.188 156.407 140.35C157.155 141.406 158.208 142.205 159.424 142.637V142.637L197.883 155.948C199.592 156.533 201.425 156.643 203.191 156.266C205.078 155.853 206.853 155.031 208.392 153.858C210.121 152.552 211.607 150.951 212.783 149.127C214.086 147.123 215.06 144.922 215.666 142.607V142.607L241.451 45.3189L242.26 45.2537L246.31 29.8973Z" fill="#2F2E41"/>
            <path d="M243.528 28.7784L242.729 28.8827L248.085 8.67345C248.48 7.324 248.544 5.89862 248.272 4.51882C248.036 3.3914 247.454 2.36721 246.606 1.59158C245.719 0.816057 244.631 0.308622 243.469 0.127822C242.054 -0.0925312 240.609 -0.0274951 239.219 0.319146L202.818 8.65303C201.548 8.96293 200.332 9.46586 199.212 10.1445C197.995 10.8724 196.862 11.7357 195.836 12.7179C194.781 13.7195 193.833 14.8302 193.01 16.0317C192.205 17.1946 191.549 18.4546 191.058 19.7821V19.7821L152.972 125.095C152.339 126.827 151.927 128.633 151.748 130.469C151.581 132.099 151.66 133.745 151.981 135.351C152.249 136.747 152.81 138.069 153.625 139.231C154.372 140.287 155.426 141.086 156.641 141.519V141.519L195.101 154.829C196.809 155.414 198.643 155.524 200.409 155.147C202.296 154.734 204.071 153.912 205.61 152.739C207.339 151.433 208.825 149.832 210.001 148.008C211.304 146.004 212.277 143.803 212.884 141.488V141.488L238.668 44.2L239.477 44.1348L243.528 28.7784Z" fill="#3F3D56"/>
            <path d="M238.897 2.95604L233.546 4.13449C233.605 4.5999 233.559 5.07256 233.411 5.51769C233.245 6.03834 233.003 6.5316 232.694 6.98173C231.998 8.00361 231.07 8.8436 229.986 9.43177C229.856 9.50114 229.726 9.56519 229.597 9.62393C229.469 9.68267 229.34 9.73601 229.211 9.78393C229.082 9.83186 228.955 9.87419 228.828 9.91092C228.701 9.94766 228.576 9.97861 228.453 10.0038L207.532 14.2625C207.144 14.3531 206.74 14.3485 206.354 14.2491C206.043 14.1652 205.769 13.9796 205.575 13.7215C205.379 13.4444 205.269 13.1157 205.257 12.7761C205.241 12.3428 205.309 11.9106 205.458 11.5036C205.495 11.3938 205.537 11.2832 205.585 11.1719C205.632 11.0606 205.684 10.9492 205.74 10.8379C205.796 10.726 205.856 10.6147 205.922 10.5039C205.988 10.3932 206.057 10.2825 206.131 10.1719L202.169 11.0443C201.215 11.2693 200.302 11.641 199.461 12.1464C198.541 12.6907 197.687 13.3382 196.913 14.0765C196.115 14.8307 195.4 15.6682 194.779 16.5749C194.173 17.451 193.681 18.401 193.314 19.402L155.3 125.63C154.827 126.936 154.523 128.297 154.397 129.68C154.279 130.901 154.349 132.133 154.602 133.333C154.813 134.37 155.243 135.35 155.864 136.205C156.433 136.98 157.227 137.56 158.136 137.865V137.865L196.879 150.519C198.157 150.931 199.522 150.992 200.831 150.697C202.226 150.376 203.537 149.758 204.674 148.885C205.946 147.916 207.041 146.733 207.91 145.388C208.872 143.911 209.594 142.289 210.049 140.583V140.583L245.447 9.26114C245.744 8.25869 245.799 7.19949 245.608 6.17139C245.441 5.32886 245.018 4.55957 244.396 3.97086C243.743 3.38227 242.938 2.99219 242.074 2.84611C241.019 2.6679 239.938 2.70529 238.897 2.95604V2.95604Z" fill="white"/>
            <path d="M218.12 53.2671H141.051V27.0113H218.12V53.2671Z" fill="white"/>
            <path d="M195.588 62.5338H120.056V99.3435H195.588V62.5338Z" fill="white"/>
            <path d="M132.326 80.2099C135.344 80.2099 137.79 77.7507 137.79 74.7171C137.79 71.6836 135.344 69.2244 132.326 69.2244C129.309 69.2244 126.863 71.6836 126.863 74.7171C126.863 77.7507 129.309 80.2099 132.326 80.2099Z" fill="#6C63FF"/>
            <path d="M144.945 71.0553C144.703 71.0553 144.471 71.1518 144.301 71.3234C144.13 71.4951 144.034 71.728 144.034 71.9708C144.034 72.2136 144.13 72.4464 144.301 72.6181C144.471 72.7898 144.703 72.8862 144.945 72.8862H187.873C188.114 72.8856 188.345 72.7889 188.515 72.6173C188.685 72.4457 188.781 72.2132 188.781 71.9708C188.781 71.7284 188.685 71.4958 188.515 71.3242C188.345 71.1526 188.114 71.0559 187.873 71.0553H144.945Z" fill="#E6E6E6"/>
            <path d="M144.944 76.548C144.825 76.5476 144.706 76.5709 144.595 76.6166C144.485 76.6623 144.384 76.7295 144.299 76.8143C144.214 76.8992 144.147 77 144.101 77.1111C144.055 77.2221 144.031 77.3412 144.031 77.4615C144.031 77.5818 144.054 77.701 144.099 77.8123C144.145 77.9235 144.212 78.0246 144.297 78.1098C144.381 78.195 144.481 78.2627 144.592 78.3088C144.702 78.355 144.821 78.3788 144.941 78.3789H163.417C163.536 78.3789 163.655 78.3552 163.765 78.3092C163.875 78.2632 163.976 78.1958 164.06 78.1108C164.145 78.0258 164.212 77.9249 164.258 77.8138C164.304 77.7027 164.327 77.5837 164.327 77.4635C164.327 77.3432 164.304 77.2242 164.258 77.1131C164.212 77.0021 164.145 76.9011 164.06 76.8161C163.976 76.7311 163.875 76.6637 163.765 76.6177C163.655 76.5717 163.536 76.548 163.417 76.548H144.944Z" fill="#E6E6E6"/>
            <path d="M128.135 85.3293C127.443 85.3293 126.879 85.74 126.879 86.2448C126.879 86.7495 127.443 87.1602 128.135 87.1602H187.363C188.056 87.1602 188.619 86.7495 188.619 86.2448C188.619 85.74 188.056 85.3293 187.363 85.3293H128.135Z" fill="#E6E6E6"/>
            <path d="M128.135 90.8221C127.443 90.8221 126.879 91.2328 126.879 91.7375C126.879 92.2422 127.443 92.653 128.135 92.653H173.73C174.422 92.653 174.986 92.2422 174.986 91.7375C174.986 91.2328 174.422 90.8221 173.73 90.8221H128.135Z" fill="#E6E6E6"/>
            <path d="M196.357 100.116H119.288V61.7616H196.357V100.116ZM120.824 98.5712H194.82V63.3061H120.824V98.5712Z" fill="#E6E6E6"/>
            <path d="M154.09 45.4595C157.107 45.4595 159.554 43.0003 159.554 39.9668C159.554 36.9332 157.107 34.474 154.09 34.474C151.073 34.474 148.626 36.9332 148.626 39.9668C148.626 43.0003 151.073 45.4595 154.09 45.4595Z" fill="#6C63FF"/>
            <path d="M166.708 36.3049C166.467 36.3049 166.235 36.4014 166.064 36.5731C165.894 36.7447 165.798 36.9776 165.798 37.2204C165.798 37.4632 165.894 37.696 166.064 37.8677C166.235 38.0394 166.467 38.1358 166.708 38.1358H209.636C209.877 38.1352 210.108 38.0385 210.279 37.8669C210.449 37.6953 210.545 37.4628 210.545 37.2204C210.545 36.978 210.449 36.7455 210.279 36.5739C210.108 36.4023 209.877 36.3055 209.636 36.3049H166.708Z" fill="#E6E6E6"/>
            <path d="M166.708 41.7977C166.588 41.7973 166.47 41.8206 166.359 41.8663C166.248 41.912 166.148 41.9792 166.063 42.064C165.978 42.1489 165.911 42.2497 165.865 42.3607C165.819 42.4718 165.795 42.5909 165.794 42.7112C165.794 42.8315 165.818 42.9507 165.863 43.0619C165.909 43.1732 165.976 43.2743 166.06 43.3595C166.145 43.4447 166.245 43.5123 166.356 43.5585C166.466 43.6047 166.585 43.6285 166.704 43.6286H200.483C200.724 43.6286 200.956 43.5321 201.127 43.3605C201.298 43.1888 201.394 42.9559 201.394 42.7131C201.394 42.4703 201.298 42.2375 201.127 42.0658C200.956 41.8941 200.724 41.7977 200.483 41.7977H166.708Z" fill="#E6E6E6"/>
            <path d="M218.12 53.2671H141.051V27.0113H218.12V53.2671ZM142.588 51.7227H216.584V28.5558H142.588V51.7227Z" fill="#E6E6E6"/>
            <path d="M66.6881 153.282H70.573L72.4213 138.216L66.6873 138.217L66.6881 153.282Z" fill="#FFB6B6"/>
            <path d="M78.0657 156.908L65.8556 156.908L65.8554 152.166L73.9235 152.165C75.022 152.165 76.0755 152.604 76.8523 153.385C77.6292 154.166 78.0656 155.225 78.0656 156.329L78.0657 156.908V156.908Z" fill="#2F2E41"/>
            <path d="M27.8398 148.22L31.2443 150.101L40.0837 137.795L35.0591 135.018L27.8398 148.22Z" fill="#FFB6B6"/>
            <path d="M36.072 156.908L25.3724 150.995L27.6451 146.839L34.7151 150.746C35.6778 151.278 36.3908 152.173 36.6972 153.234C37.0037 154.294 36.8785 155.434 36.3493 156.401L36.072 156.908V156.908Z" fill="#2F2E41"/>
            <path d="M66.5064 144.92C66.1602 144.919 65.826 144.792 65.566 144.563C65.3061 144.333 65.1382 144.016 65.0936 143.671L60.235 106.031C60.2135 105.864 60.1402 105.709 60.0257 105.586C59.9111 105.464 59.7611 105.382 59.597 105.35C59.4329 105.319 59.2632 105.341 59.1121 105.412C58.961 105.484 58.8362 105.601 58.7556 105.748L38.5066 142.682C38.3396 142.983 38.0704 143.215 37.7481 143.334C37.4257 143.453 37.0717 143.451 36.7502 143.33L32.3366 141.639C32.159 141.571 31.9968 141.468 31.8594 141.336C31.722 141.205 31.6122 141.046 31.5365 140.871C31.4607 140.696 31.4205 140.508 31.4183 140.317C31.4161 140.126 31.4518 139.936 31.5234 139.759L45.5504 105.117C45.5859 105.029 45.61 104.937 45.622 104.843C47.5219 90.0597 52.3558 82.5419 53.792 80.5899C53.8969 80.4465 53.9659 80.2797 53.9933 80.1038C54.0206 79.9279 54.0055 79.7479 53.9491 79.5791L53.7517 78.9837C53.6728 78.7473 53.6567 78.4944 53.7048 78.2498C53.7529 78.0053 53.8637 77.7776 54.0261 77.5892C59.2014 71.6631 68.2216 74.8968 68.3121 74.9301L68.3573 74.9469L68.3856 74.9858C78.5 88.931 74.7604 134.224 73.908 143.162C73.8762 143.498 73.7273 143.812 73.4875 144.048C73.2478 144.284 72.9327 144.428 72.598 144.453L66.6171 144.916C66.58 144.918 66.5431 144.92 66.5064 144.92Z" fill="#2F2E41"/>
            <path d="M63.7642 40.3318C68.5393 40.3318 72.4102 36.4402 72.4102 31.6396C72.4102 26.8391 68.5393 22.9474 63.7642 22.9474C58.9891 22.9474 55.1182 26.8391 55.1182 31.6396C55.1182 36.4402 58.9891 40.3318 63.7642 40.3318Z" fill="#FFB8B8"/>
            <path d="M50.3972 86.9498L75.8387 89.2777C73.6206 81.5238 71.5884 73.7972 73.2448 66.0986C75.3483 59.2255 75.5439 55.418 69.9949 52.1811L66.2483 43.7786L59.4676 43.5307L56.1612 42.6197C53.49 46.9375 52.3973 52.0555 53.0708 57.095C54.5081 68.0538 54.1199 78.223 50.3972 86.9498Z" fill="#6C63FF"/>
            <path d="M54.2591 48.162L51.7 36.3538C51.166 33.5587 51.3 30.676 52.0909 27.9431C52.177 27.663 52.2808 27.3887 52.4017 27.1219C53.11 25.5699 54.2238 24.2401 55.6243 23.2739C57.0249 22.3078 58.6598 21.7416 60.3551 21.6355C66.1709 21.2316 67.0248 21.848 67.2351 22.152C70.5215 22.0186 73.0698 23.2951 74.2325 25.6572C74.3464 25.8917 74.4078 26.1484 74.4123 26.4093C74.4168 26.6702 74.3644 26.9289 74.2587 27.1672C74.153 27.4055 73.9966 27.6176 73.8006 27.7886C73.6045 27.9596 73.3736 28.0853 73.124 28.1568C71.4998 28.6276 69.2168 29.1506 67.5047 28.9968C64.0728 33.1352 65.4758 40.7174 68.9576 45.2351L69.0944 45.4127L65.6447 46.1234L61.6359 40.5109C61.5565 40.3999 61.4417 40.3195 61.3105 40.2834C61.1794 40.2473 61.0398 40.2575 60.9153 40.3123C60.7907 40.3672 60.6886 40.4634 60.6262 40.5848C60.5637 40.7063 60.5445 40.8456 60.572 40.9795L61.7891 46.9238L54.2591 48.162Z" fill="#2F2E41"/>
            <path d="M241.25 157H0V156.39H241.359L241.25 157Z" fill="#CACACA"/>
            <path d="M103.678 79.958L40.7529 124.693L25.6738 103.256L88.599 58.5207L103.678 79.958Z" fill="white"/>
            <path d="M46.9147 110.75C49.3784 108.999 49.9633 105.571 48.2211 103.094C46.4789 100.617 43.0693 100.029 40.6057 101.781C38.142 103.532 37.5571 106.96 39.2993 109.437C41.0415 111.914 44.4511 112.502 46.9147 110.75Z" fill="#6C63FF"/>
            <path d="M51.9598 95.9514C51.7626 96.0916 51.6289 96.3048 51.5881 96.5441C51.5472 96.7834 51.6026 97.0292 51.7421 97.2274C51.8815 97.4256 52.0936 97.5601 52.3316 97.6011C52.5696 97.6422 52.8141 97.5865 53.0113 97.4463L88.0611 72.5283C88.2576 72.3878 88.3907 72.1748 88.4311 71.9358C88.4716 71.6968 88.4161 71.4515 88.2769 71.2536C88.1377 71.0557 87.9261 70.9214 87.6885 70.8801C87.4509 70.8388 87.2068 70.8939 87.0096 71.0334L51.9598 95.9514Z" fill="#E6E6E6"/>
            <path d="M55.1144 100.436C54.9172 100.576 54.7833 100.789 54.7421 101.028C54.7009 101.267 54.7558 101.513 54.8948 101.711C55.0337 101.909 55.2453 102.044 55.483 102.086C55.7208 102.128 55.9653 102.073 56.1628 101.933L56.1659 101.931L83.7423 82.3261C83.9394 82.1859 84.0732 81.9727 84.114 81.7334C84.1548 81.4941 84.0994 81.2483 83.96 81.05C83.8909 80.9519 83.8033 80.8684 83.7022 80.8042C83.601 80.7401 83.4883 80.6967 83.3705 80.6763C83.1324 80.6353 82.8879 80.691 82.6907 80.8312L55.1144 100.436Z" fill="#E6E6E6"/>
            <path d="M103.678 79.958L40.7529 124.693L25.6738 103.256L88.599 58.5207L103.678 79.958ZM41.1202 122.541L101.537 79.5887L88.2316 60.6735L27.8152 103.625L41.1202 122.541Z" fill="#E6E6E6"/>
            <path d="M247.361 72.0155C247.584 72.0068 247.807 72.0449 248.014 72.1274C248.211 72.2068 248.39 72.3263 248.539 72.4784C248.689 72.6315 248.806 72.8138 248.883 73.0141C248.964 73.2264 249.001 73.4531 248.991 73.6804C248.982 73.9135 248.928 74.1426 248.832 74.355C248.739 74.5634 248.608 74.753 248.447 74.9145C248.287 75.0752 248.1 75.2052 247.894 75.2982C247.684 75.3927 247.458 75.4446 247.229 75.451C247.006 75.4577 246.783 75.4176 246.576 75.3332C246.38 75.2526 246.202 75.1321 246.054 74.9794C245.906 74.8258 245.791 74.6435 245.715 74.4434C245.635 74.2319 245.599 74.0062 245.609 73.7802C245.619 73.5483 245.672 73.3203 245.768 73.1089C245.861 72.9026 245.99 72.7148 246.149 72.5545C246.308 72.3941 246.494 72.264 246.699 72.1705C246.907 72.0756 247.132 72.023 247.361 72.0155V72.0155Z" fill="#F2F2F2"/>
            <path d="M70.45 93.8225L66.3581 71.3339L66.6463 57.4264L57.4238 57.1367L59.153 72.7826L65.1161 94.4784C64.6212 95.0832 64.3179 95.8233 64.2454 96.6031C64.1729 97.3828 64.3345 98.1666 64.7094 98.8531C65.0843 99.5397 65.6552 100.098 66.3485 100.455C67.0418 100.812 67.8257 100.952 68.5989 100.857C69.3722 100.762 70.0994 100.436 70.6866 99.9212C71.2739 99.4066 71.6942 98.7269 71.8935 97.9698C72.0927 97.2126 72.0617 96.4128 71.8044 95.6736C71.5471 94.9344 71.0753 94.2896 70.45 93.8225H70.45Z" fill="#FFB8B8"/>
            <path d="M56.8474 58.5854C60.1887 57.3059 63.8813 57.3059 67.2226 58.5854L66.6462 46.9958C66.6462 46.387 66.527 45.7842 66.2952 45.2217C66.0635 44.6593 65.7238 44.1483 65.2956 43.7178C64.8675 43.2873 64.3591 42.9458 63.7997 42.7129C63.2402 42.4799 62.6406 42.36 62.035 42.36V42.36C61.4295 42.36 60.8299 42.4799 60.2704 42.7129C59.7109 42.9458 59.2026 43.2873 58.7744 43.7178C58.3462 44.1483 58.0066 44.6593 57.7748 45.2217C57.5431 45.7842 57.4238 46.387 57.4238 46.9958L56.8474 58.5854Z" fill="#6C63FF"/>
            </svg>
           <div>Notificações</div>
            <div class="subtitulo">Ative as notificações do navegador para  você ser notificado assim que o status do pedido for atualizado</div>
            <button id="solicita-notificacao" class="btn-azul">Continuar</button>
        </div>
        `
    document.body.appendChild(notificacaoWrapper)

    const button = select('#solicita-notificacao')
    let solicitaNotificacao

    if (typeof window.solicitaPermissaoNotificacao === 'function') {
      try {
        solicitaNotificacao = window.solicitaPermissaoNotificacao()
      } catch {
        //
      }
    }

    button.addEventListener('click', () => {
      typeof solicitaNotificacao === 'function' && solicitaNotificacao()
      localStorage.setItem('notificacao-exibida-2', true)
      notificacaoWrapper.remove()
    })
  } else {
    if (typeof window.solicitaPermissaoNotificacao === 'function') {
      try {
        window.solicitaPermissaoNotificacao()
      } catch {
        //
      }
    }
  }
}

getIntervaloDisponibilidade()
function getIntervaloDisponibilidade(callback) {
  axios
    .get(getUrlAction('Cadastros', 'GetIntervalosAtivos'), {
      params: {
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then((response) => {
      estabelecimento.intervaloProdutos.intervalos =
        response.data.ListaIntervalos
      estabelecimento.intervaloProdutos.ativo = response.data.UtilizaIntervalos
      estabelecimento.intervaloProdutos.intervalosPromocao =
        response.data.IntervalosPromocao
      callback && callback()
    })
    .catch((error) => {
      Sentry.captureException(error)
      console.error(error)
    })
}

function verificaDisponibilidade(produto, isAgrupamento) {
  let elemento

  if (isAgrupamento) {
    const idSubAgrupamento = produto.SubAgrupamentoDelivery
      ? produto.SubAgrupamentoDelivery.Id
      : null
    elemento = buscaElementoProduto(idSubAgrupamento || produto.Id, true)
  } else {
    elemento = buscaElementoProduto(produto.IdProd)
  }

  if (elemento) {
    const achouIntervalo =
      estabelecimento?.intervaloProdutos?.intervalosPromocao?.find(
        (intervalo) => intervalo == produto.Intervalo,
      )
    if (
      (produto.Intervalo || produto.Intervalo == 0) &&
      estabelecimento.intervaloProdutos &&
      estabelecimento.intervaloProdutos.intervalos &&
      !estabelecimento.intervaloProdutos.intervalos.includes(
        produto.Intervalo,
      ) &&
      !achouIntervalo
    ) {
      if (produto.ExibirProdutoForaDeHorario) {
        elemento.setAttribute('exibir-fora-horario', true)
      }
      elemento.classList.add('indisponivel')
      return false
    } else {
      elemento && elemento.classList.remove('indisponivel')
      return true
    }
  }
}

function buscaElementoProduto(idProduto, agrupamento) {
  let elementoProduto
  if (agrupamento) {
    elementoProduto = select(`[agrupamento="${idProduto}"]`)
  } else {
    elementoProduto = select(`[idProd="${idProduto}"]`)
  }
  return elementoProduto
}

export const mensagemFidelidade = () => {
  if (
    (estabelecimento.programaFidelidade.Ativo &&
      !usuario.UtilizaProgramaFidelidade) ||
    false
  ) {
    const wrapper = createElement('div', {
      class: 'wrapper-solicita-endereco cadastrar-fidelidade',
    })
    wrapper.innerHTML = `
        <div class="wrapper-content">
            <svg class="img-fidelidade" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" width="930" height="609.87353" viewBox="0 0 930 609.87353" xmlns:xlink="http://www.w3.org/1999/xlink"><path id="f5877e54-26d9-4110-bb17-7d90037dcb2b-39" data-name="Path 438" d="M176.062,706.84891a24.21462,24.21462,0,0,0,23.38269-4.11877c8.18977-6.87442,10.758-18.196,12.8467-28.68191l6.17973-31.01657L205.53341,651.94c-9.30465,6.40642-18.81826,13.01867-25.26011,22.29786s-9.25223,21.94707-4.07792,31.988" transform="translate(-135 -145.06323)" fill="#e6e6e6"/><path id="af7e5462-cb8c-4c3a-a84b-026a28a01614-40" data-name="Path 439" d="M178.0597,746.55947c-1.62839-11.86369-3.30382-23.88078-2.15884-35.87167,1.01467-10.64932,4.26373-21.04881,10.87831-29.57938A49.20592,49.20592,0,0,1,199.40383,669.668c1.26215-.79648,2.42409,1.20354,1.16733,1.997a46.77945,46.77945,0,0,0-18.50446,22.32562c-4.02858,10.24607-4.67545,21.41582-3.98154,32.3003.41944,6.58218,1.31074,13.1212,2.20588,19.65251a1.19817,1.19817,0,0,1-.808,1.42251,1.16348,1.16348,0,0,1-1.42253-.808Z" transform="translate(-135 -145.06323)" fill="#f2f2f2"/><path id="b74da307-8ad0-4d1b-99e4-dedad26aca71-41" data-name="Path 442" d="M189.78073,727.523a17.82513,17.82513,0,0,0,15.53141,8.01862c7.8644-.37318,14.41806-5.85973,20.31713-11.07027l17.452-15.4088-11.54987-.55281c-8.3062-.39784-16.82672-.771-24.73814,1.79338s-15.20757,8.72639-16.654,16.91541" transform="translate(-135 -145.06323)" fill="#e6e6e6"/><path id="eea67ff0-2845-4236-af55-5d249be779f1-42" data-name="Path 443" d="M173.45672,753.37916c7.83972-13.87142,16.93234-29.28794,33.1808-34.21552a37.02609,37.02609,0,0,1,13.95545-1.44105c1.48189.128,1.11179,2.41174-.367,2.28454a34.39833,34.39833,0,0,0-22.27164,5.89215c-6.27994,4.27453-11.16975,10.21755-15.30781,16.51907-2.53511,3.86051-4.80577,7.88445-7.07642,11.903C174.84454,755.60586,172.72271,754.67832,173.45672,753.37916Z" transform="translate(-135 -145.06323)" fill="#f2f2f2"/><rect x="241.60236" y="315.46812" width="344" height="293" fill="#fff"/><path d="M721.60236,754.53136h-346v-295h346Zm-344-2h342v-291h-342Z" transform="translate(-135 -145.06323)" fill="#3f3d56"/><rect x="370.60236" y="372.46812" width="86" height="236" fill="#6c63ff"/><rect x="370.60236" y="372.46812" width="86" height="236" fill="#6c63ff"/><polygon points="242.602 336.968 242.602 384.506 585.602 406.468 584.591 347.81 242.602 336.968" opacity="0.2"/><rect x="221.60236" y="288.46812" width="384" height="84" fill="#fff"/><path d="M741.60236,518.53136h-386v-86h386Zm-384-2h382v-82h-382Z" transform="translate(-135 -145.06323)" fill="#3f3d56"/><rect x="370.60236" y="280.46812" width="86" height="91" fill="#6c63ff"/><path d="M539.39446,346.18758c22.70142,33.65162,1.31244,87.77544,1.31244,87.77544s-58.19523-.43626-80.89664-34.08788-1.31244-87.77544-1.31244-87.77544S516.69305,312.536,539.39446,346.18758Z" transform="translate(-135 -145.06323)" fill="#6c63ff"/><path d="M549.81026,346.18758c-22.70141,33.65162-1.31244,87.77544-1.31244,87.77544s58.19523-.43626,80.89664-34.08788,1.31244-87.77544,1.31244-87.77544S572.51167,312.536,549.81026,346.18758Z" transform="translate(-135 -145.06323)" fill="#6c63ff"/><circle cx="353.60236" cy="217.46812" r="9" fill="#3f3d56"/><circle cx="407.60236" cy="308.46812" r="9" fill="#3f3d56"/><circle cx="407.60236" cy="505.46812" r="9" fill="#3f3d56"/><circle cx="377.60236" cy="250.46812" r="6" fill="#3f3d56"/><circle cx="467.60236" cy="199.46812" r="6" fill="#3f3d56"/><circle cx="428.60236" cy="340.46812" r="6" fill="#3f3d56"/><circle cx="392.60236" cy="418.46812" r="6" fill="#3f3d56"/><circle cx="423.60236" cy="445.46812" r="6" fill="#3f3d56"/><circle cx="416.60236" cy="558.46812" r="6" fill="#3f3d56"/><polygon points="786.636 597.422 775.663 597.421 770.442 555.095 786.638 555.096 786.636 597.422" fill="#ffb7b7"/><path d="M924.43436,753.122l-35.38273-.00131v-.44753a13.77268,13.77268,0,0,1,13.77195-13.77173h.00087l21.61057.00087Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><polygon points="813.437 597.422 824.411 597.421 829.631 555.095 813.435 555.096 813.437 597.422" fill="#ffb7b7"/><path d="M945.63827,738.90234l21.61057-.00087h.00087a13.77268,13.77268,0,0,1,13.77194,13.77173v.44753l-35.38272.00131Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><circle cx="902.0207" cy="403.18697" r="19.17963" transform="translate(4.5896 886.53434) rotate(-63.5798)" fill="#ffb7b7"/><path d="M887.89752,535.13036s-6.05673,25.23635-3.02834,37.34981,12.11347,94.88871,12.11347,94.88871l6.05674,65.61456,24.22688,2.01893-3.02834-76.71851,3.02834-66.624L944.427,656.26493v76.9473l25.69387,1.00946.55194-100.16477s2.01893-78.73743-11.104-88.832-15.1418-12.11344-15.1418-12.11344Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M924.47066,424.09038l22.98469,12.11344,3.02834,104.98325s-13.12294-8.07564-33.312,2.0189-33.312,3.02837-33.312,3.02837l12.11347-45.42546-5.04727-60.56726,7.21911-6.55231Z" transform="translate(-135 -145.06323)" fill="#cbcbcb"/><path d="M898.14743,431.77855l-4.19317,3.41583s-26.24581,13.12291-27.25528,22.208l18.1702,49.46326s5.04727,11.104,1.00947,15.1418-8.07566,14.13237-7.0662,19.17964-6.05673,26.24581,2.01893,26.24581,27.25528-48.45381,26.24581-67.63345S905.369,430.38164,898.14743,431.77855Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M915.79268,425.22785l9.24592-1.53851s34.32147,9.08508,39.36874,24.22691l-14.1324,35.33089s10.09459,64.60506,7.0662,64.60506H954.3128s8.07561,6.05673,3.02834,8.07564-17.16074,18.17017-20.18908,11.104-21.19854-90.8509-19.17961-109.0211S913.99986,427.13143,915.79268,425.22785Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M919.80526,384.40712l.89831-1.808-4.5201-2.24579s-4.9864-8.11341-14.00947-5.83336-13.08269,3.6446-13.08269,3.6446l-4.50867,2.26861,2.26288,2.25149-4.05952,1.36461,2.712,1.34746-3.15554,1.81374,1.6987,9.29786s2.82141-7.05207,8.2455-4.35714,15.34557-1.39311,15.34557-1.39311l8.61958,16.68162s1.77822-5.84774,4.94868-4.28847C921.20058,403.15124,929.30029,390.25187,919.80526,384.40712Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M947.88244,561.54026A9.00059,9.00059,0,0,1,954.31571,549.33l3.88561-31.74824L970.86263,528.35l-5.63095,28.49778a9.04939,9.04939,0,0,1-17.34924,4.69252Z" transform="translate(-135 -145.06323)" fill="#ffb7b7"/><path d="M893.72894,559.35555a9.00059,9.00059,0,0,0-7.69169-11.45929L878.8072,516.739,867.359,528.789,875.98,556.52906a9.04938,9.04938,0,0,0,17.749,2.82649Z" transform="translate(-135 -145.06323)" fill="#ffb7b7"/><path d="M948.37046,439.68972s13.12288-5.0473,17.16074,10.09459,9.08507,45.42545,9.08507,45.42545c.25091,16.83971-.64416,16.83971,0,33.312l-3.02834,15.1418-17.16073-2.01893.74848-38.54583-8.82415-39.18219Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M875.78406,451.34563l-6.222.66554s-5.89147,4.38173-5.89147,14.47627-1.00947,40.37818-1.00947,40.37818-.57254.70851,4.03781,26.24581c2.24714,12.44722,6.13047,18.321,6.13047,18.321l12.531-11.63588L883.85972,509.894l4.0378-16.15127Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M1064,754.53136H136a1,1,0,0,1,0-2h928a1,1,0,0,1,0,2Z" transform="translate(-135 -145.06323)" fill="#3f3d56"/><circle cx="230.64859" cy="290.20501" r="22.02776" fill="#ffb8b8"/><path d="M357.69553,565.61049q-.41615,0-.836-.03679a9.86784,9.86784,0,0,1-8.85646-11.76339,9.23861,9.23861,0,0,1,.24216-.938l-32.51113-38.451a7.66339,7.66339,0,0,1-.53316-9.13413l.05895-.07183,29.264-28.85536a8.45924,8.45924,0,0,1,11.87842,12.04733q-.055.0543-.11111.10757l-21.19485,20.14952L358.29946,545.905a9.39035,9.39035,0,0,1,1.30871.16116,9.86758,9.86758,0,0,1-1.91261,19.54433Z" transform="translate(-135 -145.06323)" fill="#ffb8b8"/><polygon points="266.928 596.776 277.924 596.776 283.154 554.366 266.926 554.367 266.928 596.776" fill="#ffb8b8"/><path d="M399.12375,738.24988l21.65354-.00087h.00087a13.79912,13.79912,0,0,1,13.79951,13.79869v.449l-35.45328.00134Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><polygon points="157.641 581.575 167.089 587.2 193.281 553.436 179.338 545.134 157.641 581.575" fill="#ffb8b8"/><path d="M292.06791,722.11807l18.60547,11.07763.00075.00046a13.79912,13.79912,0,0,1,4.797,18.91612l-.00029.00046-.22942.38533L284.77887,734.3606Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M415.51814,726.86015H403.20583a4.02851,4.02851,0,0,1-4.01309-3.60932l-12.4126-116.67831a1.34555,1.34555,0,0,0-2.564-.4116l-22.39254,49.58379-39.64482,64.64563a4.0551,4.0551,0,0,1-5.06585,1.58354l-15.83779-6.96816a4.03709,4.03709,0,0,1-1.83927-5.76478l36.4445-61.02314,11.17722-51.4152c-3.51538-22.2971,11.55495-55.44664,11.70778-55.77951l.07468-.162,41.5118-16.22509.20818.25486c16.37107,53.72388,26.34689,111.53991,18.98108,198.27152A4.06315,4.06315,0,0,1,415.51814,726.86015Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M357.16762,546.29387l-.19333-.40639c-.0924-.19443-9.32287-19.66257-16.43835-40.46987a30.69125,30.69125,0,0,1,2.12808-24.59616,31.02608,31.02608,0,0,1,19.78517-15.21419h0a31.06385,31.06385,0,0,1,36.05541,18.60367c5.64412,14.11413,3.84532,29.17924,2.1525,41.0267l-.03371.23737-.2159.10334Z" transform="translate(-135 -145.06323)" fill="#6c63ff"/><path d="M392.35661,422.82521H357.37914V407.57864c7.67716-3.05,15.18965-5.64384,19.73089,0a15.24671,15.24671,0,0,1,15.24661,15.24657Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M355.44265,404.88807c-20.91019,0-26.763,26.2101-26.763,40.99656,0,8.24624,3.72934,11.19562,9.58956,12.1936l2.06962-11.0378,4.84728,11.51276c1.64615.00821,3.37549-.02364,5.16832-.05691l1.6435-3.38414,3.66493,3.32342c14.6786.02187,26.54228,2.16158,26.54228-12.55093C382.20515,431.09817,377.07235,404.88807,355.44265,404.88807Z" transform="translate(-135 -145.06323)" fill="#2f2e41"/><path d="M448.3868,434.22219q.19948.36519.36853.7513a9.86785,9.86785,0,0,1-6.07712,13.41206,9.24155,9.24155,0,0,1-.93929.2372l-18.15655,46.96587a7.66336,7.66336,0,0,1-7.76025,4.84713l-.09127-.01726-39.353-11.84688a8.45924,8.45924,0,0,1,4.87818-16.19994q.07364.0222.14688.04569l27.84438,8.93958,21.557-38.21713a9.38748,9.38748,0,0,1-.486-1.22578,9.86762,9.86762,0,0,1,18.06859-7.69186Z" transform="translate(-135 -145.06323)" fill="#ffb8b8"/><path d="M798.21867,314.93171c-14.71126-19.68715-41.63633-24.43848-55.016-14.4405s-16.45312,37.16578-1.74186,56.85292c13.61709,18.2229,38.28788,23.19273,51.87646,16.36552a1.70623,1.70623,0,0,0-.008.64694l.7661,3.78749a1.72815,1.72815,0,0,0,2.75777,1.0192l6.48744-5.06824a1.7282,1.7282,0,0,0-.32149-2.92255l-3.48973-1.65968a1.71,1.71,0,0,0-.384-.12059C809.61955,358.3189,811.86537,333.19421,798.21867,314.93171Z" transform="translate(-135 -145.06323)" fill="#ccc"/><path d="M766.03958,307.49879a28.43178,28.43178,0,0,1,23.81222,31.08457c-.15813,1.65975,2.43513,1.6489,2.59222,0a31.08812,31.08812,0,0,0-25.71533-33.58419C765.097,304.72181,764.39579,307.21935,766.03958,307.49879Z" transform="translate(-135 -145.06323)" fill="#fff"/><path d="M307.19769,339.62407c12.86166-20.94237,7.33248-47.71854-6.90025-56.45949s-40.61474-1.56289-53.47639,19.37948c-11.90506,19.38475-7.41154,44.14672,3.95178,54.25292a1.7066,1.7066,0,0,0-.60414.23155l-3.23673,2.11082a1.72815,1.72815,0,0,0,.07142,2.9392l7.106,4.15682a1.72819,1.72819,0,0,0,2.59716-1.37818l.25344-3.856a1.7105,1.7105,0,0,0-.02977-.40137C271.08908,366.24354,295.26677,359.051,307.19769,339.62407Z" transform="translate(-135 -145.06323)" fill="#ccc"/><path d="M302.22,306.975a28.43178,28.43178,0,0,1-20.09183,33.60938c-1.60081.46606-.63292,2.872.95741,2.40893a31.08811,31.08811,0,0,0,21.71181-36.30114C304.45246,305.07335,301.87253,305.34419,302.22,306.975Z" transform="translate(-135 -145.06323)" fill="#fff"/><path d="M950.26462,187.99029c-1.07548-24.553-20.65376-43.63766-37.3403-42.90674s-34.52115,21.45438-33.44566,46.00735c.99548,22.72681,18.58763,40.723,33.66182,42.7303a1.70645,1.70645,0,0,0-.37079.53021l-1.499,3.56158a1.72816,1.72816,0,0,0,1.70547,2.39487l8.215-.53664a1.7282,1.7282,0,0,0,1.37957-2.59642l-1.94986-3.33628a1.71019,1.71019,0,0,0-.24947-.31584C935.2619,230.26732,951.26229,210.76651,950.26462,187.99029Z" transform="translate(-135 -145.06323)" fill="#6c63ff"/><path d="M927.85361,163.7315a28.43179,28.43179,0,0,1,2.181,39.09624c-1.06508,1.28273,1.08432,2.73367,2.14242,1.45932a31.08812,31.08812,0,0,0-2.34665-42.23351C928.63791,160.90572,926.65236,162.57516,927.85361,163.7315Z" transform="translate(-135 -145.06323)" fill="#fff"/><path d="M796.775,258.87236a40.78441,40.78441,0,0,1-31.9-18.89576c-.96575-1.54387-2.22647-3.24048-1.55793-5.14081a3.37989,3.37989,0,0,1,3.50209-2.339c1.97114.23991,3.24314,2.1682,3.486,4.01585.27545,2.09589-1.20316,3.74123-3.02865,4.52-4.461,1.90287-8.96171-1.0379-12.59546-3.38488-8.27978-5.34781-17.38675-10.18416-27.41958-10.79361-9.28263-.56383-19.23683,3.07583-24.4,11.12566-.9033,1.40833,1.33949,2.70971,2.23832,1.30834,5.12058-7.98343,15.4722-10.85073,24.4728-9.6168a47.57615,47.57615,0,0,1,15.31322,5.199c2.47389,1.28387,4.87324,2.70708,7.2241,4.20317a46.09642,46.09642,0,0,0,7.08547,4.06183c4.13161,1.69719,9.601,1.5646,12.487-2.34291,2.69239-3.64546.61164-9.71453-3.89154-10.7394a6.08493,6.08493,0,0,0-7.128,7.239c.44931,2.14673,2.06581,4.24753,3.31706,6.0022a43.37948,43.37948,0,0,0,32.79527,18.17034c1.66744.08248,1.66308-2.51,0-2.59222Z" transform="translate(-135 -145.06323)" fill="#ccc"/></svg>
            <div class="u-m-8-0">
                <div class="font-14 font-500">Gostaria de se cadastrar no programa de fidelidade?</div>
                <div class="font-12 u-m-t-3">Ao se cadastrar no programa de fidelidade, você pode acumular pontos que são convertidos em benefícios.</div>
            </div>

            <div class="flex-column gap-8">
                <button class="btn-azul">Cadastrar</button>
                <button class="btn-transparent">Não tenho interesse</button>
            </div>
        </div>`

    const cadastrar = select('.btn-azul', wrapper)
    const naoCadastrar = select('.btn-transparent', wrapper)

    naoCadastrar.addEventListener('click', () => {
      wrapper.remove()
    })

    cadastrar.addEventListener('click', () => {
      if (
        (estabelecimento.programaFidelidade.obrigatorioSexo ||
          estabelecimento.programaFidelidade.obrigatorioCPF ||
          estabelecimento.programaFidelidade.obrigatorioNascimento) &&
        !usuario.dataNascimento &&
        !usuario.cpf &&
        !usuario.sexo
      ) {
        const content = select('.wrapper-content', wrapper)
        content.innerHTML = `<div class="font-14 font-500">Antes de continuar, preencha as informações abaixo para concluir seu cadastro</div>`

        const inputCPF = createElement(
          'div',
          { class: 'input-wrapper' },
          createElement('input', {
            class: '',
            id: 'input-cpf',
            type: 'text',
            required: true,
            value: usuario.cpf || '',
          }),
        )
        IMask(inputCPF.querySelector('input'), {
          mask: '000.000.000-00',
        })

        const labelCPF = createElement(
          'label',
          { class: 'label', for: 'input-cpf' },
          'CPF',
        )

        inputCPF.appendChild(labelCPF)

        if (estabelecimento.programaFidelidade.obrigatorioCPF) {
          content.appendChild(inputCPF)
        }

        const flex = createElement('div', { class: 'flex gap-8 w-100' })
        content.appendChild(flex)

        const inputTelefone = createElement(
          'div',
          { class: 'input-wrapper' },
          createElement('input', {
            class: '',
            id: 'input-telefone',
            type: 'text',
            required: true,
            value: usuario.telefone || '',
          }),
        )
        IMask(inputTelefone.querySelector('input'), {
          mask: '(00) 00000-0000',
        })
        const labelTelefone = createElement(
          'label',
          { class: 'label', for: 'input-telefone' },
          'Telefone',
        )
        inputTelefone.appendChild(labelTelefone)
        flex.appendChild(inputTelefone)

        const selectSexo = createElement(
          'div',
          { class: 'input-wrapper' },
          createElement(
            'select',
            {
              class: '',
              type: 'text',
              required: true,
              value: usuario.sexo || 0,
            },
            ` 
              <option value="0">Masculino</option>
              <option value="1">Feminino</option>
            `,
          ),
        )

        if (estabelecimento.programaFidelidade.obrigatorioSexo) {
          flex.appendChild(selectSexo)
        }

        const dataNascimento = usuario.dataNascimento
          ? new Date(usuario.dataNascimento)
          : new Date()
        const inputDate = createElement(
          'div',
          { class: 'input-wrapper' },
          createElement('input', {
            class: '',
            id: 'input-date',
            type: 'date',
            required: true,
            value: dataNascimento,
          }),
        )

        const labelDate = createElement(
          'label',
          { class: 'label', for: 'input-date' },
          'Data de Nascimento',
        )

        inputDate.appendChild(labelDate)

        if (estabelecimento.programaFidelidade.obrigatorioNascimento) {
          flex.appendChild(inputDate)
        }

        const buttons = createElement('div', { class: 'flex gap-12 w-100' })

        const cancelar = createElement(
          'button',
          { class: 'btn-transparent' },
          'Cancelar',
        )
        buttons.appendChild(cancelar)
        cancelar.addEventListener('click', () => {
          wrapper.remove()
        })

        const cadastrar = createElement(
          'button',
          { class: 'btn-azul' },
          'Cadastrar',
        )
        buttons.appendChild(cadastrar)
        cadastrar.addEventListener('click', () => {
          // CPF e Telefone sempre vão ser obrigatórios
          if (
            inputIsValid(inputCPF.firstElementChild) &&
            inputIsValid(inputTelefone.firstElementChild)
          ) {
            if (
              estabelecimento.programaFidelidade &&
              estabelecimento.programaFidelidade.obrigatorioNascimento &&
              !inputIsValid(inputDate.firstElementChild)
            ) {
              toast('Data de nascimento obrigatória.')
              return
            }

            usuario.dataNascimento = inputDate.firstElementChild.value || ''
            usuario.cpf = inputCPF.firstElementChild.value || ''
            usuario.sexo = selectSexo.firstElementChild.value || 0
            usuario.telefone = inputTelefone.firstElementChild.value || ''

            axios
              .get(getUrlAction('cadastros', 'SetDadosUsuario'), {
                params: {
                  telefone:
                    usuario.telefone || inputTelefone.firstElementChild.value,
                  cpf: usuario.cpf || inputCPF.firstElementChild.value,
                  dataNascimento:
                    usuario.dataNascimento || inputDate.firstElementChild.value,
                  sexo: usuario.sexo || selectSexo.firstElementChild.value,
                  cadastroFidelidade: true,
                },
              })
              .then((data) => {
                if (data && data.data.lValid) {
                  usuario.UtilizaProgramaFidelidade = true
                  toast('Cadastrado com sucesso!')
                  wrapper.remove()
                } else {
                  toast(
                    'Falha ao cadastrar, verifique os campos e tente novamente.',
                  )
                }
              })
              .catch((error) => {
                Sentry.captureException(error)
                console.error(error)
              })
          } else {
            toast('Verifique os campos marcados.')
          }
        })

        content.appendChild(buttons)
      } else {
        axios
          .get(getUrlAction('cadastros', 'SetDadosUsuario'), {
            params: {
              telefone: usuario.telefone,
              cpf: usuario.cpf,
              dataNascimento: convertBRDateToAmerican(
                usuario.dataNascimento ?? '',
              ),
              sexo: usuario.sexo,
              cadastroFidelidade: true,
            },
          })
          .then((data) => {
            if (data && data.data.lValid) {
              usuario.UtilizaProgramaFidelidade = true
              toast('Cadastrado com sucesso!')
              wrapper.remove()
            } else if (data && data.data.erros && data.data.erros?.length > 0) {
              toast(data.data.erros[0])
            } else {
              toast(
                'Falha ao cadastrar, verifique os campos e tente novamente.',
              )
            }
          })
          .catch((error) => {
            Sentry.captureException(error)
            console.error(error)
          })
      }
    })

    document.body.appendChild(wrapper)
  }
}

export const mensagemBeneficioDisponiveis = () => {
  // Verifico se o usuário tem benefícios disponíveis para resgate
  const pontos = estabelecimento.programaFidelidade?.cliente?.pontos
  const beneficios = estabelecimento.programaFidelidade?.beneficios
  if (!pontos || !beneficios) {
    return
  }

  // Verifico se o cliente já não tem itens na sacola, somente para a mensagem não ficar aparecendo sem necessidade
  const pedido = localStorage.getItem(
    `pedido-mobile-${estabelecimento.urlEmpresa}`,
  )
  if (pedido) {
    const ped = JSON.parse(pedido)
    if (ped && ped?.Itens?.length > 0) {
      return
    }
  }

  const beneficioDisponivel = beneficios.filter(
    (beneficio) => pontos >= beneficio.Pontos && beneficio.Produto > 0,
  )

  if (
    estabelecimento.programaFidelidade.Ativo &&
    beneficioDisponivel &&
    beneficioDisponivel.length > 0
  ) {
    const wrapper = createElement('div', {
      class: 'wrapper-solicita-endereco beneficio-disponivel-fideliza',
    })
    wrapper.innerHTML = `
        <div class="wrapper-content">
            <svg class="img-fidelidade" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 671.52209 516.5519" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M714.25623,337.17107c14.40587-38.73235,48.442-72.19975,89.574-76.18066A190.39843,190.39843,0,0,0,773.73826,388.201c2.10493,17.203,6.23736,36.11769-3.03627,50.7593-5.77009,9.11047-15.93914,14.71912-26.42153,17.25022-10.483,2.531-21.40582,2.3349-32.188,2.12433l-2.41384,1.19194C702.09559,418.90394,699.85037,375.90342,714.25623,337.17107Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M804.0293,261.83435a162.73935,162.73935,0,0,0-60.45985,79.81243c-2.37124,6.93389-4.17322,14.17413-4.27711,21.53716a40.19468,40.19468,0,0,0,5.43533,20.44411c3.24478,5.85508,7.24188,11.46843,9.00688,18.0103,1.86039,6.89548.34393,13.87115-3.45644,19.82867-4.64985,7.2892-11.64153,12.47292-18.655,17.30456C723.836,444.13619,715.6627,449.585,710.898,458.01242c-.57731,1.0211-2.128.06561-1.55152-.954,8.28972-14.66233,25.6874-19.98825,36.33039-32.44276,4.96621-5.8115,8.21115-13.15484,6.67573-20.89328-1.34266-6.76694-5.45955-12.559-8.7962-18.459-3.50354-6.19509-5.79254-12.62428-6.05939-19.79191-.273-7.3321,1.24974-14.65805,3.43331-21.62215a157.886,157.886,0,0,1,22.2696-44.03568,165.625,165.625,0,0,1,39.97114-39.58613c.95861-.66927,1.81057.94189.85822,1.60679Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M746.58457,331.03381a24.41609,24.41609,0,0,1-12.19648-29.16909c.3593-1.11541,2.10948-.60948,1.7497.50742a22.60875,22.60875,0,0,0,11.40073,27.11015c1.04712.52635.08718,2.07486-.95395,1.55152Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M742.69144,380.876a47.06,47.06,0,0,0,26.6914-21.53564c.5809-1.019,2.13173-.06385,1.55153.954A48.94959,48.94959,0,0,1,743.114,382.64761c-1.12076.35042-1.53723-1.42312-.42255-1.77164Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M775.41584,286.50364a13.82072,13.82072,0,0,0,12.89848,2.36892c1.11576-.36446,1.53105,1.40955.42255,1.77163a15.48721,15.48721,0,0,1-14.275-2.589.94127.94127,0,0,1-.29878-1.25274.91526.91526,0,0,1,1.25273-.29878Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M902.97269,359.7196c-.69023.24739-1.38046.49478-2.075.757a182.01161,182.01161,0,0,0-26.83058,12.32209c-.67045.36266-1.34445.74028-2.00309,1.12144A191.88011,191.88011,0,0,0,818.376,419.83559a186.33934,186.33934,0,0,0-16.01376,23.34847c-6.54286,11.29406-12.73837,24.06028-22.34728,32.291a31.96646,31.96646,0,0,1-3.13139,2.41826L711.32,462.37915c-.13131-.11-.26687-.20536-.3989-.31556l-2.64608-.49974c.21491-.43883.44723-.88934.66214-1.32816.1236-.25507.26181-.50669.38541-.76176.087-.16895.17481-.33782.24369-.49526.02876-.05635.05825-.11252.08348-.154.06888-.15744.14958-.29636.21491-.43882q1.93751-3.78275,3.93494-7.55141c.00354-.015.00354-.015.02169-.02649,10.19513-19.11771,22.07586-37.55224,36.3769-53.59746.43043-.4826.86367-.98035,1.324-1.45586a177.81,177.81,0,0,1,21.12062-19.897,157.19321,157.19321,0,0,1,12.94424-9.2422,130.71583,130.71583,0,0,1,37.47369-16.31174c26.45309-6.85124,54.80286-5.16605,78.13912,8.36463C901.79662,359.01488,902.3795,359.35807,902.97269,359.7196Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M902.62839,360.51686a162.73946,162.73946,0,0,0-96.3264,27.32475c-6.068,4.10868-11.86589,8.80469-16.3819,14.62111a40.19466,40.19466,0,0,0-7.96895,19.59592c-.93438,6.62853-1.12255,13.517-3.652,19.803-2.66613,6.62574-8.07677,11.2824-14.698,13.75107-8.10125,3.02048-16.80467,2.94992-25.31349,2.58513-9.44742-.405-19.25393-.9754-28.13216,2.88479-1.07573.46771-1.73856-1.22879-.66446-1.6958,15.44661-6.71606,32.54426-.49391,48.54056-4.03032,7.46417-1.65016,14.47627-5.55973,17.9094-12.66287,3.00213-6.21139,3.20224-13.31468,4.09032-20.03439.9325-7.05581,2.97567-13.56729,7.078-19.45091,4.19647-6.01862,9.823-10.9512,15.75933-15.197a157.88622,157.88622,0,0,1,44.29354-21.75219,165.62515,165.62515,0,0,1,55.74831-7.54192c1.16834.04278.87855,1.84214-.28216,1.79964Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M815.09913,381.18306a24.41607,24.41607,0,0,1,7.82361-30.633c.95843-.67428,2.05124.78341,1.09153,1.45858a22.60876,22.60876,0,0,0-7.21934,28.51c.51917,1.05071-1.1796,1.70916-1.6958.66446Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M781.98226,418.63531a47.0601,47.0601,0,0,0,34.27754-1.12494c1.07734-.46389,1.7405,1.23247.66446,1.6958a48.94954,48.94954,0,0,1-35.67126,1.09809c-1.10585-.395-.37058-2.06179.72926-1.66895Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M864.92953,362.98663a13.82068,13.82068,0,0,0,8.87246,9.65722c1.1103.38077.37381,2.04725-.72927,1.669a15.48721,15.48721,0,0,1-9.839-10.66172.94126.94126,0,0,1,.51567-1.18013.91527.91527,0,0,1,1.18013.51567Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M334.37445,692.19971c-37.5339-17.28962-68.33548-53.75588-69.19893-95.071a190.3985,190.3985,0,0,0,124.575,39.61237c17.31282-.79984,36.48558-3.49212,50.38507,6.8607,8.64873,6.4416,13.47344,17.00516,15.20574,27.64875,1.73211,10.64416.71176,21.521-.31242,32.25647l1.00625,2.497C414.95562,710.49772,371.90834,709.48933,334.37445,692.19971Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M266.03209,596.99389A162.73938,162.73938,0,0,0,341.051,663.30817c6.735,2.88809,13.81852,5.23167,21.15268,5.8913a40.19472,40.19472,0,0,0,20.79618-3.876c6.0834-2.79336,11.98256-6.35515,18.639-7.6211,7.01628-1.33437,13.85751.70453,19.511,4.94394,6.91725,5.187,11.55819,12.55019,15.84641,19.90847,4.76124,8.17,9.57725,16.73144,17.62083,22.11892.9746.65276-.09526,2.12683-1.06838,1.47505-13.99446-9.37328-17.99139-27.12348-29.60662-38.67658-5.41988-5.39089-12.49722-9.1811-20.32951-8.23443-6.849.82781-12.93542,4.49556-19.07054,7.37714-6.442,3.02571-13.02565,4.82267-20.193,4.54749-7.33177-.28149-14.52181-2.35308-21.30114-5.05631a157.88611,157.88611,0,0,1-42.22824-25.53138,165.625,165.625,0,0,1-36.45466-42.84638c-.595-1.00641,1.07593-1.73426,1.667-.73443Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M330.696,659.50023a24.4161,24.4161,0,0,1-30.00683,9.95893c-1.08509-.4425-.44844-2.14948.6381-1.70638a22.60879,22.60879,0,0,0,27.89368-9.32094c.60392-1.00439,2.07552.06974,1.47505,1.06839Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M380.10185,667.14609a47.06,47.06,0,0,0-19.45854-28.24146c-.97225-.6562.09732-2.13046,1.06839-1.47506a48.94954,48.94954,0,0,1,20.18864,29.429c.26479,1.144-1.53514,1.42537-1.79849.28756Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M288.47018,627.38856a13.82069,13.82069,0,0,0,3.33619-12.68275c-.27916-1.1401,1.52114-1.42024,1.79849-.28756a15.48721,15.48721,0,0,1-3.65963,14.0387.94126.94126,0,0,1-1.27172.20333.91527.91527,0,0,1-.20333-1.27172Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M371.10959,505.72486c.19456.707.38912,1.41389.59811,2.12621a182.011,182.011,0,0,0,10.2608,27.68447c.311.69593.63663,1.39652.967,2.08206a191.88,191.88,0,0,0,41.73011,57.00208,186.34036,186.34036,0,0,0,22.07251,17.73122c10.76773,7.377,23.02964,14.51891,30.51126,24.72193a31.967,31.967,0,0,1,2.17488,3.30506l-20.421,64.20481c-.11963.12262-.22492.25059-.34478.37393l-.69813,2.60078c-.42135-.24743-.853-.51311-1.27437-.76054-.245-.14251-.48547-.29933-.73048-.44184-.1619-.09954-.32366-.19982-.47544-.28039-.054-.03293-.1078-.06658-.14724-.09487-.15179-.08057-.28422-.17153-.42134-.24743q-3.62563-2.21764-7.2327-4.494c-.01466-.00467-.01466-.00467-.02478-.02364-18.29323-11.6097-35.77794-24.84859-50.6974-40.32046-.44872-.46564-.91232-.93523-1.35171-1.4302a177.80919,177.80919,0,0,1-18.24528-22.56284,157.19366,157.19366,0,0,1-8.23832-13.6052A130.71577,130.71577,0,0,1,355.686,584.69757c-4.83406-26.89493-1.01284-55.0365,14.24145-77.28435C370.31807,506.84436,370.7043,506.28906,371.10959,505.72486Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M371.87858,506.12839a162.73942,162.73942,0,0,0,19.9726,98.11479c3.63871,6.36092,7.88349,12.4969,13.34227,17.43924a40.19461,40.19461,0,0,0,18.93819,9.426c6.539,1.43228,13.39364,2.14009,19.47065,5.137,6.40549,3.15886,10.64027,8.9057,12.60188,15.69444,2.40009,8.30622,1.67249,16.97946.6662,25.43644-1.1173,9.38986-2.42659,19.12528.75213,28.26968.38515,1.108-1.35657,1.6408-1.74113.5345-5.53043-15.90967,1.96509-32.48863-.35325-48.70631-1.08179-7.56747-4.45067-14.85478-11.27428-18.81451-5.96695-3.46261-13.03484-4.19856-19.6683-5.59154-6.96525-1.46266-13.30384-3.99172-18.86087-8.52665-5.68454-4.639-10.17815-10.62194-13.96353-16.86194a157.8862,157.8862,0,0,1-18.34523-45.8097,165.6251,165.6251,0,0,1-3.31053-56.15865c.13089-1.16178,1.90322-.73693,1.7732.41725Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M385.876,594.96834a24.4161,24.4161,0,0,1-29.95474-10.11453c-.6-1.00662.93608-1.98623,1.53685-.97828a22.60877,22.60877,0,0,0,27.88339,9.35168c1.0869-.43835,1.61519,1.30529.5345,1.74113Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M420.72043,630.81887a47.06,47.06,0,0,0,1.46675-34.26461c-.3812-1.1093,1.36039-1.64247,1.74114-.53451a48.94952,48.94952,0,0,1-1.59877,35.65233c-.47736,1.07286-2.08389.21382-1.60912-.85321Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M371.49445,543.90611a13.82069,13.82069,0,0,0,10.29965-8.11785c.46353-1.07838,2.06963-.21815,1.60912.85321a15.48719,15.48719,0,0,1-11.37427,9.00578.94127.94127,0,0,1-1.13782-.60332.91528.91528,0,0,1,.60332-1.13782Z" transform="translate(-264.23896 -191.72405)" fill="#fff"></path><path d="M420.79664,463.88161c-33.16617-32.64969-47.174-66.71152-39.4442-95.91008,9.9198-37.47017,53.98856-63.37763,120.90656-71.07942l.24715,2.14936c-65.98643,7.59406-109.38293,32.92008-119.06244,69.4835-7.52277,28.41593,6.28173,61.73366,38.87068,93.81564Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M740.79422,579.7781c-41.39342,0-86.37473-6.15129-131.054-17.97964-55.25177-14.62727-105.91173-36.70549-146.503-63.84869l1.202-1.79765c40.39583,27.01171,90.83135,48.98906,145.85446,63.55507,49.72364,13.16444,99.82012,19.264,144.8553,17.65433l.07816,2.161Q748.09308,579.77915,740.79422,579.7781Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M835.75583,566.17534l-.69286-2.049c37.02076-12.517,60.17576-32.68032,66.96183-58.31211,8.626-32.5842-10.11414-70.39606-52.76866-106.47046-42.87209-36.25766-104.69447-66.34238-174.08133-84.71123l.55345-2.09127c69.69,18.44965,131.81338,48.69016,174.92417,85.15113,43.32837,36.6437,62.31563,75.23872,53.46364,108.67528C897.13566,532.73456,873.49692,553.41542,835.75583,566.17534Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M495.81884,580.6822c-81.33562-36.07335-144.01087-82.874-176.47943-131.78169l1.80188-1.19667c32.24411,48.56921,94.59036,95.09258,175.55419,131.00116Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M781.78839,643.17632q-12.58406,0-25.598-.56189l.093-2.161c64.74593,2.80314,121.87245-4.94512,165.21455-22.41145l.80905,2.00678C884.49827,635.28336,836.30822,643.17632,781.78839,643.17632Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M734.59646,298.83182c-13.44328-4.37688-27.271-8.45222-41.09874-12.113-79.57335-21.06585-157.79477-28.5453-226.211-21.62563l-.21757-2.15253c68.67128-6.94238,147.16045.555,226.982,21.68689,13.86681,3.67134,27.73362,7.7583,41.21491,12.14785Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M369.964,467.12624c-33.16617-32.64969-47.174-66.71151-39.4442-95.91008,9.9198-37.47017,53.98856-63.37762,120.90656-71.07941l.24715,2.14936c-65.98643,7.59406-109.38293,32.92008-119.06244,69.4835-7.52277,28.41593,6.28173,61.73366,38.87069,93.81564Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M689.96157,583.02274c-41.39341,0-86.37473-6.15129-131.054-17.97964-55.25178-14.62728-105.91174-36.70549-146.503-63.8487l1.202-1.79764c40.39584,27.01171,90.83135,48.98905,145.85446,63.55507,49.72364,13.16443,99.82012,19.264,144.8553,17.65433l.07816,2.161Q697.26043,583.02379,689.96157,583.02274Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M784.92319,569.42l-.69287-2.049c37.02076-12.517,60.17577-32.68032,66.96183-58.3121,8.626-32.58421-10.11414-70.39606-52.76866-106.47047C755.5514,366.33073,693.729,336.246,624.34217,317.87716l.55344-2.09127C694.5856,334.23554,756.709,364.476,799.81979,400.937c43.32837,36.6437,62.31562,75.23872,53.46363,108.67527C846.303,535.9792,822.66427,556.66006,784.92319,569.42Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M444.98619,583.92684c-81.33562-36.07335-144.01087-82.874-176.47942-131.7817l1.80187-1.19667c32.24411,48.56922,94.59036,95.09259,175.55419,131.00117Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M730.95574,646.421q-12.58405,0-25.598-.5619l.09294-2.161c64.74593,2.80315,121.87246-4.94511,165.21456-22.41144l.809,2.00677C833.66562,638.528,785.47558,646.421,730.95574,646.421Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M683.76381,302.07645c-13.44328-4.37688-27.271-8.45221-41.09874-12.113-79.57335-21.06585-157.79477-28.54531-226.211-21.62563l-.21758-2.15253c68.67129-6.94239,147.16045.555,226.982,21.68689,13.86681,3.67134,27.73362,7.75829,41.21492,12.14785Z" transform="translate(-264.23896 -191.72405)" fill="#f0f0f0"></path><path d="M468.87453,462.69114a16.78275,16.78275,0,0,0-16.764,16.764,787.72309,787.72309,0,0,0-6.35989,141.64658c.12727,3.02072.26827,5.78373.432,8.44957.23765,4.40223.53972,9.0495.89724,13.81506.20543,2.8116.42195,5.63164.65907,8.44218.39713,4.57756.83334,9.22905,1.29754,13.82457.29151,2.80737.59411,5.62847.91783,8.438.62158,5.51863,1.325,11.17562,2.15148,17.29417A16.80547,16.80547,0,0,0,468.87453,708.202H750.07641a16.78275,16.78275,0,0,0,16.764-16.764l.01267-.11618c1.25265-5.70663,2.41922-11.522,3.468-17.28572.56085-3.03868,1.04511-5.79852,1.48026-8.4369.789-4.80359,1.49083-9.453,2.08441-13.81823.40611-2.93094.77366-5.769,1.09158-8.439.52334-4.36949.99705-8.88579,1.44752-13.80766.24662-2.67535.47264-5.43836.69181-8.44641v-.00106A491.7331,491.7331,0,0,0,766.853,479.57128l-.01267-.11618a16.78275,16.78275,0,0,0-16.764-16.764Z" transform="translate(-264.23896 -191.72405)" fill="#3f3d56"></path><path d="M620.39285,534.45867c-60.92989,0-125.4931-5.53658-209.992-16.61292h-.009a17.78279,17.78279,0,0,1-17.65486-15.8683,16.33291,16.33291,0,0,1-.11143-1.973V449.17182a2.57984,2.57984,0,0,1,.01478-.32531,17.88428,17.88428,0,0,1,17.83072-17.52019c147.00994-19.98853,236.31351-19.98642,398.07536.00422h.00739a17.88113,17.88113,0,0,1,17.761,17.57407,1.97187,1.97187,0,0,1,.01056.26721v50.83265a16.37335,16.37335,0,0,1-.112,1.97826A17.807,17.807,0,0,1,808.47988,517.85C738.59132,528.921,681.308,534.45867,620.39285,534.45867Z" transform="translate(-264.23896 -191.72405)" fill="#4f44e0"></path><path d="M630.16637,569.76417H593.19789a17.76765,17.76765,0,0,1-17.74728-17.74728V417.70877a17.76766,17.76766,0,0,1,17.74728-17.74728h36.96848a17.76777,17.76777,0,0,1,17.7478,17.74728V552.01689A17.76776,17.76776,0,0,1,630.16637,569.76417Z" transform="translate(-264.23896 -191.72405)" fill="#3f3d56"></path><path d="M714.09809,374.26152a46.871,46.871,0,0,0-1.40969-7.4518,48.31277,48.31277,0,0,0-2.74017-7.13362,41.985,41.985,0,0,0-18.90375-19.6287c-10.31172-5.07621-22.10746-5.49163-33.19456-3.04587a65.60467,65.60467,0,0,0-25.6438,12.00579A66.68654,66.68654,0,0,0,621.511,359.0944c-3.285,3.94159-9.39592,14.77084-9.83636,15.77344A65.65846,65.65846,0,0,0,597.0819,353.993a68.60755,68.60755,0,0,0-25.136-15.19088,63.33207,63.33207,0,0,0-15.40609-3.13149,49.03154,49.03154,0,0,0-16.52565,1.44184,41.63138,41.63138,0,0,0-23.564,17.22518,43.45194,43.45194,0,0,0-7.35958,26.50381,44.58105,44.58105,0,0,0,3.03115,13.83922,52.76431,52.76431,0,0,0,3.31237,6.94859,54.05393,54.05393,0,0,0,4.40341,6.30932,49.87922,49.87922,0,0,0,24.5047,16.31765c10.27468,3.17546,21.17358,3.27923,31.739,1.78841,10.84972-1.531,21.29326-5.04321,31.512-8.88968,1.36322-.51311,2.7207-1.04115,4.08022-1.564,9.08449,3.49475,18.246,6.86534,27.75547,9.0046a83.57644,83.57644,0,0,0,32.6722,1.31028,52.428,52.428,0,0,0,27.09377-13.23441,48.65189,48.65189,0,0,0,14.03619-24.37452A42.07665,42.07665,0,0,0,714.09809,374.26152ZM573.25957,415.59611a72.84607,72.84607,0,0,1-17.67.10338,54.84149,54.84149,0,0,1-12.28767-3.27051,38.632,38.632,0,0,1-20.70364-20.55571,41.35361,41.35361,0,0,1-2.50543-9.10759,37.705,37.705,0,0,1-.00257-8.35782,39.33793,39.33793,0,0,1,2.34958-8.52819,40.18986,40.18986,0,0,1,4.411-7.55155,37.90379,37.90379,0,0,1,5.69013-5.71521,34.63915,34.63915,0,0,1,6.37382-3.73484,38.95352,38.95352,0,0,1,8.33584-2.22983,49.33657,49.33657,0,0,1,11.62186.09076,60.0992,60.0992,0,0,1,13.38578,3.68976,63.17378,63.17378,0,0,1,12.88963,7.51511,61.87593,61.87593,0,0,1,9.96053,9.93062A61.03434,61.03434,0,0,1,602.361,380.3633a63.26732,63.26732,0,0,1,3.89466,14.39293l.00838.07221a65.6,65.6,0,0,0-.42479,7.46784c.00185.96128.0439,1.92136.09229,2.88091a5.74665,5.74665,0,0,0-1.12683,1.51664,181.72746,181.72746,0,0,1-23.1162,7.33093Q577.50951,414.9895,573.25957,415.59611Zm130.01831-32.83069a41.34678,41.34678,0,0,1-2.50583,9.10871A38.41847,38.41847,0,0,1,680.06881,412.429a54.84257,54.84257,0,0,1-12.2878,3.27051,72.86439,72.86439,0,0,1-17.70212-.1072c-10.43444-1.49208-20.50012-4.7857-30.346-8.46146-.40538-.15137-.8076-.31092-1.21252-.46347a5.64344,5.64344,0,0,0-1.07818-1.5,64.7573,64.7573,0,0,0-.32306-10.4382,63.27186,63.27186,0,0,1,3.89057-14.36586,61.03446,61.03446,0,0,1,7.25218-12.48834,61.87273,61.87273,0,0,1,9.96092-9.93109,63.17378,63.17378,0,0,1,12.88963-7.51511,60.10468,60.10468,0,0,1,13.38591-3.68976,49.33815,49.33815,0,0,1,11.6216-.09076,38.95859,38.95859,0,0,1,8.336,2.22983,34.63817,34.63817,0,0,1,6.37428,3.73517,37.89835,37.89835,0,0,1,5.68987,5.71521,40.19532,40.19532,0,0,1,4.41081,7.55122,39.33847,39.33847,0,0,1,2.34957,8.52819A37.70565,37.70565,0,0,1,703.27788,382.76542Z" transform="translate(-264.23896 -191.72405)" fill="#3f3d56"></path><circle cx="234.91885" cy="377.49935" r="6.48927" fill="#4f44e0"></circle><circle cx="281.42532" cy="361.27616" r="6.48927" fill="#4f44e0"></circle><circle cx="260.87595" cy="412.10881" r="6.48927" fill="#4f44e0"></circle><circle cx="453.39108" cy="377.49935" r="6.48927" fill="#4f44e0"></circle><circle cx="406.88462" cy="361.27616" r="6.48927" fill="#4f44e0"></circle><circle cx="427.43398" cy="412.10881" r="6.48927" fill="#4f44e0"></circle><circle cx="458.7988" cy="491.06164" r="6.48927" fill="#4f44e0"></circle><circle cx="475.022" cy="444.55518" r="6.48927" fill="#4f44e0"></circle><circle cx="424.18935" cy="465.10453" r="6.48927" fill="#4f44e0"></circle><circle cx="272.77294" cy="491.06164" r="6.48927" fill="#4f44e0"></circle><circle cx="288.99614" cy="444.55518" r="6.48927" fill="#4f44e0"></circle><circle cx="238.16349" cy="465.10453" r="6.48927" fill="#4f44e0"></circle><path id="e3b13650-ec26-4d46-b148-6e027bc06f3e-138" data-name="Path 2961" d="M688.85406,230.95885a15.505,15.505,0,0,0,15.09905-1.77382c5.488-4.09309,7.54528-11.23784,9.26848-17.86242l5.09038-19.59856-8.59743,5.21981c-6.1831,3.75309-12.508,7.63053-16.97107,13.32833s-6.72093,13.68235-3.77964,20.2943" transform="translate(-264.23896 -191.72405)" fill="#f2f2f2"></path><path id="fe24b413-2f3e-41ab-87c6-b6db4596196d-139" data-name="Path 2961" d="M458.90992,398.36947a15.50508,15.50508,0,0,0,2.42942-15.00753c-2.43349-6.39922-8.74159-10.33464-14.64091-13.80633l-17.455-10.2635,2.6655,9.69832c1.91612,6.97459,3.913,14.11963,8.17055,19.97257s11.3184,10.21134,18.4831,9.19343" transform="translate(-264.23896 -191.72405)" fill="#f2f2f2"></path><path id="a5193a92-e661-4e54-a5ba-e6f2c93163f3-140" data-name="Path 2961" d="M868.81573,700.12072a15.50505,15.50505,0,0,0,2.42943-15.00753c-2.43349-6.39922-8.74159-10.33464-14.64091-13.80633l-17.455-10.2635,2.66551,9.69832c1.91612,6.97459,3.913,14.11963,8.17055,19.97257s11.3184,10.21134,18.4831,9.19343" transform="translate(-264.23896 -191.72405)" fill="#f2f2f2"></path><circle cx="274.93604" cy="116.84683" r="8.65237" fill="#fd6584"></circle><circle cx="44.56681" cy="372.09162" r="8.65237" fill="#fd6584"></circle><circle cx="639.41694" cy="301.79115" r="8.65237" fill="#fd6584"></circle><circle cx="35.91444" cy="154.70093" r="8.65237" fill="#e6e6e6"></circle><circle cx="571.27956" cy="401.29335" r="8.65237" fill="#e6e6e6"></circle><circle cx="588.58429" cy="138.47775" r="8.65237" fill="#e6e6e6"></circle><path d="M473.44627,476.466c-.74792,1.1831-2.5614,1.01117-3.57972.27153-1.41366-1.0268-.956-3.00456.01749-4.17314,3.09392-3.71413,8.21092.20712,8.90113,3.89565A9.27938,9.27938,0,0,1,474.41893,485.7c-3.53,2.09176-8.11518,1.04275-11.15017-1.46083-6.331-5.22252-4.60725-15.679,2.42494-19.4573,4.48787-2.41126,10.16158-1.35295,14.58259.66691,4.97662,2.2737,9.256,5.75872,13.85821,8.66365a77.26931,77.26931,0,0,0,33.376,11.39673c2.07536.21164,2.06059-3.03451,0-3.24464a74.22262,74.22262,0,0,1-19.17778-4.61774,84.28,84.28,0,0,1-17.23256-9.45844c-5.41882-3.7143-11.08-7.32243-17.78609-7.93619a15.42963,15.42963,0,0,0-14.22369,6.18907,15.75693,15.75693,0,0,0-2.36808,13.822,14.59255,14.59255,0,0,0,11.12376,9.57724,11.9295,11.9295,0,0,0,12.57661-5.8106c2.46831-4.2689,2.388-10.00318-1.34011-13.54246a8.60681,8.60681,0,0,0-8.369-2.27617,7.36267,7.36267,0,0,0-4.97852,6.33629c-.35972,5.54119,7.50617,8.31229,10.51282,3.55618,1.119-1.77015-1.68757-3.4-2.80165-1.63763Z" transform="translate(-264.23896 -191.72405)" fill="#3f3d56"></path><path d="M750.9124,476.466c.74791,1.1831,2.5614,1.01117,3.57972.27153,1.41366-1.0268.956-3.00456-.0175-4.17314-3.09392-3.71413-8.21091.20712-8.90113,3.89565A9.27937,9.27937,0,0,0,749.93974,485.7c3.53,2.09176,8.11518,1.04275,11.15017-1.46083,6.331-5.22252,4.60725-15.679-2.42494-19.4573-4.48788-2.41126-10.16159-1.35295-14.58259.66691-4.97663,2.2737-9.256,5.75872-13.85821,8.66365a77.26931,77.26931,0,0,1-33.376,11.39673c-2.07536.21164-2.06059-3.03451,0-3.24464a74.22279,74.22279,0,0,0,19.17779-4.61774,84.28024,84.28024,0,0,0,17.23256-9.45844c5.41882-3.7143,11.08-7.32243,17.78608-7.93619a15.42961,15.42961,0,0,1,14.22369,6.18907,15.75693,15.75693,0,0,1,2.36809,13.822,14.59257,14.59257,0,0,1-11.12376,9.57724,11.92951,11.92951,0,0,1-12.57662-5.8106c-2.46831-4.2689-2.388-10.00318,1.34011-13.54246a8.60682,8.60682,0,0,1,8.369-2.27617,7.36268,7.36268,0,0,1,4.97853,6.33629c.35972,5.54119-7.50618,8.31229-10.51282,3.55618-1.119-1.77015,1.68756-3.4,2.80165-1.63763Z" transform="translate(-264.23896 -191.72405)" fill="#3f3d56"></path><polygon points="96.295 39.328 92.009 44.705 76.852 35.739 81.137 30.362 96.295 39.328" fill="#e4e4e4"></polygon><polygon points="112.11 62.43 115.895 68.079 99.972 75.999 96.187 70.351 112.11 62.43" fill="#e4e4e4"></polygon><polygon points="128.593 37.872 136.157 38.14 135.404 53.967 127.839 53.7 128.593 37.872" fill="#e4e4e4"></polygon><polygon points="631.66 370.281 627.374 375.658 612.217 366.692 616.503 361.315 631.66 370.281" fill="#e4e4e4"></polygon><polygon points="647.475 393.383 651.26 399.032 635.337 406.952 631.552 401.303 647.475 393.383" fill="#e4e4e4"></polygon><polygon points="663.958 368.825 671.522 369.093 670.769 384.92 663.204 384.653 663.958 368.825" fill="#e4e4e4"></polygon></svg>            
            <div class="u-m-8-0">
                <div class="font-16 font-500">Existem benefícios disponíveis para resgate!</div>
            </div>
            <div class="flex-column gap-8">
                <button class="btn-azul verificar-beneficios">Visualizar meus benefícios</button>
                <button class="btn-transparent">Agora não</button>
            </div>
        </div>`

    const verificar = select('.verificar-beneficios', wrapper)
    const naoVerificarBeneficios = select('.btn-transparent', wrapper)

    verificar &&
      verificar.addEventListener('click', () => {
        $('#menu-fidelidade').click()
        wrapper.remove()
      })

    naoVerificarBeneficios &&
      naoVerificarBeneficios.addEventListener('click', () => {
        wrapper.remove()
      })

    document.body.appendChild(wrapper)
  }
}

function mensagemSalvandoPedido(pix) {
  const wrapperMessage = createElement('div', {
    class: 'wrapper-message-pedido-salvo',
  })

  let htmlSteps = ''
  if (pix) {
    htmlSteps = `
         <div class="border-dashed"></div>
            <div class="step pendente" step='2'>
                <div class="loader"> 
                    <div class="showbox">
                        <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                            </svg> 
                        </div>
                    </div>
                </div>
                <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" fill="#D9D9D9"/>
                    <path d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z" fill="#24292E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z" fill="#24292E"/>
                </svg>
                <div>Gerando QR Code</div>
            </div>
                     <div class="border-dashed"></div>
            <div class="step pendente" step='3'>
                <div class="loader"> 
                    <div class="showbox">
                        <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                            </svg> 
                        </div>
                    </div>
                </div>
                <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" fill="#D9D9D9"/>
                    <path d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z" fill="#24292E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z" fill="#24292E"/>
                </svg>
                <div>Enviando pedido</div>
            </div>
        `
  } else {
    htmlSteps = `
                <div class="border-dashed"></div>
            <div class="step pendente" step='2'>
                <div class="loader"> 
                    <div class="showbox">
                        <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                            </svg> 
                        </div>
                    </div>
                </div>
                <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" fill="#D9D9D9"/>
                    <path d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z" fill="#24292E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z" fill="#24292E"/>
                </svg>
                <div>Enviando o pedido</div>
            </div>
            <div class="border-dashed"></div>
            <div class="step pendente" step='3'>
                <div class="loader">
                    <div class="showbox">
                        <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                            </svg> 
                        </div>
                    </div>
                </div>
                <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" fill="#D9D9D9"/>
                    <path d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z" fill="#24292E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z" fill="#24292E"/>
                </svg>
                <div>Pedido recebido</div>
            </div>
        `
  }
  wrapperMessage.innerHTML = `
    <div class="wrapper-message-content ${pix ? 'pagamento-pix' : ''}">
        <div class="font-14 font-500 header-title">Salvando pedido</div>
        <div class="steps">
            <div class="step" step='1'>
                <div class="loader">
                    <div class="showbox">
                        <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                            </svg> 
                        </div>
                    </div>
                </div>
                <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" fill="#D9D9D9"/>
                    <path d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z" fill="#24292E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z" fill="#24292E"/>
                </svg>
                <div>Verificando os dados do pedido</div>
            </div>
            ${htmlSteps}
        </div>
        <div id="texto-entrega"></div>
        <div id="message-content"></div>
        <div class="flex buttons-message" disabled>
            <button id="fechar" class="btn btn-small-primary btn-blue-transparent">Fechar</button>
            <button id="acompanhar" class="btn btn-small-primary btn-green">Acompanhar o pedido</button> 
            </div>
        </div>
        `

  const buttonFechar = select('#fechar', wrapperMessage)
  const buttonAcompanhar = select('#acompanhar', wrapperMessage)

  function callback(callback, id) {
    wrapperMessage.remove()

    // Faz o resset do objeto global do pedido
    storeOrder = {
      Itens: [],
      Sabores: [],
    }
    $('#confirmar-pedido').remove()
    $('#btn-pedido').remove()
  }

  buttonFechar.addEventListener('click', () => {
    if (!select('.tentar-novamente')) {
      callback()
      avaliacao()
    }
  })

  buttonAcompanhar &&
    buttonAcompanhar.addEventListener('click', () => {
      callback()
      paginaPedidos()
      avaliacao()
    })

  const steps = selectAll('.step', wrapperMessage)

  if (!pix) {
    setTimeout(() => {
      steps && steps[0].classList.add('success')
      steps && steps[1].classList.remove('pendente')
    }, 1000)
  }

  document.body.appendChild(wrapperMessage)

  return steps
}

function processaPedidoSalvo(response, metodoSelecionado) {
  usuario.enderecoSelecionado = null

  const statusOrder = JSON.parse(response)
  const step3 = select('[step="3"]')

  if (statusOrder.lValid) {
    /** Faz o parse do retorno**/
    let ret
    try {
      ret = JSON.parse(JSON.parse(response).ret)
    } catch (e) {
      ret = JSON.parse(response)
      ret.Valid = ret.lValid
    }

    if (ret.Valid || ret.lValid) {
      const idPedidoTemporario =
        'pedido-temporario-' + estabelecimento.urlEmpresa + usuario.id
      // Salva no storage para que o pedido seja exibido na tela de pedidos rapidamente
      storage.set(idPedidoTemporario, { ...storeOrder, cartao: null })

      // Se está valido atualiza o passo da mensagem
      // Foi feito um delay por que o processo de salvar era tão rápido que não dava tempo de terminar
      // o setTimeout da etapa anterior e ai a segunda etapa era concluída antes da primeira
      setTimeout(
        () => {
          const stepEnviandoPedido = select('[step="2"]')
          if (stepEnviandoPedido) {
            stepEnviandoPedido.classList.remove('pendente')
            stepEnviandoPedido.classList.add('success')
            step3.classList.remove('pendente')
          }
        },
        storeOrder.pixPago ? 0 : 1500,
      )

      dadosCartao = null

      // Remove o item que está salvo no local storage
      localStorage.removeItem(`pedido-mobile-${estabelecimento.urlEmpresa}`)

      if (storeOrder && storeOrder.CodObsEntrega != '1') {
        const wrapperTempoEntrega = select('#texto-entrega')
        if (calculaTempoEntrega(storeOrder)?.length > 0) {
          wrapperTempoEntrega.innerHTML = `
                    <div class="info-panel info-yellow u-m-16 font-13 font-500 text-center">
                        ${calculaTempoEntrega(storeOrder)}
                    </div>
                    `
        }
      }

      if ((metodoSelecionado.Prefixo === 'PIX' && !storeOrder.pixPago) && storeOrder.pixNaEntrega) {
        const totalPedidoPIX =
          document.getElementById('total-pedido').textContent
        const formaPagPix = estabelecimento.pagamento?.metodos.find(
          (metodo) => metodo.Prefixo === 'PIX',
        )
        let bandeiraPix

        if (formaPagPix && formaPagPix.Bandeiras.length > 0) {
          bandeiraPix = formaPagPix.Bandeiras.find(
            (band) => band.Bandeira?.ChavePIX?.length > 0,
          )
        }

        const wrapper = select('#message-content')
        wrapper.innerHTML = `
          <div class="message-chavepix">
              <div class="text">
                  Valor do pedido: <span style='color: #4962f1;'>${totalPedidoPIX}</span>
              </div>                                                          
          <div class="text">Chave PIX para pagamento:</div>
              <div id="chave">
                  <span id="chavepix">${bandeiraPix?.Bandeira?.ChavePIX || estabelecimento?.chavepix || ''} </span>
                  <div class="copiar">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 24 24" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                  </div>
                  <div class="copiado" style="display: none">
                      <div class="copiar">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                          <div class="txtcopy">Copiado!</div>
                      </div>
                  </div>
          </div>`

        const botaoCopiar = select('.copiar', wrapper)
        botaoCopiar.addEventListener('click', () => {
          const key = select('.message-chavepix #chavepix').textContent.trim()

          navigator.clipboard.writeText(key)

          botaoCopiar.style.display = 'none'

          const copiado = select('.message-chavepix .copiado', wrapper)
          copiado.style.display = 'flex'

          setTimeout(() => {
            copiado.style.display = 'none'
            botaoCopiar.style.display = 'flex'
          }, 2000)
        })
      }

      setTimeout(() => {
        step3.classList.add('success')

        const buttons = select('.buttons-message')
        buttons.removeAttribute('disabled')
      }, 3500)
    } else {
      const step = select('[step="2"]')
      step.innerHTML = `
            <svg viewBox="0 0 24 24" width="16" height="16" stroke="#C73E1D" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
            <span class="text">Erro ao salvar pedido</span>
            `
      const buttons = select('.buttons-message')
      buttons.removeAttribute('disabled')
      const tentarNovamente = createElement(
        'button',
        { class: 'btn btn-primary tentar-novamente' },
        'Tentar novamente',
      )
      buttons.appendChild(tentarNovamente)
      buttons.querySelector('#acompanhar').remove()

      tentarNovamente.addEventListener('click', () => {
        select('.wrapper-message-pedido-salvo').remove()
        select('#salva-pedido').click()
      })
    }
  } else {
    if (statusOrder.cardError) {
      select('.wrapper-message-pedido-salvo').remove()

      showMessage(
        'Erro',
        'Erro ao efetuar pagamento, utilize outro cartão ou tente novamente mais tarde',
        'error',
        'Ok',
        () => {
          const button = select('.message-box button')
          button &&
            $(button).on('click', function () {
              select('.message-box').remove()
            })
        },
      )
    }
  }

  if ('Notification' in window) {
    exibeMensagemNotificacao()
  }
}

function calculaTempoEntrega(storeOrder) {
  let tempoEntrega = ''
  if (
    estabelecimento.agendamento.ativo &&
    storeOrder.DataEntrega &&
    storeOrder.HoraEntrega.slice(0, 5)
  ) {
    tempoEntrega =
      'Agendado para: ' +
      storeOrder.DataEntrega +
      ' às ' +
      storeOrder.HoraEntrega.slice(0, 5)
  } else {
    if (tempoEntrega && !storeOrder.CodObsEntrega) {
      tempoEntrega =
        'Previsão para entrega: ' +
        addMinutes(new Date(), Number(tempoEntrega[0]))
      if (tempoEntrega[1]) {
        tempoEntrega += ' - ' + addMinutes(new Date(), Number(tempoEntrega[1]))
      }
    } else if (
      storeOrder.CodObsEntrega &&
      (estabelecimento.entrega.tempoRetirada || tempoEntrega)
    ) {
      tempoEntrega = 'Previsão para retirada: '

      if (estabelecimento.entrega.tempoRetirada) {
        tempoEntrega += addMinutes(
          new Date(),
          Number(estabelecimento.entrega.tempoRetirada),
        )
      } else if (tempoEntrega) {
        tempoEntrega += addMinutes(new Date(), Number(tempoEntrega[0]))
        if (tempoEntrega[1]) {
          tempoEntrega +=
            ' - ' + addMinutes(new Date(), Number(tempoEntrega[1]))
        }
      }
    }
  }

  return tempoEntrega
}

function calculaTaxaEntrega() {
  return new Promise((resolve) => {
    const configuracoesEntrega = {
      taxaEntrega: 0,
      podeEntregar: true,
    }

    if(estabelecimento.entrega.percentualTaxaEntrega > 0){
      configuracoesEntrega.taxaEntrega = storeOrder.valorTotal * (estabelecimento.entrega.percentualTaxaEntrega / 100)

      beforeResolve()
    }

    const validaPorKM = estabelecimento.tipoEntrega == 'raio' || estabelecimento.tipoEntrega == 'distancia'

    if (estabelecimento.qrCode.ativo || estabelecimento.entrega.somenteEntregaBalcao || storeOrder.CodObsEntrega) {
      configuracoesEntrega.taxaEntrega = 0
      resolve(configuracoesEntrega)
    } else if (!estabelecimento.qrCode.ativo) {
      const endereco =
        usuario.enderecoSelecionado ||
        usuario.enderecoPrincipal ||
        usuario.enderecos[0]

      if (!usuario.enderecoPrincipal) {
        usuario.enderecoPrincipal = endereco
      }

      if (!endereco) {
        configuracoesEntrega.enderecoCadastrado = false
      } else {
        configuracoesEntrega.enderecoCadastrado = true
        configuracoesEntrega.taxaEntrega = endereco.TaxaEntrega
      }

      // Se o tipo de entrega é calculado por km e foi definido um endereço
      if (validaPorKM && endereco) {
        // Instancio o geocoder
        if (!estabelecimento.api.geocoder) {
          criaInstanciaGeocoder().then(() => {
            continua()
          })
        } else {
          continua()
        }

        // Busco as coordenadas do cliente para ver se o estabelecimento não deixou restrito no mapa essa região
        function continua() {
          const enderecoFormatado = formatAddress(endereco)
          buscaCoordenadasCliente(enderecoFormatado)
            .then((coordenadasCliente) => {
              endereco.latitude = coordenadasCliente.latitude
              endereco.longitude = coordenadasCliente.longitude

              if (!endereco.Raio) {
                new Promise((resolveRaio) => {
                  buscaRaioEndereco(endereco, resolveRaio)
                }).then(() => {
                  buscaValorTaxaEntregaPorRaio(endereco).then((response) => {
                    updateConfig(response)
                  })
                })
              } else {
                buscaValorTaxaEntregaPorRaio(endereco).then((response) => {
                  updateConfig(response)
                })
              }
            })
            .catch((response) => {
              if (response.error) {
                Sentry.captureException(error)
                console.error(error)
              }
            })
        }

        function updateConfig(response) {
          configuracoesEntrega.taxaEntrega = response.TaxaEntrega
          configuracoesEntrega.podeEntregar = response.PodeEntregar

          beforeResolve()
        }
      } else {
        beforeResolve()
      }
    }

    function beforeResolve() {
      if (estabelecimento.semTaxaEntrega) {
        configuracoesEntrega.taxaEntrega = 0
      }
      // Se não é cobrado taxa de entrega acima de um determinado valor do pedido
      else if (
        estabelecimento.entregaGratis > 0 &&
        storeOrder.valorTotal > estabelecimento.entregaGratis
      ) {
        configuracoesEntrega.entregaGratuita = true
        configuracoesEntrega.taxaEntrega = 0
      }

      const enderecoAtual =
        usuario.enderecoSelecionado ||
        usuario.enderecoPrincipal ||
        usuario.enderecos[0]
      if (enderecoAtual) {
        enderecoAtual.TaxaEntrega = configuracoesEntrega.taxaEntrega
      }

      resolve(configuracoesEntrega)
    }
  })
}

function atualizaPrecoPizza(idProduto) {
  let sabores = []
  if (storeDadosItemPedido.saboresProd) {
    sabores = storeDadosItemPedido.saboresProd.filter(
      (item) => item.CodProduto == idProduto,
    )
  }

  if (sabores.length > 0) {
    let valorMenor = sabores[0].Preco
    sabores.forEach((sabor) => {
      if (sabor.Preco < valorMenor) {
        valorMenor = sabor.Preco
      }
    })

    const elementoProduto = select(`[idprod="${idProduto}"]`)
    const elementoPreco = select('.produto-info-preco', elementoProduto)
    elementoPreco.innerHTML = 'A partir de ' + format.money(valorMenor)
  }
}

window.buscaEndereco = buscaEndereco

function buscaPedidosLog() {
  if (usuario.logado || estabelecimento.qrCode.ativo) {
    const parametros = {
      pagina: 0,
      idCliente: usuario.id,
      dbName: estabelecimento.urlEmpresa,
    }

    if (estabelecimento.qrCode.ativo) {
      // Criava um id no localstorage para identificar o cliente e listar os pedidos feitos por ele na mesa
      parametros.identificadorQRCode = usuario.identificadorQRCode

      if (estabelecimento.mesa != '') {
        parametros.tipoPedido = 0
        parametros.mesa = estabelecimento.mesa
      }
    }

    if (estabelecimento.comanda.ativo) {
      parametros.tipoPedido = 3
    }

    axios
      .get(getUrlAction('Pedido', 'GetPedidosLog'), {
        params: parametros,
      })
      .then(({ data }) => {
        const pedidos = []

        if (data.pedidos.length > 0) {
          data.pedidos.forEach((pedido) => {
            const dados = JSON.parse(pedido.OrderString)
            const ordem = JSON.parse(dados.Data)
            const novoPedido = {
              ...ordem,
              status: {
                enviado: pedido.Enviado,
                lido: pedido.Lido,
                cancelado: pedido.Cancelado,
                saiuParaEntrega: pedido.SaiuParaEntrega,
                pago: pedido.Pago,
              },
              DataPedido: pedido.Data,
              HoraLido: pedido.HoraTxtLido,
            }

            novoPedido.HoraEntrega = pedido.HoraTxt
            novoPedido.HoraPedido = pedido.HoraTxt
            novoPedido.Id = pedido.Id || random()

            pedidos.push(novoPedido)
          })
        }

        showPedidos(
          pedidos.sort((a, b) => {
            return Number(b.CodTicks) - Number(a.CodTicks)
          }),
        )
      })
      .catch((erro) => {
        console.log(erro)
        Sentry.captureException(erro)
      })
  } else {
    Sentry.captureException('Usuario não está logado')
  }
}

function buscaDadosUsuario() {
  // Busca dados do usuário
  axios
    .get(getUrlAction('Account', 'GetDadosUser'))
    .then(function ({ data }) {
      usuario.id = data.Id
      usuario.nome = data.UserName
      usuario.fotoPerfil = data.ProfilePicture
      usuario.sexo = data.Sexo
      usuario.dataNascimento = convertBRDateToAmerican(
        data.dataNascimento ?? '',
      )
      usuario.telefone = data.TelefoneCelular
      usuario.email = data.Email
      usuario.cpf = data.CNPJ_CPF
      usuario.UtilizaProgramaFidelidade = data.UtilizaProgramaFidelidade
      usuario.cartoes = data.cartoes

      if (data.temSenha) {
        usuario.temSenha = data.temSenha
      }

      try {
        mixpanel.identify(usuario.nome)
        mixpanel.people.set({
          $name: usuario.nome,
          $email: usuario.email,
        })
      } catch (e) {
        Sentry.captureException(e)
      }

      // Nome do usuário
      const profileElement = select('.profile .profile-name')
      if (profileElement) {
        profileElement.textContent = usuario.nome
      }

      // Foto de perfil
      if (usuario.fotoPerfil) {
        usuario.fotoPerfil = usuario.fotoPerfil.replace('http:', 'https:')
        select('.profile .profile-img').setAttribute('src', usuario.fotoPerfil)
      }

      const isLoginGoogle =
        usuario.fotoPerfil && usuario.fotoPerfil?.includes('googleusercontent')
      const programaFidelidadeAtivo =
        estabelecimento && estabelecimento.programaFidelidade?.Ativo
      if (
        isLoginGoogle &&
        programaFidelidadeAtivo &&
        usuario &&
        usuario.UtilizaProgramaFidelidade
      ) {
        if (
          (estabelecimento.programaFidelidade.obrigatorioCPF && !usuario.cpf) ||
          (estabelecimento.programaFidelidade.obrigatorioNascimento &&
            !usuario.dataNascimento) ||
          (estabelecimento.programaFidelidade.obrigatorioSexo &&
            usuario.sexo != 0 &&
            usuario.sexo != 1) ||
          (estabelecimento.programaFidelidade.obrigatorioTelefone &&
            !usuario.telefone) ||
          (estabelecimento.programaFidelidade.obrigatorioEmail &&
            !usuario.email)
        ) {
          mensagemFidelidade()
        }
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function buscaCapa() {
  axios
    .get(getUrlAction('Home', 'GetUrlCapa'), {
      params: {
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then(function ({ data }) {
      if (data.PathBannerS3) {
        const capa = document.createElement('img')

        capa.src = data.PathBannerS3
        capa.alt = 'capa'
        select('.capa').appendChild(capa)

        storeInfoEstab.capa = data.PathBannerS3
      }

      estabelecimento.tituloDestaques = data.TituloDestaques || 'Destaques'

      estabelecimento.mensagem = data.InfoEstab
      if (estabelecimento.mensagem) {
        const mensagem = document.createElement('div')
        mensagem.innerHTML = `
                <div class= "mensagem-estab" > 
                        <div class="mensagem-estab--content">${estabelecimento.mensagem}</div> 
                        <div class="mensagem-estab--close">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.9175 1.34381L1.91748 13.3438" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.91748 1.34381L13.9175 13.3438" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>                   
                    </div>
                    `

        const wrapper = select('.mensagem-estab-wrapper')
        wrapper && wrapper.appendChild(mensagem)
        wrapper
          .querySelector('.mensagem-estab--close')
          .addEventListener('click', () => {
            mensagem.remove()
          })
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function criaTemplateTempoEntrega(horaInclusao) {
  const dataInclusao = new Date()

  const [hora, minutos] = horaInclusao.split(':')
  // Define a hora de inclusão
  dataInclusao.setHours(hora)
  dataInclusao.setMinutes(minutos)

  if (estabelecimento.tempoEntrega) {
    if (estabelecimento.tempoEntrega[1]) {
      return `Previsão para entrega: ${addMinutes(dataInclusao, Number(estabelecimento.tempoEntrega[1]))}`
    } else {
      return `Previsão para entrega: ${addMinutes(dataInclusao, Number(estabelecimento.tempoEntrega[0]))}`
    }
  } else {
    return ''
  }
}

function exibePedidosComanda() {
  axios
    .get(getUrlAction('Pedido', 'GetPedidosComanda'), {
      params: {
        urlEmpresa: estabelecimento.urlEmpresa,
        strComanda: estabelecimento.comanda.numero,
      },
    })
    .then(({ data }) => {
      typeof data === 'string' && (data = JSON.parse(data))

      if (!data.isOffline) {
        storePedidosMesa = data.pedidosD
        showPedidos(storePedidosMesa, null, data.saldoFidelidade)
      } else {
        buscaPedidosLog()
      }
    })
    .catch((error) => {
      console.log(error)
      Sentry.captureException(error)
    })
}

function exibePedidosSenha() {
  let pedidos = localStorage.getItem('pedidos-senha')
  if (pedidos) {
    pedidos = JSON.parse(pedidos)
    showPedidos(pedidos, true)
  } else {
    showPedidos()
  }
}

function exibePedidosMesa() {
  if (estabelecimento.offline) {
    buscaPedidosLog()
  } else {
    axios
      .get(getUrlAction('Pedido', 'GetPedidosMesa'), {
        params: {
          urlEmpresa: estabelecimento.urlEmpresa,
          strMesa: estabelecimento.mesa,
        },
      })
      .then(({ data }) => {
        typeof data === 'string' && (data = JSON.parse(data))
        if (!data.isOffline) {
          track('Pedidos exibidos', {
            Estabelecimento: estabelecimento.fantasia,
            Offline: false,
          })
          storePedidosMesa = data.pedidosD
          showPedidos(storePedidosMesa)
        }
      })
      .catch((error) => {
        console.log(error)
        Sentry.captureException(error)
        reject(error)
      })
  }
}

function removeProdutoTaxaEntrega(pedido) {
  pedido.Itens.forEach((prod, index) => {
    const produtoDesc = prod.Descricao || prod.Produto_Produto
    if (produtoDesc) {
      if (produtoDesc && produtoDesc.toLowerCase() == 'taxa de entrega') {
        pedido.Itens.splice(index, 1)
      }
    }
  })
}

function converteValoresPedidoParaDecimal(listaPedidos) {
  listaPedidos.forEach((pedido) => {
    parse(
      [
        'ValorTotalPedido',
        'ValorDesconto',
        'TrocoDelivery',
        'TaxaEntrega',
        'ReaisDesconto',
        'PercentualDesconto',
      ],
      pedido,
    )

    pedido.Itens.forEach((item) => {
      parse(
        [
          'PrecoDelivery',
          'Quantidade',
          'QuantidadeAPagar',
          'ValorApagar',
          'ValorComAdicionais',
          'ValorTotal',
          'ValorUnitario',
        ],
        item,
      )

      item.Adicionais.forEach((adicional) => {
        parse(['Quantidade', 'ValorTotal', 'ValorUnitario'], adicional)
      })
    })
  })

  function parse(keys, object) {
    keys.forEach((key) => {
      object[key] = toFloat(object[key])
    })
  }
  function toFloat(value) {
    if (typeof value === 'string') {
      return parseFloat(value.replace(',', '.'))
    } else {
      return value
    }
  }
}

function progressoPedido(pedidoData) {
  let etapaAtual = 0
  pedidoData.status.lido && (etapaAtual = 1)
  pedidoData.status.saiuParaEntrega && (etapaAtual = 2)
  pedidoData.status.pago && (etapaAtual = 3)

  const wrapper = createElement('div', { class: 'flex gap-8 flex-center' })

  const stepsIcons = [
    {
      svg: `
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.882469 1.14306C1.12325 0.930952 1.46733 0.882913 1.757 1.02097L13.0358 6.39654C13.2685 6.50745 13.4167 6.74227 13.4167 7.00005C13.4167 7.25784 13.2685 7.49266 13.0358 7.60357L1.757 12.9791C1.46734 13.1172 1.12325 13.0692 0.882469 12.857C0.675742 12.6749 0.577056 12.3994 0.621157 12.1274L1.45262 7.00005L0.621157 1.87267C0.577056 1.60072 0.675742 1.32518 0.882469 1.14306ZM2.26811 7.43755L1.50736 12.1288L12.2683 7.00005L1.50736 1.87129L2.26811 6.56255H6.56251C6.80413 6.56255 7.00001 6.75843 7.00001 7.00005C7.00001 7.24168 6.80413 7.43755 6.56251 7.43755H2.26811Z" fill="#5B5B5B"/>
                </svg>`,
      text: 'Enviado',
      hora: (pedidoData.HoraPedido || '--:--').slice(0, 5),
    },
    {
      svg: `
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.18752 1.33337C1.62373 1.33337 1.16669 1.85571 1.16669 2.50004V13.5C1.16669 14.1444 1.62373 14.6667 2.18752 14.6667H11.8125C12.3763 14.6667 12.8334 14.1444 12.8334 13.5V2.50004C12.8334 1.85571 12.3763 1.33337 11.8125 1.33337H2.18752ZM2.04169 2.50004C2.04169 2.40799 2.10698 2.33337 2.18752 2.33337H11.8125C11.8931 2.33337 11.9584 2.40799 11.9584 2.50004V13.5C11.9584 13.5921 11.8931 13.6667 11.8125 13.6667H2.18752C2.10698 13.6667 2.04169 13.5921 2.04169 13.5V2.50004Z" fill="#5B5B5B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 4.5C3.5 4.22386 3.69588 4 3.9375 4H10.6458C10.8875 4 11.0833 4.22386 11.0833 4.5C11.0833 4.77614 10.8875 5 10.6458 5H3.9375C3.69588 5 3.5 4.77614 3.5 4.5Z" fill="#5B5B5B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 7C3.5 6.72386 3.69588 6.5 3.9375 6.5H7.14583C7.38746 6.5 7.58333 6.72386 7.58333 7C7.58333 7.27614 7.38746 7.5 7.14583 7.5H3.9375C3.69588 7.5 3.5 7.27614 3.5 7Z" fill="#5B5B5B"/>
                </svg>
                `,
      text: 'Lido',
      hora: (pedidoData.HoraLido || '--:--').slice(0, 5),
    },
    {
      svg: `
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.485338 7.03604C2.0835 12.0866 12.2667 13.4301 12.9467 9.75963L13.125 7.97609L13.1228 7.99789L12.7327 11.9004L12.7227 12H12.6267H5.7451C4.24412 12 2.83243 11.3898 1.7711 10.282C0.709742 9.17428 0.125 7.70091 0.125 6.1343V5.86575C0.125 4.29917 0.709742 2.82578 1.77108 1.71805L0.485338 7.03604ZM0.485338 7.03604C2.0835 12.0866 12.2667 13.4301 12.9467 9.75963L13.1188 7.95388L13.118 7.95104L13.1147 7.93982C13.1137 7.93616 13.1124 7.93185 13.1109 7.92686C13.1085 7.91872 13.1056 7.90884 13.1021 7.89733C13.091 7.86024 13.0744 7.8063 13.0523 7.73794C13.008 7.60128 12.9417 7.40702 12.8533 7.17555C12.6932 6.75686 12.4598 6.21499 12.1523 5.67225H12.3339H12.4586L12.4391 5.54367L12.3702 5.08982C12.3593 5.01746 12.1281 3.59097 10.8133 2.13045C9.593 0.775079 7.81707 0 5.942 0H5.74505C4.2441 0 2.83241 0.610303 1.77108 1.71805L0.485338 7.03604ZM8.92891 8.52534H12.0996L11.853 10.9926H5.7451C3.17849 10.9926 1.09025 8.81308 1.09025 6.13425V5.86575C1.09025 3.18697 3.17849 1.00742 5.7451 1.00742H5.942C7.55545 1.00742 9.07403 1.66982 10.1098 2.82029C10.7355 3.51523 11.0715 4.20008 11.2455 4.6648H5.17776H4.9731L5.09044 4.83978L6.77858 7.35679C7.26933 8.08851 8.07315 8.52534 8.92891 8.52534ZM11.0046 5.67225C11.4507 6.33723 11.7614 7.03116 11.9497 7.51793H9.90252L8.84165 5.67225H11.0046ZM6.82695 5.67225H7.71601L8.77245 7.51019C8.29109 7.46253 7.84951 7.19683 7.5693 6.77918L6.82695 5.67225Z" fill="#5B5B5B"/>
                </svg>`,
      text: pedidoData.HoraAcerto ? 'Entregue' : 'Na entrega',
      hora: (pedidoData.HoraAcerto || pedidoData.HoraEntrega || '--:--').slice(
        0,
        5,
      ),
    },
  ]

  let timer = 500
  stepsIcons.forEach((step, index) => {
    let divider = ''

    if (index != stepsIcons.length - 1) {
      divider = `<div class="divider-gray"></div>`
    }

    const stepClass = 'step-' + index
    // Se o pedido foi entregue ou está na entrega
    const classeEntrega = pedidoData.HoraEntrega
      ? pedidoData.HoraAcerto
        ? 'entregue'
        : 'na-entrega'
      : ''

    wrapper.innerHTML += `
            <div class="flex-column flex-center gap-4 opacity-show ${stepClass} ${classeEntrega}">
                <div class="u-relative">
                    <div class="svg-step">${step.svg}</div>        
                    <svg class="svg-check svg-icon-status" width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.00001 0.449951C1.45365 0.449951 0.200012 1.70359 0.200012 3.24995C0.200012 4.79631 1.45365 6.04995 3.00001 6.04995C4.54637 6.04995 5.80001 4.79631 5.80001 3.24995C5.80001 1.70359 4.54637 0.449951 3.00001 0.449951Z" fill="#1EBF7C" stroke="white" stroke-width="0.1"/>
                        <path d="M4.32001 2.57001L4.46152 2.71152L4.46633 2.70636L4.32001 2.57001ZM1.68001 3.44501L1.5336 3.58144L1.53859 3.58643L1.68001 3.44501ZM1.94501 3.18001L2.08652 3.0385L2.08136 3.03369L1.94501 3.18001ZM2.56251 3.79751L2.42109 3.93893L2.56251 4.08035L2.70393 3.93893L2.56251 3.79751ZM4.05501 2.30501L3.91858 2.1586L3.91359 2.16359L4.05501 2.30501ZM4.46633 2.70636C4.53478 2.6329 4.57205 2.53574 4.57028 2.43535L4.17034 2.44241C4.17028 2.43917 4.17148 2.43604 4.17369 2.43367L4.46633 2.70636ZM2.83635 4.33652L4.46152 2.71152L4.17859 2.42859L2.55359 4.05359L2.83635 4.33652ZM2.56251 4.44985C2.6652 4.44985 2.76369 4.40909 2.83635 4.33652L2.55359 4.05359C2.55593 4.05125 2.5592 4.04985 2.56251 4.04985V4.44985ZM2.28859 4.33643C2.36124 4.409 2.45982 4.44985 2.56251 4.44985V4.04985C2.56583 4.04985 2.569 4.05116 2.57135 4.0535L2.28859 4.33643ZM1.53859 3.58643L2.28859 4.33643L2.57135 4.0535L1.82143 3.30359L1.53859 3.58643ZM1.42975 3.31035C1.42798 3.41074 1.46515 3.50798 1.5336 3.58144L1.82633 3.30867C1.82854 3.31104 1.82974 3.31417 1.82969 3.31741L1.42975 3.31035ZM1.54319 3.04318C1.47219 3.11418 1.43152 3.20996 1.42975 3.31035L1.82969 3.31741C1.82963 3.32065 1.82832 3.32374 1.82603 3.32603L1.54319 3.04318ZM1.81035 2.92975C1.70996 2.93152 1.61418 2.97218 1.54319 3.04318L1.82603 3.32603C1.82374 3.32832 1.82065 3.32963 1.81741 3.32969L1.81035 2.92975ZM2.08136 3.03369C2.0079 2.96524 1.91074 2.92798 1.81035 2.92975L1.81741 3.32969C1.81417 3.32974 1.81104 3.32854 1.80867 3.32633L2.08136 3.03369ZM2.70393 3.65609L2.08652 3.0385L1.80359 3.32143L2.42109 3.93893L2.70393 3.65609ZM3.91359 2.16359L2.42109 3.65609L2.70393 3.93893L4.19643 2.44643L3.91359 2.16359ZM4.18967 2.05475C4.08928 2.05298 3.99203 2.09015 3.91858 2.1586L4.19136 2.45133C4.18899 2.45354 4.18585 2.45474 4.18261 2.45469L4.18967 2.05475ZM4.45684 2.16819C4.38584 2.09719 4.29006 2.05652 4.18967 2.05475L4.18261 2.45469C4.17937 2.45463 4.17629 2.45332 4.174 2.45103L4.45684 2.16819ZM4.57028 2.43535C4.5685 2.33496 4.52784 2.23918 4.45684 2.16819L4.174 2.45103C4.17171 2.44874 4.17039 2.44565 4.17034 2.44241L4.57028 2.43535Z" fill="#F5ECEC"/>
                    </svg> 
                    <svg class="svg-loader svg-icon-status" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.74975 1.09775C8.57866 0.967417 9.42284 0.967417 10.2517 1.09775C10.3491 1.11305 10.4424 1.14736 10.5264 1.19874C10.6105 1.25011 10.6836 1.31754 10.7416 1.39716C10.7996 1.47679 10.8413 1.56706 10.8644 1.66281C10.8875 1.75857 10.8915 1.85794 10.8762 1.95525C10.8609 2.05256 10.8266 2.1459 10.7753 2.22995C10.7239 2.314 10.6565 2.3871 10.5768 2.44509C10.4972 2.50308 10.4069 2.54482 10.3112 2.56792C10.2154 2.59103 10.1161 2.59505 10.0187 2.57975C9.34423 2.47369 8.65728 2.47369 7.98275 2.57975C7.78623 2.61065 7.58548 2.56221 7.42466 2.44509C7.26385 2.32798 7.15615 2.15177 7.12525 1.95525C7.09435 1.75872 7.14279 1.55797 7.25991 1.39716C7.37702 1.23635 7.55323 1.12865 7.74975 1.09775ZM5.34575 2.69375C5.46258 2.85452 5.51082 3.05508 5.47988 3.25139C5.44894 3.44769 5.34136 3.6237 5.18075 3.74075C4.62853 4.14264 4.14264 4.62852 3.74075 5.18075C3.62164 5.33604 3.44655 5.43863 3.25285 5.4666C3.05915 5.49458 2.86219 5.44573 2.704 5.33049C2.54582 5.21525 2.43895 5.04274 2.40621 4.84978C2.37347 4.65683 2.41744 4.45872 2.52875 4.29775C3.02245 3.61906 3.61934 3.02183 4.29775 2.52775C4.37745 2.4698 4.46779 2.42812 4.5636 2.4051C4.65941 2.38208 4.75882 2.37817 4.85615 2.39358C4.95348 2.409 5.04681 2.44344 5.13082 2.49495C5.21483 2.54645 5.28786 2.614 5.34575 2.69375ZM12.6557 2.69375C12.7137 2.61408 12.7868 2.54662 12.8708 2.49521C12.9548 2.4438 13.0482 2.40945 13.1455 2.39413C13.2428 2.3788 13.3422 2.38281 13.438 2.40591C13.5338 2.429 13.6241 2.47075 13.7037 2.52875C14.3824 3.02242 14.9796 3.61931 15.4737 4.29775C15.5908 4.45873 15.6391 4.65964 15.6081 4.85627C15.5771 5.05291 15.4692 5.22915 15.3082 5.34625C15.1472 5.46334 14.9463 5.51169 14.7497 5.48065C14.553 5.44961 14.3768 5.34173 14.2597 5.18075C13.8581 4.6286 13.3726 4.14272 12.8207 3.74075C12.6601 3.6237 12.5525 3.44769 12.5216 3.25139C12.4906 3.05508 12.5389 2.85452 12.6557 2.69375ZM1.95575 7.12575C2.1521 7.15674 2.32811 7.26442 2.44511 7.42511C2.56212 7.5858 2.61054 7.78637 2.57975 7.98275C2.47369 8.65727 2.47369 9.34422 2.57975 10.0188C2.61065 10.2153 2.56221 10.416 2.4451 10.5768C2.32798 10.7377 2.15178 10.8454 1.95525 10.8763C1.75872 10.9071 1.55797 10.8587 1.39716 10.7416C1.23635 10.6245 1.12865 10.4483 1.09775 10.2518C0.967417 9.42284 0.967417 8.57866 1.09775 7.74975C1.11309 7.65243 1.14746 7.55908 1.19889 7.47505C1.25031 7.39102 1.31779 7.31794 1.39747 7.25999C1.47715 7.20204 1.56746 7.16036 1.66326 7.13733C1.75905 7.11429 1.85844 7.11036 1.95575 7.12575ZM16.0457 7.12575C16.143 7.11036 16.2424 7.11429 16.3382 7.13733C16.434 7.16036 16.5243 7.20204 16.604 7.25999C16.6837 7.31794 16.7511 7.39102 16.8026 7.47505C16.854 7.55908 16.8884 7.65243 16.9037 7.74975C17.034 8.57866 17.034 9.42284 16.9037 10.2518C16.8728 10.4483 16.7651 10.6245 16.6043 10.7416C16.4435 10.8587 16.2427 10.9071 16.0462 10.8763C15.8497 10.8454 15.6735 10.7377 15.5564 10.5768C15.4392 10.416 15.3908 10.2153 15.4217 10.0188C15.5278 9.34423 15.5278 8.65727 15.4217 7.98275C15.3909 7.78637 15.4393 7.5858 15.5563 7.42511C15.6733 7.26442 15.8494 7.15674 16.0457 7.12575ZM2.69375 12.6557C2.77339 12.5977 2.86368 12.556 2.95945 12.5329C3.05523 12.5098 3.15461 12.5058 3.25194 12.5211C3.34926 12.5364 3.44261 12.5708 3.52665 12.6222C3.6107 12.6736 3.68379 12.7411 3.74175 12.8207C4.14334 13.3729 4.62888 13.8587 5.18075 14.2607C5.33605 14.3798 5.43863 14.5549 5.46661 14.7486C5.49458 14.9423 5.44574 15.1393 5.33049 15.2975C5.21525 15.4556 5.04274 15.5625 4.84979 15.5953C4.65684 15.628 4.45873 15.584 4.29775 15.4727C3.61904 14.979 3.02181 14.3822 2.52775 13.7037C2.4698 13.624 2.42813 13.5337 2.40511 13.4379C2.38209 13.3421 2.37817 13.2426 2.39359 13.1453C2.409 13.048 2.44345 12.9547 2.49495 12.8706C2.54646 12.7866 2.61401 12.7136 2.69375 12.6557ZM15.3077 12.6557C15.3874 12.7137 15.4548 12.7868 15.5062 12.8708C15.5577 12.9549 15.592 13.0482 15.6073 13.1455C15.6226 13.2429 15.6186 13.3422 15.5955 13.438C15.5724 13.5338 15.5307 13.6241 15.4727 13.7037C14.9791 14.3825 14.3822 14.9797 13.7037 15.4737C13.624 15.5317 13.5336 15.5734 13.4378 15.5965C13.342 15.6195 13.2425 15.6235 13.1452 15.6081C13.0478 15.5928 12.9544 15.5584 12.8704 15.5069C12.7863 15.4554 12.7132 15.3879 12.6552 15.3082C12.5972 15.2285 12.5555 15.1382 12.5325 15.0423C12.5094 14.9465 12.5054 14.8471 12.5208 14.7497C12.5362 14.6523 12.5706 14.5589 12.622 14.4749C12.6735 14.3908 12.741 14.3177 12.8207 14.2597C13.3728 13.8581 13.8587 13.3726 14.2607 12.8207C14.3777 12.6601 14.5538 12.5525 14.7501 12.5216C14.9464 12.4907 15.1469 12.5389 15.3077 12.6557ZM7.12575 16.0457C7.15675 15.8494 7.26442 15.6734 7.42511 15.5564C7.58581 15.4394 7.78637 15.3909 7.98275 15.4217C8.65727 15.5278 9.34423 15.5278 10.0187 15.4217C10.1161 15.4064 10.2154 15.4104 10.3112 15.4335C10.4069 15.4566 10.4972 15.4984 10.5768 15.5564C10.6565 15.6144 10.7239 15.6875 10.7753 15.7715C10.8266 15.8556 10.8609 15.9489 10.8762 16.0462C10.8915 16.1435 10.8875 16.2429 10.8644 16.3387C10.8413 16.4344 10.7996 16.5247 10.7416 16.6043C10.6836 16.6839 10.6105 16.7514 10.5264 16.8027C10.4424 16.8541 10.3491 16.8884 10.2517 16.9037C9.42284 17.034 8.57866 17.034 7.74975 16.9037C7.65243 16.8884 7.55909 16.854 7.47505 16.8026C7.39102 16.7512 7.31794 16.6837 7.25999 16.604C7.20205 16.5243 7.16037 16.434 7.13733 16.3382C7.1143 16.2424 7.11036 16.143 7.12575 16.0457Z" fill="#4f44e0"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.74975 1.09775C8.57866 0.967417 9.42284 0.967417 10.2517 1.09775C10.3491 1.11305 10.4424 1.14736 10.5264 1.19874C10.6105 1.25011 10.6836 1.31754 10.7416 1.39716C10.7996 1.47679 10.8413 1.56706 10.8644 1.66281C10.8875 1.75857 10.8915 1.85794 10.8762 1.95525C10.8609 2.05256 10.8266 2.1459 10.7753 2.22995C10.7239 2.314 10.6565 2.3871 10.5768 2.44509C10.4972 2.50308 10.4069 2.54482 10.3112 2.56792C10.2154 2.59103 10.1161 2.59505 10.0187 2.57975C9.34423 2.47369 8.65728 2.47369 7.98275 2.57975C7.78623 2.61065 7.58548 2.56221 7.42466 2.44509C7.26385 2.32798 7.15615 2.15177 7.12525 1.95525C7.09435 1.75872 7.14279 1.55797 7.25991 1.39716C7.37702 1.23635 7.55323 1.12865 7.74975 1.09775ZM5.34575 2.69375C5.46258 2.85452 5.51082 3.05508 5.47988 3.25139C5.44894 3.44769 5.34136 3.6237 5.18075 3.74075C4.62853 4.14264 4.14264 4.62852 3.74075 5.18075C3.62164 5.33604 3.44655 5.43863 3.25285 5.4666C3.05915 5.49458 2.86219 5.44573 2.704 5.33049C2.54582 5.21525 2.43895 5.04274 2.40621 4.84978C2.37347 4.65683 2.41744 4.45872 2.52875 4.29775C3.02245 3.61906 3.61934 3.02183 4.29775 2.52775C4.37745 2.4698 4.46779 2.42812 4.5636 2.4051C4.65941 2.38208 4.75882 2.37817 4.85615 2.39358C4.95348 2.409 5.04681 2.44344 5.13082 2.49495C5.21483 2.54645 5.28786 2.614 5.34575 2.69375ZM12.6557 2.69375C12.7137 2.61408 12.7868 2.54662 12.8708 2.49521C12.9548 2.4438 13.0482 2.40945 13.1455 2.39413C13.2428 2.3788 13.3422 2.38281 13.438 2.40591C13.5338 2.429 13.6241 2.47075 13.7037 2.52875C14.3824 3.02242 14.9796 3.61931 15.4737 4.29775C15.5908 4.45873 15.6391 4.65964 15.6081 4.85627C15.5771 5.05291 15.4692 5.22915 15.3082 5.34625C15.1472 5.46334 14.9463 5.51169 14.7497 5.48065C14.553 5.44961 14.3768 5.34173 14.2597 5.18075C13.8581 4.6286 13.3726 4.14272 12.8207 3.74075C12.6601 3.6237 12.5525 3.44769 12.5216 3.25139C12.4906 3.05508 12.5389 2.85452 12.6557 2.69375ZM1.95575 7.12575C2.1521 7.15674 2.32811 7.26442 2.44511 7.42511C2.56212 7.5858 2.61054 7.78637 2.57975 7.98275C2.47369 8.65727 2.47369 9.34422 2.57975 10.0188C2.61065 10.2153 2.56221 10.416 2.4451 10.5768C2.32798 10.7377 2.15178 10.8454 1.95525 10.8763C1.75872 10.9071 1.55797 10.8587 1.39716 10.7416C1.23635 10.6245 1.12865 10.4483 1.09775 10.2518C0.967417 9.42284 0.967417 8.57866 1.09775 7.74975C1.11309 7.65243 1.14746 7.55908 1.19889 7.47505C1.25031 7.39102 1.31779 7.31794 1.39747 7.25999C1.47715 7.20204 1.56746 7.16036 1.66326 7.13733C1.75905 7.11429 1.85844 7.11036 1.95575 7.12575ZM16.0457 7.12575C16.143 7.11036 16.2424 7.11429 16.3382 7.13733C16.434 7.16036 16.5243 7.20204 16.604 7.25999C16.6837 7.31794 16.7511 7.39102 16.8026 7.47505C16.854 7.55908 16.8884 7.65243 16.9037 7.74975C17.034 8.57866 17.034 9.42284 16.9037 10.2518C16.8728 10.4483 16.7651 10.6245 16.6043 10.7416C16.4435 10.8587 16.2427 10.9071 16.0462 10.8763C15.8497 10.8454 15.6735 10.7377 15.5564 10.5768C15.4392 10.416 15.3908 10.2153 15.4217 10.0188C15.5278 9.34423 15.5278 8.65727 15.4217 7.98275C15.3909 7.78637 15.4393 7.5858 15.5563 7.42511C15.6733 7.26442 15.8494 7.15674 16.0457 7.12575ZM2.69375 12.6557C2.77339 12.5977 2.86368 12.556 2.95945 12.5329C3.05523 12.5098 3.15461 12.5058 3.25194 12.5211C3.34926 12.5364 3.44261 12.5708 3.52665 12.6222C3.6107 12.6736 3.68379 12.7411 3.74175 12.8207C4.14334 13.3729 4.62888 13.8587 5.18075 14.2607C5.33605 14.3798 5.43863 14.5549 5.46661 14.7486C5.49458 14.9423 5.44574 15.1393 5.33049 15.2975C5.21525 15.4556 5.04274 15.5625 4.84979 15.5953C4.65684 15.628 4.45873 15.584 4.29775 15.4727C3.61904 14.979 3.02181 14.3822 2.52775 13.7037C2.4698 13.624 2.42813 13.5337 2.40511 13.4379C2.38209 13.3421 2.37817 13.2426 2.39359 13.1453C2.409 13.048 2.44345 12.9547 2.49495 12.8706C2.54646 12.7866 2.61401 12.7136 2.69375 12.6557ZM15.3077 12.6557C15.3874 12.7137 15.4548 12.7868 15.5062 12.8708C15.5577 12.9549 15.592 13.0482 15.6073 13.1455C15.6226 13.2429 15.6186 13.3422 15.5955 13.438C15.5724 13.5338 15.5307 13.6241 15.4727 13.7037C14.9791 14.3825 14.3822 14.9797 13.7037 15.4737C13.624 15.5317 13.5336 15.5734 13.4378 15.5965C13.342 15.6195 13.2425 15.6235 13.1452 15.6081C13.0478 15.5928 12.9544 15.5584 12.8704 15.5069C12.7863 15.4554 12.7132 15.3879 12.6552 15.3082C12.5972 15.2285 12.5555 15.1382 12.5325 15.0423C12.5094 14.9465 12.5054 14.8471 12.5208 14.7497C12.5362 14.6523 12.5706 14.5589 12.622 14.4749C12.6735 14.3908 12.741 14.3177 12.8207 14.2597C13.3728 13.8581 13.8587 13.3726 14.2607 12.8207C14.3777 12.6601 14.5538 12.5525 14.7501 12.5216C14.9464 12.4907 15.1469 12.5389 15.3077 12.6557ZM7.12575 16.0457C7.15675 15.8494 7.26442 15.6734 7.42511 15.5564C7.58581 15.4394 7.78637 15.3909 7.98275 15.4217C8.65727 15.5278 9.34423 15.5278 10.0187 15.4217C10.1161 15.4064 10.2154 15.4104 10.3112 15.4335C10.4069 15.4566 10.4972 15.4984 10.5768 15.5564C10.6565 15.6144 10.7239 15.6875 10.7753 15.7715C10.8266 15.8556 10.8609 15.9489 10.8762 16.0462C10.8915 16.1435 10.8875 16.2429 10.8644 16.3387C10.8413 16.4344 10.7996 16.5247 10.7416 16.6043C10.6836 16.6839 10.6105 16.7514 10.5264 16.8027C10.4424 16.8541 10.3491 16.8884 10.2517 16.9037C9.42284 17.034 8.57866 17.034 7.74975 16.9037C7.65243 16.8884 7.55909 16.854 7.47505 16.8026C7.39102 16.7512 7.31794 16.6837 7.25999 16.604C7.20205 16.5243 7.16037 16.434 7.13733 16.3382C7.1143 16.2424 7.11036 16.143 7.12575 16.0457Z" stroke="#4f44e0" />
                    </svg>
                </div>
                <div class="font-12 font-500 no-wrap">${step.text}</div>
                <div class="font-12 font-seccondary  font-500">${step.hora}</div>
            </div>
            ${divider}
            `

    if (index <= etapaAtual) {
      setTimeout(() => {
        select('.' + stepClass).classList.add('concluido')
      }, timer)
      timer += 250
    } else {
      select('.' + stepClass, wrapper).classList.add('pendente')
    }
  })

  return wrapper
}

export function saveError(error, captureContext) {
  Sentry.captureException(error, captureContext)
}

function criaTemplatePaginaProduto(params) {
  let htmlSabores = ''
  if (params.sabores) {
    htmlSabores = `
        <div class="u-p-12-0">
            <div class="font-title-dark">Sabores</div>
            <div class="font-gray font-12">Clique em um grupo para visualizar os sabores.</div>
        </div>
        <div class="divider"></div>
        ${params.sabores}
        `
  }

  const htmlAdicionais = `${params.HTMLAdicionais && params.saboresPizzaHTML ? `<h3>Adicionais</h3>` + params.HTMLAdicionais : params.HTMLAdicionais}`
  let htmlOberservacao = ''
  if (params.foraDeHorario) {
    htmlOberservacao = `<div class="produto-indisponivel">Este produto está indisponível no momento</div>`
  } else if (
    (estabelecimento.qrCode.ativo &&
      !estabelecimento.naoExibeCampoObsProdutoQRCode) ||
    (!estabelecimento.qrCode.ativo &&
      !estabelecimento.naoExibeCampoObsProdutoDelivery)
  ) {
    htmlOberservacao = `
        <div class="item-observacao">
            <span>Alguma observação?</span>
            <input id="pedido-obs" placeholder="Ex: mal passado, retirar cebola." value="${params.produtoASerEditado?.Observacao ?? ''}">
        </div>`
  }

  let htmlContent = ''
  if (params.pizza) {
    htmlContent = `
        <div class="adicional-img-container">
            ${params.capa}
                <header class="header-product">
                    <div class="title-product">${params.descricaoItem}</div>
                    <div class="font-subtitle font-white">${params.descricao}</div>
                    ${params.ingredientes}
                </header>    
        </div>
        <div class="container"> 
            <div id="conteudo-produto">
              ${params.HTMLAgrupamento}
              <div class="adicionais-itens">
                  ${htmlSabores}
                  ${htmlAdicionais}
             </div>
            </div>
           ${htmlOberservacao}
        </div>
        `
  } else {
    htmlContent = `
        <div class="adicional-img-container">${params.capa}</div>
        <div class="container">
            <header class="adicional-title">
                <div class="span-container">
                    <span>${params.descricaoItem}</span>
                </div>
                <span>${params.descricao}</span>
                ${params.ingredientes}
            </header>    
            <div id="conteudo-produto">
              ${params.HTMLAgrupamento}
                <div class="adicionais-itens">
                    ${htmlSabores}
                    ${htmlAdicionais}
              </div>
            </div>
           ${htmlOberservacao}
        </div>
        `
  }
  return `   
    <div class="u-relative">
        <div class="nav-bar">
            <img id="back-produto" src="${location.origin}/images/global/arrow-left.svg">          
        </div>
    </div>
    <div class="pagina animate__animated animate__slideInRight u-viewport ${params.pizza ? 'wrapper-pizza' : ''}" id-produto="${params.id}" style="height:${window.innerHeight}px">
        <div id="adicional-container"> 
            <div class="flex-column overflow-auto h-100">    
                ${htmlContent}
            </div>
        </div>
 
        <div id="btn-adicionar-produto" class="fixed-bottom-button">
            <div class="wrapper-btn-fixed w-100">
                <div class="flex-center gap-8">
                    <div id="adc-unidade" class="u-flex-center">
                        <div class="quantidade-itens">
                            <div id="remover-produto" class="btn-subtracao u-flex-center">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H18.75C19.1642 12 19.5 12.3358 19.5 12.75C19.5 13.1642 19.1642 13.5 18.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z" fill="#353535"/>
                                </svg>          
                            </div>
                            <input id="qtd-produto" type="number" class="qtd-value" min="1" value=${params.produtoASerEditado ? params.produtoASerEditado.Quantidade : '1'} readonly></span>
                            <div id="adicionar-produto" class="btn-adicao u-flex-center">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7499 4.5C12.1641 4.5 12.4999 4.83579 12.4999 5.25V11H18.25C18.6642 11 19 11.3358 19 11.75C19 12.1642 18.6642 12.5 18.25 12.5H12.4999V18.25C12.4999 18.6642 12.1641 19 11.7499 19C11.3357 19 10.9999 18.6642 10.9999 18.25V12.5H5.25C4.83579 12.5 4.5 12.1642 4.5 11.75C4.5 11.3358 4.83579 11 5.25 11H10.9999V5.25C10.9999 4.83579 11.3357 4.5 11.7499 4.5Z" fill="#353535"/>
                                </svg>             
                            </div>
                        </div>      
                    </div>
                    <button id="add-pedido" class="btn btn-primary">
                        ${params.produtoASerEditado ? 'Salvar' : 'Adicionar'} (<span id="total-button">${format.money(params.preco)}</span >)
                    </button>
                </div>
            </div>
        </div>
    </div>
        `
}

function getProdutoAgrupamento() {
  let idProduto = select('.pagina').getAttribute('id-produto')

  let produto
  if (idProduto == 'agrupamento') {
    const elemento = select('[name="produto-agrupamento"]:checked')
    if (elemento) {
      idProduto = elemento.getAttribute('data-id-produto')
    }

    store.agrupamentos.forEach((agrupamento) => {
      agrupamento.infoProd.forEach((produtoArr) => {
        if (produtoArr.IdProd == idProduto) {
          produto = produtoArr
        }
      })
    })
  }

  produto.isAgrupamento = true

  return produto
}

function getKeyOrders() {
  let storageKey = 'lista-pedidos-'
  if (estabelecimento.comanda.ativo) {
    storageKey += 'comanda-' + estabelecimento.comanda.numero
  } else if (estabelecimento.mesa) {
    storageKey += 'mesa-' + estabelecimento.mesa
  }

  return storageKey
}

function verificaStatusComanda() {
  return new Promise((resolve, reject) => {
    axios
      .get(getUrlAction('home', 'verificaHashComanda'), {
        params: {
          comanda: estabelecimento.comanda.numero,
          hash: estabelecimento.comanda.hashLocal,
          urlEmpresa: estabelecimento.urlEmpresa,
        },
      })
      .then(({ data }) => {
        if (estabelecimento.comanda.hash) {
          if (data.liberada && !data.hash) {
            createMessageBox({
              content: `
                    <div class="flex-column gap-8 text-center">
                        <img class="m-a" src="./images/qrcode.png" alt="imagem de um QRCode">                                
                        <div>
                            <div id="texto-principal" class="font-16">Comanda ${estabelecimento.comanda.numero} indisponível</div>
                            <div id="texto-subtitulo" class="font-12 font-seccondary u-m-t-4">Faça a leitura do QRCode localizado na sua comanda para fazer pedido</div>
                        </div>
                    </div>
                    <div class="flex gap-12 w-100 u-m-t-16">
                        <button class="btn-transparent w-100" id="btn-cancelar">Cancelar</button>    
                        <button class="btn-azul w-100" id="btn-solicitar-permissao">Abrir câmera</button>                                                    
                    </div>`,
              beforeAppend: (wrapper) => {
                const buttonCancel = select('#btn-cancelar', wrapper)
                buttonCancel.addEventListener('click', () => {
                  wrapper.remove()
                })

                const buttonSolicitarPermissao = select(
                  '#btn-solicitar-permissao',
                  wrapper,
                )
                buttonSolicitarPermissao.addEventListener('click', () => {
                  wrapper.remove()
                  // Abre em uma nova aba o google
                  window.open('https://lerqrcode.mogomenu.com.br')
                })
              },
            })

            return
          }
        }

        if (data.prePago) {
          try {
            const prePago = JSON.parse(data.prePago)

            if (prePago.somentePrePago) {
              if (prePago.cartao.Saldo >= storeOrder.valorTotal) {
                resolve(data)
              } else {
                exibeMensagemSaldoInsuficiente(prePago)
              }
            } else {
              resolve(data)
            }
          } catch (e) {
            //
          }
        } else {
          resolve(data)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function exibeMensagemSaldoInsuficiente(saldo) {
  createMessageBox({
    content: `
        <div class="flex-column gap-8 text-center">
            <svg class="svg-orange m-a" width="42" height="36" viewBox="0 0 42 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M21 36C30.9412 36 39 27.9411 39 18C39 8.05885 30.9412 0 21 0C11.0589 0 3 8.05885 3 18C3 27.9411 11.0589 36 21 36Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5714 0.857616C41.5714 1.33306 41.1924 1.71593 40.7233 1.71593C40.2556 1.71593 39.8759 1.33306 39.8759 0.857616C39.8759 0.384257 40.2556 0 40.7233 0C41.1924 0 41.5714 0.384257 41.5714 0.857616ZM6.79917 5.17354C6.79917 5.66083 6.42015 6.059 5.95105 6.059C5.78333 6.059 5.61939 6.00713 5.47993 5.90994C5.34047 5.81275 5.23176 5.67461 5.16756 5.51298C5.10334 5.35135 5.08651 5.17349 5.11918 5.00189C5.15185 4.83027 5.23256 4.67262 5.35111 4.54886C5.46965 4.4251 5.62071 4.34078 5.78518 4.30656C5.94966 4.27234 6.12017 4.28977 6.27515 4.35662C6.43014 4.42348 6.56264 4.53678 6.65591 4.68218C6.74919 4.82759 6.79904 4.99858 6.79917 5.17354ZM39.2006 28.3738C39.2006 28.8471 38.8209 29.2321 38.3531 29.2321C37.886 29.2321 37.505 28.8471 37.505 28.3738C37.505 27.9004 37.8854 27.5154 38.3531 27.5154C38.8209 27.5154 39.2006 27.9004 39.2006 28.3738ZM2.12283 35.0808C2.12736 35.1998 2.10881 35.3185 2.06829 35.4297C2.02778 35.541 1.96613 35.6427 1.88706 35.7285C1.80798 35.8143 1.71309 35.8826 1.6081 35.9293C1.50311 35.9759 1.39016 36 1.27604 36C1.16192 36 1.04898 35.9759 0.943984 35.9293C0.838989 35.8826 0.744108 35.8143 0.66503 35.7285C0.585952 35.6427 0.524307 35.541 0.483792 35.4297C0.443278 35.3185 0.424728 35.1998 0.429256 35.0808C0.435447 34.8507 0.527411 34.6323 0.685602 34.4718C0.843793 34.3114 1.05574 34.2216 1.27638 34.2216C1.49701 34.2216 1.70896 34.3114 1.86715 34.4718C2.02534 34.6323 2.11664 34.8507 2.12283 35.0808Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8241 16.9286V14.7857C15.8241 11.8271 18.3333 9.42859 21.4285 9.42859C24.5237 9.42859 27.0329 11.8271 27.0329 14.7857V16.9286H27.5934C28.2124 16.9286 28.7142 17.4083 28.7142 18V24.4286C28.7142 25.6121 27.7106 26.5714 26.4725 26.5714H16.3846C15.1465 26.5714 14.1428 25.6121 14.1428 24.4286V18C14.1428 17.4083 14.6447 16.9286 15.2637 16.9286H15.8241ZM21.4285 19.6072C20.8095 19.6072 20.3077 20.0868 20.3077 20.6786V22.8214C20.3077 23.4132 20.8095 23.8929 21.4285 23.8929C22.0476 23.8929 22.5494 23.4132 22.5494 22.8214V20.6786C22.5494 20.0868 22.0476 19.6072 21.4285 19.6072ZM24.7912 16.9286V14.7857C24.7912 13.0105 23.2857 11.5714 21.4285 11.5714C19.5714 11.5714 18.0659 13.0105 18.0659 14.7857V16.9286H24.7912Z" fill="currentColor"/>
            </svg>                                                
            <div>
                <div id="texto-principal" class="font-16">
                    <div>Saldo insuficiente</div>
                   <div background: #efefef; border: 1px solid #e5e5e5; border-radius: 4px; margin: 14px 0;">
                     <div class="font-12 font-seccondary u-m-t-4">Seu saldo</div>
                     <div class="u-m-b-8 u-m-t-3">R$ 140,00</div>
                   </div>
                </div>
                <div id="texto-subtitulo" class="font-12 font-seccondary u-m-t-4">Você precisa adicionar mais créditos na comanda para continuar fazendo pedidos.</div>
            </div>
            </div>
        <div class="flex gap-12 w-100 u-m-t-16">
            <button class="btn-transparent w-100" id="btn-cancelar">Fechar</button>                                                      
        </div>
        `,
    beforeAppend: (wrapper) => {
      const button = select('#btn-cancelar', wrapper)
      button.addEventListener('click', () => {
        wrapper.remove()
      })
    },
  })
}

function solicitarPermissaoComanda() {
  return new Promise((resolve, reject) => {
    // Se a existe uma conexão socket ativa
    if (window.ws) {
      const params = {
        idSocket:
          `C${estabelecimento.comanda.numero}:${estabelecimento.urlEmpresa}+` +
          estabelecimento.comanda.hash,
        message: JSON.stringify({
          RemoteMethod: 12,
          nome: estabelecimento.dispositivo,
          idSocket: estabelecimento.idSocket,
        }),
      }

      window.ws.send(JSON.stringify(params))

      window.socketAwaitingResponse = true

      // Aguarda 60s, se não receber resposta, cancela a solicitação
      const timer = 1
      const inverval = setInterval(() => {
        if (!window.socketAwaitingResponse) {
          clearInterval(inverval)
          if (
            estabelecimento.comanda.hashLocal != estabelecimento.comanda.hash
          ) {
            resolve(false)
          } else {
            resolve(true)
          }
        }

        if (timer == 60) {
          clearInterval(inverval)
          reject(true)
        }
      }, 1000)
    } else {
      reject(true)
    }
  })
}

function mensagemLiberarAcessoComanda(retornoSocket) {
  createMessageBox({
    content: `
            <div class="flex-column gap-8 text-center">
                <svg class="m-a" width="42" height="36" viewBox="0 0 42 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.2" d="M21 36C30.9412 36 39 27.9411 39 18C39 8.05885 30.9412 0 21 0C11.0589 0 3 8.05885 3 18C3 27.9411 11.0589 36 21 36Z" fill="#FF9332"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5714 0.857616C41.5714 1.33306 41.1924 1.71593 40.7233 1.71593C40.2556 1.71593 39.8759 1.33306 39.8759 0.857616C39.8759 0.384257 40.2556 0 40.7233 0C41.1924 0 41.5714 0.384257 41.5714 0.857616ZM6.79917 5.17354C6.79917 5.66083 6.42015 6.059 5.95105 6.059C5.78333 6.059 5.61939 6.00713 5.47993 5.90994C5.34047 5.81275 5.23176 5.67461 5.16756 5.51298C5.10334 5.35135 5.08651 5.17349 5.11918 5.00189C5.15185 4.83027 5.23256 4.67262 5.35111 4.54886C5.46965 4.4251 5.62071 4.34078 5.78518 4.30656C5.94966 4.27234 6.12017 4.28977 6.27515 4.35662C6.43014 4.42348 6.56264 4.53678 6.65591 4.68218C6.74919 4.82759 6.79904 4.99858 6.79917 5.17354ZM39.2006 28.3738C39.2006 28.8471 38.8209 29.2321 38.3531 29.2321C37.886 29.2321 37.505 28.8471 37.505 28.3738C37.505 27.9004 37.8854 27.5154 38.3531 27.5154C38.8209 27.5154 39.2006 27.9004 39.2006 28.3738ZM2.12283 35.0808C2.12736 35.1998 2.10881 35.3185 2.06829 35.4297C2.02778 35.541 1.96613 35.6427 1.88706 35.7285C1.80798 35.8143 1.71309 35.8826 1.6081 35.9293C1.50311 35.9759 1.39016 36 1.27604 36C1.16192 36 1.04898 35.9759 0.943984 35.9293C0.838989 35.8826 0.744108 35.8143 0.66503 35.7285C0.585952 35.6427 0.524307 35.541 0.483792 35.4297C0.443278 35.3185 0.424728 35.1998 0.429256 35.0808C0.435447 34.8507 0.527411 34.6323 0.685602 34.4718C0.843793 34.3114 1.05574 34.2216 1.27638 34.2216C1.49701 34.2216 1.70896 34.3114 1.86715 34.4718C2.02534 34.6323 2.11664 34.8507 2.12283 35.0808Z" fill="#FF9332"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.3799 10.4716L29.7185 23.1488C30.3757 24.4634 29.8429 26.0618 28.5284 26.7191C28.1589 26.9038 27.7515 27 27.3383 27H14.6611C13.1914 27 12 25.8086 12 24.3389C12 23.9258 12.0962 23.5183 12.2809 23.1488L18.6196 10.4716C19.2768 9.15708 20.8753 8.62426 22.1898 9.28152C22.7048 9.53902 23.1224 9.9566 23.3799 10.4716ZM21 20.8125C20.068 20.8125 19.3125 21.568 19.3125 22.5C19.3125 23.432 20.068 24.1875 21 24.1875C21.932 24.1875 22.6875 23.432 22.6875 22.5C22.6875 21.568 21.932 20.8125 21 20.8125ZM21 19.125C21.6213 19.125 22.125 18.7652 22.125 18.3214V14.3036C22.125 13.8598 21.6213 13.5 21 13.5C20.3787 13.5 19.875 13.8598 19.875 14.3036V18.3214C19.875 18.7652 20.3787 19.125 21 19.125Z" fill="#FF9332"/>
                </svg>                                                         
                <div>
                    <div id="texto-principal" class="font-16">${retornoSocket.nome} pediu permissão para fazer pedidos</div>
                    <div id="texto-subtitulo" class="font-12 font-seccondary u-m-t-4">Ao permitir, o dispositivo estará liberado para fazer pedidos na comanda ${estabelecimento.comanda.numero}</div>
                </div>
                </div>
            <div class="flex gap-12 w-100 u-m-t-16">
                <button class="btn-transparent w-100" id="btn-cancelar">Cancelar</button>    
                <button class="btn-azul w-100" id="btn-permissao">Permitir</button>                                                    
            </div>
            `,
    beforeAppend: (wrapper) => {
      const btnCancelar = select('#btn-cancelar', wrapper)
      btnCancelar.addEventListener('click', () => {
        wrapper.remove()
        toast('Recusado')

        const params = {
          idSocket: retornoSocket.idSocket,
          message: JSON.stringify({
            RemoteMethod: 13,
            hash: '',
          }),
        }

        window.ws.send(JSON.stringify(params))
      })

      const btnPermitirAcesso = select('#btn-permissao', wrapper)
      btnPermitirAcesso.addEventListener('click', () => {
        const params = {
          idSocket: retornoSocket.idSocket,
          message: JSON.stringify({
            RemoteMethod: 13,
            hash: estabelecimento.comanda.hashLocal,
          }),
        }

        window.ws.send(JSON.stringify(params))

        wrapper.remove()

        toast(retornoSocket.nome + ' pode fazer pedios nesta comanda')
      })
    },
  })
}

function solicitaLiberacaoComanda() {
  createMessageBox({
    content: `
        <div class="flex-column gap-8 text-center">
            <svg class="svg-orange m-a" width="42" height="36" viewBox="0 0 42 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M21 36C30.9412 36 39 27.9411 39 18C39 8.05885 30.9412 0 21 0C11.0589 0 3 8.05885 3 18C3 27.9411 11.0589 36 21 36Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5714 0.857616C41.5714 1.33306 41.1924 1.71593 40.7233 1.71593C40.2556 1.71593 39.8759 1.33306 39.8759 0.857616C39.8759 0.384257 40.2556 0 40.7233 0C41.1924 0 41.5714 0.384257 41.5714 0.857616ZM6.79917 5.17354C6.79917 5.66083 6.42015 6.059 5.95105 6.059C5.78333 6.059 5.61939 6.00713 5.47993 5.90994C5.34047 5.81275 5.23176 5.67461 5.16756 5.51298C5.10334 5.35135 5.08651 5.17349 5.11918 5.00189C5.15185 4.83027 5.23256 4.67262 5.35111 4.54886C5.46965 4.4251 5.62071 4.34078 5.78518 4.30656C5.94966 4.27234 6.12017 4.28977 6.27515 4.35662C6.43014 4.42348 6.56264 4.53678 6.65591 4.68218C6.74919 4.82759 6.79904 4.99858 6.79917 5.17354ZM39.2006 28.3738C39.2006 28.8471 38.8209 29.2321 38.3531 29.2321C37.886 29.2321 37.505 28.8471 37.505 28.3738C37.505 27.9004 37.8854 27.5154 38.3531 27.5154C38.8209 27.5154 39.2006 27.9004 39.2006 28.3738ZM2.12283 35.0808C2.12736 35.1998 2.10881 35.3185 2.06829 35.4297C2.02778 35.541 1.96613 35.6427 1.88706 35.7285C1.80798 35.8143 1.71309 35.8826 1.6081 35.9293C1.50311 35.9759 1.39016 36 1.27604 36C1.16192 36 1.04898 35.9759 0.943984 35.9293C0.838989 35.8826 0.744108 35.8143 0.66503 35.7285C0.585952 35.6427 0.524307 35.541 0.483792 35.4297C0.443278 35.3185 0.424728 35.1998 0.429256 35.0808C0.435447 34.8507 0.527411 34.6323 0.685602 34.4718C0.843793 34.3114 1.05574 34.2216 1.27638 34.2216C1.49701 34.2216 1.70896 34.3114 1.86715 34.4718C2.02534 34.6323 2.11664 34.8507 2.12283 35.0808Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8241 16.9286V14.7857C15.8241 11.8271 18.3333 9.42859 21.4285 9.42859C24.5237 9.42859 27.0329 11.8271 27.0329 14.7857V16.9286H27.5934C28.2124 16.9286 28.7142 17.4083 28.7142 18V24.4286C28.7142 25.6121 27.7106 26.5714 26.4725 26.5714H16.3846C15.1465 26.5714 14.1428 25.6121 14.1428 24.4286V18C14.1428 17.4083 14.6447 16.9286 15.2637 16.9286H15.8241ZM21.4285 19.6072C20.8095 19.6072 20.3077 20.0868 20.3077 20.6786V22.8214C20.3077 23.4132 20.8095 23.8929 21.4285 23.8929C22.0476 23.8929 22.5494 23.4132 22.5494 22.8214V20.6786C22.5494 20.0868 22.0476 19.6072 21.4285 19.6072ZM24.7912 16.9286V14.7857C24.7912 13.0105 23.2857 11.5714 21.4285 11.5714C19.5714 11.5714 18.0659 13.0105 18.0659 14.7857V16.9286H24.7912Z" fill="currentColor"/>
            </svg>                                                
            <div>
                <div id="texto-principal" class="font-16">Comanda ${estabelecimento.comanda.numero} em uso</div>
                <div id="texto-subtitulo" class="font-12 font-seccondary u-m-t-4">Esta comanda é de outra pessoa, deseja solicitar permissão para fazer pedidos nela?</div>
            </div>
            </div>
        <div class="flex gap-12 w-100 u-m-t-16">
            <button class="btn-transparent w-100" id="btn-cancelar">Cancelar</button>    
            <button class="btn-azul w-100" id="btn-solicitar-permissao">Solicitar permissão</button>                                                    
        </div>
        `,
    beforeAppend: (wrapper) => {
      const btnCancelar = select('#btn-cancelar', wrapper)
      btnCancelar.addEventListener('click', () => {
        wrapper.remove()
        toast(
          'Esta comanda está bloqueada, para fazer pedidos solicite outra comanda.',
        )
      })

      const textoPrincipal = select('#texto-principal', wrapper)
      const textoSubtitulo = select('#texto-subtitulo', wrapper)

      const btnSolicitarComanda = select('#btn-solicitar-permissao', wrapper)
      btnSolicitarComanda.addEventListener('click', () => {
        solicitarPermissaoComanda()
          .then((liberado) => {
            if (liberado) {
              const svg = select('.svg-orange', wrapper)
              svg.classList.add('svg-green')
              svg.classList.remove('svg-orange')

              textoPrincipal.textContent = 'Comanda liberada'
              textoSubtitulo.textContent =
                'Agora você pode fazer pedidos nesta comanda'
              btnCancelar.remove()

              // remove os eventos de click
              const newNODE = btnSolicitarComanda.cloneNode(true)
              btnSolicitarComanda.replaceWith(newNODE)
              newNODE.textContent = 'Continuar'

              newNODE.addEventListener('click', () => {
                const btnConfirmarPedido = select('#confirmarPedido')
                btnConfirmarPedido && btnConfirmarPedido.click()
                wrapper.remove()
              })
            } else {
              textoPrincipal.textContent = 'Acesso negado'
              textoSubtitulo.textContent =
                'O acesso a esta comanda foi negado, você pode solicitar outra comanda'
              btnCancelar.textContent = 'Fechar'
              btnSolicitarComanda.remove()
            }
          })
          .catch((error) => {
            if (error) {
              toast(
                'Ocorreu um erro, verifique sua conexão com a internet e tente novamente',
              )
            } else {
              textoPrincipal.textContent = 'Acesso negado'
              textoSubtitulo.textContent =
                'O acesso a esta comanda foi negado, solicite uma nova comanda.'

              btnCancelar.textContent = 'Fechar'
              btnSolicitarComanda.remove()
            }
          })
      })
    },
  })
}

function verificaUsoCookies() {
  let configCookies = localStorage.getItem('config-cookies')
  if (configCookies) {
    configCookies = JSON.parse(configCookies)

    usuario.cookies = configCookies
  } else {
    const banner = createElement(
      'div',
      { class: 'floating-message' },
      `
            <img src="images/cookie.svg" alt="coockie">
            <div class="u-margin-b-10">
                <div class="font-500 fonte-14">Nosso site usa cookies</div>
                <div>Utilizamos cookies para personalizar sua experiência no nosso site. Ao continuar, você concorda com a nossa <a href="home/politicadeprivacidade" target="_blank">política de cookies.</a></div>
            </div>
            <div id="configurar-cookie" class="hide">
                <div class="flex-column gap-16 u-margin-b-15 u-p-8 after-background">
                    <div class="flex-column">
                        <div class="fonte-14 font-500">Essênciais</div>
                        <div class="flex flex-between">                
                            <div>Recursos indispensáveis para o funcionamento do site, como preferências, dados de login e ferramentas para rastreamento de erros.</div>
                            <input type="checkbox" checked disabled>
                        </div>
                    </div>
                    <div class="flex-column">
                        <div class="fonte-14 font-500">Analytics</div>
                        <div class="flex flex-between">
                            <div>Ferramentas de análise de dados para entender como os usuários interagem com o site.</div>
                            <input id="coockie-mixpanel" type="checkbox" checked>
                        </div>
                    </div>                
                </div>
            </div>
            
            <div class="flex-end flex gap-8 flex-wrap">
                <button class="btn-transparent">Configurar</button>
                <button class="btn-azul">Aceitar</button>
            </div>
        `,
    )

    const btnConfigurar = select('button.btn-transparent', banner)
    btnConfigurar.addEventListener('click', () => {
      const configurarCookie = select('#configurar-cookie', banner)
      configurarCookie.classList.toggle('hide')
    })

    const btnAceitar = select('button.btn-azul', banner)
    btnAceitar.addEventListener('click', () => {
      const coockieMixpanel = select('#coockie-mixpanel', banner)
      usuario.cookies.consentimentoMixpanel = coockieMixpanel.checked

      if (coockieMixpanel.checked) {
        window.trackAwait.forEach((item) => {
          track(item.nome, item.atributos)
        })
      }

      localStorage.setItem('config-cookies', JSON.stringify(usuario.cookies))

      banner.remove()
    })

    document.body.appendChild(banner)
  }
}

function loaderSabor() {
  return createElement(
    'div',
    { class: 'absolute inset-0 loader-sabor' },
    `
    <div class="showbox">
        <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
        <circle stroke="#4f44e0" style="stroke: #4f44e0!important" class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
        </svg> </div>
    </div>
    `,
  )
}

function leituraQrCode() {
  return new Promise((resolve, reject) => {
    checkCameraPermission().then((cameraPermissionGranted) => {
      if (cameraPermissionGranted) {
        renderQrScanner()
          .then((comanda) => {
            resolve(comanda)
          })
          .catch(() => {
            reject()
          })
      } else {
        toast(
          'Precisamos da sua permissão para acessar a câmera do seu dispositivo.',
        )
      }
    })
  })

  function renderQrScanner() {
    return new Promise((resolve, reject) => {
      let currentFacingMode = 'user'; // Começar com 'user' para compatibilidade com PCs

      const wrapper = createMessageBox({
        content: `
          <div class="flex flex-center flex-column gap-20 text-center">
            <div class="font-16 font-500 m-t-4">Posicione o QR Code dentro da área de leitura</div>
            <button id="toggle-camera" class="btn-azul" style="margin-bottom: 10px;">Trocar câmera</button>
            <div id="qr-header" style="width: 500px;height: 420px;"></div>                  
          </div>`,
        beforeAppend: (wrapper) => {
          wrapper.classList.add('wrapper-qr-code')
        },
      });

      let html5QrcodeScanner;
      let hasMultipleCameras = false;

      function startScanner(facingMode) {
        if (html5QrcodeScanner) {
          html5QrcodeScanner.clear().then(() => {
            html5QrcodeScanner = null;
            initializeScanner(facingMode);
          }).catch(error => {
            console.error("Erro ao limpar scanner:", error);
            html5QrcodeScanner = null;
            initializeScanner(facingMode);
          });
        } else {
          initializeScanner(facingMode);
        }
      }

      function initializeScanner(facingMode) {
        // Configuração mais flexível
        const config = {
          fps: 10,
          qrbox: 250
        };

        // Somente adiciona videoConstraints se o dispositivo tiver múltiplas câmeras
        if (hasMultipleCameras) {
          config.videoConstraints = {
            facingMode: facingMode
          };
        }

        html5QrcodeScanner = new Html5QrcodeScanner('qr-header', config, /* verbose= */ false);
        html5QrcodeScanner.render(onScanSuccess, onScanError);
      }

      function onScanSuccess(decodedText, decodedResult) {
        console.log(`Scan result: ${decodedText}`, decodedResult);
        html5QrcodeScanner.clear();
        const isNumber = /^\d+$/.test(decodedText.trim());
        if (isNumber) {
          const comanda = decodedText.trim();
          wrapper.remove();
          toast(`Comanda "${comanda}"`);
          resolve(comanda);
        } else {
          toast(`Comanda "${decodedText}" inválida.`);
          reject();
        }
      }

      function onScanError(errorMessage) {
        // Podemos opcionalmente logar erros não relacionados ao scan
        if (errorMessage.includes("OverconstrainedError")) {
          console.log("Câmera solicitada não está disponível, usando configuração padrão");
        }
      }

      // Verificar disponibilidade de câmeras antes de iniciar
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        navigator.mediaDevices.enumerateDevices()
          .then(devices => {
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            console.log('Câmeras disponíveis:', videoDevices.length);

            // Atualizar a flag de múltiplas câmeras
            hasMultipleCameras = videoDevices.length > 1;

            // Desabilitar o botão de troca se não houver múltiplas câmeras
            if (!hasMultipleCameras) {
              const toggleButton = wrapper.querySelector('#toggle-camera');
              toggleButton.style.display = 'none';
            }

            // Iniciar com a configuração apropriada
            startScanner(currentFacingMode);
          })
          .catch(err => {
            console.error("Erro ao enumerar dispositivos:", err);
            startScanner(currentFacingMode); // Usar configuração padrão
          });
      } else {
        // Se a API não estiver disponível
        startScanner(currentFacingMode);
      }

      // Botão para trocar câmera
      wrapper.querySelector('#toggle-camera').addEventListener('click', () => {
        if (hasMultipleCameras) {
          currentFacingMode = currentFacingMode === 'environment' ? 'user' : 'environment';
          startScanner(currentFacingMode);
        }
      });

      // Manipulação de cliques automáticos nos botões da biblioteca
      const checkAndClickButtons = () => {
        setTimeout(() => {
          const buttonRequestCamera = document.querySelector('#html5-qrcode-button-camera-permission');
          if (buttonRequestCamera) buttonRequestCamera.click();

          const interval = setInterval(() => {
            const startScan = document.querySelector('#html5-qrcode-button-camera-start');
            if (startScan) {
              startScan.click();
              clearInterval(interval);
            }
          }, 500);
        }, 1000);
      };

      checkAndClickButtons();
    });
  }
}

export function checkCameraPermission() {
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('acessoCamera') == 'true') {
      resolve(true)
      return
    }

    const wrapper = createMessageBox({
      content: `
            <div class="flex flex-center flex-column gap-20 text-center">
                <div>
                    <div class="font-16 font-500 m-t-4">Permitir acesso a câmera</div>
                    <div class="font-13 font-normal text-gray-300">Precisamos da sua permissão para acessar a câmera do seu dispositivo para a leitura das comandas.</div>
                </div>
                <img src="./images/acesso-camera.svg" alt="Acesso a câmera">                  
                <div id="btn-permitir-camera" class="btn-azul w-m-c">Permitir acesso a câmera</div>
              </div>`,
      beforeAppend: (wrapper) => {
        const btnAcesso = select('#btn-permitir-camera', wrapper)
        btnAcesso.addEventListener('click', () => {
          navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((stream) => {
              // Se a promessa for resolvida, significa que a permissão foi concedida
              stream.getTracks().forEach((track) => track.stop())
              resolve(true)
              wrapper.remove()
            })
            .catch((error) => {
              // Tratar erros, se houver
              console.error('Erro ao solicitar permissão da câmera:', error)
              // Rejeitar a promessa em caso de erro
              reject(false)
            })
        })
      },
    })

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        // Se a promessa for resolvida, significa que a permissão foi concedida
        stream.getTracks().forEach((track) => track.stop())
        resolve(true)
        wrapper.remove()

        localStorage.setItem('acessoCamera', 'true')
      })
      .catch((error) => {
        // Tratar erros, se houver
        console.error('Erro ao solicitar permissão da câmera:', error)
        // Rejeitar a promessa em caso de erro
        reject(false)
      })
  })
}

function createCard(dataExpiracao, ultimosQuatroDigitos) {
  return createElement(
    'div',
    { class: 'card-forma-pagamento cursor-pointer text-center u-flex' },
    `
    <i class=" far fa-credit-card"></i>
    <div class="font-10-5 font-500">
        <div>${dataExpiracao}</div>
        <div>${ultimosQuatroDigitos}</div>
    </div>`,
  )
}

function verificaPagamentoOnline() {
  const formaDePagamentoOnline = estabelecimento.pagamento.metodos.find(
    (pagamento) => pagamento.Prefixo === 'OLON',
  )
  let pagamentoOnlineSelecionado = false
  if (formaDePagamentoOnline) {
    pagamentoOnlineSelecionado =
      storeOrder.CodTipoPagamento == formaDePagamentoOnline.Id
  }

  return {
    formaDePagamentoOnline,
    pagamentoOnlineSelecionado,
  }
}

function calculaValorAdicionalSabor(sabor, adicional, qtdSabores, quantidadePizzas) {
  const quantidadeSabores =
    qtdSabores ||
    storProduto.Sabores.reduce((acc, item) => {
      return acc + item.Quantidade
    }, 0)
  const quantidadeSaborAtual =
    storProduto.Sabores.filter((item) => item.CodSabor == sabor.CodSabor)
      .length || sabor.Quantidade

  const valorProporcional =
    ((adicional.preco || adicional.ValorTotal || 0) * quantidadeSaborAtual) / quantidadeSabores

  return valorProporcional * quantidadePizzas
}

function verificaURL() {
  try {
    const url = window.location.href
    const parametros = url.split('?')[1]
    if (parametros) {
      const parametrosSplit = parametros.split('&')
      parametrosSplit.forEach((parametro) => {
        const [key, value] = parametro.split('=')
        if (key == 'produto') {
          const idProduto = parseInt(value)
          exibeTelaLoading(idProduto)
        }
      })
    }
  } catch (e) {
    Sentry.captureException(e)
  }
}

function exibeTelaLoading(idProduto) {
  const wrapper = createElement(
    'div',
    {
      id: 'aguardando-produto',
      class: 'bg-white fixed flex flex-center flex-column gap-16 inset-0',
      produto: idProduto,
    },
    `
      <div class="showbox">
        <div class="loader" style="width: 6rem;height: 6rem;"> 
            <svg class="circular" viewBox="25 25 50 50">
            <circle stroke="#4f44e0" style="stroke: #4f44e0!important" class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
            </svg>
        </div>
    </div>
    <span class="font- font-500">Aguarde, estamos preparando tudo pra você..</span>  
    `,
  )

  document.body.appendChild(wrapper)
}

function verificaAutorizacaoPix() {
  const dadosSolicitados = {}

  if (!usuario.cpf) {
    dadosSolicitados.cpf = true
  }

  if (!usuario.email) {
    dadosSolicitados.email = true
  }

  if (Object.keys(dadosSolicitados).length > 0) {
    solicitaDadosUsuario(dadosSolicitados, () => {
      const btnSalvarPedido = select('#salva-pedido')
      btnSalvarPedido.click()
    })
    return false
  } else {
    return true
  }
}

export function exibeQrCodePIX(
  linkImagemPix,
  configuracoesPIX,
  order_id,
  qrcode,
  //sicredi
  sicredi,
  txid,
  idBandeira
) {
  if (!configuracoesPIX) {
    configuracoesPIX = {
      linkImagemPix,
      order_id,
      inicioExibicao: new Date().getTime(),
      pedido: JSON.stringify(storeOrder),
      qrcode,
      sicredi,
      txid,
      idBandeira
    }

    if (!configuracoesPIX.order_id && !configuracoesPIX.txid) {
      return
    }
    storeOrder.configuracoesPagamentoQRCode = configuracoesPIX

    storage.set(`pedido-mobile-${estabelecimento.urlEmpresa}`, storeOrder)
  } else {
    const tempoExibicaoDate = new Date(configuracoesPIX.inicioExibicao)
    // se o tempo de exibição do QR Code for maior que 2 minutos e 30s, remove o QR Code
    const tempoExibicao = new Date() - tempoExibicaoDate
    if (tempoExibicao > 150000) {
      showButtonOrder(true)
      return
    } else {
      confirmarPedido()
    }
  }

  const wrapper = createElement(
    'div',
    {
      class:
        'pix-wrapper',
    },
    `
        <div class="pix-header">
            <h1>Pagamento PIX</h1>
            <p>Use a chave PIX abaixo para finalizar seu pagamento</p>
        </div>
        
        ${linkImagemPix ? `<img src="${linkImagemPix}" style="width: 160px;margin: 0 auto;">` : ''}
        ${!linkImagemPix && configuracoesPIX.sicredi ? `<canvas id="canvas" style="width: 160px;margin: 0 auto;"></canvas>` : ''}

        
        <div class="countdown-container">
            <div class="timer" id="timer">02:00</div>
            <div class="progress-container">
                <div class="progress-bar" id="progress-bar"></div>
            </div>
            <p class="time-remaining">Você tem <span id="time-text">2 minutos</span> para completar o pagamento</p>
        </div>
        
        <div class="pix-container">
            <h2>Chave PIX:</h2>
            <div class="pix-key-container">
                <div class="pix-key" id="pix-key">${configuracoesPIX.qrcode}</div>
                <button class="copy-button" id="copy-button">Copiar</button>
            </div>
        </div>
        
        <div class="instructions">
            <h3>Atenção!</h3>
            <p>Após efetuar o pagamento, retorne a esta página para concluir seu processo de compra. Esta página será atualizada automaticamente quando seu pagamento for confirmado.</p>
        </div>
        
        <div class="success-message" id="success-message">
            <h3>Pagamento confirmado!</h3>
            <p>Estamos processando seu pedido.</p>
        </div>
    `,
  )
  // Copy button functionality
  const copyButton = select('#copy-button', wrapper);
  const pixKey = select('#pix-key', wrapper);

  copyButton.addEventListener('click', function () {
    navigator.clipboard.writeText(pixKey.textContent)
      .then(() => {
        const originalText = copyButton.textContent;
        copyButton.textContent = 'Copiado!';
        setTimeout(() => {
          copyButton.textContent = originalText;
        }, 2000);
      })
      .catch(err => {
        console.error('Erro ao copiar: ', err);
      });
  });

  // Countdown timer functionality
  const timerElement = select('#timer', wrapper);
  const progressBar = select('#progress-bar', wrapper);
  const timeText = select('#time-text', wrapper);

  const tempoExibicao = new Date(configuracoesPIX.inicioExibicao)
  const totalSeconds = 120; // 2 minutes
  let secondsRemaining = totalSeconds - Math.floor((new Date() - tempoExibicao) / 1000);

  function updateTimer() {
    const minutes = Math.floor(secondsRemaining / 60);
    const seconds = secondsRemaining % 60;

    // Update timer display
    timerElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    // Update progress bar
    const progressPercentage = (secondsRemaining / totalSeconds) * 100;
    progressBar.style.width = `${progressPercentage}%`;

    // Update time text
    if (secondsRemaining > 60) {
      timeText.textContent = `${Math.ceil(secondsRemaining / 60)} minutos`;
    } else if (secondsRemaining === 60) {
      timeText.textContent = "1 minuto";
    } else if (secondsRemaining === 1) {
      timeText.textContent = "1 segundo";
    } else {
      timeText.textContent = `${secondsRemaining} segundos`;
    }

    // Change color when time is running out
    if (secondsRemaining <= 30) {
      timerElement.style.color = '#dc3545';
      progressBar.style.background = 'linear-gradient(90deg, #dc3545, #ff4d6d)';
    }

    // Decrement timer
    secondsRemaining--;

    // Check if timer has expired
    if (secondsRemaining < 0) {
      clearInterval(timerInterval);
      timerElement.textContent = "00:00";
      timeText.textContent = "Tempo esgotado";
    }
  }

  // Initial call and set interval
  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);


  document.body.appendChild(wrapper)

  if (!linkImagemPix && configuracoesPIX.sicredi) {
    const canvas = select('#canvas', wrapper)
    QRCode.toCanvas(canvas, configuracoesPIX.qrcode)
  }

  const interval = setInterval(() => {
    if (new Date() - (new Date(configuracoesPIX.inicioExibicao + 150000)) > 0) {
      wrapper.remove()
      const msg = select(".wrapper-message-pedido-salvo")
      if (msg) {
        msg.remove()
      }
      toast('QR Code expirado, por favor, solicite um novo QR Code.')

      clearInterval(interval)
    }
  }, 5000)

  // consulta o pagamento do PIX a cada 5 segundos caso não esteja em requisição
  let consultaEmAndamento = false
  const intervalConsulta = setInterval(() => {
    if (!consultaEmAndamento) {
      if (configuracoesPIX && (configuracoesPIX.order_id || configuracoesPIX.sicredi && configuracoesPIX.txid)) {
        consultaEmAndamento = true
        consultaPagamentoPIX(configuracoesPIX).then((response) => {
          if (response.sucessoNoPagamento) {
            const pixContent = select('.pix-wrapper')
            pixContent.remove()

            wrapper.remove()

            storeOrder.pixPago = true
            storeOrder.PrePago = true
            storeOrder.IsPagtoOnline = true

            select('#salva-pedido').click()

            const stepEnviandoPedido = select('[step="3"]')
            if (stepEnviandoPedido) {
              stepEnviandoPedido.classList.remove('pendente')
            }
          } else {
            consultaEmAndamento = false
          }
        })
      } else {
        clearInterval(intervalConsulta)
      }
    }
  }, 5000)
}

function consultaPagamentoPIX(configuracoesPIX) {

  if (configuracoesPIX.sicredi) {
    return axios
      .get(getUrlAction('pedido', 'ConsultaCobrancaPIX'), {
        params: {
          idBandeira: configuracoesPIX.idBandeira,
          txid: configuracoesPIX.txid,
        },
      })
      .then((response) => {
        const data = response.data
        const ret = JSON.parse(data.ret)
        if (ret && ret.status == 'CONCLUIDA') {
          return {
            sucessoNoPagamento: true,
          }
        } else {
          return {}
        }
      })
      .catch((error) => {
        toast('Ocorreu um erro ao consultar o pagamento do PIX')
      })
  } else {
    return axios
      .get(getUrlAction('pedido', 'VerificaPagamentoPIX'), {
        params: {
          order_id: configuracoesPIX.order_id,
        },
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        toast('Ocorreu um erro ao consultar o pagamento do PIX')
      })
  }


}


